
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredc87"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredc87"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iisr1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useSyncExternalStore", () => $d51ff6fbc6548743$export$306c0aa65ff9ec16);
$parcel$export(module.exports, "startTransition", () => $d51ff6fbc6548743$export$7568632d0d33d16d);
$parcel$export(module.exports, "useDeferredValue", () => $d51ff6fbc6548743$export$6a7bc4e911dc01cf);
$parcel$export(module.exports, "useTransition", () => $d51ff6fbc6548743$export$7b286972b8d8ccbf);
$parcel$export(module.exports, "useInsertionEffect", () => $d51ff6fbc6548743$export$aaabe4eda9ed9969);
$parcel$export(module.exports, "PureComponent", () => $d51ff6fbc6548743$export$221d75b3f55bb0bd);
$parcel$export(module.exports, "memo", () => $d51ff6fbc6548743$export$7c73462e0d25e514);
$parcel$export(module.exports, "forwardRef", () => $d51ff6fbc6548743$export$257a8862b851cb5b);
$parcel$export(module.exports, "Children", () => $d51ff6fbc6548743$export$dca3b0875bd9a954);
$parcel$export(module.exports, "Suspense", () => $d51ff6fbc6548743$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "lazy", () => $d51ff6fbc6548743$export$488013bae63b21da);
$parcel$export(module.exports, "SuspenseList", () => $d51ff6fbc6548743$export$998bcd577473dd93);
$parcel$export(module.exports, "createPortal", () => $d51ff6fbc6548743$export$d39a5bbd09211389);
$parcel$export(module.exports, "render", () => $d51ff6fbc6548743$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $d51ff6fbc6548743$export$fa8d919ba61d84db);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $d51ff6fbc6548743$export$ae55be85d98224ed);
$parcel$export(module.exports, "version", () => $d51ff6fbc6548743$export$83d89fbfd8236492);
$parcel$export(module.exports, "createFactory", () => $d51ff6fbc6548743$export$d38cd72104c1f0e9);
$parcel$export(module.exports, "isValidElement", () => $d51ff6fbc6548743$export$a8257692ac88316c);
$parcel$export(module.exports, "isFragment", () => $d51ff6fbc6548743$export$9522e17588c12572);
$parcel$export(module.exports, "isMemo", () => $d51ff6fbc6548743$export$56885ab8b9c456ab);
$parcel$export(module.exports, "cloneElement", () => $d51ff6fbc6548743$export$e530037191fcd5d7);
$parcel$export(module.exports, "unmountComponentAtNode", () => $d51ff6fbc6548743$export$502457920280e6be);
$parcel$export(module.exports, "findDOMNode", () => $d51ff6fbc6548743$export$466bfc07425424d5);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $d51ff6fbc6548743$export$c78a37762a8d58e1);
$parcel$export(module.exports, "flushSync", () => $d51ff6fbc6548743$export$cd75ccfd720a3cd4);
$parcel$export(module.exports, "StrictMode", () => $d51ff6fbc6548743$export$5f8d39834fd61797);
$parcel$export(module.exports, "isElement", () => $d51ff6fbc6548743$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "default", () => $d51ff6fbc6548743$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Component", () => (parcelRequire("9SeGy")).Component);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("9SeGy")).Fragment);
$parcel$export(module.exports, "createContext", () => (parcelRequire("9SeGy")).createContext);
$parcel$export(module.exports, "createElement", () => (parcelRequire("9SeGy")).createElement);
$parcel$export(module.exports, "createRef", () => (parcelRequire("9SeGy")).createRef);

var $9SeGy = parcelRequire("9SeGy");

var $bJrD0 = parcelRequire("bJrD0");
function $d51ff6fbc6548743$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $d51ff6fbc6548743$var$E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $d51ff6fbc6548743$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $bJrD0.useState)({
        t: {
            __: e,
            u: t
        }
    }), u = r[0].t, o = r[1];
    return (0, $bJrD0.useLayoutEffect)(function() {
        u.__ = e, u.u = t, $d51ff6fbc6548743$var$R(u) && o({
            t: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $bJrD0.useEffect)(function() {
        return $d51ff6fbc6548743$var$R(u) && o({
            t: u
        }), n(function() {
            $d51ff6fbc6548743$var$R(u) && o({
                t: u
            });
        });
    }, [
        n
    ]), e;
}
function $d51ff6fbc6548743$var$R(n) {
    try {
        return !((t = n.__) === (e = n.u()) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
    var t, e;
}
function $d51ff6fbc6548743$export$7568632d0d33d16d(n) {
    n();
}
function $d51ff6fbc6548743$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $d51ff6fbc6548743$export$7b286972b8d8ccbf() {
    return [
        !1,
        $d51ff6fbc6548743$export$7568632d0d33d16d
    ];
}
var $d51ff6fbc6548743$export$aaabe4eda9ed9969 = (0, $bJrD0.useLayoutEffect);
function $d51ff6fbc6548743$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $d51ff6fbc6548743$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $d51ff6fbc6548743$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $9SeGy.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u.type = n, u;
}
($d51ff6fbc6548743$export$221d75b3f55bb0bd.prototype = new (0, $9SeGy.Component)).isPureReactComponent = !0, $d51ff6fbc6548743$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $d51ff6fbc6548743$var$E(this.props, n) || $d51ff6fbc6548743$var$E(this.state, t);
};
var $d51ff6fbc6548743$var$T = (0, $9SeGy.options).__b;
(0, $9SeGy.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $d51ff6fbc6548743$var$T && $d51ff6fbc6548743$var$T(n);
};
var $d51ff6fbc6548743$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $d51ff6fbc6548743$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $d51ff6fbc6548743$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $d51ff6fbc6548743$var$A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $d51ff6fbc6548743$var$L = function(n, t) {
    return null == n ? null : (0, $9SeGy.toChildArray)((0, $9SeGy.toChildArray)(n).map(t));
}, $d51ff6fbc6548743$export$dca3b0875bd9a954 = {
    map: $d51ff6fbc6548743$var$L,
    forEach: $d51ff6fbc6548743$var$L,
    count: function(n) {
        return n ? (0, $9SeGy.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $9SeGy.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $9SeGy.toChildArray)
}, $d51ff6fbc6548743$var$U = (0, $9SeGy.options).__e;
(0, $9SeGy.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $d51ff6fbc6548743$var$U(n, t, e, r);
};
var $d51ff6fbc6548743$var$F = (0, $9SeGy.options).unmount;
function $d51ff6fbc6548743$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $d51ff6fbc6548743$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $d51ff6fbc6548743$var$V(n, t, e);
    })), n;
}
function $d51ff6fbc6548743$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $d51ff6fbc6548743$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $d51ff6fbc6548743$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $d51ff6fbc6548743$var$j(n) {
    if (!n.__) return null;
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $d51ff6fbc6548743$export$488013bae63b21da(n) {
    var e, r, u, o = null;
    function i(i) {
        if (e || (e = n()).then(function(n) {
            n && (o = n.default || n), u = !0;
        }, function(n) {
            r = n, u = !0;
        }), r) throw r;
        if (!u) throw e;
        return o ? (0, $9SeGy.createElement)(o, i) : null;
    }
    return i.displayName = "Lazy", i.__f = !0, i;
}
function $d51ff6fbc6548743$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $9SeGy.options).unmount = function(n) {
    var t = n.__c;
    t && (t.__z = !0), t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $d51ff6fbc6548743$var$F && $d51ff6fbc6548743$var$F(n);
}, ($d51ff6fbc6548743$export$74bf444e3cd11ea5.prototype = new (0, $9SeGy.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.o && (r.o = []), r.o.push(e);
    var u = $d51ff6fbc6548743$var$j(r.__v), o = !1, i = function() {
        o || r.__z || (o = !0, e.__R = null, u ? u(c) : c());
    };
    e.__R = i;
    var l = e.__P;
    e.__P = null;
    var c = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $d51ff6fbc6548743$var$W(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.o.pop();)t.__P = l, t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $d51ff6fbc6548743$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $d51ff6fbc6548743$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $d51ff6fbc6548743$var$V(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $9SeGy.createElement)((0, $9SeGy.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $9SeGy.createElement)((0, $9SeGy.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $d51ff6fbc6548743$var$H = function(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $d51ff6fbc6548743$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $d51ff6fbc6548743$var$Y(n) {
    var e = this, r = n.h;
    if (e.componentWillUnmount = function() {
        (0, $9SeGy.render)(null, e.v), e.v = null, e.h = null;
    }, e.h && e.h !== r && e.componentWillUnmount(), !e.v) {
        for(var u = e.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        e.h = r, e.v = {
            nodeType: 1,
            parentNode: r,
            childNodes: [],
            __k: {
                __m: u.__m
            },
            contains: function() {
                return !0;
            },
            namespaceURI: r.namespaceURI,
            insertBefore: function(n, t) {
                this.childNodes.push(n), e.h.insertBefore(n, t);
            },
            removeChild: function(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.h.removeChild(n);
            }
        };
    }
    (0, $9SeGy.render)((0, $9SeGy.createElement)($d51ff6fbc6548743$var$Z, {
        context: e.context
    }, n.__v), e.v);
}
function $d51ff6fbc6548743$export$d39a5bbd09211389(n, e) {
    var r = (0, $9SeGy.createElement)($d51ff6fbc6548743$var$Y, {
        __v: n,
        h: e
    });
    return r.containerInfo = e, r;
}
($d51ff6fbc6548743$export$998bcd577473dd93.prototype = new (0, $9SeGy.Component)).__a = function(n) {
    var t = this, e = $d51ff6fbc6548743$var$j(t.__v), r = t.l.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $d51ff6fbc6548743$var$H(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $d51ff6fbc6548743$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var t = (0, $9SeGy.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.l.set(t[e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $d51ff6fbc6548743$export$998bcd577473dd93.prototype.componentDidUpdate = $d51ff6fbc6548743$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.l.forEach(function(t, e) {
        $d51ff6fbc6548743$var$H(n, e, t);
    });
};
var $d51ff6fbc6548743$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $d51ff6fbc6548743$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $d51ff6fbc6548743$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $d51ff6fbc6548743$var$K = /[A-Z0-9]/g, $d51ff6fbc6548743$var$Q = "undefined" != typeof document, $d51ff6fbc6548743$var$X = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $d51ff6fbc6548743$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $9SeGy.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $d51ff6fbc6548743$export$fa8d919ba61d84db(n, t, e) {
    return (0, $9SeGy.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $9SeGy.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $9SeGy.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $d51ff6fbc6548743$var$en = (0, $9SeGy.options).event;
function $d51ff6fbc6548743$var$rn() {}
function $d51ff6fbc6548743$var$un() {
    return this.cancelBubble;
}
function $d51ff6fbc6548743$var$on() {
    return this.defaultPrevented;
}
(0, $9SeGy.options).event = function(n) {
    return $d51ff6fbc6548743$var$en && (n = $d51ff6fbc6548743$var$en(n)), n.persist = $d51ff6fbc6548743$var$rn, n.isPropagationStopped = $d51ff6fbc6548743$var$un, n.isDefaultPrevented = $d51ff6fbc6548743$var$on, n.nativeEvent = n;
};
var $d51ff6fbc6548743$var$ln, $d51ff6fbc6548743$var$cn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $d51ff6fbc6548743$var$fn = (0, $9SeGy.options).vnode;
(0, $9SeGy.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 === e.indexOf("-");
        for(var i in t){
            var l = t[i];
            if (!("value" === i && "defaultValue" in t && null == l || $d51ff6fbc6548743$var$Q && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var c = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === l ? l = "" : "translate" === c && "no" === l ? l = !1 : "o" === c[0] && "n" === c[1] ? "ondoubleclick" === c ? i = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || $d51ff6fbc6548743$var$X(t.type) ? "onfocus" === c ? i = "onfocusin" : "onblur" === c ? i = "onfocusout" : $d51ff6fbc6548743$var$J.test(i) && (i = c) : c = i = "oninput" : o && $d51ff6fbc6548743$var$G.test(i) ? i = i.replace($d51ff6fbc6548743$var$K, "-$&").toLowerCase() : null === l && (l = void 0), "oninput" === c && u[i = c] && (i = "oninputCapture"), u[i] = l;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $9SeGy.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $9SeGy.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $d51ff6fbc6548743$var$cn)) : t.className && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $d51ff6fbc6548743$var$q, $d51ff6fbc6548743$var$fn && $d51ff6fbc6548743$var$fn(n);
};
var $d51ff6fbc6548743$var$an = (0, $9SeGy.options).__r;
(0, $9SeGy.options).__r = function(n) {
    $d51ff6fbc6548743$var$an && $d51ff6fbc6548743$var$an(n), $d51ff6fbc6548743$var$ln = n.__c;
};
var $d51ff6fbc6548743$var$sn = (0, $9SeGy.options).diffed;
(0, $9SeGy.options).diffed = function(n) {
    $d51ff6fbc6548743$var$sn && $d51ff6fbc6548743$var$sn(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $d51ff6fbc6548743$var$ln = null;
};
var $d51ff6fbc6548743$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $d51ff6fbc6548743$var$ln.__n[n.__c].props.value;
            },
            useCallback: (0, $bJrD0.useCallback),
            useContext: (0, $bJrD0.useContext),
            useDebugValue: (0, $bJrD0.useDebugValue),
            useDeferredValue: $d51ff6fbc6548743$export$6a7bc4e911dc01cf,
            useEffect: (0, $bJrD0.useEffect),
            useId: (0, $bJrD0.useId),
            useImperativeHandle: (0, $bJrD0.useImperativeHandle),
            useInsertionEffect: $d51ff6fbc6548743$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $bJrD0.useLayoutEffect),
            useMemo: (0, $bJrD0.useMemo),
            useReducer: (0, $bJrD0.useReducer),
            useRef: (0, $bJrD0.useRef),
            useState: (0, $bJrD0.useState),
            useSyncExternalStore: $d51ff6fbc6548743$export$306c0aa65ff9ec16,
            useTransition: $d51ff6fbc6548743$export$7b286972b8d8ccbf
        }
    }
}, $d51ff6fbc6548743$export$83d89fbfd8236492 = "18.3.1";
function $d51ff6fbc6548743$export$d38cd72104c1f0e9(n) {
    return (0, $9SeGy.createElement).bind(null, n);
}
function $d51ff6fbc6548743$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $d51ff6fbc6548743$var$q;
}
function $d51ff6fbc6548743$export$9522e17588c12572(n) {
    return $d51ff6fbc6548743$export$a8257692ac88316c(n) && n.type === (0, $9SeGy.Fragment);
}
function $d51ff6fbc6548743$export$56885ab8b9c456ab(n) {
    return !!n && "string" == typeof n.displayName && n.displayName.startsWith("Memo(");
}
function $d51ff6fbc6548743$export$e530037191fcd5d7(n) {
    return $d51ff6fbc6548743$export$a8257692ac88316c(n) ? (0, $9SeGy.cloneElement).apply(null, arguments) : n;
}
function $d51ff6fbc6548743$export$502457920280e6be(n) {
    return !!n.__k && ((0, $9SeGy.render)(null, n), !0);
}
function $d51ff6fbc6548743$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $d51ff6fbc6548743$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $d51ff6fbc6548743$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $d51ff6fbc6548743$export$5f8d39834fd61797 = (0, $9SeGy.Fragment), $d51ff6fbc6548743$export$45a5e7f76e0caa8d = $d51ff6fbc6548743$export$a8257692ac88316c, $d51ff6fbc6548743$export$2e2bcd8739ae039 = {
    useState: (0, $bJrD0.useState),
    useId: (0, $bJrD0.useId),
    useReducer: (0, $bJrD0.useReducer),
    useEffect: (0, $bJrD0.useEffect),
    useLayoutEffect: (0, $bJrD0.useLayoutEffect),
    useInsertionEffect: $d51ff6fbc6548743$export$aaabe4eda9ed9969,
    useTransition: $d51ff6fbc6548743$export$7b286972b8d8ccbf,
    useDeferredValue: $d51ff6fbc6548743$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $d51ff6fbc6548743$export$306c0aa65ff9ec16,
    startTransition: $d51ff6fbc6548743$export$7568632d0d33d16d,
    useRef: (0, $bJrD0.useRef),
    useImperativeHandle: (0, $bJrD0.useImperativeHandle),
    useMemo: (0, $bJrD0.useMemo),
    useCallback: (0, $bJrD0.useCallback),
    useContext: (0, $bJrD0.useContext),
    useDebugValue: (0, $bJrD0.useDebugValue),
    version: "18.3.1",
    Children: $d51ff6fbc6548743$export$dca3b0875bd9a954,
    render: $d51ff6fbc6548743$export$b3890eb0ae9dca99,
    hydrate: $d51ff6fbc6548743$export$fa8d919ba61d84db,
    unmountComponentAtNode: $d51ff6fbc6548743$export$502457920280e6be,
    createPortal: $d51ff6fbc6548743$export$d39a5bbd09211389,
    createElement: (0, $9SeGy.createElement),
    createContext: (0, $9SeGy.createContext),
    createFactory: $d51ff6fbc6548743$export$d38cd72104c1f0e9,
    cloneElement: $d51ff6fbc6548743$export$e530037191fcd5d7,
    createRef: (0, $9SeGy.createRef),
    Fragment: (0, $9SeGy.Fragment),
    isValidElement: $d51ff6fbc6548743$export$a8257692ac88316c,
    isElement: $d51ff6fbc6548743$export$45a5e7f76e0caa8d,
    isFragment: $d51ff6fbc6548743$export$9522e17588c12572,
    isMemo: $d51ff6fbc6548743$export$56885ab8b9c456ab,
    findDOMNode: $d51ff6fbc6548743$export$466bfc07425424d5,
    Component: (0, $9SeGy.Component),
    PureComponent: $d51ff6fbc6548743$export$221d75b3f55bb0bd,
    memo: $d51ff6fbc6548743$export$7c73462e0d25e514,
    forwardRef: $d51ff6fbc6548743$export$257a8862b851cb5b,
    flushSync: $d51ff6fbc6548743$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $d51ff6fbc6548743$export$c78a37762a8d58e1,
    StrictMode: $d51ff6fbc6548743$export$5f8d39834fd61797,
    Suspense: $d51ff6fbc6548743$export$74bf444e3cd11ea5,
    SuspenseList: $d51ff6fbc6548743$export$998bcd577473dd93,
    lazy: $d51ff6fbc6548743$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $d51ff6fbc6548743$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $bJrD0);

});
parcelRegister("9SeGy", function(module, exports) {

$parcel$export(module.exports, "options", () => $73048c6b859c8a02$export$41c562ebe57d11e2);
$parcel$export(module.exports, "createElement", () => $73048c6b859c8a02$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $73048c6b859c8a02$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $73048c6b859c8a02$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $73048c6b859c8a02$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $73048c6b859c8a02$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $73048c6b859c8a02$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $73048c6b859c8a02$export$fa8d919ba61d84db);
$parcel$export(module.exports, "cloneElement", () => $73048c6b859c8a02$export$e530037191fcd5d7);
$parcel$export(module.exports, "createContext", () => $73048c6b859c8a02$export$fd42f52fd3ae1109);
$parcel$export(module.exports, "h", () => $73048c6b859c8a02$export$c8a8987d4410bf2d);
var $73048c6b859c8a02$var$n, $73048c6b859c8a02$export$41c562ebe57d11e2, $73048c6b859c8a02$var$u, $73048c6b859c8a02$export$a8257692ac88316c, $73048c6b859c8a02$var$i, $73048c6b859c8a02$var$r, $73048c6b859c8a02$var$o, $73048c6b859c8a02$var$e, $73048c6b859c8a02$var$f, $73048c6b859c8a02$var$c, $73048c6b859c8a02$var$s, $73048c6b859c8a02$var$a, $73048c6b859c8a02$var$h, $73048c6b859c8a02$var$p = {}, $73048c6b859c8a02$var$v = [], $73048c6b859c8a02$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $73048c6b859c8a02$var$d = Array.isArray;
function $73048c6b859c8a02$var$w(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $73048c6b859c8a02$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $73048c6b859c8a02$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $73048c6b859c8a02$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $73048c6b859c8a02$var$m(l, e, i, r, null);
}
function $73048c6b859c8a02$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$73048c6b859c8a02$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $73048c6b859c8a02$export$41c562ebe57d11e2.vnode && $73048c6b859c8a02$export$41c562ebe57d11e2.vnode(e), e;
}
function $73048c6b859c8a02$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $73048c6b859c8a02$export$ffb0004e005737fa(n) {
    return n.children;
}
function $73048c6b859c8a02$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $73048c6b859c8a02$var$S(n, l) {
    if (null == l) return n.__ ? $73048c6b859c8a02$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $73048c6b859c8a02$var$S(n) : null;
}
function $73048c6b859c8a02$var$C(n) {
    if (n.__P && n.__d) {
        var u = n.__v, t = u.__e, i = [], r = [], o = $73048c6b859c8a02$var$w({}, u);
        o.__v = u.__v + 1, $73048c6b859c8a02$export$41c562ebe57d11e2.vnode && $73048c6b859c8a02$export$41c562ebe57d11e2.vnode(o), $73048c6b859c8a02$var$z(n.__P, o, u, n.__n, n.__P.namespaceURI, 32 & u.__u ? [
            t
        ] : null, i, null == t ? $73048c6b859c8a02$var$S(u) : t, !!(32 & u.__u), r), o.__v = u.__v, o.__.__k[o.__i] = o, $73048c6b859c8a02$var$V(i, o, r), u.__e = u.__ = null, o.__e != t && $73048c6b859c8a02$var$M(o);
    }
}
function $73048c6b859c8a02$var$M(n) {
    if (null != (n = n.__) && null != n.__c) return n.__e = n.__c.base = null, n.__k.some(function(l) {
        if (null != l && null != l.__e) return n.__e = n.__c.base = l.__e;
    }), $73048c6b859c8a02$var$M(n);
}
function $73048c6b859c8a02$var$$(n) {
    (!n.__d && (n.__d = !0) && $73048c6b859c8a02$var$i.push(n) && !$73048c6b859c8a02$var$I.__r++ || $73048c6b859c8a02$var$r != $73048c6b859c8a02$export$41c562ebe57d11e2.debounceRendering) && (($73048c6b859c8a02$var$r = $73048c6b859c8a02$export$41c562ebe57d11e2.debounceRendering) || $73048c6b859c8a02$var$o)($73048c6b859c8a02$var$I);
}
function $73048c6b859c8a02$var$I() {
    for(var n, l = 1; $73048c6b859c8a02$var$i.length;)$73048c6b859c8a02$var$i.length > l && $73048c6b859c8a02$var$i.sort($73048c6b859c8a02$var$e), n = $73048c6b859c8a02$var$i.shift(), l = $73048c6b859c8a02$var$i.length, $73048c6b859c8a02$var$C(n);
    $73048c6b859c8a02$var$I.__r = 0;
}
function $73048c6b859c8a02$var$P(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, d, w, g, _, m = t && t.__k || $73048c6b859c8a02$var$v, b = l.length;
    for(f = $73048c6b859c8a02$var$A(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 != y.__i && m[y.__i] || $73048c6b859c8a02$var$p, y.__i = a, g = $73048c6b859c8a02$var$z(n, y, h, i, r, o, e, f, c, s), d = y.__e, y.ref && h.ref != y.ref && (h.ref && $73048c6b859c8a02$var$D(h.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $73048c6b859c8a02$var$H(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : d && (f = d.nextSibling), y.__u &= -7);
    return u.__e = w, f;
}
function $73048c6b859c8a02$var$A(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? o = n.__k[r] = $73048c6b859c8a02$var$m(null, o, null, null, null) : $73048c6b859c8a02$var$d(o) ? o = n.__k[r] = $73048c6b859c8a02$var$m($73048c6b859c8a02$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? o = n.__k[r] = $73048c6b859c8a02$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $73048c6b859c8a02$var$T(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $73048c6b859c8a02$var$S(e)), $73048c6b859c8a02$var$E(e, e));
    return t;
}
function $73048c6b859c8a02$var$H(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $73048c6b859c8a02$var$H(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $73048c6b859c8a02$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $73048c6b859c8a02$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($73048c6b859c8a02$var$d(n) ? n.some(function(n) {
        $73048c6b859c8a02$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $73048c6b859c8a02$var$T(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $73048c6b859c8a02$var$j(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $73048c6b859c8a02$var$y.test(l) ? u : u + "px";
}
function $73048c6b859c8a02$var$F(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $73048c6b859c8a02$var$j(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $73048c6b859c8a02$var$j(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($73048c6b859c8a02$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $73048c6b859c8a02$var$c, n.addEventListener(l, r ? $73048c6b859c8a02$var$a : $73048c6b859c8a02$var$s, r)) : n.removeEventListener(l, r ? $73048c6b859c8a02$var$a : $73048c6b859c8a02$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $73048c6b859c8a02$var$O(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $73048c6b859c8a02$var$c++;
            else if (u.t < t.u) return;
            return t($73048c6b859c8a02$export$41c562ebe57d11e2.event ? $73048c6b859c8a02$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $73048c6b859c8a02$var$z(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, y, _, m, b, S, C, M, $, I, A, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $73048c6b859c8a02$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (S = u.props, C = "prototype" in T && T.prototype.render, M = (a = T.contextType) && i[a.__c], $ = a ? M ? M.props.value : a.__ : i, t.__c ? b = (h = u.__c = t.__c).__ = h.__E : (C ? u.__c = h = new T(S, $) : (u.__c = h = new $73048c6b859c8a02$export$16fa2f45be04daa8(S, $), h.constructor = T, h.render = $73048c6b859c8a02$var$G), M && M.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), C && null == h.__s && (h.__s = h.state), C && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $73048c6b859c8a02$var$w({}, h.__s)), $73048c6b859c8a02$var$w(h.__s, T.getDerivedStateFromProps(S, h.__s))), y = h.props, _ = h.state, h.__v = u, p) C && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), C && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (C && null == T.getDerivedStateFromProps && S !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(S, $), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(S, h.__s, $)) {
                u.__v != t.__v && (h.props = S, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $73048c6b859c8a02$var$v.push.apply(h.__h, h._sb), h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(S, h.__s, $), C && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(y, _, m);
            });
        }
        if (h.context = $, h.props = S, h.__P = n, h.__e = !1, I = $73048c6b859c8a02$export$41c562ebe57d11e2.__r, A = 0, C) h.state = h.__s, h.__d = !1, I && I(u), a = h.render(h.props, h.state, h.context), $73048c6b859c8a02$var$v.push.apply(h.__h, h._sb), h._sb = [];
        else do h.__d = !1, I && I(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $73048c6b859c8a02$var$w($73048c6b859c8a02$var$w({}, i), h.getChildContext())), C && !p && null != h.getSnapshotBeforeUpdate && (m = h.getSnapshotBeforeUpdate(y, _)), H = null != a && a.type === $73048c6b859c8a02$export$ffb0004e005737fa && null == a.key ? $73048c6b859c8a02$var$q(a.props.children) : a, f = $73048c6b859c8a02$var$P(n, $73048c6b859c8a02$var$d(H) ? H : [
            H
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), b && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(L = o.length; L--;)$73048c6b859c8a02$var$g(o[L]);
                $73048c6b859c8a02$var$N(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $73048c6b859c8a02$var$N(u);
        $73048c6b859c8a02$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $73048c6b859c8a02$var$B(t.__e, u, t, i, r, o, e, c, s);
    return (a = $73048c6b859c8a02$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $73048c6b859c8a02$var$N(n) {
    n && (n.__c && (n.__c.__e = !0), n.__k && n.__k.some($73048c6b859c8a02$var$N));
}
function $73048c6b859c8a02$var$V(n, u, t) {
    for(var i = 0; i < t.length; i++)$73048c6b859c8a02$var$D(t[i], t[++i], t[++i]);
    $73048c6b859c8a02$export$41c562ebe57d11e2.__c && $73048c6b859c8a02$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $73048c6b859c8a02$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $73048c6b859c8a02$var$q(n) {
    return "object" != typeof n || null == n || n.__b > 0 ? n : $73048c6b859c8a02$var$d(n) ? n.map($73048c6b859c8a02$var$q) : $73048c6b859c8a02$var$w({}, n);
}
function $73048c6b859c8a02$var$B(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, w, _, m, b = i.props || $73048c6b859c8a02$var$p, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((w = e[a]) && "setAttribute" in w == !!x && (x ? w.localName == x : 3 == w.nodeType)) {
            u = w, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($73048c6b859c8a02$export$41c562ebe57d11e2.__m && $73048c6b859c8a02$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $73048c6b859c8a02$var$n.call(u.childNodes), !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(w = u.attributes[a]).name] = w.value;
        for(a in b)w = b[a], "dangerouslySetInnerHTML" == a ? v = w : "children" == a || a in k || "value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k || $73048c6b859c8a02$var$F(u, a, null, w, o);
        for(a in k)w = k[a], "children" == a ? y = w : "dangerouslySetInnerHTML" == a ? h = w : "value" == a ? _ = w : "checked" == a ? m = w : c && "function" != typeof w || b[a] === w || $73048c6b859c8a02$var$F(u, a, w, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $73048c6b859c8a02$var$P("template" == t.type ? u.content : u, $73048c6b859c8a02$var$d(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $73048c6b859c8a02$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$73048c6b859c8a02$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $73048c6b859c8a02$var$F(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $73048c6b859c8a02$var$F(u, a, m, b[a], o));
    }
    return u;
}
function $73048c6b859c8a02$var$D(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $73048c6b859c8a02$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $73048c6b859c8a02$var$E(n, u, t) {
    var i, r;
    if ($73048c6b859c8a02$export$41c562ebe57d11e2.unmount && $73048c6b859c8a02$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $73048c6b859c8a02$var$D(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $73048c6b859c8a02$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $73048c6b859c8a02$var$E(i[r], u, t || "function" != typeof n.type);
    t || $73048c6b859c8a02$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $73048c6b859c8a02$var$G(n, l, u) {
    return this.constructor(n, u);
}
function $73048c6b859c8a02$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $73048c6b859c8a02$export$41c562ebe57d11e2.__ && $73048c6b859c8a02$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $73048c6b859c8a02$var$z(t, u = (!r && i || t).__k = $73048c6b859c8a02$export$c8a8987d4410bf2d($73048c6b859c8a02$export$ffb0004e005737fa, null, [
        u
    ]), o || $73048c6b859c8a02$var$p, $73048c6b859c8a02$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $73048c6b859c8a02$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $73048c6b859c8a02$var$V(e, u, f);
}
function $73048c6b859c8a02$export$fa8d919ba61d84db(n, l) {
    $73048c6b859c8a02$export$b3890eb0ae9dca99(n, l, $73048c6b859c8a02$export$fa8d919ba61d84db);
}
function $73048c6b859c8a02$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $73048c6b859c8a02$var$w({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $73048c6b859c8a02$var$n.call(arguments, 2) : t), $73048c6b859c8a02$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $73048c6b859c8a02$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $73048c6b859c8a02$var$$(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $73048c6b859c8a02$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$73048c6b859c8a02$var$n = $73048c6b859c8a02$var$v.slice, $73048c6b859c8a02$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $73048c6b859c8a02$var$u = 0, $73048c6b859c8a02$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $73048c6b859c8a02$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $73048c6b859c8a02$var$w({}, this.state), "function" == typeof n && (n = n($73048c6b859c8a02$var$w({}, u), this.props)), n && $73048c6b859c8a02$var$w(u, n), null != n && this.__v && (l && this._sb.push(l), $73048c6b859c8a02$var$$(this));
}, $73048c6b859c8a02$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $73048c6b859c8a02$var$$(this));
}, $73048c6b859c8a02$export$16fa2f45be04daa8.prototype.render = $73048c6b859c8a02$export$ffb0004e005737fa, $73048c6b859c8a02$var$i = [], $73048c6b859c8a02$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $73048c6b859c8a02$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $73048c6b859c8a02$var$I.__r = 0, $73048c6b859c8a02$var$f = /(PointerCapture)$|Capture$/i, $73048c6b859c8a02$var$c = 0, $73048c6b859c8a02$var$s = $73048c6b859c8a02$var$O(!1), $73048c6b859c8a02$var$a = $73048c6b859c8a02$var$O(!0), $73048c6b859c8a02$var$h = 0;

});

parcelRegister("bJrD0", function(module, exports) {

$parcel$export(module.exports, "useState", () => $88a9540d1aad6464$export$60241385465d0a34);
$parcel$export(module.exports, "useReducer", () => $88a9540d1aad6464$export$13e3392192263954);
$parcel$export(module.exports, "useEffect", () => $88a9540d1aad6464$export$6d9c69b0de29b591);
$parcel$export(module.exports, "useLayoutEffect", () => $88a9540d1aad6464$export$e5c5a5f917a5871c);
$parcel$export(module.exports, "useRef", () => $88a9540d1aad6464$export$b8f5890fc79d6aca);
$parcel$export(module.exports, "useMemo", () => $88a9540d1aad6464$export$1538c33de8887b59);
$parcel$export(module.exports, "useImperativeHandle", () => $88a9540d1aad6464$export$d5a552a76deda3c2);
$parcel$export(module.exports, "useCallback", () => $88a9540d1aad6464$export$35808ee640e87ca7);
$parcel$export(module.exports, "useContext", () => $88a9540d1aad6464$export$fae74005e78b1a27);
$parcel$export(module.exports, "useDebugValue", () => $88a9540d1aad6464$export$dc8fbce3eb94dc1e);
$parcel$export(module.exports, "useErrorBoundary", () => $88a9540d1aad6464$export$c052f6604b7d51fe);
$parcel$export(module.exports, "useId", () => $88a9540d1aad6464$export$f680877a34711e37);

var $9SeGy = parcelRequire("9SeGy");
var $88a9540d1aad6464$var$t, $88a9540d1aad6464$var$r, $88a9540d1aad6464$var$u, $88a9540d1aad6464$var$i, $88a9540d1aad6464$var$o = 0, $88a9540d1aad6464$var$f = [], $88a9540d1aad6464$var$c = (0, $9SeGy.options), $88a9540d1aad6464$var$e = $88a9540d1aad6464$var$c.__b, $88a9540d1aad6464$var$a = $88a9540d1aad6464$var$c.__r, $88a9540d1aad6464$var$v = $88a9540d1aad6464$var$c.diffed, $88a9540d1aad6464$var$l = $88a9540d1aad6464$var$c.__c, $88a9540d1aad6464$var$m = $88a9540d1aad6464$var$c.unmount, $88a9540d1aad6464$var$s = $88a9540d1aad6464$var$c.__;
function $88a9540d1aad6464$var$p(n, t) {
    $88a9540d1aad6464$var$c.__h && $88a9540d1aad6464$var$c.__h($88a9540d1aad6464$var$r, n, $88a9540d1aad6464$var$o || t), $88a9540d1aad6464$var$o = 0;
    var u = $88a9540d1aad6464$var$r.__H || ($88a9540d1aad6464$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $88a9540d1aad6464$export$60241385465d0a34(n) {
    return $88a9540d1aad6464$var$o = 1, $88a9540d1aad6464$export$13e3392192263954($88a9540d1aad6464$var$D, n);
}
function $88a9540d1aad6464$export$13e3392192263954(n, u, i) {
    var o = $88a9540d1aad6464$var$p($88a9540d1aad6464$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $88a9540d1aad6464$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $88a9540d1aad6464$var$r, !$88a9540d1aad6464$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.some(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $88a9540d1aad6464$var$r.__f = !0;
        var c = $88a9540d1aad6464$var$r.shouldComponentUpdate, e = $88a9540d1aad6464$var$r.componentWillUpdate;
        $88a9540d1aad6464$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $88a9540d1aad6464$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $88a9540d1aad6464$export$6d9c69b0de29b591(n, u) {
    var i = $88a9540d1aad6464$var$p($88a9540d1aad6464$var$t++, 3);
    !$88a9540d1aad6464$var$c.__s && $88a9540d1aad6464$var$C(i.__H, u) && (i.__ = n, i.u = u, $88a9540d1aad6464$var$r.__H.__h.push(i));
}
function $88a9540d1aad6464$export$e5c5a5f917a5871c(n, u) {
    var i = $88a9540d1aad6464$var$p($88a9540d1aad6464$var$t++, 4);
    !$88a9540d1aad6464$var$c.__s && $88a9540d1aad6464$var$C(i.__H, u) && (i.__ = n, i.u = u, $88a9540d1aad6464$var$r.__h.push(i));
}
function $88a9540d1aad6464$export$b8f5890fc79d6aca(n) {
    return $88a9540d1aad6464$var$o = 5, $88a9540d1aad6464$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $88a9540d1aad6464$export$d5a552a76deda3c2(n, t, r) {
    $88a9540d1aad6464$var$o = 6, $88a9540d1aad6464$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $88a9540d1aad6464$export$1538c33de8887b59(n, r) {
    var u = $88a9540d1aad6464$var$p($88a9540d1aad6464$var$t++, 7);
    return $88a9540d1aad6464$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $88a9540d1aad6464$export$35808ee640e87ca7(n, t) {
    return $88a9540d1aad6464$var$o = 8, $88a9540d1aad6464$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $88a9540d1aad6464$export$fae74005e78b1a27(n) {
    var u = $88a9540d1aad6464$var$r.context[n.__c], i = $88a9540d1aad6464$var$p($88a9540d1aad6464$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($88a9540d1aad6464$var$r)), u.props.value) : n.__;
}
function $88a9540d1aad6464$export$dc8fbce3eb94dc1e(n, t) {
    $88a9540d1aad6464$var$c.useDebugValue && $88a9540d1aad6464$var$c.useDebugValue(t ? t(n) : n);
}
function $88a9540d1aad6464$export$c052f6604b7d51fe(n) {
    var u = $88a9540d1aad6464$var$p($88a9540d1aad6464$var$t++, 10), i = $88a9540d1aad6464$export$60241385465d0a34();
    return u.__ = n, $88a9540d1aad6464$var$r.componentDidCatch || ($88a9540d1aad6464$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $88a9540d1aad6464$export$f680877a34711e37() {
    var n = $88a9540d1aad6464$var$p($88a9540d1aad6464$var$t++, 11);
    if (!n.__) {
        for(var u = $88a9540d1aad6464$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $88a9540d1aad6464$var$j() {
    for(var n; n = $88a9540d1aad6464$var$f.shift();){
        var t = n.__H;
        if (n.__P && t) try {
            t.__h.some($88a9540d1aad6464$var$z), t.__h.some($88a9540d1aad6464$var$B), t.__h = [];
        } catch (r) {
            t.__h = [], $88a9540d1aad6464$var$c.__e(r, n.__v);
        }
    }
}
$88a9540d1aad6464$var$c.__b = function(n) {
    $88a9540d1aad6464$var$r = null, $88a9540d1aad6464$var$e && $88a9540d1aad6464$var$e(n);
}, $88a9540d1aad6464$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $88a9540d1aad6464$var$s && $88a9540d1aad6464$var$s(n, t);
}, $88a9540d1aad6464$var$c.__r = function(n) {
    $88a9540d1aad6464$var$a && $88a9540d1aad6464$var$a(n), $88a9540d1aad6464$var$t = 0;
    var i = ($88a9540d1aad6464$var$r = n.__c).__H;
    i && ($88a9540d1aad6464$var$u === $88a9540d1aad6464$var$r ? (i.__h = [], $88a9540d1aad6464$var$r.__h = [], i.__.some(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.some($88a9540d1aad6464$var$z), i.__h.some($88a9540d1aad6464$var$B), i.__h = [], $88a9540d1aad6464$var$t = 0)), $88a9540d1aad6464$var$u = $88a9540d1aad6464$var$r;
}, $88a9540d1aad6464$var$c.diffed = function(n) {
    $88a9540d1aad6464$var$v && $88a9540d1aad6464$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $88a9540d1aad6464$var$f.push(t) && $88a9540d1aad6464$var$i === $88a9540d1aad6464$var$c.requestAnimationFrame || (($88a9540d1aad6464$var$i = $88a9540d1aad6464$var$c.requestAnimationFrame) || $88a9540d1aad6464$var$w)($88a9540d1aad6464$var$j)), t.__H.__.some(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $88a9540d1aad6464$var$u = $88a9540d1aad6464$var$r = null;
}, $88a9540d1aad6464$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.some($88a9540d1aad6464$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $88a9540d1aad6464$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $88a9540d1aad6464$var$c.__e(r, n.__v);
        }
    }), $88a9540d1aad6464$var$l && $88a9540d1aad6464$var$l(n, t);
}, $88a9540d1aad6464$var$c.unmount = function(n) {
    $88a9540d1aad6464$var$m && $88a9540d1aad6464$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.some(function(n) {
        try {
            $88a9540d1aad6464$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $88a9540d1aad6464$var$c.__e(t, r.__v));
};
var $88a9540d1aad6464$var$k = "function" == typeof requestAnimationFrame;
function $88a9540d1aad6464$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $88a9540d1aad6464$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $88a9540d1aad6464$var$k && (t = requestAnimationFrame(r));
}
function $88a9540d1aad6464$var$z(n) {
    var t = $88a9540d1aad6464$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $88a9540d1aad6464$var$r = t;
}
function $88a9540d1aad6464$var$B(n) {
    var t = $88a9540d1aad6464$var$r;
    n.__c = n.__(), $88a9540d1aad6464$var$r = t;
}
function $88a9540d1aad6464$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $88a9540d1aad6464$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});


parcelRegister("diC8V", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $9aea8b31228977c0$export$306c0aa65ff9ec16, (v) => $9aea8b31228977c0$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aea8b31228977c0$export$306c0aa65ff9ec16;
"use strict";
parcelRequire("iisr1");
var $bJrD0 = parcelRequire("bJrD0");
var $iisr1 = parcelRequire("iisr1");
function $9aea8b31228977c0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $9aea8b31228977c0$var$objectIs = "function" === typeof Object.is ? Object.is : $9aea8b31228977c0$var$is, $9aea8b31228977c0$var$useState = $bJrD0.useState, $9aea8b31228977c0$var$useEffect = $bJrD0.useEffect, $9aea8b31228977c0$var$useLayoutEffect = $bJrD0.useLayoutEffect, $9aea8b31228977c0$var$useDebugValue = $bJrD0.useDebugValue;
function $9aea8b31228977c0$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $9aea8b31228977c0$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $9aea8b31228977c0$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $9aea8b31228977c0$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $9aea8b31228977c0$var$useEffect(function() {
        $9aea8b31228977c0$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $9aea8b31228977c0$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $9aea8b31228977c0$var$useDebugValue(value);
    return value;
}
function $9aea8b31228977c0$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$9aea8b31228977c0$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $9aea8b31228977c0$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $9aea8b31228977c0$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $9aea8b31228977c0$var$useSyncExternalStore$1 : $9aea8b31228977c0$var$useSyncExternalStore$2;
$9aea8b31228977c0$export$306c0aa65ff9ec16 = void 0 !== $iisr1.useSyncExternalStore ? $iisr1.useSyncExternalStore : $9aea8b31228977c0$var$shim;

});

parcelRegister("236az", function(module, exports) {

$parcel$export(module.exports, "default", () => $17e0a5b6ecfde368$export$2e2bcd8739ae039);

var $iVn1G = parcelRequire("iVn1G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $iVn1G.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $17e0a5b6ecfde368$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRegister("iVn1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6f6965627b2efc$export$2e2bcd8739ae039);

var $6UaoQ = parcelRequire("6UaoQ");
/** Detect free variable `self`. */ var $dc6f6965627b2efc$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $dc6f6965627b2efc$var$root = (0, $6UaoQ.default) || $dc6f6965627b2efc$var$freeSelf || Function('return this')();
var $dc6f6965627b2efc$export$2e2bcd8739ae039 = $dc6f6965627b2efc$var$root;

});
parcelRegister("6UaoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $50700a371abeb233$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $50700a371abeb233$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $50700a371abeb233$export$2e2bcd8739ae039 = $50700a371abeb233$var$freeGlobal;

});



parcelRegister("gOuvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3d8fb097699e6b0$export$2e2bcd8739ae039);

var $iVn1G = parcelRequire("iVn1G");

var $eJe73 = parcelRequire("eJe73");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $iVn1G.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $eJe73.default);
var $c3d8fb097699e6b0$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("eJe73", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab90372cfefc2cc1$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $ab90372cfefc2cc1$var$stubFalse() {
    return false;
}
var $ab90372cfefc2cc1$export$2e2bcd8739ae039 = $ab90372cfefc2cc1$var$stubFalse;

});


parcelRegister("jiWCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0dd2b649a289ec8$export$2e2bcd8739ae039);

var $6UaoQ = parcelRequire("6UaoQ");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $6UaoQ.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $e0dd2b649a289ec8$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("4nFPU", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("dvnvv", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

parcelRegister("3C1av", function(module, exports) {
module.exports = import("3b1Jt").then(()=>parcelRequire('1VIfx'));

});


var $9SeGy = parcelRequire("9SeGy");

var $9SeGy = parcelRequire("9SeGy");
const $7e84e1a08353bb30$var$alert = {
    remove: (id)=>document.getElementById(id).outerHTML = "",
    add: (text, alertStyle = "alert-success", countdown = 5000)=>{
        if (!text) return;
        let alertNode = document.createElement("DIV");
        alertNode.id = $7e84e1a08353bb30$var$alert.hash(text);
        alertNode.innerHTML = text;
        alertNode.classList.add("global-alert", "alert", alertStyle);
        document.body.appendChild(alertNode);
        setTimeout(()=>$7e84e1a08353bb30$var$alert.remove(alertNode.id), countdown);
    },
    hash: (str)=>{
        let hash = 0;
        if (str.length == 0) return hash;
        for(let i = 0; i < str.length; i++){
            let char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
};
var $7e84e1a08353bb30$export$2e2bcd8739ae039 = $7e84e1a08353bb30$var$alert;



const $a43f12068c4c782d$var$storage = {
    usage: ()=>{
        let total = 0;
        let k;
        for(k in localStorage)if (Object.prototype.hasOwnProperty.call(localStorage, k)) total += (localStorage[k].length + k.length) * 2;
        return total;
    },
    createStorageBox: (data, metadata = null)=>({
            data: data,
            createdAt: Date.now(),
            metadata: metadata
        }),
    remove: (id)=>localStorage.removeItem(id),
    set: (id, data, metadata = null)=>{
        localStorage.setItem(id, JSON.stringify($a43f12068c4c782d$var$storage.createStorageBox(data, metadata)));
        return Promise.resolve(id);
    },
    get: (id)=>{
        let data = localStorage.getItem(id);
        if (data != null) {
            data = JSON.parse(data);
            if (Object.prototype.hasOwnProperty.call(data, "data")) return new Promise((r)=>r(data.data));
        }
        return new Promise((r)=>r(null));
    },
    reset: ()=>localStorage.clear() && window.dispatchEvent(new CustomEvent("resetStorage"))
};
var $a43f12068c4c782d$export$2e2bcd8739ae039 = $a43f12068c4c782d$var$storage;





let $a31e1c96daaf01b5$var$listenerQueue = [];
let $a31e1c96daaf01b5$var$lqIndex = 0;
const $a31e1c96daaf01b5$var$QUEUE_ITEMS_PER_LISTENER = 4;
let $a31e1c96daaf01b5$export$8a255bebea64f637 = 0;
const $a31e1c96daaf01b5$export$5fb5cc0d078610b = (initialValue)=>{
    let listeners = [];
    let $atom = {
        get () {
            if (!$atom.lc) $atom.listen(()=>{})();
            return $atom.value;
        },
        lc: 0,
        listen (listener) {
            $atom.lc = listeners.push(listener);
            return ()=>{
                for(let i = $a31e1c96daaf01b5$var$lqIndex + $a31e1c96daaf01b5$var$QUEUE_ITEMS_PER_LISTENER; i < $a31e1c96daaf01b5$var$listenerQueue.length;)if ($a31e1c96daaf01b5$var$listenerQueue[i] === listener) $a31e1c96daaf01b5$var$listenerQueue.splice(i, $a31e1c96daaf01b5$var$QUEUE_ITEMS_PER_LISTENER);
                else i += $a31e1c96daaf01b5$var$QUEUE_ITEMS_PER_LISTENER;
                let index = listeners.indexOf(listener);
                if (~index) {
                    listeners.splice(index, 1);
                    if (!--$atom.lc) $atom.off();
                }
            };
        },
        notify (oldValue, changedKey) {
            $a31e1c96daaf01b5$export$8a255bebea64f637++;
            let runListenerQueue = !$a31e1c96daaf01b5$var$listenerQueue.length;
            for (let listener of listeners)$a31e1c96daaf01b5$var$listenerQueue.push(listener, $atom.value, oldValue, changedKey);
            if (runListenerQueue) {
                for($a31e1c96daaf01b5$var$lqIndex = 0; $a31e1c96daaf01b5$var$lqIndex < $a31e1c96daaf01b5$var$listenerQueue.length; $a31e1c96daaf01b5$var$lqIndex += $a31e1c96daaf01b5$var$QUEUE_ITEMS_PER_LISTENER)$a31e1c96daaf01b5$var$listenerQueue[$a31e1c96daaf01b5$var$lqIndex]($a31e1c96daaf01b5$var$listenerQueue[$a31e1c96daaf01b5$var$lqIndex + 1], $a31e1c96daaf01b5$var$listenerQueue[$a31e1c96daaf01b5$var$lqIndex + 2], $a31e1c96daaf01b5$var$listenerQueue[$a31e1c96daaf01b5$var$lqIndex + 3]);
                $a31e1c96daaf01b5$var$listenerQueue.length = 0;
            }
        },
        /* It will be called on last listener unsubscribing.
       We will redefine it in onMount and onStop. */ off () {},
        set (newValue) {
            let oldValue = $atom.value;
            if (oldValue !== newValue) {
                $atom.value = newValue;
                $atom.notify(oldValue);
            }
        },
        subscribe (listener) {
            let unbind = $atom.listen(listener);
            listener($atom.value);
            return unbind;
        },
        value: initialValue
    };
    return $atom;
};
const $a31e1c96daaf01b5$export$2bb990bb90890844 = (store)=>store;


const $5332018adf75499b$export$a94cb3a0c5b0c060 = (0, $a31e1c96daaf01b5$export$5fb5cc0d078610b)({});
function $5332018adf75499b$export$8ddaddf355aae59c(me) {
    $5332018adf75499b$export$a94cb3a0c5b0c060.set(me);
}
function $5332018adf75499b$export$cca2f5a1ccdd2100() {
    $5332018adf75499b$export$a94cb3a0c5b0c060.set({});
}


const $cb95bcae1947788f$var$isString = (obj)=>typeof obj === 'string';
const $cb95bcae1947788f$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $cb95bcae1947788f$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $cb95bcae1947788f$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $cb95bcae1947788f$var$lastOfPathSeparatorRegExp = /###/g;
const $cb95bcae1947788f$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($cb95bcae1947788f$var$lastOfPathSeparatorRegExp, '.') : key;
const $cb95bcae1947788f$var$canNotTraverseDeeper = (object)=>!object || $cb95bcae1947788f$var$isString(object);
const $cb95bcae1947788f$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$cb95bcae1947788f$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($cb95bcae1947788f$var$canNotTraverseDeeper(object)) return {};
        const key = $cb95bcae1947788f$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($cb95bcae1947788f$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $cb95bcae1947788f$var$cleanKey(stack[stackIndex])
    };
};
const $cb95bcae1947788f$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $cb95bcae1947788f$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $cb95bcae1947788f$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $cb95bcae1947788f$var$getLastOfPath(object, p, Object);
        if (last?.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $cb95bcae1947788f$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $cb95bcae1947788f$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $cb95bcae1947788f$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $cb95bcae1947788f$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $cb95bcae1947788f$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $cb95bcae1947788f$var$getPath(data, key);
    if (value !== undefined) return value;
    return $cb95bcae1947788f$var$getPath(defaultData, key);
};
const $cb95bcae1947788f$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($cb95bcae1947788f$var$isString(target[prop]) || target[prop] instanceof String || $cb95bcae1947788f$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $cb95bcae1947788f$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $cb95bcae1947788f$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $cb95bcae1947788f$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $cb95bcae1947788f$var$escape = (data)=>{
    if ($cb95bcae1947788f$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$cb95bcae1947788f$var$_entityMap[s]);
    return data;
};
class $cb95bcae1947788f$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $cb95bcae1947788f$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $cb95bcae1947788f$var$looksLikeObjectPathRegExpCache = new $cb95bcae1947788f$var$RegExpCache(20);
const $cb95bcae1947788f$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $cb95bcae1947788f$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $cb95bcae1947788f$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $cb95bcae1947788f$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $cb95bcae1947788f$var$getCleanedCode = (code)=>code?.replace('_', '-');
const $cb95bcae1947788f$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        console?.[type]?.apply?.(console, args);
    }
};
class $cb95bcae1947788f$var$Logger {
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $cb95bcae1947788f$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($cb95bcae1947788f$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $cb95bcae1947788f$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $cb95bcae1947788f$var$Logger(this.logger, options);
    }
}
var $cb95bcae1947788f$var$baseLogger = new $cb95bcae1947788f$var$Logger();
class $cb95bcae1947788f$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $cb95bcae1947788f$var$ResourceStore extends $cb95bcae1947788f$var$EventEmitter {
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($cb95bcae1947788f$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $cb95bcae1947788f$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$cb95bcae1947788f$var$isString(key)) return result;
        return $cb95bcae1947788f$var$deepFind(this.data?.[lng]?.[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $cb95bcae1947788f$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($cb95bcae1947788f$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $cb95bcae1947788f$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $cb95bcae1947788f$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $cb95bcae1947788f$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $cb95bcae1947788f$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            value = this.processors[processor]?.process(value, key, options, translator) ?? value;
        });
        return value;
    }
};
const $cb95bcae1947788f$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $cb95bcae1947788f$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        proxy?.revoke?.();
        if (key === $cb95bcae1947788f$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $cb95bcae1947788f$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$cb95bcae1947788f$var$PATH_KEY]: path } = selector($cb95bcae1947788f$var$createProxy());
    return path.join(opts?.keySeparator ?? '.');
}
const $cb95bcae1947788f$var$checkedLoadedFor = {};
const $cb95bcae1947788f$var$shouldHandleAsObject = (res)=>!$cb95bcae1947788f$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $cb95bcae1947788f$var$Translator extends $cb95bcae1947788f$var$EventEmitter {
    constructor(services, options = {}){
        super();
        $cb95bcae1947788f$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $cb95bcae1947788f$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = {
            ...o
        };
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if (resolved?.res === undefined) return false;
        const isObject = $cb95bcae1947788f$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$cb95bcae1947788f$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $cb95bcae1947788f$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $cb95bcae1947788f$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? {
            ...o
        } : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = {
            ...opt
        };
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $cb95bcae1947788f$export$ec2cccc18ab4c2ae(keys, {
            ...this.options,
            ...opt
        });
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng?.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved?.res;
        const resUsedKey = resolved?.usedKey || key;
        const resExactUsedKey = resolved?.exactUsedKey || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$cb95bcae1947788f$var$isString(opt.count);
        const hasDefaultValue = $cb95bcae1947788f$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $cb95bcae1947788f$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($cb95bcae1947788f$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, {
                    ...opt,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, {
                        ...opt,
                        defaultValue: $cb95bcae1947788f$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    });
                    else copy[m] = this.translate(deepKey, {
                        ...opt,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $cb95bcae1947788f$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...opt,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if (this.backendConnector?.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        if (this.i18nFormat?.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...opt
        }, opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            if (opt.interpolation) this.interpolator.init({
                ...opt,
                interpolation: {
                    ...this.options.interpolation,
                    ...opt.interpolation
                }
            });
            const skipOnVariables = $cb95bcae1947788f$var$isString(res) && (opt?.interpolation?.skipOnVariables !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$cb95bcae1947788f$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if (lastKey?.[0] === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $cb95bcae1947788f$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && postProcessorNames?.length && opt.applyPostProcessor !== false) res = $cb95bcae1947788f$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(opt)
            },
            ...opt
        } : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($cb95bcae1947788f$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$cb95bcae1947788f$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($cb95bcae1947788f$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$cb95bcae1947788f$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(usedNS)) {
                    $cb95bcae1947788f$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat?.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        if (this.i18nFormat?.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$cb95bcae1947788f$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
class $cb95bcae1947788f$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $cb95bcae1947788f$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $cb95bcae1947788f$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $cb95bcae1947788f$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($cb95bcae1947788f$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($cb95bcae1947788f$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($cb95bcae1947788f$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($cb95bcae1947788f$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
const $cb95bcae1947788f$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $cb95bcae1947788f$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $cb95bcae1947788f$var$PluralResolver {
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $cb95bcae1947788f$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $cb95bcae1947788f$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (typeof Intl === 'undefined') {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $cb95bcae1947788f$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $cb95bcae1947788f$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return rule?.resolvedOptions().pluralCategories.length > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$cb95bcae1947788f$var$suffixesOrder[pluralCategory1] - $cb95bcae1947788f$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
}
const $cb95bcae1947788f$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $cb95bcae1947788f$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $cb95bcae1947788f$var$isString(key)) {
        path = $cb95bcae1947788f$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $cb95bcae1947788f$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $cb95bcae1947788f$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $cb95bcae1947788f$var$Interpolator {
    constructor(options = {}){
        this.logger = $cb95bcae1947788f$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options?.interpolation?.format || ((value)=>value);
        this.init(options);
    }
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $cb95bcae1947788f$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $cb95bcae1947788f$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $cb95bcae1947788f$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $cb95bcae1947788f$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $cb95bcae1947788f$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $cb95bcae1947788f$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $cb95bcae1947788f$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp?.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $cb95bcae1947788f$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($cb95bcae1947788f$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options?.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options?.interpolation?.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$cb95bcae1947788f$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $cb95bcae1947788f$var$regexSafe(this.escape(val)) : $cb95bcae1947788f$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $cb95bcae1947788f$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$cb95bcae1947788f$var$isString(value) && !this.useRawValueToEscape) value = $cb95bcae1947788f$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${$cb95bcae1947788f$var$regexEscape(sep)}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if ((matchedSingleQuotes?.length ?? 0) % 2 === 0 && !matchedDoubleQuotes || (matchedDoubleQuotes?.length ?? 0) % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$cb95bcae1947788f$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$cb95bcae1947788f$var$isString(value)) return value;
            if (!$cb95bcae1947788f$var$isString(value)) value = $cb95bcae1947788f$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $cb95bcae1947788f$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $cb95bcae1947788f$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = {
            ...optForCache,
            [o.interpolationkey]: undefined
        };
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($cb95bcae1947788f$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $cb95bcae1947788f$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($cb95bcae1947788f$var$getCleanedCode(l), o)(v);
class $cb95bcae1947788f$var$Formatter {
    constructor(options = {}){
        this.logger = $cb95bcae1947788f$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $cb95bcae1947788f$var$createCachedFormatter : $cb95bcae1947788f$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $cb95bcae1947788f$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $cb95bcae1947788f$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options?.formatParams?.[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $cb95bcae1947788f$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $cb95bcae1947788f$var$Connector extends $cb95bcae1947788f$var$EventEmitter {
    constructor(backend, store, services, options = {}){
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $cb95bcae1947788f$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        this.backend?.init?.(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $cb95bcae1947788f$var$pushPath(q.loaded, [
                lng
            ], ns);
            $cb95bcae1947788f$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($cb95bcae1947788f$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($cb95bcae1947788f$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend?.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $cb95bcae1947788f$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($cb95bcae1947788f$var$isString(args[1])) ret.defaultValue = args[1];
            if ($cb95bcae1947788f$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $cb95bcae1947788f$var$transformOptions = (options)=>{
    if ($cb95bcae1947788f$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($cb95bcae1947788f$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($cb95bcae1947788f$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs?.indexOf?.('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $cb95bcae1947788f$var$noop = ()=>{};
const $cb95bcae1947788f$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
const $cb95bcae1947788f$var$SUPPORT_NOTICE_KEY = '__i18next_supportNoticeShown';
const $cb95bcae1947788f$var$getSupportNoticeShown = ()=>typeof globalThis !== 'undefined' && !!globalThis[$cb95bcae1947788f$var$SUPPORT_NOTICE_KEY];
const $cb95bcae1947788f$var$setSupportNoticeShown = ()=>{
    if (typeof globalThis !== 'undefined') globalThis[$cb95bcae1947788f$var$SUPPORT_NOTICE_KEY] = true;
};
const $cb95bcae1947788f$var$usesLocize = (inst)=>{
    if (inst?.modules?.backend?.name?.indexOf('Locize') > 0) return true;
    if (inst?.modules?.backend?.constructor?.name?.indexOf('Locize') > 0) return true;
    if (inst?.options?.backend?.backends) {
        if (inst.options.backend.backends.some((b)=>b?.name?.indexOf('Locize') > 0 || b?.constructor?.name?.indexOf('Locize') > 0)) return true;
    }
    if (inst?.options?.backend?.projectId) return true;
    if (inst?.options?.backend?.backendOptions) {
        if (inst.options.backend.backendOptions.some((b)=>b?.projectId)) return true;
    }
    return false;
};
class $cb95bcae1947788f$var$I18n extends $cb95bcae1947788f$var$EventEmitter {
    constructor(options = {}, callback){
        super();
        this.options = $cb95bcae1947788f$var$transformOptions(options);
        this.services = {};
        this.logger = $cb95bcae1947788f$var$baseLogger;
        this.modules = {
            external: []
        };
        $cb95bcae1947788f$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($cb95bcae1947788f$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $cb95bcae1947788f$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$cb95bcae1947788f$var$transformOptions(options)
        };
        this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        if (typeof this.options.overloadTranslationOptionHandler !== 'function') this.options.overloadTranslationOptionHandler = defOpts.overloadTranslationOptionHandler;
        if (this.options.showSupportNotice !== false && !$cb95bcae1947788f$var$usesLocize(this) && !$cb95bcae1947788f$var$getSupportNoticeShown()) {
            if (typeof console !== 'undefined' && typeof console.info !== 'undefined') console.info("\uD83C\uDF10 i18next is maintained with support from Locize \u2014 consider powering your project with managed localization (AI, CDN, integrations): https://locize.com \uD83D\uDC99");
            $cb95bcae1947788f$var$setSupportNoticeShown();
        }
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $cb95bcae1947788f$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $cb95bcae1947788f$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $cb95bcae1947788f$var$Formatter;
            const lu = new $cb95bcae1947788f$var$LanguageUtil(this.options);
            this.store = new $cb95bcae1947788f$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $cb95bcae1947788f$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $cb95bcae1947788f$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $cb95bcae1947788f$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $cb95bcae1947788f$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $cb95bcae1947788f$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $cb95bcae1947788f$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $cb95bcae1947788f$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $cb95bcae1947788f$var$noop) {
        let usedCallback = callback;
        const usedLng = $cb95bcae1947788f$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng?.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            this.options.preload?.forEach?.((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $cb95bcae1947788f$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $cb95bcae1947788f$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $cb95bcae1947788f$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $cb95bcae1947788f$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $cb95bcae1947788f$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($cb95bcae1947788f$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                this.services.languageDetector?.cacheUserLanguage?.(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = {
                ...opts
            };
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $cb95bcae1947788f$export$ec2cccc18ab4c2ae(k, {
                    ...this.options,
                    ...opts
                });
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $cb95bcae1947788f$export$ec2cccc18ab4c2ae(key, {
                    ...this.options,
                    ...opts
                });
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($cb95bcae1947788f$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        return this.translator?.translate(...args);
    }
    exists(...args) {
        return this.translator?.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $cb95bcae1947788f$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($cb95bcae1947788f$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $cb95bcae1947788f$var$defer();
        if ($cb95bcae1947788f$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services?.languageUtils || new $cb95bcae1947788f$var$LanguageUtil($cb95bcae1947788f$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $cb95bcae1947788f$var$I18n(options, callback);
        instance.createInstance = $cb95bcae1947788f$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $cb95bcae1947788f$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $cb95bcae1947788f$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = {
                    ...this.store.data[l]
                };
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = {
                        ...prev[l][n]
                    };
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $cb95bcae1947788f$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        if (options.interpolation) {
            const defOpts = $cb95bcae1947788f$var$get();
            const mergedInterpolation = {
                ...defOpts.interpolation,
                ...this.options.interpolation,
                ...options.interpolation
            };
            const mergedForInterpolator = {
                ...mergedOptions,
                interpolation: mergedInterpolation
            };
            clone.services.interpolator = new $cb95bcae1947788f$var$Interpolator(mergedForInterpolator);
        }
        clone.translator = new $cb95bcae1947788f$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $cb95bcae1947788f$export$2e2bcd8739ae039 = $cb95bcae1947788f$var$I18n.createInstance();
const $cb95bcae1947788f$export$99152e8d49ca4e7d = $cb95bcae1947788f$export$2e2bcd8739ae039.createInstance;
const $cb95bcae1947788f$export$147ec2801e896265 = $cb95bcae1947788f$export$2e2bcd8739ae039.dir;
const $cb95bcae1947788f$export$2cd8252107eb640b = $cb95bcae1947788f$export$2e2bcd8739ae039.init;
const $cb95bcae1947788f$export$d3d08d944062d7e = $cb95bcae1947788f$export$2e2bcd8739ae039.loadResources;
const $cb95bcae1947788f$export$a5d9bf5d83fcab09 = $cb95bcae1947788f$export$2e2bcd8739ae039.reloadResources;
const $cb95bcae1947788f$export$1f96ae73734a86cc = $cb95bcae1947788f$export$2e2bcd8739ae039.use;
const $cb95bcae1947788f$export$61465194746e7fd2 = $cb95bcae1947788f$export$2e2bcd8739ae039.changeLanguage;
const $cb95bcae1947788f$export$f90d180fc7da3b3b = $cb95bcae1947788f$export$2e2bcd8739ae039.getFixedT;
const $cb95bcae1947788f$export$625550452a3fa3ec = $cb95bcae1947788f$export$2e2bcd8739ae039.t;
const $cb95bcae1947788f$export$f7e9f41ea797a17 = $cb95bcae1947788f$export$2e2bcd8739ae039.exists;
const $cb95bcae1947788f$export$2b4b218e406d2d00 = $cb95bcae1947788f$export$2e2bcd8739ae039.setDefaultNamespace;
const $cb95bcae1947788f$export$93d9ee97c1ad3f31 = $cb95bcae1947788f$export$2e2bcd8739ae039.hasLoadedNamespace;
const $cb95bcae1947788f$export$83be934b53fff43b = $cb95bcae1947788f$export$2e2bcd8739ae039.loadNamespaces;
const $cb95bcae1947788f$export$8cd7e7a54fa865bc = $cb95bcae1947788f$export$2e2bcd8739ae039.loadLanguages;


const $c6f88c2c6ea3c4b1$var$me = {
    get () {
        return (0, $5332018adf75499b$export$a94cb3a0c5b0c060).get();
    },
    get data () {
        return (0, $5332018adf75499b$export$a94cb3a0c5b0c060).get()?.data;
    },
    get lang () {
        return (0, $5332018adf75499b$export$a94cb3a0c5b0c060).get()?.data?.lang;
    },
    get groups () {
        return (0, $5332018adf75499b$export$a94cb3a0c5b0c060).get()?.groups;
    },
    get id () {
        return (0, $5332018adf75499b$export$a94cb3a0c5b0c060).get()?.id;
    },
    get avatar () {
        return (0, $5332018adf75499b$export$a94cb3a0c5b0c060).get()?.avatar;
    },
    getGroupName (id) {
        let group = (0, $5332018adf75499b$export$a94cb3a0c5b0c060).get()?.groups?.find((g)=>g["id"] == id);
        return group ? group["name"] : "";
    },
    update () {
        return (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get("/api/me", true).then((r)=>{
            if (!r || !r?.id) {
                (0, $5332018adf75499b$export$8ddaddf355aae59c)({});
                return null;
            }
            Promise.all(r.groups.map((g)=>(0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get(`/api/groups/${g.id}`).catch(()=>null).then((group)=>group))).then((groups)=>{
                r.groups = groups.filter((g)=>g != null);
                (0, $5332018adf75499b$export$8ddaddf355aae59c)(Object.assign({
                    loaded: true
                }, r));
            });
            (0, $cb95bcae1947788f$export$2e2bcd8739ae039).changeLanguage(r?.data?.lang);
            return r;
        }).catch((err)=>{
            if (err?.networkError) // Network issue — don't clear user state
            return {
                _networkError: true
            };
            // Auth failure (401/403) or other HTTP error — clear user state
            (0, $5332018adf75499b$export$8ddaddf355aae59c)({});
            return null;
        });
    },
    fetch () {
        if ((0, $5332018adf75499b$export$a94cb3a0c5b0c060).get()["loaded"]) return new Promise((r)=>r((0, $5332018adf75499b$export$a94cb3a0c5b0c060).get()));
        return $c6f88c2c6ea3c4b1$var$me.update();
    },
    reset () {
        (0, $5332018adf75499b$export$cca2f5a1ccdd2100)();
    },
    logout () {
        (0, $a43f12068c4c782d$export$2e2bcd8739ae039).reset();
    }
};
var $c6f88c2c6ea3c4b1$export$2e2bcd8739ae039 = $c6f88c2c6ea3c4b1$var$me;



parcelRequire("iisr1");
var $bJrD0 = parcelRequire("bJrD0");

var $iisr1 = parcelRequire("iisr1");
var $9SeGy = parcelRequire("9SeGy");

var $a99e0b75acbdb5bf$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $a99e0b75acbdb5bf$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $98b8487e681fd7c4$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $98b8487e681fd7c4$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($a99e0b75acbdb5bf$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($98b8487e681fd7c4$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $98b8487e681fd7c4$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $98b8487e681fd7c4$var$i = /^\s*$/, $98b8487e681fd7c4$var$s = Object.create(null);
function $98b8487e681fd7c4$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($98b8487e681fd7c4$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $98b8487e681fd7c4$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $98b8487e681fd7c4$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($98b8487e681fd7c4$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $98b8487e681fd7c4$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $98b8487e681fd7c4$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $98b8487e681fd7c4$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $98b8487e681fd7c4$var$a("", t);
        }, "");
    }
};
var $98b8487e681fd7c4$export$2e2bcd8739ae039 = $98b8487e681fd7c4$var$c;


const $8948bff4a00b46d7$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    const args = [
        msg,
        {
            code: code,
            ...rest || {}
        }
    ];
    if (i18n?.services?.logger?.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($8948bff4a00b46d7$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n?.services?.logger?.warn) i18n.services.logger.warn(...args);
    else if (console?.warn) console.warn(...args);
};
const $8948bff4a00b46d7$var$alreadyWarned = {};
const $8948bff4a00b46d7$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($8948bff4a00b46d7$export$844ec244b1367d54(msg) && $8948bff4a00b46d7$var$alreadyWarned[msg]) return;
    if ($8948bff4a00b46d7$export$844ec244b1367d54(msg)) $8948bff4a00b46d7$var$alreadyWarned[msg] = new Date();
    $8948bff4a00b46d7$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $8948bff4a00b46d7$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $8948bff4a00b46d7$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $8948bff4a00b46d7$var$loadedClb(i18n, cb));
};
const $8948bff4a00b46d7$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($8948bff4a00b46d7$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $8948bff4a00b46d7$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $8948bff4a00b46d7$var$loadedClb(i18n, cb));
};
const $8948bff4a00b46d7$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $8948bff4a00b46d7$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $8948bff4a00b46d7$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($8948bff4a00b46d7$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $8948bff4a00b46d7$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $8948bff4a00b46d7$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;


const $41e77d45d3c057fa$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $41e77d45d3c057fa$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $41e77d45d3c057fa$var$unescapeHtmlEntity = (m)=>$41e77d45d3c057fa$var$htmlEntities[m];
const $41e77d45d3c057fa$export$e8bacd2802a88316 = (text)=>text.replace($41e77d45d3c057fa$var$matchHtmlEntity, $41e77d45d3c057fa$var$unescapeHtmlEntity);


let $be3a1ef505afdca5$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $41e77d45d3c057fa$export$e8bacd2802a88316,
    transDefaultProps: undefined
};
const $be3a1ef505afdca5$export$2e2366488d12e20d = (options = {})=>{
    $be3a1ef505afdca5$var$defaultOptions = {
        ...$be3a1ef505afdca5$var$defaultOptions,
        ...options
    };
};
const $be3a1ef505afdca5$export$212bb2fc580a90a8 = ()=>$be3a1ef505afdca5$var$defaultOptions;


let $fb1664200764ca4e$var$i18nInstance;
const $fb1664200764ca4e$export$a039134f2fc7e0 = (instance)=>{
    $fb1664200764ca4e$var$i18nInstance = instance;
};
const $fb1664200764ca4e$export$64af334f494c2f47 = ()=>$fb1664200764ca4e$var$i18nInstance;



const $c1087cd88d2287b5$var$hasChildren = (node, checkLength)=>{
    if (!node) return false;
    const base = node.props?.children ?? node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $c1087cd88d2287b5$var$getChildren = (node)=>{
    if (!node) return [];
    const children = node.props?.children ?? node.children;
    return node.props?.i18nIsDynamicList ? $c1087cd88d2287b5$var$getAsArray(children) : children;
};
const $c1087cd88d2287b5$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $iisr1.isValidElement));
const $c1087cd88d2287b5$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $c1087cd88d2287b5$var$mergeProps = (source, target)=>{
    const newTarget = {
        ...target
    };
    newTarget.props = {
        ...target.props,
        ...source.props
    };
    return newTarget;
};
const $c1087cd88d2287b5$var$getValuesFromChildren = (children)=>{
    const values = {};
    if (!children) return values;
    const getData = (childs)=>{
        const childrenArray = $c1087cd88d2287b5$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $8948bff4a00b46d7$export$844ec244b1367d54)(child)) return;
            if ($c1087cd88d2287b5$var$hasChildren(child)) getData($c1087cd88d2287b5$var$getChildren(child));
            else if ((0, $8948bff4a00b46d7$export$a6cdc56e425d0d0a)(child) && !(0, $iisr1.isValidElement)(child)) Object.assign(values, child);
        });
    };
    getData(children);
    return values;
};
const $c1087cd88d2287b5$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $c1087cd88d2287b5$var$getAsArray(children);
    const keepArray = i18nOptions?.transSupportBasicHtmlNodes ? i18nOptions.transKeepBasicHtmlNodesFor ?? [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $8948bff4a00b46d7$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $iisr1.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $8948bff4a00b46d7$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $c1087cd88d2287b5$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $8948bff4a00b46d7$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $8948bff4a00b46d7$export$a6cdc56e425d0d0a)(child)) {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $8948bff4a00b46d7$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $8948bff4a00b46d7$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $c1087cd88d2287b5$var$escapeLiteralLessThan = (str, keepArray = [], knownComponentsMap = {})=>{
    if (!str) return str;
    const knownNames = Object.keys(knownComponentsMap);
    const allValidNames = [
        ...keepArray,
        ...knownNames
    ];
    let result = '';
    let i = 0;
    while(i < str.length)if (str[i] === '<') {
        let isValidTag = false;
        const closingMatch = str.slice(i).match(/^<\/(\d+|[a-zA-Z][a-zA-Z0-9_-]*)>/);
        if (closingMatch) {
            const tagName = closingMatch[1];
            if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                isValidTag = true;
                result += closingMatch[0];
                i += closingMatch[0].length;
            }
        }
        if (!isValidTag) {
            const openingMatch = str.slice(i).match(/^<(\d+|[a-zA-Z][a-zA-Z0-9_-]*)(\s+[\w-]+(?:=(?:"[^"]*"|'[^']*'|[^\s>]+))?)*\s*(\/)?>/);
            if (openingMatch) {
                const tagName = openingMatch[1];
                if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                    isValidTag = true;
                    result += openingMatch[0];
                    i += openingMatch[0].length;
                }
            }
        }
        if (!isValidTag) {
            result += '&lt;';
            i += 1;
        }
    } else {
        result += str[i];
        i += 1;
    }
    return result;
};
const $c1087cd88d2287b5$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap ?? {};
    const getData = (childs)=>{
        const childrenArray = $c1087cd88d2287b5$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $8948bff4a00b46d7$export$844ec244b1367d54)(child)) return;
            if ($c1087cd88d2287b5$var$hasChildren(child)) getData($c1087cd88d2287b5$var$getChildren(child));
            else if ((0, $8948bff4a00b46d7$export$a6cdc56e425d0d0a)(child) && !(0, $iisr1.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const escapedString = $c1087cd88d2287b5$var$escapeLiteralLessThan(targetString, keepArray, data);
    const ast = (0, $98b8487e681fd7c4$export$2e2bcd8739ae039).parse(`<0>${escapedString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    const renderInner = (child, node, rootReactNode)=>{
        const childs = $c1087cd88d2287b5$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $c1087cd88d2287b5$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props?.i18nIsDynamicList ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $iisr1.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $iisr1.Children).map([
            child
        ], (c)=>{
            const INTERNAL_DYNAMIC_MARKER = 'data-i18n-is-dynamic-list';
            const override = {
                key: i,
                [INTERNAL_DYNAMIC_MARKER]: undefined
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children' || k === 'i18nIsDynamicList' || k === INTERNAL_DYNAMIC_MARKER) return;
                override[k] = c.props[k];
            });
            return (0, $iisr1.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $c1087cd88d2287b5$var$getAsArray(reactNode);
        const astNodes = $c1087cd88d2287b5$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children?.[0]?.content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const props = {
                    ...node.attrs
                };
                if (shouldUnescape) Object.keys(props).forEach((p)=>{
                    const val = props[p];
                    if ((0, $8948bff4a00b46d7$export$844ec244b1367d54)(val)) props[p] = (0, $41e77d45d3c057fa$export$e8bacd2802a88316)(val);
                });
                const child = Object.keys(props).length !== 0 ? $c1087cd88d2287b5$var$mergeProps({
                    props: props
                }, tmp) : tmp;
                const isElement = (0, $iisr1.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $c1087cd88d2287b5$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $8948bff4a00b46d7$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $8948bff4a00b46d7$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $8948bff4a00b46d7$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($c1087cd88d2287b5$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $9SeGy.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $9SeGy.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $8948bff4a00b46d7$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const unescapeFn = typeof i18nOptions.unescape === 'function' ? i18nOptions.unescape : (0, $be3a1ef505afdca5$export$212bb2fc580a90a8)().unescape;
                const content = shouldUnescape ? unescapeFn(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $9SeGy.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $c1087cd88d2287b5$var$getAsArray(children || []));
    return $c1087cd88d2287b5$var$getChildren(result[0]);
};
const $c1087cd88d2287b5$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $iisr1.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $9SeGy.createElement)((0, $9SeGy.Fragment), null, comp);
    }
    return (0, $9SeGy.createElement)(Componentized, {
        key: componentKey
    });
};
const $c1087cd88d2287b5$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$c1087cd88d2287b5$var$fixComponentProps(c, index, translation));
const $c1087cd88d2287b5$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $c1087cd88d2287b5$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $c1087cd88d2287b5$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $c1087cd88d2287b5$var$generateArrayComponents(components, translation);
    if ((0, $8948bff4a00b46d7$export$a6cdc56e425d0d0a)(components)) return $c1087cd88d2287b5$var$generateObjectComponents(components, translation);
    (0, $8948bff4a00b46d7$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $c1087cd88d2287b5$var$isComponentsMap = (object)=>{
    if (!(0, $8948bff4a00b46d7$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $c1087cd88d2287b5$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const i18n = i18nFromProps || (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $8948bff4a00b46d7$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = {
        ...(0, $be3a1ef505afdca5$export$212bb2fc580a90a8)(),
        ...i18n.options?.react
    };
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $8948bff4a00b46d7$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const { transDefaultProps: transDefaultProps } = reactI18nextOptions;
    const mergedTOptions = transDefaultProps?.tOptions ? {
        ...transDefaultProps.tOptions,
        ...tOptions
    } : tOptions;
    const mergedShouldUnescape = shouldUnescape ?? transDefaultProps?.shouldUnescape;
    const mergedValues = transDefaultProps?.values ? {
        ...transDefaultProps.values,
        ...values
    } : values;
    const mergedComponents = transDefaultProps?.components ? {
        ...transDefaultProps.components,
        ...components
    } : components;
    const nodeAsString = $c1087cd88d2287b5$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || mergedTOptions?.defaultValue || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $cb95bcae1947788f$export$ec2cccc18ab4c2ae)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options?.interpolation?.defaultVariables) values = mergedValues && Object.keys(mergedValues).length > 0 ? {
        ...mergedValues,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    else values = mergedValues;
    const valuesFromChildren = $c1087cd88d2287b5$var$getValuesFromChildren(children);
    if (valuesFromChildren && typeof valuesFromChildren.count === 'number' && count === undefined) count = valuesFromChildren.count;
    const interpolationOverride = values || count !== undefined && !i18n.options?.interpolation?.alwaysFormat || !children ? mergedTOptions.interpolation : {
        interpolation: {
            ...mergedTOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...mergedTOptions,
        context: context || mergedTOptions.context,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $c1087cd88d2287b5$var$generateComponents(mergedComponents, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($c1087cd88d2287b5$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $c1087cd88d2287b5$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, mergedShouldUnescape);
    const useAsParent = parent ?? reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $9SeGy.createElement)(useAsParent, additionalProps, content) : content;
}


parcelRequire("iisr1");
var $9SeGy = parcelRequire("9SeGy");




const $f4663bfcfe4ffd82$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $be3a1ef505afdca5$export$2e2366488d12e20d)(instance.options.react);
        (0, $fb1664200764ca4e$export$a039134f2fc7e0)(instance);
    }
};


const $7769fa9636e2bfa3$export$5603ab5ced17ce64 = (0, $9SeGy.createContext)();
class $7769fa9636e2bfa3$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
const $7769fa9636e2bfa3$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        const componentsInitialProps = await ForComponent.getInitialProps?.(ctx) ?? {};
        const i18nInitialProps = $7769fa9636e2bfa3$export$704200e5d0b9e8f();
        return {
            ...componentsInitialProps,
            ...i18nInitialProps
        };
    };
const $7769fa9636e2bfa3$export$704200e5d0b9e8f = ()=>{
    const i18n = (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces?.getUsedNamespaces() ?? [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $8c71aa9aa535d5cc$export$8d6a9236f2e3f2ce({ children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $bJrD0.useContext)((0, $7769fa9636e2bfa3$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $c1087cd88d2287b5$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}



parcelRequire("iisr1");
var $bJrD0 = parcelRequire("bJrD0");

var $iisr1 = parcelRequire("iisr1");


class $eaea0ad540941491$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $eaea0ad540941491$export$aa9e222d9ffc5d1b);
    }
}


const $26281eec76d2f46f$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $26281eec76d2f46f$var$entityPattern = new RegExp(Object.keys($26281eec76d2f46f$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $26281eec76d2f46f$export$5cfeaa4af6841c8f = (text)=>text.replace($26281eec76d2f46f$var$entityPattern, (match)=>$26281eec76d2f46f$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));


const $00db812af0d6c1ae$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};



var $iisr1 = parcelRequire("iisr1");



const $b32d08888f11c85b$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove, ...propsWithoutChildren } = props;
        return (0, $iisr1.default).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, $iisr1.default).createElement(type, props);
    if (children.length === 1) return (0, $iisr1.default).createElement(type, props, children[0]);
    return (0, $iisr1.default).createElement(type, props, ...children);
};
const $b32d08888f11c85b$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $00db812af0d6c1ae$export$660b2ee2d4fb4eff)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (parentFrame.declaration.props?.children && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $26281eec76d2f46f$export$5cfeaa4af6841c8f)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $eaea0ad540941491$export$aa9e222d9ffc5d1b)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $eaea0ad540941491$export$aa9e222d9ffc5d1b)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $b32d08888f11c85b$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $eaea0ad540941491$export$aa9e222d9ffc5d1b)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};




function $50efdd7bf92ffac6$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const i18n = i18nFromProps || (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $8948bff4a00b46d7$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, $iisr1.default).createElement((0, $iisr1.default).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || i18n.t?.bind(i18n) || ((k)=>k);
    let namespaces = ns || t.ns || i18n.options?.defaultNS;
    namespaces = (0, $8948bff4a00b46d7$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if (i18n.options?.interpolation?.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const translation = t(i18nKey, {
        defaultValue: defaultTranslation,
        ...mergedValues,
        ns: namespaces
    });
    try {
        const rendered = (0, $b32d08888f11c85b$export$1038df9fa5e5f35f)(translation, content);
        return (0, $iisr1.default).createElement((0, $iisr1.default).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $8948bff4a00b46d7$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, $iisr1.default).createElement((0, $iisr1.default).Fragment, {}, translation);
    }
}
$50efdd7bf92ffac6$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $f4a0a3e9374b3fcc$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $bJrD0.useContext)((0, $7769fa9636e2bfa3$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    const t = tFromProps || i18n?.t.bind(i18n);
    return (0, $50efdd7bf92ffac6$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || t?.ns || defaultNSFromContext || i18n?.options?.defaultNS,
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$f4a0a3e9374b3fcc$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';



parcelRequire("iisr1");
var $bJrD0 = parcelRequire("bJrD0");
var $c184300de87cd952$exports = {};
'use strict';

$c184300de87cd952$exports = (parcelRequire("diC8V"));




const $23287d5819478a30$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $8948bff4a00b46d7$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $8948bff4a00b46d7$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $8948bff4a00b46d7$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    return Array.isArray(k) ? k[k.length - 1] : k;
};
const $23287d5819478a30$var$notReadySnapshot = {
    t: $23287d5819478a30$var$notReadyT,
    ready: false
};
const $23287d5819478a30$var$dummySubscribe = ()=>()=>{};
const $23287d5819478a30$export$9fc83ad70ead8663 = (ns, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $bJrD0.useContext)((0, $7769fa9636e2bfa3$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $7769fa9636e2bfa3$export$ea171b67e3820290)();
    if (!i18n) (0, $8948bff4a00b46d7$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
    const i18nOptions = (0, $bJrD0.useMemo)(()=>({
            ...(0, $be3a1ef505afdca5$export$212bb2fc580a90a8)(),
            ...i18n?.options?.react,
            ...props
        }), [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || i18n?.options?.defaultNS;
    const unstableNamespaces = (0, $8948bff4a00b46d7$export$844ec244b1367d54)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $bJrD0.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n?.reportNamespaces?.addUsedNamespaces?.(namespaces);
    const revisionRef = (0, $bJrD0.useRef)(0);
    const subscribe = (0, $bJrD0.useCallback)((callback)=>{
        if (!i18n) return $23287d5819478a30$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $bJrD0.useRef)();
    const getSnapshot = (0, $bJrD0.useCallback)(()=>{
        if (!i18n) return $23287d5819478a30$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $8948bff4a00b46d7$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $bJrD0.useState)(0);
    const { t: t, ready: ready } = (0, $c184300de87cd952$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $bJrD0.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $8948bff4a00b46d7$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $8948bff4a00b46d7$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $bJrD0.useRef)(null);
    const wrapperLangRef = (0, $bJrD0.useRef)();
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $bJrD0.useMemo)(()=>{
        const original = finalI18n;
        const lang = original?.language;
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const arr = [
            t,
            i18nWrapper,
            ready
        ];
        arr.t = t;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) throw new Promise((resolve)=>{
        const onLoaded = ()=>resolve();
        if (props.lng) (0, $8948bff4a00b46d7$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
        else (0, $8948bff4a00b46d7$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
    });
    return ret;
};


parcelRequire("iisr1");
var $9SeGy = parcelRequire("9SeGy");
var $iisr1 = parcelRequire("iisr1");


const $ee5bb531210bb8d0$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation({ forwardedRef: forwardedRef, ...rest }) {
            const [t, i18n, ready] = (0, $23287d5819478a30$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $9SeGy.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $8948bff4a00b46d7$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $9SeGy.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $iisr1.forwardRef)(forwardRef) : I18nextWithTranslation;
    };



const $730c785d8f766145$export$b63289fbda65eed1 = ({ ns: ns, children: children, ...options })=>{
    const [t, i18n, ready] = (0, $23287d5819478a30$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};


parcelRequire("iisr1");
var $bJrD0 = parcelRequire("bJrD0");
var $9SeGy = parcelRequire("9SeGy");

function $416905e0717fbb75$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $bJrD0.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $9SeGy.createElement)((0, $7769fa9636e2bfa3$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}


parcelRequire("iisr1");
var $9SeGy = parcelRequire("9SeGy");
parcelRequire("iisr1");
var $bJrD0 = parcelRequire("bJrD0");

const $92a5e6fb63b23713$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $bJrD0.useContext)((0, $7769fa9636e2bfa3$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $fb1664200764ca4e$export$64af334f494c2f47)();
    if (i18n.options?.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $6a3a7999dcfd4802$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR({ initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest }) {
            (0, $92a5e6fb63b23713$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $9SeGy.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $7769fa9636e2bfa3$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $8948bff4a00b46d7$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $791ae55525c87072$export$324d90190a8b822a = ()=>'';
const $791ae55525c87072$export$2da9be4cfdb689b1 = ()=>'';
const $791ae55525c87072$export$98e628dec113755e = ()=>'';
const $791ae55525c87072$export$2e6c959c16ff56b8 = ()=>'';
const $791ae55525c87072$export$4e35d5c922a95490 = ()=>'';
const $791ae55525c87072$export$720a3b9db04b7a0f = ()=>'';



var $6df9954f38281adf$exports = {};
$6df9954f38281adf$exports = JSON.parse('{"account":"\xda\u010Det","add_bookmark":"P\u0159idat zpr\xe1vu do z\xe1lo\u017Eek","add_date":"Zadat datum","ago":"p\u0159ed {{duration}}","api_key":"API kl\xed\u010D","are_you_sure":"Jste si opravdu jisti?","ask_delete_message":"Opravdu chcete smazat tuto zpr\xe1vu?","audio_not_ready":"","bookmark_added":"Zpr\xe1va p\u0159id\xe1na do z\xe1lo\u017Eek!","bookmark_removed":"Zpr\xe1va odstran\u011Bna ze z\xe1lo\u017Eek!","bookmarks":"z\xe1lo\u017Eky","cancel_write":"Opravdu chcete ukon\u010Dit psan\xed nov\xe9 zpr\xe1vy?","cancel":"Zru\u0161it","changed_group_name":"zm\u011Bnili jm\xe9no skupiny","confirm_password_placeholder":"potvrdit heslo","connect":"P\u0159ipojen\xed","create_a_group":"Vytvo\u0159it skupinu","create_the_group":"Vytvo\u0159it tuto skupinu","daily":"Denn\xed","default_group":"V\xfdchoz\xed skupina","delete":"Smazat","destroy_account_explain":"Smaz\xe1n\xed \xfa\u010Dtu nelze vr\xe1tit zp\u011Bt. Bu\u010Fte si opravdu jisti.","destroy_account":"Smazat \xfa\u010Det","edit":"Upravit","email":"E-mail","email_input":"Vypl\u0148te sem sv\u016Fj e-mail","empty_message":"Pr\xe1zdnou zpr\xe1vu nelze odeslat!","error":"Do\u0161lo k chyb\u011B","error_new_message":"Do\u0161lo k chyb\u011B b\u011Bhem odes\xedl\xe1n\xed zpr\xe1vy.","error_upload":"Do\u0161lo k chyb\u011B b\u011Bhem nahr\xe1v\xe1n\xed","forgot_password":"Zapom\u011Bli jste sv\xe9 heslo?","group_left":"Opustili jste tuto skupinu!","group_share_choice":"Do kter\xe9 skupiny chcete poslat tuto zpr\xe1vu?","groups":"Skupiny","group_updated":"Skupina byla aktualizov\xe1na!","has_commented_on":"komentovali v","has_joined":"vstoupili","has_left":"opustili","has_posted_in":"zve\u0159ejnili v","hourly":"Hodinov\xe1","in":"v","Invalid login/password":"Neplatn\xfd login a/nebo heslo","invitation_link":"Odkaz s pozv\xe1nkou","invitation_welcome":"V\xedtejte na Zusam! P\u0159ed vstupem do skupiny se p\u0159ihla\u0161te.","just_now":"Pr\xe1v\u011B te\u010F","lang":"jazyk","login_input":"Vybrat login","login":"Login","login_placeholder":"e-mail","logout":"Odhl\xe1sit","mark_all_as_read":"ozna\u010Dit v\u0161e jako p\u0159e\u010Dten\xe9","monthly":"M\u011Bs\xed\u010Dn\xed","multiple_photos_upload":"Do\u0161lo k chyb\u011B. Zkuste nahr\xe1t obr\xe1zky jeden po druh\xe9m (toto se ob\u010Das v n\u011Bkter\xfdch prohl\xed\u017Ee\u010D\xedch stane).","name_input":"Vybrat jm\xe9no","name":"Jm\xe9no","new_password_placeholder":"nov\xe9 heslo","next_coms":"Shl\xe9dnout dal\u0161\xed koment\xe1\u0159e","none":"\u017D\xe1dn\xe1","notification_emails":"E-mailov\xe1 upozorn\u011Bn\xed","notification_emails_stopped":"E-mailov\xe1 upozorn\u011Bn\xed zastavena!","notifications":"upozorn\u011Bn\xed","parent_message":"Nad\u0159azen\xe1 zpr\xe1va","password":"Heslo","password_input":"Vypl\u0148te sem nov\xe9 heslo","password_placeholder":"heslo","password_reset_mail_sent":"E-mail pro obnovu hesla byl odesl\xe1n!","passwords_dont_match":"Hesla se neshoduj\xed","previous_coms":"Shl\xe9dnout p\u0159edchoz\xed koment\xe1\u0159e","public_link":"ve\u0159ejn\xfd odkaz","publish_in_group":"zve\u0159ejnit ve skupin\u011B","quit_group":"Opustit skupinu","remove_bookmark":"Smazat zpr\xe1vu ze z\xe1lo\u017Eek","replies_one":"{{count}} odpov\u011B\u010F","replies_other":"{{count}} odpov\u011Bd\xed","reply":"odpov\u011B\u010F","reset_api_key":"Resetovat API kl\xed\u010D (budete odpojeni)","reset_invitation_link":"Resetovat odkaz s pozv\xe1nkou","reset_password_title":"Resetovat heslo","save_changes":"Ulo\u017Eit zm\u011Bny","search_in_group":"hledat ve skupin\u011B","search_without_result":"Hled\xe1n\xed nevr\xe1tilo \u017Eadn\xe9 odpov\xeddaj\xedc\xed zpr\xe1vy.","settings":"Nastaven\xed","settings_updated":"Nastaven\xed byla aktualizov\xe1na","share_message":"sd\xedlet zpr\xe1vu","signup":"Zalo\u017Eit \xfa\u010Det","submit":"Odeslat","text_placeholder":"Zde napi\u0161te svou zpr\xe1vu","the_message_from":"zpr\xe1vu od","title_placeholder":"Nadpis zpr\xe1vy (voliteln\u011B)","to":"na","upload_audio":"","upload_image":"Nahr\xe1t fotky","upload_music":"Nahr\xe1t hudbu","upload_pdf":"Nahr\xe1t PDF","upload_video":"Nahr\xe1t video","User not found":"U\u017Eivatel nenalezen","users":"u\u017Eivatel\xe9","video_not_ready":"Video je\u0161t\u011B nen\xed p\u0159ipraveno.","weekly":"T\xfddenn\xed"}');


var $6a418c1183be7fbe$exports = {};
$6a418c1183be7fbe$exports = JSON.parse('{"account":"Konto","add_bookmark":"Nachricht zu den Lesezeichnen hinzuf\xfcgen","add_date":"Ein Datum hinzuf\xfcgen","ago":"Vor {{duration}}","api_key":"API-Schl\xfcssel","are_you_sure":"Bist du sicher?","ask_delete_message":"Diese Nachricht l\xf6schen?","audio_not_ready":"Audio ist noch nicht fertig.","bookmark_added":"Nachricht zu den Lesezeichen hinzugef\xfcgt.","bookmark_removed":"Nachricht aus den Lesezeichen entfernt.","bookmarks":"Lesezeichen","cancel":"Abbrechen","cancel_write":"Willst du das Schreiben einer neuen Nachricht wirklich abbrechen?","changed_group_name":"hat den Gruppenamen ge\xe4ndert","confirm_password_placeholder":"Passwort best\xe4tigen","connect":"Verbindung","create_a_group":"Eine Gruppe erstellen","create_the_group":"Die Gruppe erstellen","daily":"T\xe4glich","default_group":"Standard-Gruppe","delete":"L\xf6schen","destroy_account":"Dein Konto l\xf6schen","destroy_account_explain":"Wenn du dein Konto einmal gel\xf6scht hast, gibt es keinen Weg zur\xfcck. Bitte sei sicher.","edit":"Bearbeiten","email":"E-Mail","email_input":"Gib hier deine E-Mail-Adresse ein","empty_message":"Die Nachricht ist leer und kann nicht gesendet werden.","error":"Ein Fehler ist aufgetreten","error_new_message":"Beim Senden deiner Nachricht ist ein Fehler aufgetreten.","error_upload":"Beim Hochladen ist ein Fehler aufgetreten","forgot_password":"Passwort vergessen?","group_left":"Du hast die Gruppe verlassen.","groups":"Gruppen","group_share_choice":"An welche Gruppe m\xf6chtest du diese Nachricht senden?","group_updated":"Die Gruppe wurde aktualisiert.","has_commented_on":"hat kommentiert","has_joined":"ist beigetreten","has_left":"hat verlassen","has_posted_in":"hat ver\xf6ffentlicht in","hourly":"St\xfcndlich","in":"in","Invalid login/password":"Ung\xfcltiges Benutzername oder Passwort","invitation_link":"Einladungslink","invitation_welcome":"Willkommen bei Zusam. Bitte melde dich an, bevor du der Gruppe beitrittst.","just_now":"Gerade jetzt","lang":"Sprache","login":"Anmelden","login_input":"W\xe4hle einen Benutzername","login_placeholder":"E-Mail","logout":"Abmelden","mark_all_as_read":"alle als gelesen markieren","monthly":"Monatlich","multiple_photos_upload":"Ein Fehler ist aufgetreten. Versuche, die Bilder nacheinander hochzuladen (dies kann bei einigen Browsern vorkommen)","name_input":"W\xe4hle einen Namen","name":"Name","new_password_placeholder":"Neues Passwort","next_coms":"N\xe4chste Kommentare ansehen","none":"Keine","notification_emails":"E-Mail-Benachrichtigungen","notification_emails_stopped":"E-Mail-Benachrichtigungen gestoppt!","notifications":"Benachrichtigungen","parent_message":"Quellenachricht","password_input":"Gib hier ein neues Passwort ein","password":"Passwort","password_placeholder":"Passwort","password_reset_mail_sent":"Die E-Mail zum Zur\xfccksetzen des Passworts findest du in deinem Posteingang.","passwords_dont_match":"Passw\xf6rter stimmen nicht \xfcberein","previous_coms":"Vorherige Kommentare ansehen","public_link":"\xf6ffentlicher Link","publish_in_group":"in der Gruppe ver\xf6ffentlichen","quit_group":"Die Gruppe verlassen","remove_bookmark":"Nachricht aus den Lesezeichnen entfernen","replies_one":"{{count}} Antwort","replies_other":"{{count}} Antworten","reply":"antworten","reset_api_key":"Setze den API-Schl\xfcssel zur\xfcck (die Verbindung wird unterbrochen)","reset_invitation_link":"Einladungslink zur\xfccksetzen","reset_password_title":"Dein Passwort zur\xfccksetzen","save_changes":"\xc4nderungen speichern","search_in_group":"in dieser Gruppe suchen","search_without_result":"Deine Suche hat zu keiner Nachricht gef\xfchrt.","settings":"Einstellungen","settings_updated":"Deine Einstellungen wurden aktualisiert","share_message":"die Nachricht teilen","signup":"Registrieren","submit":"Senden","text_placeholder":"Schreibe deine Nachricht hier","the_message_from":"die Nachricht von","title_placeholder":"Titel deiner Nachricht (optional)","to":"zu","upload_audio":"Audio hinzuf\xfcgen.","upload_image":"Fotos hinzuf\xfcgen","upload_music":"Musik hinzuf\xfcgen","upload_pdf":"PDF hinzuf\xfcgen","upload_video":"Video hinzuf\xfcgen","User not found":"Benutzer nicht gefunden","users":"Benutzer","video_not_ready":"Das Video ist noch nicht fertig.","weekly":"W\xf6chentlich"}');


var $4eb8407690f94981$exports = {};
$4eb8407690f94981$exports = JSON.parse("{\"account\":\"Account\",\"add_bookmark\":\"Bookmark message\",\"add_date\":\"Add a date\",\"ago\":\"{{duration}} ago\",\"and_x_more\":\"and {{count}} more\",\"api_key\":\"API key\",\"are_you_sure\":\"Are you sure?\",\"ask_delete_message\":\"Delete this message?\",\"audio_not_ready\":\"Audio is not ready yet.\",\"bookmark_added\":\"Message bookmarked.\",\"bookmark_removed\":\"Message bookmark removed.\",\"bookmarks\":\"bookmarks\",\"cancel\":\"Cancel\",\"cancel_write\":\"Do you really want to cancel writing a new message?\",\"changed_group_name\":\"changed the group's name\",\"confirm_password_placeholder\":\"confirm password\",\"connect\":\"Connect\",\"create_a_group\":\"Create a group\",\"create_the_group\":\"Create the group\",\"daily\":\"Daily\",\"default_group\":\"Default group\",\"default_page\":\"Default page\",\"delete\":\"Delete\",\"destroy_account\":\"Delete your account\",\"destroy_account_explain\":\"Once you delete your account, there is no going back. Please be certain.\",\"edit\":\"Edit\",\"email_disabled\":\"Emails are disabled. Please contact your system administrator to reset your password.\",\"email\":\"E-mail\",\"email_input\":\"Fill in your e-mail address here\",\"empty_message\":\"The message is empty and cannot be sent.\",\"error\":\"An error occurred\",\"error_new_message\":\"An error occurred while sending your message.\",\"error_upload\":\"An error occurred during the upload\",\"feed\":\"Feed\",\"feed_group\":\"My Feed\",\"forgot_password\":\"Forgot your password?\",\"group_left\":\"You left the group.\",\"groups\":\"Groups\",\"group_share_choice\":\"Which group do you want to send this message to?\",\"group_updated\":\"The group was updated.\",\"has_commented_on\":\"has commented on\",\"has_joined\":\"has joined\",\"has_left\":\"has left\",\"has_posted_in\":\"has posted in\",\"hourly\":\"Hourly\",\"immediately\":\"Immediately\",\"in\":\"in\",\"Invalid login/password\":\"Invalid login and/or password\",\"invalid_token_error\":\"This link is no longer valid.\",\"invitation_link\":\"Invitation link\",\"invitation_welcome\":\"Welcome to Zusam. Please sign up before joining the group.\",\"just_now\":\"Just now\",\"lang\":\"language\",\"login_input\":\"Choose a login\",\"login\":\"Log in\",\"login_placeholder\":\"e-mail\",\"logout\":\"Log out\",\"mark_all_as_read\":\"mark all as read\",\"monthly\":\"Monthly\",\"multiple_photos_upload\":\"An error ocurred. Try uploading images one by one (this can happen in some browsers)\",\"name_input\":\"Choose a name\",\"name\":\"Name\",\"new_password_placeholder\":\"new password\",\"next_coms\":\"See next comments\",\"none\":\"None\",\"notification_emails\":\"E-mail notifications\",\"notification_emails_stopped\":\"E-mail notifications stopped!\",\"notifications\":\"notifications\",\"parent_message\":\"Parent message\",\"password_input\":\"Write a new password here\",\"password\":\"Password\",\"password_placeholder\":\"password\",\"password_reset_mail_sent\":\"Look for the password reset e-mail in your inbox.\",\"passwords_dont_match\":\"Passwords don't match\",\"previous_coms\":\"See previous comments\",\"public_link\":\"public link\",\"publish_in_group\":\"publish in the group\",\"pin_in_group\":\"pin in group\",\"unpin_in_group\":\"unpin\",\"quit_group\":\"Leave the group\",\"react\":\"React\",\"remove_bookmark\":\"Unbookmark message\",\"replies_one\":\"{{count}} reply\",\"replies_other\":\"{{count}} replies\",\"reply\":\"reply\",\"reset_api_key\":\"Reset the API key (you will be disconnected)\",\"reset_invitation_link\":\"Reset invitation link\",\"reset_password_title\":\"Reset your password\",\"save_changes\":\"Save changes\",\"search_in_group\":\"search in this group\",\"search_without_result\":\"Your search did not match any message.\",\"settings\":\"Settings\",\"settings_updated\":\"Your settings were updated\",\"share_message\":\"share the message\",\"signup\":\"Sign up\",\"submit\":\"Submit\",\"text_placeholder\":\"Write your message here\",\"the_message_from\":\"the message from\",\"title_placeholder\":\"Title of your message (optional)\",\"to\":\"to\",\"upload_audio\":\"Add an audio file.\",\"upload_image\":\"Add photos\",\"upload_music\":\"Add music\",\"upload_pdf\":\"Add PDF\",\"upload_video\":\"Add a video\",\"User not found\":\"User not found\",\"users\":\"users\",\"video_not_ready\":\"Video is not ready yet.\",\"weekly\":\"Weekly\",\"you_have_no_bookmarks\":\"You have no bookmarks\"}");


var $ccf112828a522499$exports = {};
$ccf112828a522499$exports = JSON.parse('{"account":"Cuenta","add_bookmark":"Marcar este mensaje","add_date":"A\xf1adir una fecha","ago":"Hace {{duration}}","api_key":"Clave API","are_you_sure":"Est\xe1s seguro ?","ask_delete_message":"\xbfBorrar este mensaje?","audio_not_ready":"El audio a\xfan no est\xe1 listo.","bookmark_added":"Mensaje en favoritos.","bookmark_removed":"Se elimin\xf3 el marcador de mensajes.","bookmarks":"marcadores","cancel":"Cancelar","cancel_write":"\xbfQuieres cancelar este nuevo mensaje?","changed_group_name":"cambi\xf3 el nombre del grupo","confirm_password_placeholder":"confirmar contrase\xf1a","connect":"Conectarse","create_a_group":"Crear un grupo","create_the_group":"Crear el grupo","daily":"Diario","default_group":"Grupo predeterminado","delete":"Borrar","destroy_account":"Borrar la cuenta","destroy_account_explain":"Una vez que elimines tu cuenta, no hay vuelta atr\xe1s.","edit":"Editar","email":"Correo electr\xf3nico","email_input":"Escriba aqu\xed su direcci\xf3n de correo electr\xf3nico","empty_message":"El mensaje est\xe1 vac\xedo y no se puede enviar.","error_new_message":"Se ha producido un error al enviar su mensaje.","error":"Se ha producido un error","error_upload":"Se ha producido un error durante la carga","forgot_password":"\xbfOlvidaste tu contrase\xf1a?","group_left":"Has dejado el grupo.","groups":"Grupos","group_share_choice":"\xbfA qu\xe9 grupo quieres enviar este mensaje?","group_updated":"El grupo ha sido actualizado.","has_commented_on":"ha comentado","has_joined":"se has unido","has_left":"ha dejado","has_posted_in":"ha publicado en","hourly":"Cada hora","in":"en","Invalid login/password":"Usuario o contrase\xf1a incorrecto","invitation_link":"Enlace de invitaci\xf3n","invitation_welcome":"Bienvenido a Zusam. Por favor, reg\xedstrate antes de unirte al grupo.","just_now":"Ahora","lang":"idioma","login":"Iniciar sesi\xf3n","login_input":"Elige un usuario","login_placeholder":"correo electr\xf3nico","logout":"Desconectarse","mark_all_as_read":"marcar todo como leido","monthly":"Mensual","multiple_photos_upload":"Se ha producido un error. Intenta subir las im\xe1genes una a una (esto puede ocurrir en algunos navegadores)","name_input":"Elige un nombre","name":"Nombre","new_password_placeholder":"nueva contrase\xf1a","next_coms":"Ver los siguientes comentarios","none":"Ninguno","notification_emails":"Notificaciones por correo electr\xf3nico","notification_emails_stopped":"\xa1Se han detenido las notificaciones por correo electr\xf3nico!","notifications":"notificaciones","parent_message":"Mensaje para padres","password":"Contrase\xf1a","password_input":"Indicar una nueva contrase\xf1a","password_placeholder":"contrase\xf1a","password_reset_mail_sent":"Busque el correo electr\xf3nico de restablecimiento de la contrase\xf1a en su bandeja de entrada.","passwords_dont_match":"Las contrase\xf1as no coinciden","previous_coms":"Ver los comentarios anteriores","public_link":"enlace p\xfablico","publish_in_group":"publicar en el grupo","quit_group":"Dejar el grupo","remove_bookmark":"Desmarcar este mensaje","replies_one":"{{count}} respuesta","replies_other":"{{count}} respuestas","reply":"responder","reset_api_key":"Restablecer la clave API (se desconectar\xe1)","reset_invitation_link":"Cambiar el enlace de invitaci\xf3n","reset_password_title":"Cambia tu contrase\xf1a","save_changes":"Guardar los cambios","search_in_group":"buscar en este grupo","search_without_result":"Su b\xfasqueda no coincide con ning\xfan mensaje.","settings":"Par\xe1metros","settings_updated":"Sus ajustes fueron actualizados","share_message":"comparte el mensaje","signup":"Inscribirse","submit":"Enviar","text_placeholder":"Escribe tu mensaje aqu\xed","the_message_from":"el mensaje de","title_placeholder":"Asunto (opcional)","to":"a","upload_audio":"A\xf1adir un archivo de audio.","upload_image":"A\xf1adir fotos","upload_music":"A\xf1adir m\xfasica","upload_pdf":"A\xf1adir PDF","upload_video":"A\xf1adir video","User not found":"El usuario no existe","users":"usuarios","video_not_ready":"El v\xeddeo a\xfan no est\xe1 listo.","weekly":"Semanal"}');


var $04cac85e3f8bd95f$exports = {};
$04cac85e3f8bd95f$exports = JSON.parse('{"account":"Tili","add_bookmark":"Lis\xe4\xe4 suosikkeihin","add_date":"Lis\xe4\xe4 p\xe4iv\xe4m\xe4\xe4r\xe4","ago":"{{duration}} sitten","api_key":"API-avain","are_you_sure":"Oletko varma?","ask_delete_message":"Poistaako t\xe4m\xe4n viestin?","audio_not_ready":"Audio ei ole viel\xe4 valmis.","bookmark_added":"Viesti suosikeissa.","bookmark_removed":"Viestin poistettu suosikeista.","bookmarks":"suosikit","cancel":"Peruuta","cancel_write":"Haluatko todella peruuttaa uuden viestin kirjoittamisen?","changed_group_name":"muutti ryhm\xe4n nime\xe4","confirm_password_placeholder":"Vahvista salasana","connect":"Yhteys","create_a_group":"Luo ryhm\xe4","create_the_group":"Luo ryhm\xe4","daily":"P\xe4ivitt\xe4in","default_group":"Oletusryhm\xe4","delete":"Poista","destroy_account_explain":"Kun olet poistanut tilisi, paluuta ei ole. Ole varma.","destroy_account":"Poista tilisi","edit":"Muokkaa","email_input":"T\xe4yt\xe4 s\xe4hk\xf6postiosoitteesi t\xe4\xe4ll\xe4","email":"S\xe4hk\xf6posti","empty_message":"Viesti on tyhj\xe4 eik\xe4 sit\xe4 voi l\xe4hett\xe4\xe4.","error_new_message":"Virhe tapahtui viestin l\xe4hett\xe4misen yhteydess\xe4.","error":"Tapahtui virhe","error_upload":"Latauksen aikana tapahtui virhe","forgot_password":"Unohditko salasanasi?","group_left":"Sin\xe4 j\xe4tit ryhm\xe4n.","group_share_choice":"Mihin ryhm\xe4\xe4n haluat l\xe4hett\xe4\xe4 t\xe4m\xe4n viestin?","groups":"Ryhm\xe4t","group_updated":"Ryhm\xe4 on p\xe4ivitetty.","has_commented_on":"on kommentoinut","has_joined":"on liittynyt","has_left":"on poistunut","has_posted_in":"on julkaissut","hourly":"Tunneittain","in":"ryhm\xe4ss\xe4","Invalid login/password":"Virheellinen k\xe4ytt\xe4j\xe4tunnus tai salasana","invitation_link":"Kutsulinkki","invitation_welcome":"Tervetuloa Zusamiin. Rekister\xf6idy ennen ryhm\xe4\xe4n liittymist\xe4.","just_now":"Juuri nyt","lang":"kieli","login_input":"Valitse k\xe4ytt\xe4j\xe4tunnus","login":"Kirjaudu sis\xe4\xe4n","login_placeholder":"s\xe4hk\xf6posti","logout":"Kirjaudu ulos","mark_all_as_read":"merkit\xe4 kaikki luetuiksi","monthly":"Kuukausittain","multiple_photos_upload":"Tapahtui virhe. Yrit\xe4 ladata kuvat yksi kerrallaan (t\xe4m\xe4 voi tapahtua joissakin selaimissa)","name_input":"Valitse nimi","name":"Nimi","new_password_placeholder":"uusi salasana","next_coms":"Katso seuraavat kommentit","none":"Ei mik\xe4\xe4n","notification_emails":"S\xe4hk\xf6postiilmoitukset","notification_emails_stopped":"S\xe4hk\xf6postiilmoitukset lakkautettiin!","notifications":"ilmoitukset","parent_message":"L\xe4hdeviesti","password_input":"Kirjoita uusi salasana t\xe4h\xe4n","password_placeholder":"salasana","password_reset_mail_sent":"Etsi salasanan palauttamisen s\xe4hk\xf6postia postilaatikkoosi.","password":"Salasana","passwords_dont_match":"Salasanat eiv\xe4t t\xe4sm\xe4\xe4","previous_coms":"Katso aiemmat kommentit","public_link":"julkinen linkki","publish_in_group":"julkaista ryhm\xe4ss\xe4","quit_group":"Poistu ryhm\xe4st\xe4","remove_bookmark":"Poista suosikeista","replies_one":"{{count}} vastaus","replies_other":"{{count}} vastausta","reply":"vastaa","reset_api_key":"API-avain (sinut katkaistaan.)","reset_invitation_link":"Nollaa kutsulinkki","reset_password_title":"Palauta salasanasi","save_changes":"Tallenna muutokset","search_in_group":"hae t\xe4st\xe4 ryhm\xe4st\xe4","search_without_result":"Hakusi ei vastannut mit\xe4\xe4n viesti\xe4.","settings":"Asetukset","settings_updated":"Asetuksesi p\xe4ivitettiin","share_message":"jaa viesti","signup":"Rekister\xf6idy","submit":"L\xe4het\xe4","text_placeholder":"Kirjoita viestisi t\xe4h\xe4n","the_message_from":"viestist\xe4","title_placeholder":"Sinun viestisi otsikko (valinnainen)","to":"nimeksi","upload_audio":"Lis\xe4\xe4 audiotiedosto.","upload_image":"Lis\xe4\xe4 kuvia","upload_music":"Lis\xe4\xe4 musiikkia","upload_pdf":"Lis\xe4\xe4 PDF","upload_video":"Lis\xe4\xe4 video","User not found":"K\xe4ytt\xe4j\xe4\xe4 ei l\xf6ytynyt","users":"k\xe4ytt\xe4j\xe4t","video_not_ready":"Video ei ole viel\xe4 valmis.","weekly":"Viikoittain"}');


var $f4617cd4713f2200$exports = {};
$f4617cd4713f2200$exports = JSON.parse('{"account":"Compte","add_bookmark":"Ajouter aux marque-pages","add_date":"Pr\xe9ciser une date","ago":"Il y a {{duration}}","api_key":"Cl\xe9 d\'API","are_you_sure":"\xcates-vous s\xfbr\xb7e\u202F?","ask_delete_message":"Supprimer ce message\u202F?","audio_not_ready":"Le fichier audio n\'est pas pr\xeat.","bookmark_added":"Message ajout\xe9 aux marque-pages.","bookmark_removed":"Message supprim\xe9 des marque-pages.","bookmarks":"marque-pages","cancel":"Annuler","cancel_write":"Voulez-vous annuler l\'\xe9criture d\'un nouveau message\xa0?","changed_group_name":"a chang\xe9 le nom du groupe","confirm_password_placeholder":"confirmez le mot de passe","connect":"Connexion","create_a_group":"Cr\xe9er un groupe","create_the_group":"Cr\xe9er le groupe","daily":"Journalier","default_group":"Groupe par d\xe9faut","delete":"Supprimer","destroy_account_explain":"Une fois votre compte supprim\xe9, il sera impossible d\'annuler l\'op\xe9ration.","destroy_account":"Supprimer votre compte","edit":"Modifier","email":"Courriel","email_input":"Saisissez votre adresse \xe9lectronique ici","empty_message":"Le message est vide et ne peut pas \xeatre envoy\xe9.","error_new_message":"Une erreur s\u2019est produite lors de l\u2019envoi de votre message.","error":"Une erreur s\'est produite","error_upload":"Une erreur s\'est produite pendant le t\xe9l\xe9versement","forgot_password":"Mot de passe oubli\xe9\u202F?","group_left":"Vous avez quitt\xe9 le groupe.","groups":"Groupes","group_share_choice":"\xc0 quel groupe voulez-vous envoyer ce message\u202F?","group_updated":"Le groupe a \xe9t\xe9 mis \xe0 jour.","has_commented_on":"a comment\xe9","has_joined":"a rejoint","has_left":"a quitt\xe9","has_posted_in":"a post\xe9 dans","hourly":"Une fois par heure","in":"dans","Invalid login/password":"Identifiant ou mot de passe invalide","invitation_link":"Lien d\'invitation","invitation_welcome":"Bienvenue sur Zusam. Veuillez vous inscrire avant de rejoindre le groupe.","just_now":"\xc0 l\'instant","lang":"langue","login_input":"Choisissez un identifiant","login_placeholder":"courriel","login":"Se connecter","logout":"Se d\xe9connecter","mark_all_as_read":"tout marquer comme lu","monthly":"Mensuelle","multiple_photos_upload":"Une erreur s\'est produite. Essayez de t\xe9l\xe9verser les images une par une (cela peut se produire dans certains navigateurs)","name_input":"Choisissez un nom","name":"Nom","new_password_placeholder":"nouveau mot de passe","next_coms":"Voir les commentaires suivants","none":"Aucune","notification_emails":"Notifications par courriel","notification_emails_stopped":"Notifications par courriel d\xe9sactiv\xe9es\u202F!","notifications":"notifications","parent_message":"Message parent","password_input":"Entrez un nouveau mot de passe","password":"Mot de passe","password_placeholder":"mot de passe","password_reset_mail_sent":"Recherchez le courriel de r\xe9initialisation de mot de passe dans votre bo\xeete de r\xe9ception.","passwords_dont_match":"Les mots de passe ne correspondent pas","previous_coms":"Voir les commentaires pr\xe9c\xe9dents","public_link":"lien public","publish_in_group":"publier dans le groupe","quit_group":"Quitter le groupe","react":"R\xe9agir","remove_bookmark":"Supprimer des marque-pages","replies_one":"{{count}} r\xe9ponse","replies_other":"{{count}} r\xe9ponses","reply":"r\xe9pondre","reset_api_key":"Changer votre clef d\'API (vous allez \xeatre d\xe9connect\xe9)","reset_invitation_link":"R\xe9initialiser le lien d\'invitation","reset_password_title":"R\xe9initialisation de votre mot de passe","save_changes":"Enregistrer les changements","search_in_group":"rechercher dans le groupe","search_without_result":"Votre recherche ne correspond \xe0 aucun message.","settings":"Param\xe8tres","settings_updated":"Vos param\xe8tres ont \xe9t\xe9 mis \xe0 jour","share_message":"partager le message","signup":"S\'inscrire","submit":"Envoyer","text_placeholder":"\xc9crivez votre message ici","the_message_from":"le message de","title_placeholder":"Titre de votre message (optionnel)","to":"en","upload_audio":"Ajouter un fichier audio.","upload_image":"Ajouter des photos","upload_music":"Ajouter des musiques","upload_pdf":"Ajouter un PDF","upload_video":"Ajouter une vid\xe9o","User not found":"Utilisateur inexistant","users":"utilisateurs","video_not_ready":"La vid\xe9o n\'est pas encore pr\xeate.","weekly":"Hebdomadaire","you_have_no_bookmarks":"Vous n\'avez pas de marques-pages."}');


var $05eb12ad9cc47d94$exports = {};
$05eb12ad9cc47d94$exports = JSON.parse('{"account":"Fi\xf3k","add_bookmark":"\xdczenet elrak\xe1sa a k\xf6nyvjelz\u0151kh\xf6z","add_date":"D\xe1tum hozz\xe1ad\xe1sa","ago":"{{duration}} ezel\xf6tt","api_key":"API kulcs","are_you_sure":"Biztos vagy benne?","ask_delete_message":"Biztos, hogy t\xf6rl\xf6d az \xfczenetet?","audio_not_ready":"","bookmark_added":"\xdczenet hozz\xe1adva a k\xf6nyvjelz\u0151kh\xf6z !","bookmark_removed":"Az \xfczenet elt\xe1vol\xedtva a k\xf6nyvjelz\u0151k k\xf6z\xfcl!","bookmarks":"k\xf6nyvjelz\u0151k","cancel":"M\xe9gsem","cancel_write":"Biztos, hogy megszak\xedt\xf3d az \xfaj \xfczeneted \xedr\xe1s\xe1t?","changed_group_name":"megv\xe1ltoztatta a csoport nev\xe9t","confirm_password_placeholder":"jelsz\xf3 meger\u0151s\xedt\xe9se","connect":"Kapcsolat","create_a_group":"Egy csoport l\xe9trehoz\xe1sa","create_the_group":"A csoport l\xe9trehoz\xe1sa","daily":"Napi","default_group":"Alap\xe9rtelmezett csoport","delete":"T\xf6rl\xe9s","destroy_account":"A fi\xf3k t\xf6rl\xe9se","destroy_account_explain":"Miut\xe1n t\xf6r\xf6lte a fi\xf3kj\xe1t, nincs vissza\xfat. K\xe9rlek, l\xe9gy biztos.","edit":"Szerkeszt\xe9s","email":"Email","email_input":"\xcdrd az email c\xedmedet ide","empty_message":"Az \xfczenet \xfcres \xe9s \xedgy nem k\xfcldhet\u0151 el !","error":"Hiba t\xf6rt\xe9nt","error_new_message":"Hiba t\xf6rt\xe9nt az \xfczenet k\xfcld\xe9se k\xf6zben.","error_upload":"Hiba t\xf6rt\xe9nt a felt\xf6lt\xe9s k\xf6zben","forgot_password":"Elfelejtetted a jelszavad?","group_left":"Elhagytad a csoportot !","groups":"Csoportok","group_share_choice":"Melyik csoportnak szeretn\xe9 elk\xfcldeni ezt az \xfczenetet?","group_updated":"A csoport friss\xedtve !","has_commented_on":"hozz\xe1szolt","has_joined":"csatlakozott","has_left":"kil\xe9pett","has_posted_in":"k\xf6zz\xe9t\xe9ve","hourly":"\xd3r\xe1nk\xe9nt","in":"ban","Invalid login/password":"Hib\xe1s felhaszn\xe1l\xf3 \xe9s/vagy jelsz\xf3","invitation_link":"Megh\xedv\xf3 link","invitation_welcome":"\xdcdv\xf6z\xf6l a Zusam ! Regisztr\xe1lj miel\xf6tt bel\xe9psz egy csoportba.","just_now":"Csak most","lang":"nyelv","login":"Bejelentkez\xe9s","login_input":"V\xe1lassz ki egy bejelentkez\xe9st","login_placeholder":"email","logout":"Kijelentkez\xe9s","mark_all_as_read":"\xf6sszes megjel\xf6l\xe9se olvasottk\xe9nt","monthly":"Havi","multiple_photos_upload":"Hiba t\xf6rt\xe9nt. Pr\xf3b\xe1ld a k\xe9peket egyes\xe9vel felt\xf6lteni ( n\xe9h\xe1ny b\xf6ng\xe9sz\u0151ben ez t\xf6rt\xe9nhet ).","name_input":"V\xe1lassz egy nevet","name":"N\xe9v","new_password_placeholder":"\xfaj jelsz\xf3","next_coms":"K\xf6vetkez\u0151 hozz\xe1sz\xf3l\xe1sok","none":"Egyik sem","notification_emails":"Email \xe9rtes\xedt\xe9sek","notification_emails_stopped":"Az e-mail \xe9rtes\xedt\xe9sek le\xe1lltak !","notifications":"\xe9rtes\xedt\xe9sek","parent_message":"Sz\xfcl\u0151 \xfczenet","password_input":"\xcdrd ide az \xfaj jelsz\xf3t","password":"Jelsz\xf3","password_placeholder":"jelsz\xf3","password_reset_mail_sent":"A jelsz\xf3helyre\xe1ll\xedt\xf3 email el lett k\xfcldve!","passwords_dont_match":"A jelszavak nem egyeznek","previous_coms":"Kor\xe1bbi hozz\xe1sz\xf3l\xe1sok","public_link":"nyilv\xe1nos link","publish_in_group":"k\xf6zz\xe9t\xe9tel a csoportban","quit_group":"Kil\xe9p\xe9s a csoportb\xf3l","remove_bookmark":"\xdczenet k\xf6nyvjelz\u0151j\xe9nek t\xf6rl\xe9se","replies_one":"{{count}} v\xe1lasz","replies_other":"{{count}} v\xe1lasz","reply":"v\xe1lasz","reset_api_key":"Az API-kulcs alaphelyzetbe \xe1ll\xedt\xe1sa (megszakad a kapcsolat)","reset_invitation_link":"Megh\xedv\xf3 link alaphelyzetbe \xe1ll\xedt\xe1sa","reset_password_title":"Jelsz\xf3 alaphelyzetbe \xe1ll\xedt\xe1s","save_changes":"V\xe1ltoz\xe1sok ment\xe9se","search_in_group":"keres\xe9s ebben a csoportban","search_without_result":"A keres\xe9s nem egyezett egyetlen \xfczenettel sem.","settings":"Be\xe1ll\xedt\xe1sok","settings_updated":"A be\xe1ll\xedt\xe1sok friss\xfcltek","share_message":"Az \xfczenet megoszt\xe1sa","signup":"Regisztr\xe1ci\xf3","submit":"K\xfcld\xe9s","text_placeholder":"\xcdrd ide az \xfczenetet","the_message_from":"az \xfczenet k\xfcld\u0151je","title_placeholder":"\xdczenet c\xedme (nem k\xf6telez\u0151)","to":"hoz","upload_audio":"","upload_image":"Fot\xf3k hozz\xe1ad\xe1sa","upload_music":"Zen\xe9k hozz\xe1ad\xe1sa","upload_pdf":"PDF hozz\xe1ad\xe1sa","upload_video":"Vide\xf3 hozz\xe1ad\xe1sa","User not found":"Felhaszn\xe1l\xf3 nem tal\xe1lhat\xf3","users":"felhaszn\xe1l\xf3k","video_not_ready":"A vide\xf3 m\xe9g nem \xe1ll k\xe9szen.","weekly":"Heti"}');


var $f19d5628ceb29353$exports = {};
$f19d5628ceb29353$exports = JSON.parse('{"account":"Account","add_bookmark":"Aggiungi ai segnalibri","add_date":"Aggiungi una data","ago":"{{duration}} fa","api_key":"Chiave API","are_you_sure":"Sei sicuro/sicura?","ask_delete_message":"Eliminare questo messaggio?","audio_not_ready":"L\'audio non \xe8 ancora pronto.","bookmark_added":"Messaggio aggiunto ai segnalibri.","bookmark_removed":"Messaggio rimosso dai segnalibri.","bookmarks":"segnalibri","cancel":"Annulla","cancel_write":"Vuoi davvero cancellare la scrittura di un nuovo messaggio?","changed_group_name":"ha cambiato il nome del gruppo","confirm_password_placeholder":"conferma la password","connect":"Connessione","create_a_group":"Crea un gruppo","create_the_group":"Crea il gruppo","daily":"Ogni giorno","default_group":"Gruppo predefinito","delete":"Elimina","destroy_account":"Elimina il tuo account","destroy_account_explain":"Una volta il proprio account eliminato, non \xe8 pi\xf9 possibile tornare indietro. Sii certo/certa.","edit":"Modifica","email":"E-mail","email_input":"Inserisci il tuo indirizzo e-mail qui","empty_message":"Il messaggio \xe8 vuoto e non pu\xf2 essere inviato.","error_new_message":"Si \xe8 verificato un errore durante l\'invio del messaggio.","error":"Si \xe8 verificato un errore","error_upload":"Si \xe8 verificato un errore durante il caricamento","forgot_password":"Hai dimenticato la password?","group_left":"Hai lasciato il gruppo.","groups":"Gruppi","group_share_choice":"A quale gruppo vuoi inviare questo messaggio?","group_updated":"Il gruppo \xe8 stato aggiornato.","has_commented_on":"ha commentato su","has_joined":"si \xe8 unito/a a","has_left":"ha lasciato","has_posted_in":"ha pubblicato in","hourly":"Ogni ora","in":"in","Invalid login/password":"Nome utente o password non validi","invitation_link":"Collegamento di invito","invitation_welcome":"Benvenuto o benvenuta su Zusam. Iscriviti prima di entrare nel gruppo.","just_now":"Proprio ora","lang":"lingua","login":"Accedi","login_input":"Scegli un identificatore","login_placeholder":"e-mail","logout":"Esci","mark_all_as_read":"contrassegna tutto come letto","monthly":"Ogni mese","multiple_photos_upload":"Si \xe8 verificato un errore. Prova a caricare le immagini una alla volta (questo pu\xf2 accadere in alcuni browser)","name_input":"Scegli un nome","name":"Nome","new_password_placeholder":"nuova password","next_coms":"Vedi i prossimi commenti","none":"Nessuna","notification_emails":"Notifiche per posta elettronica","notification_emails_stopped":"Notifiche per posta elettronica interrotte!","notifications":"notifiche","parent_message":"Messaggio originale","password_input":"Scrivi qui una nuova password","password":"Password","password_placeholder":"password","password_reset_mail_sent":"Cerca l\'e-mail di ripristino della password nella tua casella di posta.","passwords_dont_match":"Le password non corrispondono","previous_coms":"Vedi i commenti precedenti","public_link":"collegamento pubblico","publish_in_group":"pubblica nel gruppo","quit_group":"Lascia il gruppo","remove_bookmark":"Rimuovi dai segnalibri","replies_one":"{{count}} risposta","replies_other":"{{count}} risposte","reply":"rispondi","reset_api_key":"Reimposta la chiave API (sarai disconnesso/disconnessa)","reset_invitation_link":"Ripristina il collegamento di invito","reset_password_title":"Ripristina la tua password","save_changes":"Salva le modifiche","search_in_group":"ricerca in questo gruppo","search_without_result":"La tua ricerca non corrispondeva a nessun messaggio.","settings":"Impostazioni","settings_updated":"Le impostazioni sono state aggiornate","share_message":"condividi il messaggio","signup":"Iscriviti","submit":"Invia","text_placeholder":"Scrivi qui il tuo messaggio","the_message_from":"il messaggio da","title_placeholder":"Titolo del messaggio (opzionale)","to":"in","upload_audio":"Aggiungi un file audio.","upload_image":"Aggiungi foto","upload_music":"Aggiungi musica","upload_pdf":"Aggiungi PDF","upload_video":"Aggiungi un video","User not found":"Utente non trovato","users":"utenti","video_not_ready":"Il video non \xe8 ancora pronto.","weekly":"Ogni settimana"}');


var $40c2306b9c044cf3$exports = {};
$40c2306b9c044cf3$exports = JSON.parse('{"account":"\uACC4\uC815","add_bookmark":"\uBD81\uB9C8\uD06C \uBA54\uC2DC\uC9C0","add_date":"\uB0A0\uC9DC \uCD94\uAC00","ago":"{{duration}} \uC804","api_key":"API \uD0A4","are_you_sure":"\uD655\uC2E4\uD558\uB098\uC694?","ask_delete_message":"\uC774 \uBA54\uC2DC\uC9C0\uB97C \uC0AD\uC81C\uD558\uACA0\uC2B5\uB2C8\uAE4C?","audio_not_ready":"\uC624\uB514\uC624\uAC00 \uC544\uC9C1 \uC900\uBE44\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.","bookmark_added":"\uBD81\uB9C8\uD06C\uC5D0 \uBA54\uC2DC\uC9C0\uAC00 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","bookmark_removed":"\uBD81\uB9C8\uD06C\uC5D0\uC11C \uBA54\uC2DC\uC9C0\uAC00 \uC81C\uAC70\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","bookmarks":"\uBD81\uB9C8\uD06C","cancel":"\uCDE8\uC18C","cancel_write":"\uC0C8\uB85C\uC6B4 \uBA54\uC2DC\uC9C0 \uC791\uC131\uC744 \uCDE8\uC18C\uD558\uACA0\uC2B5\uB2C8\uAE4C?","changed_group_name":"\uADF8\uB8F9 \uC774\uB984 \uBCC0\uACBD\uB428","confirm_password_placeholder":"\uBE44\uBC00\uBC88\uD638 \uD655\uC778","connect":"\uC5F0\uACB0","create_a_group":"\uADF8\uB8F9 \uB9CC\uB4E4\uAE30","create_the_group":"\uADF8\uB8F9 \uB9CC\uB4E4\uAE30","daily":"\uC77C\uAC04","default_group":"\uAE30\uBCF8 \uADF8\uB8F9","delete":"\uC0AD\uC81C","destroy_account":"\uACC4\uC815 \uC0AD\uC81C","destroy_account_explain":"\uACC4\uC815\uC744 \uC0AD\uC81C\uD558\uBA74 \uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uD655\uC778 \uD574 \uC8FC\uC138\uC694.","edit":"\uD3B8\uC9D1","email":"\uC774\uBA54\uC77C","email_input":"\uC5EC\uAE30\uC5D0 \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD569\uB2C8\uB2E4","empty_message":"\uBA54\uC2DC\uC9C0\uAC00 \uBE44\uC5B4 \uC788\uC5B4 \uBCF4\uB0BC \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.","error":"\uC624\uB958 \uBC1C\uC0DD","error_new_message":"\uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0B4\uB294 \uB3D9\uC548 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.","error_upload":"\uC5C5\uB85C\uB4DC \uC911 \uC624\uB958 \uBC1C\uC0DD","forgot_password":"\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC5B4\uBC84\uB838\uC2B5\uB2C8\uAE4C?","group_left":"\uADF8\uB8F9\uC744 \uB098\uAC14\uC2B5\uB2C8\uB2E4.","groups":"\uADF8\uB8F9","group_share_choice":"\uC774 \uBA54\uC2DC\uC9C0\uB97C \uC5B4\uB290 \uADF8\uB8F9\uC5D0 \uBCF4\uB0B4\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?","group_updated":"\uADF8\uB8F9\uC774 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","has_commented_on":"\uB313\uAE00 \uB4F1\uB85D\uB428","has_joined":"\uAC00\uC785\uB428","has_left":"\uB098\uAC14\uC74C","has_posted_in":"\uAC8C\uC2DC\uB428","hourly":"\uB9E4 \uC2DC\uAC04","in":"\uC758","Invalid login/password":"\uC798\uBABB\uB41C \uB85C\uADF8\uC778 \uBC0F/\uB610\uB294 \uBE44\uBC00\uBC88\uD638","invitation_link":"\uCD08\uB300 \uB9C1\uD06C","invitation_welcome":"Zusam\uC5D0 \uC624\uC2E0 \uAC83\uC744 \uD658\uC601\uD569\uB2C8\uB2E4. \uADF8\uB8F9\uC5D0 \uAC00\uC785\uD558\uAE30 \uC804\uC5D0 \uAC00\uC785\uD558\uC138\uC694.","just_now":"\uC9C0\uAE08 \uB2F9\uC7A5","lang":"\uC5B8\uC5B4","login":"\uB85C\uADF8\uC778","login_input":"\uB85C\uADF8\uC778 \uC120\uD0DD","login_placeholder":"\uC774\uBA54\uC77C","logout":"\uB85C\uADF8\uC544\uC6C3","mark_all_as_read":"\uBAA8\uB450 \uC77D\uC740 \uAC83\uC73C\uB85C \uD45C\uC2DC","monthly":"\uC6D4\uAC04","multiple_photos_upload":"\uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uC774\uBBF8\uC9C0\uB97C \uD558\uB098\uC529 \uC5C5\uB85C\uB4DC\uD574 \uBCF4\uC138\uC694 (\uC77C\uBD80 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uBC1C\uC0DD\uD560 \uC218 \uC788\uC74C).","name":"\uC774\uB984","name_input":"\uC774\uB984 \uC120\uD0DD","new_password_placeholder":"\uC0C8\uB85C\uC6B4 \uBE44\uBC00\uBC88\uD638","next_coms":"\uB2E4\uC74C \uB313\uAE00 \uBCF4\uAE30","none":"\uC5C6\uC74C","notification_emails":"\uC774\uBA54\uC77C \uC54C\uB9BC","notification_emails_stopped":"\uC774\uBA54\uC77C \uC54C\uB9BC\uC774 \uC911\uC9C0\uB418\uC5C8\uC2B5\uB2C8\uB2E4!","notifications":"\uC54C\uB9BC","parent_message":"\uC0C1\uC704 \uBA54\uC2DC\uC9C0","password":"\uBE44\uBC00\uBC88\uD638","password_input":"\uC5EC\uAE30\uC5D0 \uC0C8\uB85C\uC6B4 \uBE44\uBC00\uBC88\uD638 \uC791\uC131","password_placeholder":"\uBE44\uBC00\uBC88\uD638","password_reset_mail_sent":"\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815 \uC774\uBA54\uC77C\uC774 \uC804\uC1A1\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","passwords_dont_match":"\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC74C","previous_coms":"\uC774\uC804 \uB313\uAE00 \uBCF4\uAE30","public_link":"\uACF5\uAC1C \uB9C1\uD06C","publish_in_group":"\uADF8\uB8F9\uC5D0 \uAC8C\uC2DC","quit_group":"\uADF8\uB8F9 \uB098\uAC00\uAE30","remove_bookmark":"\uBD81\uB9C8\uD06C \uD574\uC81C \uBA54\uC2DC\uC9C0","replies_one":"{{count}} \uB2F5\uAE00","replies_other":"{{count}} \uB2F5\uAE00","reply":"\uB2F5\uAE00","reset_api_key":"API \uD0A4 \uC7AC\uC124\uC815 (\uC5F0\uACB0\uC774 \uB04A\uC5B4\uC9D0)","reset_invitation_link":"\uCD08\uB300 \uB9C1\uD06C \uC7AC\uC124\uC815","reset_password_title":"\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815","save_changes":"\uBCC0\uACBD \uC0AC\uD56D \uC800\uC7A5","search_in_group":"\uC774 \uADF8\uB8F9\uC5D0\uC11C \uAC80\uC0C9","search_without_result":"\uAC80\uC0C9\uC5B4\uC640 \uC77C\uCE58\uD558\uB294 \uBA54\uC2DC\uC9C0\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.","settings":"\uC124\uC815","settings_updated":"\uC124\uC815 \uC5C5\uB370\uC774\uD2B8\uB428","share_message":"\uBA54\uC2DC\uC9C0 \uACF5\uC720","signup":"\uAC00\uC785\uD558\uAE30","submit":"\uC81C\uCD9C","text_placeholder":"\uC5EC\uAE30\uC5D0 \uBA54\uC2DC\uC9C0 \uC791\uC131","the_message_from":"\uBA54\uC138\uC9C0","title_placeholder":"\uBA54\uC2DC\uC9C0 \uC81C\uBAA9 (\uC120\uD0DD\uC0AC\uD56D)","to":"\uC5D0","upload_audio":"\uC624\uB514\uC624 \uD30C\uC77C\uC744 \uCD94\uAC00\uD569\uB2C8\uB2E4.","upload_image":"\uC0AC\uC9C4 \uCD94\uAC00","upload_music":"\uC74C\uC545 \uCD94\uAC00","upload_pdf":"PDF \uCD94\uAC00","upload_video":"\uB3D9\uC601\uC0C1 \uCD94\uAC00","User not found":"\uC0AC\uC6A9\uC790\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC74C","users":"\uC0AC\uC6A9\uC790","video_not_ready":"\uB3D9\uC601\uC0C1\uC774 \uC544\uC9C1 \uC900\uBE44\uB418\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4.","weekly":"\uC8FC\uAC04"}');


var $b99eed422708927a$exports = {};
$b99eed422708927a$exports = JSON.parse('{"account":"Konto","add_bookmark":"Bokmerk melding","add_date":"Legg til en dato","ago":"{{duration}} siden","api_key":"API-n\xf8kkel","are_you_sure":"Er du sikker?","ask_delete_message":"Slett meldingen?","audio_not_ready":"Lyden er ikke klar enda.","bookmark_added":"Melding bokmerket.","bookmark_removed":"Meldingsbokmerke fjernet.","bookmarks":"bokmerker","cancel":"Avbryt","cancel_write":"Forkast den nye meldingen?","changed_group_name":"endret gruppenavnet","confirm_password_placeholder":"bekreft","connect":"Tilkobling","create_a_group":"Opprett en gruppe","create_the_group":"Opprett gruppen","daily":"Daglig","default_group":"Forvalgt gruppe","delete":"Slett","destroy_account_explain":"N\xe5r du sletter kontoen din er permanent. V\xe6r sikker i din sak.","destroy_account":"Slett kontoen din","edit":"Rediger","email":"E-post","email_input":"Fyll inn e-postadressen din her","empty_message":"Meldingen er tom og kan ikke sendes.","error":"En feil oppstod","error_new_message":"En feil inntraff ved forsendelse av meldingen din.","error_upload":"En feil inntraff under opplasting","forgot_password":"Glemt passordet?","group_left":"Du forlot gruppen.","groups":"Grupper","group_share_choice":"Hvilken gruppe vil du sende denne meldingen til?","group_updated":"Gruppen ble oppdatert.","has_commented_on":"har kommentert","has_joined":"har tatt del i","has_left":"har forlatt","has_posted_in":"har postet i","hourly":"Timevist","in":"i","Invalid login/password":"Ugyldig brukernavn/eller passord","invitation_link":"Invitasjonslenke","invitation_welcome":"Velkommen til Zusam. Registrer deg f\xf8r du tar del i gruppen.","just_now":"Akkurat n\xe5","lang":"spr\xe5k","login_input":"Velg innloggingsnavn","login":"Logg inn","login_placeholder":"e-post","logout":"Logg ut","mark_all_as_read":"marker alt som lest","monthly":"M\xe5nedlig","multiple_photos_upload":"En feil inntraff. Pr\xf8v \xe5 laste opp bilder enkeltvis. (N\xf8dvendig i noen nettlesere.)","name_input":"Velg et navn","name":"Navn","new_password_placeholder":"nytt passord","next_coms":"Vis videre kommentarer","none":"Ingen","notification_emails":"E-postmerknader","notification_emails_stopped":"E-postmerknader stoppet!","notifications":"merknader","parent_message":"Inneholdende melding","password_input":"Skriv det nye passordet ditt her","password":"Passord","password_placeholder":"passord","password_reset_mail_sent":"Se etter e-post om tilbakestilling av passord i innboksen din.","passwords_dont_match":"Passordene samsvarer ikke","previous_coms":"Vis tidligere kommentarer","public_link":"offentlig lenke","publish_in_group":"offentliggj\xf8r i gruppen","quit_group":"Forlat gruppen","remove_bookmark":"Fjern meldingsbokmerke","replies_one":"{{count}} svar","replies_other":"{{count}} svar","reply":"svar","reset_api_key":"Tilbakestill API-n\xf8kkelen (du vil bli frakoblet)","reset_invitation_link":"Tilbakestill invitasjonslenke","reset_password_title":"Tilbakestill passordet ditt","save_changes":"Lagre endringer","search_in_group":"s\xf8k i denne gruppen","search_without_result":"S\xf8ket ditt er resultatl\xf8st.","settings":"Innstillinger","settings_updated":"Innstillingene dine ble oppdatert","share_message":"del meldingen","signup":"Registrer deg","submit":"Send inn","text_placeholder":"Skriv meldingen din her","the_message_from":"meldingen fra","title_placeholder":"Navn p\xe5 meldingen (valgfritt)","to":"til","upload_audio":"Legg til en lydfil.","upload_image":"Legg til bilder","upload_music":"Legg til musikk","upload_pdf":"Legg til PDF","upload_video":"Legg til video","User not found":"Fant ikke brukeren","users":"brukere","video_not_ready":"Videoen er ikke klar enda.","weekly":"Ukentlig"}');


var $2fbb943560e4ebcb$exports = {};
$2fbb943560e4ebcb$exports = JSON.parse('{"account":"Account","add_bookmark":"Voeg bericht toe aan bladwijzers","add_date":"Voeg een datum toe","ago":"{{duration}} geleden","api_key":"API key","are_you_sure":"Bent u zeker?","ask_delete_message":"Verwijder dit bericht?","audio_not_ready":"Audio is nog niet klaar.","bookmark_added":"Bericht toegevoegd aan bladwijzers.","bookmark_removed":"Bericht verwijderd uit bladwijzers.","bookmarks":"bladwijzers","cancel":"Annuleren","cancel_write":"Bent u zeker dat u dit bericht wil annuleren?","changed_group_name":"verandert de groepsnaam","confirm_password_placeholder":"bevestig wachtwoord","connect":"Verbind","create_a_group":"Maak een groep","create_the_group":"Maak de groep","daily":"Elke dag","default_group":"Standaard groep","delete":"Verwijderen","destroy_account_explain":"Indien u uw account verwijdert, kan deze niet meer worden teruggehaald.","destroy_account":"Verwijder jouw account","edit":"Bewerken","email":"E-mail","email_input":"Voeg uw e-mail adres hier in","empty_message":"Dit bericht is leeg en kan niet worden verzonden.","error":"Er is een fout opgetreden","error_new_message":"Er is een fout opgetreden bij het doorsturen van uw bericht.","error_upload":"Er is een fout opgetreden bij het uploaden","forgot_password":"Wachtwoord vergeten?","group_left":"U heeft de groep verlaten.","groups":"Groepen","group_share_choice":"Naar welke groep wenst u dit bericht te versturen?","group_updated":"De groep werd aangepast.","has_commented_on":"heeft commentaar gegeven op","has_joined":"is erbij gekomen","has_left":"is weggegaan","has_posted_in":"heeft gepost in","hourly":"Elk uur","in":"in","Invalid login/password":"Ongeldige aanmeldnaam/wachtwoord combinatie","invitation_link":"Uitnodigings link","invitation_welcome":"Welkom op Zusam. Gelieve aan te melden vooraleer in een groep in te schrijven.","just_now":"Net","lang":"taal","login":"Aanmelden","login_input":"Kies een aanmeldingsnaam","login_placeholder":"e-mail","logout":"Afmelden","mark_all_as_read":"markeer als gelezen","monthly":"Elke maand","multiple_photos_upload":"Er is een fout opgetreden. Probeer foto\'s \xe9\xe9n voor \xe9\xe9n op te laden","name_input":"Kies een naam","name":"Naam","new_password_placeholder":"nieuw wachtwoord","next_coms":"Zie volgende","none":"Niets","notification_emails":"E-mail meldingen","notification_emails_stopped":"E-mail meldingen zijn gestopt !","notifications":"notificaties","parent_message":"Parent bericht","password_input":"Kies een nieuw wachtwoord","password_placeholder":"wachtwoord","password_reset_mail_sent":"Zoek in uw inbox naar de wachtwoordreset e-mail.","passwords_dont_match":"Wachtwoorden komen niet overeen","password":"Wachtwoord","previous_coms":"Zie vorige","public_link":"publieke link","publish_in_group":"gepubliseerd in de groep","quit_group":"Verlaat de groep","remove_bookmark":"Verwijder bericht uit bladwijzers","replies_one":"{{count}} antwoord","replies_other":"{{count}} antwoorden","reply":"antwoorden","reset_api_key":"Reset de API key (u zal worden gedeconnecteerd)","reset_invitation_link":"Reset uitnodiging link","reset_password_title":"Reset uw wachtwoord","save_changes":"Wijzigingen opslaan","search_in_group":"zoek in deze groep","search_without_result":"Er werd geen enkel bericht gevonden met deze criteria.","settings":"Instellingen","settings_updated":"Uw instellingen werden aangepast","share_message":"Deel bericht","signup":"Inschrijven","submit":"Verstuur","text_placeholder":"Schrijf jouw bericht hier","the_message_from":"het bericht van","title_placeholder":"Titel van jouw bericht (optioneel)","to":"aan","upload_audio":"Voeg een audiobestand toe.","upload_image":"Voeg foto\'s toe","upload_music":"Voeg muziek toe","upload_pdf":"Voeg PDF toe","upload_video":"Voeg filmpje toe","User not found":"Gebruiker niet gevonden","users":"gebruikers","video_not_ready":"Video is nog niet klaar.","weekly":"Elke week"}');


var $e596a382eba2d746$exports = {};
$e596a382eba2d746$exports = JSON.parse('{"account":"Konto","add_bookmark":"Dodaj wiadomo\u015B\u0107 do zak\u0142adek","add_date":"Dodaj dat\u0119","ago":"{{duration}} temu","api_key":"Klucz API","ask_delete_message":"Czy na pewno chcesz usun\u0105\u0107 t\u0105 wiadomo\u015B\u0107?","bookmark_added":"Dodano wiadomo\u015B\u0107 do zak\u0142adek.","bookmarks":"zak\u0142adki","cancel":"Anuluj","confirm_password_placeholder":"potwierd\u017A has\u0142o","connect":"Po\u0142\u0105czenie","daily":"Codziennie","default_group":"Domy\u015Blna grupa","delete":"Usu\u0144","edit":"Edytuj","email":"E-mail","error":"Wyst\u0105pi\u0142 b\u0142\u0105d","forgot_password":"Nie pami\u0119tasz has\u0142a?","groups":"Grupy","has_joined":"do\u0142\u0105czy\u0142/a","has_left":"opu\u015Bci\u0142/a","hourly":"Co godzin\u0119","invitation_link":"Link zapraszaj\u0105cy","in":"w","just_now":"Przed chwil\u0105","lang":"j\u0119zyk","login_input":"Wybierz login","login_placeholder":"Adres e-mail","login":"Zaloguj si\u0119","logout":"Wyloguj si\u0119","monthly":"Co miesi\u0105c","name_input":"Wybierz nazw\u0119","name":"Nazwa","new_password_placeholder":"nowe has\u0142o","next_coms":"Zobacz nast\u0119pne komentarze","none":"Brak","notification_emails":"Powiadomienia e-mail","notifications":"powiadomienia","password":"Has\u0142o","password_placeholder":"Has\u0142o","passwords_dont_match":"Has\u0142a nie pasuj\u0105 do siebie","previous_coms":"Zobacz poprzednie komentarze","public_link":"link publiczny","remove_bookmark":"Usu\u0144 wiadomo\u015B\u0107 z zak\u0142adek","replies_one":"{{count}} odpowied\u017A","replies_other":"{{count}} odpowiedzi","reply":"odpowiedz","reset_password_title":"Zresetuj swoje has\u0142o","save_changes":"Zapisz zmiany","settings":"Ustawienia","signup":"Zarejestruj si\u0119","submit":"Prze\u015Blij","to":"do","upload_image":"Dodaj zdj\u0119cia","upload_music":"Dodaj muzyk\u0119","upload_pdf":"Dodaj PDF","upload_video":"Dodaj film","User not found":"Nie znaleziono u\u017Cytkownika","users":"u\u017Cytkownicy","weekly":"Co tydzie\u0144"}');


var $b5cea83b062a1770$exports = {};
$b5cea83b062a1770$exports = JSON.parse('{"account":"Conta","add_bookmark":"Adicionar mensagem aos favoritos","add_date":"Adicionar uma data","ago":"{{duration}} atr\xe1s","api_key":"Chave API","are_you_sure":"Voc\xea tem certeza?","ask_delete_message":"Deletar essa mensagem?","audio_not_ready":"O \xe1udio ainda n\xe3o est\xe1 pronto.","bookmark_added":"Mensagem adicionada aos favoritos.","bookmark_removed":"Mensagem removida dos favoritos.","bookmarks":"Favoritos","cancel":"Cancelar","cancel_write":"Voc\xea realmente deseja cancelar a cria\xe7\xe3o de uma nova mensagem?","changed_group_name":"mudou o nome do grupo","confirm_password_placeholder":"confirmar senha","connect":"Conex\xe3o","create_a_group":"Criar um grupo","create_the_group":"Criar o grupo","daily":"Diariamente","default_group":"Grupo padr\xe3o","delete":"Deletar","destroy_account":"Deletar sua conta","destroy_account_explain":"Depois de excluir sua conta, n\xe3o h\xe1 como voltar atr\xe1s. Por favor, tenha certeza.","edit":"Editar","email":"E-mail","email_input":"Preencha seu endere\xe7o de e-mail aqui","empty_message":"A mensagem est\xe1 vazia e n\xe3o pode ser enviada.","error_new_message":"Um erro ocorreu ao enviar sua mensagem.","error":"Um erro ocorreu","error_upload":"Ocorreu um erro durante o envio","forgot_password":"Esqueceu sua senha?","group_left":"Voc\xea saiu do grupo.","groups":"Grupos","group_share_choice":"Para qual grupo voc\xea deseja enviar essa mensagem?","group_updated":"O grupo foi atualizado.","has_commented_on":"comentou em","has_joined":"entrou","has_left":"saiu","has_posted_in":"postou em","hourly":"Por Hora","in":"em","Invalid login/password":"Login e/ou senha inv\xe1lidos","invitation_link":"Link de convite","invitation_welcome":"Bem-vindo ao Zusam. Registre-se antes de entrar no grupo.","just_now":"Agora mesmo","lang":"idioma","login":"Entrar","login_input":"Escolha um login","login_placeholder":"e-mail","logout":"Sair da sess\xe3o","mark_all_as_read":"marcar todos como lido","monthly":"Mensal","multiple_photos_upload":"Ocorreu um erro. Tente fazer o upload das imagens uma a uma (isso pode ocorrer em alguns navegadores)","name_input":"Escolher um nome","name":"Nome","new_password_placeholder":"nova senha","next_coms":"Ver os pr\xf3ximos coment\xe1rios","none":"Nenhuma","notification_emails":"Notifica\xe7\xf5es de e-mail","notification_emails_stopped":"As notifica\xe7\xf5es de e-mail foram interrompidas!","notifications":"notifica\xe7\xf5es","parent_message":"Mensagem relacionada","password_input":"Escreva uma nova senha aqui","password_placeholder":"senha","password_reset_mail_sent":"Procure o e-mail de redefini\xe7\xe3o de senha em sua caixa de entrada.","passwords_dont_match":"As senhas n\xe3o coincidem","password":"Senha","previous_coms":"Ver coment\xe1rios anteriores","public_link":"link p\xfablico","publish_in_group":"publicar no grupo","quit_group":"Sair do grupo","remove_bookmark":"Remover mensagem dos favoritos","replies_one":"{{count}} responder","replies_other":"{{count}} respostas","reply":"responder","reset_api_key":"Redefinir a chave API (voc\xea ser\xe1 desconectado)","reset_invitation_link":"Redefinir o link de convite","reset_password_title":"Redefinir sua senha","save_changes":"Salvar altera\xe7\xf5es","search_in_group":"procurar neste grupo","search_without_result":"Sua pesquisa n\xe3o correspondeu a nenhuma mensagem.","settings":"Configura\xe7\xf5es","settings_updated":"Suas configura\xe7\xf5es foram atualizadas","share_message":"compartilhe a mensagem","signup":"Registrar-se","submit":"Enviar","text_placeholder":"Escreva sua mensagem aqui","the_message_from":"a mensagem de","title_placeholder":"T\xedtulo da sua mensagem (opcional)","to":"para","upload_audio":"Adicionar um arquivo de \xe1udio.","upload_image":"Adicionar fotos","upload_music":"Adicionar m\xfasica","upload_pdf":"Adicionar PDF","upload_video":"Adicionar um v\xeddeo","User not found":"Usu\xe1rio n\xe3o encontrado","users":"usu\xe1rios","video_not_ready":"O v\xeddeo ainda n\xe3o est\xe1 pronto.","weekly":"Semanalmente"}');


var $97ae0da879a31ac5$exports = {};
$97ae0da879a31ac5$exports = JSON.parse('{"account":"\u0423\u0447\u0451\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C","add_bookmark":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0432 \u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438","add_date":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0434\u0430\u0442\u0443","ago":"{{duration}} \u0442\u043E\u043C\u0443 \u043D\u0430\u0437\u0430\u0434","api_key":"\u041A\u043B\u044E\u0447 API","are_you_sure":"\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B?","ask_delete_message":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435?","audio_not_ready":"\u0410\u0443\u0434\u0438\u043E \u0435\u0449\u0435 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u043E.","bookmark_added":"\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438.","bookmark_removed":"\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E \u0438\u0437 \u0437\u0430\u043A\u043B\u0430\u0434\u043E\u043A.","bookmarks":"\u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438","cancel_write":"\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0443 \u043D\u043E\u0432\u043E\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F?","cancel":"\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C","changed_group_name":"\u0438\u0437\u043C\u0435\u043D\u0438\u043B \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u0440\u0443\u043F\u043F\u044B","confirm_password_placeholder":"\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C","connect":"\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435","create_a_group":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u0443","create_the_group":"\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u044D\u0442\u0443 \u0433\u0440\u0443\u043F\u043F\u0443","daily":"\u041A\u0430\u0436\u0434\u043E\u0434\u043D\u0435\u0432\u043D\u043E","default_group":"\u0413\u0440\u0443\u043F\u043F\u0430 \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E","delete":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C","destroy_account_explain":"\u041A\u0430\u043A \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u0435 \u0441\u0432\u043E\u044E \u0443\u0447\u0451\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C, \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u043D\u0435 \u0431\u0443\u0434\u0435\u0442. \u0418\u043C\u0435\u0439\u0442\u0435 \u0432 \u0432\u0438\u0434\u0443.","destroy_account":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442","edit":"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C","email_input":"\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u0437\u0434\u0435\u0441\u044C","email":"\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430","empty_message":"\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043F\u0443\u0441\u0442\u043E\u0435 \u0438 \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E.","error_new_message":"\u041F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430.","error_upload":"\u0412\u043E \u0432\u0440\u0435\u043C\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430","error":"\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430","forgot_password":"\u0417\u0430\u0431\u044B\u043B\u0438 \u0441\u0432\u043E\u0439 \u043F\u0430\u0440\u043E\u043B\u044C?","group_left":"\u0412\u044B \u043F\u043E\u043A\u0438\u043D\u0443\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u0443.","group_share_choice":"\u041A\u0430\u043A\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u0435 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u044D\u0442\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435?","groups":"\u0413\u0440\u0443\u043F\u043F\u044B","group_updated":"\u0413\u0440\u0443\u043F\u043F\u0430 \u0431\u044B\u043B\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430.","has_commented_on":"\u043F\u0440\u043E\u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043B","has_joined":"\u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u043B\u0441\u044F","has_left":"\u0443\u0448\u0435\u043B","has_posted_in":"\u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u043B \u0432","hourly":"\u041A\u0430\u0436\u0434\u044B\u0439 \u0447\u0430\u0441","Invalid login/password":"\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043B\u043E\u0433\u0438\u043D \u0438/\u0438\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C","invitation_link":"\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430","invitation_welcome":"\u0414\u043E\u0431\u0440\u043E \u043F\u043E\u0436\u0430\u043B\u043E\u0432\u0430\u0442\u044C \u043D\u0430 Zusam! \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C, \u043F\u0440\u0435\u0436\u0434\u0435 \u0447\u0435\u043C \u043F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F \u043A \u0433\u0440\u0443\u043F\u043F\u0435.","in":"\u0432","just_now":"\u041F\u0440\u044F\u043C\u043E \u0441\u0435\u0439\u0447\u0430\u0441","lang":"\u044F\u0437\u044B\u043A","login_input":"\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F","login_placeholder":"\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430","login":"\u0412\u043E\u0439\u0442\u0438","logout":"\u0412\u044B\u0439\u0442\u0438","mark_all_as_read":"\u043E\u0442\u043C\u0435\u0442\u044C\u0442\u0435 \u0432\u0441\u0435 \u043A\u0430\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u043E\u0435","monthly":"\u041A\u0430\u0436\u0434\u044B\u0439 \u043C\u0435\u0441\u044F\u0446","multiple_photos_upload":"\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043F\u043E \u043E\u0434\u043D\u043E\u043C\u0443 (\u044D\u0442\u043E \u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0442\u0438 \u0432 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430\u0445)","name_input":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0438\u043C\u044F","name":"\u0418\u043C\u044F","new_password_placeholder":"\u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C","next_coms":"\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438","none":"\u041D\u0438\u0447\u0435\u0433\u043E","notification_emails_stopped":"\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435 \u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B!","notification_emails":"\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435","notifications":"\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F","parent_message":"\u0418\u0441\u0445\u043E\u0434\u043D\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435","password_input":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u0437\u0434\u0435\u0441\u044C","password_placeholder":"\u043F\u0430\u0440\u043E\u043B\u044C","password_reset_mail_sent":"\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0430\u0448 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u044F\u0449\u0438\u043A \u043D\u0430 \u043F\u0438\u0441\u044C\u043C\u043E.","passwords_dont_match":"\u041F\u0430\u0440\u043E\u043B\u0438 \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0442","password":"\u041F\u0430\u0440\u043E\u043B\u044C","previous_coms":"\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438","public_link":"\u043E\u0431\u0449\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0441\u0441\u044B\u043B\u043A\u0430","publish_in_group":"\u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u0432 \u0433\u0440\u0443\u043F\u043F\u0435","quit_group":"\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u0433\u0440\u0443\u043F\u043F\u0443","remove_bookmark":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0438\u0437 \u0437\u0430\u043A\u043B\u0430\u0434\u043A\u0438","replies_one":"{{count}} \u043E\u0442\u0432\u0435\u0442","replies_other":"{{count}} \u043E\u0442\u0432\u0435\u0442\u043E\u0432","reply":"\u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C","reset_api_key":"\u0421\u0431\u0440\u043E\u0441\u044C\u0442\u0435 \u043A\u043B\u044E\u0447 API (\u0432\u044B \u0431\u0443\u0434\u0435\u0442\u0435 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u044B)","reset_invitation_link":"\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435","reset_password_title":"\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C","save_changes":"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F","search_in_group":"\u043F\u043E\u0438\u0441\u043A \u0432 \u044D\u0442\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u0435","search_without_result":"\u0412\u0430\u0448 \u043F\u043E\u0438\u0441\u043A \u043D\u0435 \u0432\u044B\u044F\u0432\u0438\u043B \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F.","settings_updated":"\u0412\u0430\u0448\u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0431\u044B\u043B\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u044B","settings":"\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438","share_message":"\u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043C","signup":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F","submit":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C","text_placeholder":"\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0441\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0437\u0434\u0435\u0441\u044C","the_message_from":"\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043E\u0442","title_placeholder":"\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F (\u043E\u043F\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E)","to":"\u043A","upload_audio":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u0443\u0434\u0438\u043E\u0444\u0430\u0439\u043B.","upload_image":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438","upload_music":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u0443\u0437\u044B\u043A\u0443","upload_pdf":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C PDF-\u0444\u0430\u0439\u043B","upload_video":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u0438\u0434\u0435\u043E","User not found":"\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D","users":"\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438","video_not_ready":"\u0412\u0438\u0434\u0435\u043E \u0435\u0449\u0435 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u043E.","weekly":"\u041A\u0430\u0436\u0434\u0443\u044E \u043D\u0435\u0434\u0435\u043B\u044E"}');


var $1246cd9971f5257e$exports = {};
$1246cd9971f5257e$exports = JSON.parse('{"account":"\xda\u010Det","add_bookmark":"T\xfato spr\xe1vu ulo\u017Ei\u0165 medzi z\xe1lo\u017Eky","add_date":"Prida\u0165 d\xe1tum","ago":"{{duration}} sp\xe4\u0165","api_key":"K\u013E\xfa\u010D API","are_you_sure":"Si si ist\xfd ?","ask_delete_message":"Odstr\xe1\u0148te t\xfato spr\xe1vu?","audio_not_ready":"Audio e\u0161te nie je pripraven\xfd.","bookmark_added":"Kniha spr\xe1v.","bookmark_removed":"Spr\xe1va z\xe1lo\u017Eka odstr\xe1nen\xe1.","bookmarks":"z\xe1lo\u017Eky","cancel_write":"Chcete naozaj zru\u0161i\u0165 vytv\xe1ranie nov\xe9ho pr\xedspevku?","cancel":"Zru\u0161i\u0165","changed_group_name":"zmenil n\xe1zov skupiny","confirm_password_placeholder":"potvrdi\u0165 heslo","connect":"Pripojenie","create_a_group":"Vytvori\u0165 skupinu","create_the_group":"Vytvori\u0165 skupinu","daily":"Denne","default_group":"Predvolen\xfa skupinu","delete":"Zmaza\u0165","destroy_account_explain":"Potom, \u010Do vyma\u017Eete svoj \xfa\u010Det, nie je tam \u017Eiadny n\xe1vrat. Pros\xedm, uistite sa.","destroy_account":"Odstr\xe1\u0148te svoj \xfa\u010Det","edit":"Upravi\u0165","email":"E-mail","email_input":"Vypl\u0148te svoju e-mailov\xfa adresu tu","empty_message":"Spr\xe1va je pr\xe1zdna a nie je mo\u017En\xe1.","error":"Chyba","error_new_message":"Pri odosielan\xed va\u0161ej spr\xe1vy do\u0161lo k chybe.","error_upload":"Objavila sa chyba po\u010Das odosielania","forgot_password":"Zabudli ste heslo?","group_left":"Opustili ste skupinu.","group_share_choice":"Ktor\xe9 skupiny chcete posla\u0165 t\xfato spr\xe1vu?","groups":"Skupiny","group_updated":"Skupina bola aktualizovan\xe1.","has_commented_on":"komentoval","has_joined":"sa pripojil k","has_left":"opustil","has_posted_in":"zverejnila v","hourly":"Ka\u017Ed\xfa hodinu","in":"v","Invalid login/password":"Nespr\xe1vny login alebo heslo","invitation_link":"Poz\xfdvac\xed odkaz","invitation_welcome":"Vitajte na Zusam. Pros\xedm, prihl\xe1ste sa pred vstupom do skupiny.","just_now":"Pr\xe1ve teraz","lang":"jazyk","login_input":"Zvo\u013E si nejak\xe9 prihlasovacie meno","login_placeholder":"e-mail","login":"Prihl\xe1si\u0165 sa","logout":"Odhl\xe1si\u0165 sa","mark_all_as_read":"ozna\u010Di\u0165 v\u0161etko ako pre\u010D\xedtan\xe9","monthly":"Mesa\u010Dne","multiple_photos_upload":"Objavila sa chyba. Sk\xfaste prilo\u017Ei\u0165 obr\xe1zky po jednom (t\xe1to chyba sa m\xf4\u017Ee objavova\u0165 v niektor\xfdch prehliada\u010Doch)","name_input":"Zvo\u013E si nejak\xe9 meno","name":"Meno","new_password_placeholder":"nov\xe9 heslo","next_coms":"Pozri nasleduj\xface koment\xe1re","none":"\u017Diadne","notification_emails":"E-mailov\xe9 upozornenia","notification_emails_stopped":"E-mailov\xe9 upozornenia zastavili!","notifications":"ozn\xe1menia","parent_message":"Spr\xe1va rodi\u010Da","password":"Heslo","password_input":"Tu nap\xed\u0161 heslo","password_placeholder":"heslo","password_reset_mail_sent":"Pozrite sa na e-mail na obnovenie hesla v schr\xe1nke.","passwords_dont_match":"Hesl\xe1 sa nezhoduj\xfa","previous_coms":"Pozri predch\xe1dzaj\xface koment\xe1re","public_link":"verejn\xe9 spojenie","publish_in_group":"publikova\u0165 v skupine","quit_group":"Opusti\u0165 skupinu","remove_bookmark":"Zru\u0161te ozna\u010Denie tejto spr\xe1vy","replies_one":"{{count}} odpove\u010F","replies_other":"{{count}} odpoved\xed","reply":"odpove\u010F","reset_api_key":"Obnovte k\u013E\xfa\u010D rozhrania API (budete odpojen\xed)","reset_invitation_link":"Obnovi\u0165 pozv\xe1nku odkaz","reset_password_title":"Zmena hesla","save_changes":"Ulo\u017Ei\u0165 zmeny","search_in_group":"h\u013Eada\u0165 v tejto skupine","search_without_result":"Va\u0161e vyh\u013Ead\xe1vanie nezhodla \u017Eiadne spr\xe1vy.","settings":"Nastavenia","settings_updated":"Va\u0161e nastavenia boli zmenen\xe9","share_message":"zdie\u013Eajte spr\xe1vu","signup":"Prihl\xe1si\u0165","submit":"Odosla\u0165","text_placeholder":"Tu nap\xed\u0161 pr\xedspevok","the_message_from":"spr\xe1va od","title_placeholder":"Nadpis v\xe1\u0161ho pr\xedspevku (nie je povinn\xe9)","to":"na","upload_audio":"Pridajte zvukov\xfd s\xfabor.","upload_image":"Prida\u0165 fotografie","upload_music":"Prida\u0165 hudbu","upload_pdf":"Prida\u0165 PDF","upload_video":"Pridajte video","User not found":"Neexistuj\xfaci u\u017E\xedvate\u013E","users":"u\u017E\xedvatelia","video_not_ready":"Video e\u0161te nie je pripraven\xe9.","weekly":"T\xfd\u017Edenne"}');


var $e7d0401e50621b7e$exports = {};
$e7d0401e50621b7e$exports = JSON.parse('{"account":"\u0B95\u0BA3\u0B95\u0BCD\u0B95\u0BC1","add_bookmark":"\u0BAA\u0BC1\u0B95\u0BCD\u0BAE\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF","add_date":"\u0B92\u0BB0\u0BC1 \u0BA4\u0BC7\u0BA4\u0BBF\u0BAF\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","ago":"{{duration}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","api_key":"\u0BAA\u0BA8\u0BBF\u0B87 \u0BB5\u0BBF\u0B9A\u0BC8","are_you_sure":"\u0BA8\u0BC0 \u0B9A\u0BC6\u0BBE\u0BB2\u0BCD\u0BB5\u0BA4\u0BC1 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAF\u0BBE?","ask_delete_message":"\u0B87\u0BA8\u0BCD\u0BA4 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BB5\u0BBE?","audio_not_ready":"\u0B86\u0B9F\u0BBF\u0BAF\u0BCB \u0B87\u0BA9\u0BCD\u0BA9\u0BC1\u0BAE\u0BCD \u0BA4\u0BAF\u0BBE\u0BB0\u0BBE\u0B95 \u0B87\u0BB2\u0BCD\u0BB2\u0BC8.","bookmark_added":"\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF \u0BAA\u0BC1\u0B95\u0BCD\u0BAE\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","bookmark_removed":"\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF \u0BAA\u0BC1\u0B95\u0BCD\u0BAE\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BC1 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","bookmarks":"\u0BAA\u0BC1\u0B95\u0BCD\u0BAE\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BC1\u0B95\u0BB3\u0BCD","cancel_write":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8 \u0B8E\u0BB4\u0BC1\u0BA4\u0BC1\u0BB5\u0BA4\u0BC8 \u0BB0\u0BA4\u0BCD\u0BA4\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF \u0BB5\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BC1\u0B95\u0BBF\u0BB1\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BBE?","cancel":"\u0BB0\u0BA4\u0BCD\u0BA4\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD","changed_group_name":"\u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BBF\u0BA9\u0BCD \u0BAA\u0BC6\u0BAF\u0BB0\u0BC8 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BBF\u0BAF\u0BA4\u0BC1","confirm_password_placeholder":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD\u0BB2\u0BC8 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD","connect":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1","create_a_group":"\u0B92\u0BB0\u0BC1 \u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BC8 \u0B89\u0BB0\u0BC1\u0BB5\u0BBE\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","create_the_group":"\u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BC8 \u0B89\u0BB0\u0BC1\u0BB5\u0BBE\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","daily":"\u0BA8\u0BBE\u0BB3\u0BCD\u0BA4\u0BCB\u0BB1\u0BC1\u0BAE\u0BCD","default_group":"\u0B87\u0BAF\u0BB2\u0BCD\u0BAA\u0BC1\u0BA8\u0BBF\u0BB2\u0BC8 \u0B95\u0BC1\u0BB4\u0BC1","delete":"\u0B85\u0BB4\u0BBF","destroy_account_explain":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BA3\u0B95\u0BCD\u0B95\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BBF\u0BAF\u0BA4\u0BC1\u0BAE\u0BCD, \u0BA4\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BBF\u0B9A\u0BCD \u0B9A\u0BC6\u0BB2\u0BCD\u0BB5\u0BA4\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8. \u0BA4\u0BAF\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC1 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAF\u0BBE\u0B95 \u0B87\u0BB0\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD.","destroy_account":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BA3\u0B95\u0BCD\u0B95\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1","edit":"\u0BA4\u0BC6\u0BBE\u0B95\u0BC1","email_input":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD \u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF\u0BAF\u0BC8 \u0B87\u0B99\u0BCD\u0B95\u0BC7 \u0BA8\u0BBF\u0BB0\u0BAA\u0BCD\u0BAA\u0BB5\u0BC1\u0BAE\u0BCD","email":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD","empty_message":"\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF \u0B95\u0BBE\u0BB2\u0BBF\u0BAF\u0BBE\u0B95 \u0B89\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1 \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0B85\u0BA9\u0BC1\u0BAA\u0BCD\u0BAA \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1.","error_new_message":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8 \u0B85\u0BA9\u0BC1\u0BAA\u0BCD\u0BAA\u0BC1\u0BAE\u0BCD\u0BAA\u0BCB\u0BA4\u0BC1 \u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","error_upload":"\u0BAA\u0BA4\u0BBF\u0BB5\u0BC7\u0BB1\u0BCD\u0BB1\u0BA4\u0BCD\u0BA4\u0BBF\u0BA9\u0BCD \u0BAA\u0BCB\u0BA4\u0BC1 \u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","error":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","forgot_password":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB2\u0BCD\u0BB2\u0BC8 \u0BAE\u0BB1\u0BA8\u0BCD\u0BA4\u0BC1 \u0BB5\u0BBF\u0B9F\u0BCD\u0B9F\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BBE?","group_left":"\u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BC8 \u0BB5\u0BBF\u0B9F\u0BCD\u0B9F\u0BC1 \u0BB5\u0BC6\u0BB3\u0BBF\u0BAF\u0BC7\u0BB1\u0BBF\u0BA9\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD.","group_share_choice":"\u0B87\u0BA8\u0BCD\u0BA4 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8 \u0B8E\u0BA8\u0BCD\u0BA4 \u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0B85\u0BA9\u0BC1\u0BAA\u0BCD\u0BAA \u0BB5\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BC1\u0B95\u0BBF\u0BB1\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD?","groups":"\u0B95\u0BC1\u0BB4\u0BC1\u0B95\u0BCD\u0B95\u0BB3\u0BCD","group_updated":"\u0B95\u0BC1\u0BB4\u0BC1 \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","has_commented_on":"\u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1 \u0BA4\u0BC6\u0BB0\u0BBF\u0BB5\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1","has_joined":"\u0B9A\u0BC7\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4\u0BC1\u0BB3\u0BCD\u0BB3\u0BBE\u0BB0\u0BCD","has_left":"\u0BAA\u0BC7\u0BBE\u0BAF\u0BCD \u0BB5\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","has_posted_in":"\u0B87\u0B9F\u0BC1\u0B95\u0BC8\u0BAF\u0BBF\u0B9F\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BC1\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1","hourly":"\u0BAE\u0BA3\u0BBF\u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1","Invalid login/password":"\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0BB5\u0BC1 \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD/\u0B85\u0BB2\u0BCD\u0BB2\u0BA4\u0BC1 \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD","invitation_link":"\u0B85\u0BB4\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BA4\u0BB4\u0BCD \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1","invitation_welcome":"\u0B9A\u0BC2\u0B9A\u0BBE\u0BAE\u0BBF\u0BB2\u0BCD \u0BB5\u0BB0\u0BB5\u0BC7\u0BB1\u0BCD\u0B95\u0BBF\u0BB1\u0BCB\u0BAE\u0BCD. \u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BBF\u0BB2\u0BCD \u0B9A\u0BC7\u0BB0\u0BC1\u0BB5\u0BA4\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD \u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0BAA\u0BC6\u0BB1\u0BC1\u0B95.","in":"\u0B87\u0BB2\u0BCD","just_now":"\u0B87\u0BAA\u0BCD\u0BAA\u0BCB\u0BA4\u0BC1","lang":"\u0BAE\u0BCA\u0BB4\u0BBF","login_input":"\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0BB5\u0BC8\u0BA4\u0BCD \u0BA4\u0BC7\u0BB0\u0BCD\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0B95","login_placeholder":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD","login":"\u0BAA\u0BC1\u0B95\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","logout":"\u0BB5\u0BBF\u0B9F\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","mark_all_as_read":"\u0B85\u0BA9\u0BC8\u0BA4\u0BCD\u0BA4\u0BC8\u0BAF\u0BC1\u0BAE\u0BCD \u0BB5\u0BBE\u0B9A\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BBE\u0B95 \u0B85\u0B9F\u0BC8\u0BAF\u0BBE\u0BB3\u0BAE\u0BBF\u0B9F\u0BC1","monthly":"\u0BAE\u0BBE\u0BA4\u0BBE\u0BA8\u0BCD\u0BA4\u0BBF\u0BB0","multiple_photos_upload":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1. \u0BAA\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B92\u0BB5\u0BCD\u0BB5\u0BCA\u0BA9\u0BCD\u0BB1\u0BBE\u0B95 \u0BAA\u0BA4\u0BBF\u0BB5\u0BC7\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0BAF\u0BB1\u0BCD\u0B9A\u0BBF\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD (\u0B87\u0BA4\u0BC1 \u0B9A\u0BBF\u0BB2 \u0B89\u0BB2\u0BBE\u0BB5\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0B95\u0BB4\u0BB2\u0BBE\u0BAE\u0BCD)","name_input":"\u0B92\u0BB0\u0BC1 \u0BAA\u0BC6\u0BAF\u0BB0\u0BC8\u0BA4\u0BCD \u0BA4\u0BC7\u0BB0\u0BCD\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0B95","name":"\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD","new_password_placeholder":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB2\u0BCD","next_coms":"\u0B85\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4 \u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","none":"\u0B8E\u0BA4\u0BC1\u0BB5\u0BC1\u0BAE\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","notification_emails_stopped":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD \u0B85\u0BB1\u0BBF\u0BB5\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD \u0BA8\u0BBF\u0BB1\u0BC1\u0BA4\u0BCD\u0BA4\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA9!","notification_emails":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BCD \u0B85\u0BB1\u0BBF\u0BB5\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD","notifications":"\u0B85\u0BB1\u0BBF\u0BB5\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD","parent_message":"\u0BAA\u0BC6\u0BB1\u0BCD\u0BB1\u0BCB\u0BB0\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF","password_input":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD\u0BB2\u0BC8 \u0B87\u0B99\u0BCD\u0B95\u0BC7 \u0B8E\u0BB4\u0BC1\u0BA4\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","password_placeholder":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB2\u0BCD","password_reset_mail_sent":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B87\u0BA9\u0BCD\u0BAA\u0BBE\u0B95\u0BCD\u0B9A\u0BBF\u0BB2\u0BCD \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD \u0BAE\u0BC0\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 \u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BC8\u0BA4\u0BCD \u0BA4\u0BC7\u0B9F\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD.","passwords_dont_match":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BCD \u0BAA\u0BCA\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","password":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB2\u0BCD","previous_coms":"\u0BAE\u0BC1\u0BA8\u0BCD\u0BA4\u0BC8\u0BAF \u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","public_link":"\u0BAA\u0BCA\u0BA4\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1","publish_in_group":"\u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BBF\u0BB2\u0BCD \u0BB5\u0BC6\u0BB3\u0BBF\u0BAF\u0BBF\u0B9F\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","quit_group":"\u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BC8 \u0BB5\u0BBF\u0B9F\u0BCD\u0B9F\u0BC1 \u0BB5\u0BBF\u0B9F\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","remove_bookmark":"\u0BAA\u0BC1\u0BA4\u0BCD\u0BA4\u0B95\u0BAE\u0BB0\u0BAE\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF","replies_one":"{{count}} \u0BAA\u0BA4\u0BBF\u0BB2\u0BCD","replies_other":"{{count}} \u0BAA\u0BA4\u0BBF\u0BB2\u0BCD\u0B95\u0BB3\u0BCD","reply":"\u0BAA\u0BA4\u0BBF\u0BB2\u0BCD","reset_api_key":"\u0BAA\u0BA8\u0BBF\u0B87 \u0BB5\u0BBF\u0B9A\u0BC8\u0BAF\u0BC8 \u0BAE\u0BC0\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD (\u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BA4\u0BC1\u0BA3\u0BCD\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BB5\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD)","reset_invitation_link":"\u0B85\u0BB4\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BA4\u0BB4\u0BCD \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC8 \u0BAE\u0BC0\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","reset_password_title":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB2\u0BCD\u0BB2\u0BC8 \u0BAE\u0BC0\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0B95\u0BCD\u0B95","save_changes":"\u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAF\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","search_in_group":"\u0B87\u0BA8\u0BCD\u0BA4 \u0B95\u0BC1\u0BB4\u0BC1\u0BB5\u0BBF\u0BB2\u0BCD \u0BA4\u0BC7\u0B9F\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","search_without_result":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BA4\u0BC7\u0B9F\u0BB2\u0BCD \u0B8E\u0BA8\u0BCD\u0BA4 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAA\u0BCA\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","settings_updated":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA9","settings":"\u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD","share_message":"\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BB5\u0BC1\u0BAE\u0BCD","signup":"\u0BAA\u0BA4\u0BBF\u0BB5\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0B95","submit":"\u0B9A\u0BAE\u0BB0\u0BCD\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","text_placeholder":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BC8 \u0B87\u0B99\u0BCD\u0B95\u0BC7 \u0B8E\u0BB4\u0BC1\u0BA4\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD","the_message_from":"\u0B87\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF","title_placeholder":"\u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0BAF\u0BBF\u0BA9\u0BCD \u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 (\u0BB5\u0BBF\u0BB0\u0BC1\u0BAE\u0BCD\u0BAA\u0BBF\u0BA9\u0BBE\u0BB2\u0BCD)","to":"\u0BAA\u0BC6\u0BB1\u0BC1\u0BA8\u0BB0\u0BCD","upload_audio":"\u0B86\u0B9F\u0BBF\u0BAF\u0BCB \u0B95\u0BCB\u0BAA\u0BCD\u0BAA\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD.","upload_image":"\u0BAA\u0BC1\u0B95\u0BC8\u0BAA\u0BCD\u0BAA\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","upload_music":"\u0B87\u0B9A\u0BC8\u0BAF\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","upload_pdf":"PDF \u0B90\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","upload_video":"\u0BB5\u0BC0\u0B9F\u0BBF\u0BAF\u0BCB\u0BB5\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95\u0BB5\u0BC1\u0BAE\u0BCD","User not found":"\u0BAA\u0BAF\u0BA9\u0BB0\u0BCD \u0B95\u0BA3\u0BCD\u0B9F\u0BC1\u0BAA\u0BBF\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","users":"\u0BAA\u0BAF\u0BA9\u0BB0\u0BCD\u0B95\u0BB3\u0BCD","video_not_ready":"\u0BB5\u0BC0\u0B9F\u0BBF\u0BAF\u0BCB \u0B87\u0BA9\u0BCD\u0BA9\u0BC1\u0BAE\u0BCD \u0BA4\u0BAF\u0BBE\u0BB0\u0BBE\u0B95 \u0B87\u0BB2\u0BCD\u0BB2\u0BC8.","weekly":"\u0BB5\u0BBE\u0BB0\u0BBE\u0BA8\u0BCD\u0BA4\u0BBF\u0BB0"}');


var $b041c0894ca4dd4d$exports = {};
$b041c0894ca4dd4d$exports = JSON.parse('{"account":"\u2D30\u2D4E\u2D49\u2D39\u2D30\u2D4F","add_bookmark":"\u2D54\u2D4F\u2D53 \u2D33 \u2D5C\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54","add_date":"\u2D54\u2D4F\u2D53 \u2D3D\u2D54\u2D30 \u2D4F \u2D53\u2D59\u2D30\u2D3D\u2D53\u2D37","ago":"{{duration}} \u2D49\u2D63\u2D54\u2D49\u2D4F","api_key":"\u2D5C\u2D30\u2D59\u2D30\u2D54\u2D53\u2D5C \u2D4F API","are_you_sure":"\u2D49\u2D59 \u2D5C\u2D43\u2D47\u2D47\u2D49\u2D37?","ask_delete_message":"\u2D49\u2D59 \u2D5C\u2D43\u2D47\u2D47\u2D49\u2D37 \u2D30\u2D37 \u2D5C\u2D3D\u2D3D\u2D59\u2D37 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D30\u2D37?","audio_not_ready":"","bookmark_added":"\u2D5C\u2D53\u2D37\u2D3C \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D56\u2D54 \u2D5C\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54 !","bookmark_removed":"\u2D5C\u2D3B\u2D5C\u2D5C\u2D61\u2D30\u2D3D\u2D3D\u2D59 \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D59\u2D33 \u2D5C\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54 !","bookmarks":"\u2D5C\u2D30\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54","cancel_write":"\u2D49\u2D59 \u2D5C\u2D43\u2D47\u2D47\u2D49\u2D37 \u2D53\u2D54 \u2D5C\u2D54\u2D49\u2D37 \u2D30\u2D37 \u2D5C\u2D30\u2D54\u2D49\u2D37 \u2D3D\u2D54\u2D30 \u2D4F \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D5C\u2D30\u2D4E\u2D30\u2D62\u2D4F\u2D53\u2D5C?","cancel":"\u2D59\u2D59\u2D54","changed_group_name":"\u2D5C\u2D59\u2D4F\u2D3C\u2D4D\u2D37 \u2D49\u2D59\u2D4E \u2D4F \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","confirm_password_placeholder":"\u2D59\u2D37\u2D37\u2D49\u2D37 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","connect":"\u2D30\u2D61\u2D30\u2D39","create_a_group":"\u2D59\u2D3D\u2D54 \u2D3D\u2D54\u2D30 \u2D4F \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","create_the_group":"\u2D59\u2D3D\u2D54 \u2D5C\u2D30\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","daily":"\u2D3D\u2D53 \u2D30\u2D59\u2D59","default_group":"\u2D5C\u2D30\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 \u2D5C\u2D30\u2D4E\u2D54\u2D37\u2D53\u2D5C","delete":"\u2D59\u2D59\u2D3C\u2D39","destroy_account_explain":"\u2D4E\u2D5B \u2D5C\u2D3D\u2D3D\u2D59\u2D37 \u2D30\u2D4E\u2D49\u2D39\u2D30\u2D4F \u2D4F\u2D4F\u2D3D, \u2D53\u2D59\u2D30\u2D54 \u2D30\u2D37 \u2D37 \u2D5C\u2D30\u2D56\u2D53\u2D4D\u2D37. \u2D43\u2D47\u2D47\u2D30 \u2D59 \u2D53\u2D62\u2D30\u2D37.","destroy_account":"\u2D3D\u2D3D\u2D59 \u2D30\u2D4E\u2D49\u2D39\u2D30\u2D4F \u2D4F\u2D4F\u2D3D","edit":"\u2D59\u2D33\u2D33\u2D37","email_input":"\u2D59\u2D59\u2D49\u2D37\u2D3C \u2D49\u2D4E\u2D30\u2D62\u2D4D \u2D4F\u2D4F\u2D3D \u2D37\u2D30","email":"\u2D49\u2D4E\u2D30\u2D62\u2D4D","empty_message":"\u2D5C\u2D45\u2D61\u2D30 \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D53\u2D54 \u2D49\u2D63\u2D54\u2D49 \u2D53\u2D59\u2D49\u2D3C\u2D39 \u2D4F\u2D4F\u2D59 !","error_new_message":"\u2D5C\u2D30\u2D63\u2D33\u2D4D\u2D5C \u2D33 \u2D53\u2D59\u2D49\u2D3C\u2D39 \u2D4F \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D4F\u2D4F\u2D3D.","error_upload":"\u2D5C\u2D30\u2D63\u2D33\u2D4D\u2D5C \u2D33 \u2D61\u2D30\u2D33\u2D30\u2D4E","error":"\u2D5C\u2D4D\u2D4D\u2D30 \u2D49\u2D5B\u2D5C \u2D4F \u2D5C\u2D63\u2D33\u2D4D\u2D5C","forgot_password":"\u2D49\u2D59 \u2D5C\u2D3B\u2D5C\u2D5C\u2D53\u2D37 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C \u2D4F\u2D4F\u2D3D?","group_left":"\u2D5C\u2D3C\u2D3C\u2D56\u2D37 \u2D59\u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 !","group_share_choice":"\u2D4E\u2D30\u2D5C\u2D5C\u2D30 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 \u2D4F\u2D4F\u2D30 \u2D5C\u2D54\u2D49\u2D37 \u2D30\u2D37 \u2D30\u2D59 \u2D5C\u2D59\u2D59\u2D49\u2D3C\u2D39\u2D37 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D30\u2D37?","groups":"\u2D5C\u2D49\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30\u2D61\u2D49\u2D4F","group_updated":"\u2D5C\u2D3B\u2D5C\u2D5C\u2D53\u2D59\u2D4E\u2D30\u2D62\u2D4F\u2D53 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30 \u2D4F\u2D4F\u2D3D !","has_commented_on":"\u2D49\u2D59\u2D3D\u2D54 \u2D30\u2D45\u2D3C\u2D30\u2D61\u2D30\u2D4D \u2D45\u2D3C","has_joined":"\u2D49\u2D3D\u2D5B\u2D4E","has_left":"\u2D49\u2D3C\u2D3C\u2D56","has_posted_in":"\u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D3C\u2D59\u2D54 \u2D33","hourly":"\u2D3D\u2D53 \u2D5C\u2D30\u2D59\u2D54\u2D30\u2D33\u2D5C","Invalid login/password":"\u2D49\u2D5C\u2D5C\u2D30\u2D61\u2D63\u2D33\u2D4D \u2D53\u2D3D\u2D5B\u2D30\u2D4E \u2D37/\u2D4F\u2D49\u2D56 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","invitation_link":"\u2D30\u2D59\u2D56\u2D53\u2D4F \u2D4F \u2D53\u2D59\u2D49\u2D33\u2D54","invitation_welcome":"\u2D30\u2D4F\u2D59\u2D53\u2D3C \u2D49\u2D59\u2D3D \u2D33 Zusam ! \u2D49\u2D45\u2D5A\u2D5A\u2D30 \u2D30\u2D3D \u2D53\u2D63\u2D4E\u2D4E\u2D3B\u2D4E \u2D37\u2D30\u2D5C \u2D4F \u2D53\u2D3D\u2D5B\u2D30\u2D4E \u2D56\u2D54 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30.","in":"\u2D33","just_now":"\u2D37\u2D56\u2D49 \u2D4F\u2D4F\u2D49\u2D5C","lang":"\u2D5C\u2D53\u2D5C\u2D4D\u2D30\u2D62\u2D5C","login_input":"\u2D59\u2D5C\u2D49 \u2D3D\u2D54\u2D30 \u2D4F \u2D53\u2D3D\u2D5B\u2D30\u2D4E","login_placeholder":"\u2D49\u2D4E\u2D30\u2D62\u2D4D","login":"\u2D30\u2D3D\u2D5B\u2D30\u2D4E","logout":"\u2D3C\u2D3C\u2D56","mark_all_as_read":"\u2D55\u2D5B\u2D4E \u2D4E\u2D30\u2D55\u2D55\u2D30 \u2D30\u2D4E \u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D56\u2D54\u2D4F","monthly":"\u2D3D\u2D53 \u2D30\u2D62\u2D62\u2D53\u2D54","multiple_photos_upload":"\u2D5C\u2D30\u2D63\u2D33\u2D4D\u2D5C. \u2D30\u2D4D\u2D59 \u2D30\u2D33\u2D30\u2D4E \u2D4F \u2D5C\u2D61\u2D4D\u2D30\u2D3C\u2D49\u2D4F \u2D49\u2D5B\u2D5C \u2D59 \u2D62\u2D49\u2D5B\u2D5C (\u2D49\u2D63\u2D4E\u2D54 \u2D30\u2D37 \u2D62\u2D49\u2D4D\u2D49 \u2D53\u2D62\u2D30\u2D37 \u2D37\u2D49 \u2D3D\u2D54\u2D30 \u2D4F \u2D49\u2D4E\u2D59\u2D59\u2D30\u2D54\u2D30\u2D5C\u2D4F).","name_input":"\u2D59\u2D5C\u2D49 \u2D3D\u2D54\u2D30 \u2D4F \u2D62\u2D49\u2D59\u2D4E","name":"\u2D49\u2D59\u2D4E","new_password_placeholder":"\u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D30\u2D4E\u2D30\u2D62\u2D4F\u2D53 \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","next_coms":"\u2D65\u2D55 \u2D49\u2D45\u2D3C\u2D30\u2D61\u2D30\u2D4D\u2D4F \u2D49\u2D4E\u2D33\u2D33\u2D53\u2D54\u2D30","none":"\u2D53\u2D40\u2D53","notification_emails_stopped":"\u2D31\u2D37\u2D37\u2D4F \u2D49\u2D59\u2D53\u2D3C\u2D54\u2D49\u2D5C\u2D4F \u2D4F \u2D49\u2D4E\u2D30\u2D62\u2D4D !","notification_emails":"\u2D49\u2D59\u2D53\u2D3C\u2D54\u2D49\u2D5C\u2D4F \u2D4F \u2D49\u2D4E\u2D30\u2D62\u2D4D","notifications":"\u2D49\u2D59\u2D53\u2D3C\u2D54\u2D49\u2D5C\u2D4F","parent_message":"\u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D4F \u2D49\u2D4E\u2D30\u2D54\u2D30\u2D61\u2D4F","password_input":"\u2D30\u2D54\u2D49 \u2D37\u2D30 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D30\u2D4E\u2D30\u2D62\u2D4F\u2D53 \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","password_placeholder":"\u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","password_reset_mail_sent":"\u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D59\u2D59\u2D49\u2D3C\u2D39 \u2D49\u2D4E\u2D30\u2D62\u2D4D \u2D45\u2D3C \u2D61\u2D30\u2D4D\u2D30\u2D59 \u2D4F \u2D53\u2D59\u2D54\u2D53\u2D59 \u2D4F \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C!","passwords_dont_match":"\u2D53\u2D54 \u2D49\u2D4E\u2D59\u2D30\u2D59\u2D30 \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","password":"\u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C","previous_coms":"\u2D65\u2D55 \u2D49\u2D45\u2D3C\u2D30\u2D61\u2D30\u2D4D\u2D4F \u2D49\u2D4E\u2D63\u2D61\u2D53\u2D54\u2D30","public_link":"\u2D30\u2D59\u2D56\u2D53\u2D4F \u2D30\u2D4E\u2D30\u2D5C\u2D30\u2D62","publish_in_group":"\u2D3C\u2D59\u2D54 \u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","quit_group":"\u2D3C\u2D3C\u2D56 \u2D59\u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","remove_bookmark":"\u2D3D\u2D3D\u2D59 \u2D5C\u2D30\u2D59\u2D4F\u2D30 \u2D4F \u2D5C\u2D4E\u2D49\u2D5C\u2D30\u2D54","replies_one":"{{count}} \u2D49\u2D54\u2D30\u2D54","replies_other":"{{count}} \u2D5C\u2D49\u2D4E\u2D54\u2D30\u2D54\u2D53\u2D5C\u2D49\u2D4F","reply":"\u2D54\u2D30\u2D54","reset_api_key":"\u2D59\u2D4F\u2D3C\u2D4D \u2D5C\u2D30\u2D59\u2D30\u2D54\u2D53\u2D5C \u2D4F API (\u2D54\u2D30\u2D37 \u2D49\u2D5C\u2D5C\u2D61\u2D30\u2D3D\u2D3D\u2D59 \u2D53\u2D4E\u2D62\u2D30\u2D61\u2D30\u2D39 \u2D4F\u2D4F\u2D3D)","reset_invitation_link":"\u2D30\u2D4D\u2D59 \u2D30\u2D59\u2D4F\u2D53\u2D4E \u2D4F \u2D53\u2D59\u2D56\u2D53\u2D4F \u2D4F \u2D53\u2D59\u2D49\u2D33\u2D54","reset_password_title":"\u2D30\u2D4D\u2D59 \u2D30\u2D59\u2D4F\u2D53\u2D4E \u2D4F \u2D49\u2D4F\u2D49\u2D33\u2D4D \u2D4F \u2D61\u2D30\u2D37\u2D30\u2D3C \u2D4F\u2D4F\u2D3D","save_changes":"\u2D43\u2D39\u2D53 \u2D49\u2D59\u2D4F\u2D3C\u2D30\u2D4D\u2D4F","search_in_group":"\u2D54\u2D63\u2D53 \u2D33 \u2D5C\u2D33\u2D54\u2D53\u2D4E\u2D4E\u2D30","search_without_result":"\u2D53\u2D54 \u2D49\u2D4E\u2D59\u2D30\u2D59\u2D30 \u2D53\u2D54\u2D63\u2D53 \u2D4F\u2D4F\u2D3D \u2D30\u2D3D\u2D37 \u2D3D\u2D54\u2D30\u2D62\u2D33\u2D30\u2D5C\u2D5C \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C.","settings_updated":"\u2D5C\u2D5C\u2D53\u2D59\u2D4E\u2D30\u2D62\u2D4F\u2D53\u2D4F\u2D5C \u2D5C\u2D59\u2D56\u2D30\u2D4D \u2D4F\u2D4F\u2D3D","settings":"\u2D5C\u2D49\u2D59\u2D56\u2D30\u2D4D","share_message":"\u2D31\u2D39\u2D53 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D30\u2D3C","signup":"\u2D30\u2D63\u2D4E\u2D4E\u2D3B\u2D4E","submit":"\u2D30\u2D63\u2D4F","text_placeholder":"\u2D30\u2D54\u2D49 \u2D37\u2D30 \u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D4F\u2D4F\u2D3D","the_message_from":"\u2D5C\u2D30\u2D31\u2D54\u2D30\u2D5C \u2D59\u2D33","title_placeholder":"\u2D30\u2D63\u2D61\u2D4D \u2D4F \u2D5C\u2D31\u2D54\u2D30\u2D5C \u2D4F\u2D4F\u2D3D (\u2D30\u2D54\u2D53\u2D5B\u2D5B\u2D49\u2D4D)","to":"\u2D49","upload_audio":"","upload_image":"\u2D54\u2D4F\u2D53 \u2D5C\u2D49\u2D61\u2D4D\u2D30\u2D3C\u2D49\u2D4F","upload_music":"\u2D54\u2D4F\u2D53 \u2D49\u2D65\u2D30\u2D61\u2D30\u2D4F\u2D4F","upload_pdf":"\u2D54\u2D4F\u2D53 PDF","upload_video":"\u2D54\u2D4F\u2D53 \u2D49\u2D3C\u2D49\u2D37\u2D62\u2D53\u2D5C\u2D4F","User not found":"\u2D30\u2D4F\u2D59\u2D59\u2D4E\u2D54\u2D59 \u2D53\u2D54 \u2D49\u2D4D\u2D4D\u2D49","users":"\u2D49\u2D4F\u2D59\u2D59\u2D4E\u2D54\u2D30\u2D59","video_not_ready":"\u2D49\u2D59\u2D53\u2D4D \u2D53\u2D54 \u2D49\u2D61\u2D4A\u2D49\u2D37 \u2D53\u2D3C\u2D49\u2D37\u2D62\u2D53.","weekly":"\u2D3D\u2D53 \u2D49\u2D4E\u2D30\u2D4D\u2D30\u2D59\u2D59"}');


var $1311eef7cf72bb90$exports = {};
$1311eef7cf72bb90$exports = JSON.parse('{"account":"\u8D26\u6237","add_bookmark":"\u4E3A\u6D88\u606F\u6DFB\u52A0\u4E66\u7B7E","add_date":"\u6DFB\u52A0\u65E5\u671F","ago":"{{duration}}\u524D","api_key":"API\u5BC6\u94A5","are_you_sure":"\u60A8\u786E\u5B9A\u5417?","ask_delete_message":"\u5220\u9664\u6B64\u6D88\u606F?","audio_not_ready":"\u97F3\u9891\u5C1A\u672A\u51C6\u5907\u597D\u3002","bookmark_added":"\u6D88\u606F\u5DF2\u6DFB\u52A0\u4E66\u7B7E","bookmark_removed":"\u6D88\u606F\u4E2D\u7684\u4E66\u7B7E\u5DF2\u88AB\u79FB\u9664","bookmarks":"\u4E66\u7B7E","cancel_write":"\u662F\u5426\u786E\u5B9E\u8981\u53D6\u6D88\u7F16\u5199\u65B0\u6D88\u606F?","cancel":"\u53D6\u6D88","changed_group_name":"\u66F4\u6539\u4E86\u7EC4\u7684\u540D\u79F0","confirm_password_placeholder":"\u786E\u8BA4\u5BC6\u7801","connect":"\u8FDE\u63A5","create_a_group":"\u521B\u5EFA\u7FA4\u7EC4","create_the_group":"\u521B\u5EFA\u7FA4\u7EC4","daily":"\u6BCF\u5929","default_group":"\u9ED8\u8BA4\u7FA4\u7EC4","delete":"\u5220\u9664","destroy_account_explain":"\u4E00\u65E6\u60A8\u5220\u9664\u4E86\u8D26\u6237,\u60A8\u5C06\u65E0\u6CD5\u64A4\u9500\u672C\u64CD\u4F5C! \u8BF7\u786E\u8BA4\u3002","destroy_account":"\u5220\u9664\u60A8\u7684\u8D26\u6237","edit":"\u7F16\u8F91","email_input":"\u5728\u8FD9\u91CC\u8F93\u5165\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740","email":"\u7535\u5B50\u90AE\u7BB1","empty_message":"\u65E0\u6CD5\u53D1\u9001\u7A7A\u6D88\u606F","error_new_message":"\u53D1\u9001\u6D88\u606F\u65F6\u51FA\u9519\u3002","error_upload":"\u4E0A\u4F20\u51FA\u9519","error":"\u51FA\u9519\u4E86","forgot_password":"\u5FD8\u8BB0\u4F60\u7684\u5BC6\u7801\u4E86\u5417?","group_left":"\u4F60\u79BB\u5F00\u4E86\u7FA4\u7EC4","group_share_choice":"\u60A8\u60F3\u5C06\u6B64\u6D88\u606F\u53D1\u9001\u5230\u54EA\u4E2A\u7FA4\u7EC4?","groups":"\u7EC4","group_updated":"\u7FA4\u7EC4\u5DF2\u66F4\u65B0","has_commented_on":"\u8BC4\u8BBA\u4E8E","has_joined":"\u5DF2\u52A0\u5165","has_left":"\u5DF2\u9000\u51FA","has_posted_in":"\u5DF2\u53D1\u5E03\u4E8E","hourly":"\u6BCF\u5C0F\u65F6","Invalid login/password":"\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF","invitation_link":"\u9080\u8BF7\u94FE\u63A5","invitation_welcome":"\u6B22\u8FCE\u6765\u5230Zusam ! \u5728\u52A0\u5165\u4E00\u4E2A\u7EC4\u524D,\u8BF7\u5148\u6CE8\u518C\u3002","in":"\u91CC","just_now":"\u521A\u521A","lang":"\u8BED\u8A00","login_input":"\u9009\u62E9\u4E00\u4E2A\u4EE5\u767B\u5F55","login_placeholder":"\u7535\u5B50\u90AE\u7BB1","login":"\u767B\u5F55","logout":"\u6CE8\u9500","mark_all_as_read":"\u5168\u90E8\u5DF2\u8BFB","monthly":"\u6BCF\u6708","multiple_photos_upload":"\u53D1\u751F\u9519\u8BEF\u3002 \u8BF7\u5C1D\u8BD5\u9010\u4E2A\u4E0A\u4F20\u56FE\u50CF(\u5728\u67D0\u4E9B\u6D4F\u89C8\u5668\u4E2D\u53EF\u80FD\u4F1A\u53D1\u751F\u8FD9\u79CD\u60C5\u51B5)\u3002","name_input":"\u9009\u62E9\u4E00\u4E2A\u540D\u79F0","name":"\u59D3\u540D","new_password_placeholder":"\u65B0\u5BC6\u7801","next_coms":"\u67E5\u770B\u4E0B\u4E00\u4E2A\u8BC4\u8BBA","none":"\u65E0","notification_emails_stopped":"\u5DF2\u505C\u7528\u90AE\u4EF6\u63D0\u9192!","notification_emails":"\u7535\u5B50\u90AE\u4EF6\u901A\u77E5","notifications":"\u901A\u77E5","parent_message":"\u7236\u6D88\u606F","password_input":"\u5728\u6B64\u8F93\u5165\u60A8\u7684\u7684\u5BC6\u7801","password_placeholder":"\u5BC6\u7801","password_reset_mail_sent":"\u5BC6\u7801\u91CD\u7F6E\u90AE\u4EF6\u5DF2\u53D1\u9001\u5230\u60A8\u7684\u7535\u5B50\u90AE\u7BB1\u6536\u4EF6\u7BB1","passwords_dont_match":"\u5BC6\u7801\u4E0D\u4E00\u81F4","password":"\u5BC6\u7801","previous_coms":"\u67E5\u770B\u4EE5\u524D\u7684\u8BC4\u8BBA","public_link":"\u516C\u5171\u94FE\u63A5","publish_in_group":"\u5728\u7FA4\u7EC4\u91CC\u53D1\u5E03","quit_group":"\u79BB\u5F00\u7FA4\u7EC4","remove_bookmark":"\u4E3A\u6D88\u606F\u79FB\u9664\u4E66\u7B7E","replies_one":"{{count}}\u56DE\u590D","replies_other":"{{count}}\u56DE\u590D\u4E86","reply":"\u56DE\u590D","reset_api_key":"\u91CD\u7F6EAPI\u5BC6\u94A5(\u60A8\u5C06\u4F1A\u65AD\u5F00\u8FDE\u63A5)","reset_invitation_link":"\u91CD\u8BBE\u9080\u8BF7\u94FE\u63A5","reset_password_title":"\u91CD\u7F6E\u60A8\u7684\u5BC6\u7801","save_changes":"\u4FDD\u5B58\u66F4\u6539","search_in_group":"\u5728\u6B64\u7FA4\u7EC4\u4E2D\u641C\u7D22","search_without_result":"\u6CA1\u6709\u5339\u914D\u7684\u6D88\u606F\u3002","settings_updated":"\u4F60\u7684\u8BBE\u7F6E\u5DF2\u66F4\u65B0","settings":"\u8BBE\u7F6E","share_message":"\u5206\u4EAB\u6B64\u6D88\u606F","signup":"\u6CE8\u518C","submit":"\u63D0\u4EA4","text_placeholder":"\u5728\u8FD9\u91CC\u8F93\u5165\u60A8\u7684\u6D88\u606F","the_message_from":"\u6D88\u606F\u6765\u81EA","title_placeholder":"\u60A8\u6D88\u606F\u7684\u6807\u9898(\u53EF\u9009)","to":"\u5230","upload_audio":"\u6DFB\u52A0\u97F3\u9891\u6587\u4EF6\u3002","upload_image":"\u6DFB\u52A0\u56FE\u7247","upload_music":"\u6DFB\u52A0\u97F3\u4E50","upload_pdf":"\u6DFB\u52A0PDF\u6587\u4EF6","upload_video":"\u6DFB\u52A0\u89C6\u9891","User not found":"\u7528\u6237\u4E0D\u5B58\u5728","users":"\u7528\u6237","video_not_ready":"\u89C6\u9891\u5C1A\u672A\u51C6\u5907\u597D\u3002","weekly":"\u6BCF\u5468"}');


const $a1c13afdb4e96f13$export$9a771d6906431624 = {
    possibleLang: {
        cs_CZ: "\u010De\u0161tina",
        de_DE: "Deutsch",
        en_US: "English",
        es_ES: "espa\xf1ol",
        fi_FI: "suomalainen",
        fr_FR: "fran\xe7ais",
        hu_HU: "magyar nyelv",
        it_IT: "italiano",
        ko_KR: "\uD55C\uAD6D\uC5B4",
        nb_NO: "Norge",
        nl_NL: "Nederlands",
        pl_PL: "polski",
        pt_BR: "Portugu\xeas",
        ru_RU: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        sk_SK: "Slovensk\xfd",
        ta_IN: "\u0939\u093F\u0902\u0926\u0942",
        zgh: "\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C",
        zh_Hans: "\u4E2D\u6587"
    },
    // possible dicts names to load
    getDefaultLang: ()=>(0, $2d00f79f92830cb9$export$2e2bcd8739ae039)?.info?.default_lang || "en_US",
    getCurrentLang: ()=>(0, $c6f88c2c6ea3c4b1$export$2e2bcd8739ae039).lang || $a1c13afdb4e96f13$export$9a771d6906431624.getDefaultLang()
};
(0, $cb95bcae1947788f$export$2e2bcd8739ae039).use((0, $f4663bfcfe4ffd82$export$ae7e14d40d89f296)).init({
    resources: {
        cs_CZ: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($6df9954f38281adf$exports)))
        },
        de_DE: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($6a418c1183be7fbe$exports)))
        },
        en_US: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($4eb8407690f94981$exports)))
        },
        es_ES: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($ccf112828a522499$exports)))
        },
        fi_FI: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($04cac85e3f8bd95f$exports)))
        },
        fr_FR: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($f4617cd4713f2200$exports)))
        },
        hu_HU: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($05eb12ad9cc47d94$exports)))
        },
        it_IT: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($f19d5628ceb29353$exports)))
        },
        ko_KR: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($40c2306b9c044cf3$exports)))
        },
        nb_NO: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($b99eed422708927a$exports)))
        },
        nl_NL: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($2fbb943560e4ebcb$exports)))
        },
        pl_PL: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($e596a382eba2d746$exports)))
        },
        pt_BR: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($b5cea83b062a1770$exports)))
        },
        ru_RU: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($97ae0da879a31ac5$exports)))
        },
        sk_SK: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($1246cd9971f5257e$exports)))
        },
        ta_IN: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($e7d0401e50621b7e$exports)))
        },
        zgh: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($b041c0894ca4dd4d$exports)))
        },
        zh_Hans: {
            translation: (0, (/*@__PURE__*/$parcel$interopDefault($1311eef7cf72bb90$exports)))
        }
    },
    lng: $a1c13afdb4e96f13$export$9a771d6906431624.getCurrentLang(),
    // if you're using a language detector, do not define the lng option
    fallbackLng: $a1c13afdb4e96f13$export$9a771d6906431624.getDefaultLang(),
    interpolation: {
        escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
});


// Stateless utilities
// Should be agnostic of other components of zusam if possible
const $30ef6c271b4e9124$var$util = {
    // check if the input is a valid URL
    isValidUrl: (url)=>{
        try {
            new URL(url);
            return true;
        } catch (_) {
            return false;
        }
    },
    limitLength: (string, size = 20)=>{
        return [
            ...string.split("").slice(0, Math.floor(size / 2)),
            string.length > size ? "..." : "",
            ...string.split("").slice(Math.floor(size / 2)).slice(Math.floor(size / 2) * -1)
        ].join("");
    },
    escapeRegex: (string)=>{
        return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
    },
    getSubpath: ()=>new URL(document.baseURI).pathname.replace(/\/$/, ""),
    // toApp transforms an api url into an "app" url that the user can naviate to
    toApp: (url)=>{
        if (!url || typeof url != "string") return "";
        if ($30ef6c271b4e9124$var$util.isValidUrl(url)) return url;
        return location.origin + $30ef6c271b4e9124$var$util.getSubpath() + url;
    },
    // genId starts with a letter to be DOM friendly
    // seed can be used to order ids
    // TODO improve using ideas from ai/nanoid
    genId: (seed)=>`z${seed || ""}-${Date.now().toString().slice(-5)}${Math.random().toString().slice(-5)}`,
    // transform an id into int for the API (TODO: revisit this on 0.5)
    id2Int: (id)=>parseInt(id.replace(/[^\d]/g, ""), 10),
    urlRegExp: /(\([^()]*)?https?:\/\/[^[\]\n\r "]*[-A-Za-z0-9+&@#/%=~_()|]/i,
    getUrl: (txt)=>{
        if (!txt) return "";
        let url = txt.match($30ef6c271b4e9124$var$util.urlRegExp);
        if (url && url[0].startsWith("(")) {
            let link = url[0].match(/https?:\/\//i);
            url["index"] += link["index"];
            url[0] = url[0].slice(link["index"]);
            if (url[0].endsWith(")")) url[0] = url[0].slice(0, -1);
        }
        return url;
    },
    limitStrSize: (str, limit)=>str.length > limit ? `${str.slice(0, limit - 3)}...` : str,
    // full datetime as a string adapted to the users timezone
    humanFullDate: (timestamp)=>{
        if (!timestamp) return "";
        let d = new Date(timestamp * 1000);
        d = new Date(d.getTime() + d.getTimezoneOffset() * -60000);
        return d.toISOString().replace("T", " ").replace(/\..*$/, "");
    },
    // duration relative to event
    humanTime: (timestamp)=>{
        if (!timestamp) return null;
        const duration = Math.abs(Math.round((Date.now() / 1000 - timestamp) / 60));
        if (duration < 1) return (0, $cb95bcae1947788f$export$2e2bcd8739ae039).t("just_now");
        if (duration < 60) return (0, $cb95bcae1947788f$export$2e2bcd8739ae039).t("ago", {
            duration: `${duration}mn`
        });
        if (duration < 1440) return (0, $cb95bcae1947788f$export$2e2bcd8739ae039).t("ago", {
            duration: `${Math.floor(duration / 60)}h`
        });
        return $30ef6c271b4e9124$var$util.humanFullDate(timestamp).split(" ")[0];
    },
    // get the id of an object from an url
    getId: (e)=>{
        switch(typeof e){
            case "object":
                return e ? e.id : null;
            case "string":
                return e.split("/").pop().replace(/\?.*$/, "").replace(/\.\w+$/, "");
            default:
                console.error(e);
                throw "Could not extract id !";
        }
    },
    // get the url to a thubmnail
    thumbnail: (id, width, height = 99999)=>typeof id == "string" && !id.startsWith("z") ? $30ef6c271b4e9124$var$util.toApp(`/api/images/thumbnail/${width}/${height}/${id}`) : null,
    // same as http.thumbnail but for a crop
    crop: (id, width, height)=>typeof id == "string" && !id.startsWith("z") ? $30ef6c271b4e9124$var$util.toApp(`/api/images/crop/${width}/${height}/${id}`) : null,
    // default avatar in base64
    defaultAvatar: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIAAQMAAADOtka5AAAABlBMVEUAAAD///+l2Z/dAAAAAnRSTlMA/iyWEiMAAAMJSURBVHja7ZtBjpwwEEWxmIhFFmiURZZEyi6HCLkZHCXr2eQKHIUjoEiRSGRRiWB6klaDU/hDF4z+W6LuNz3+ZRvbkCSEEEIIIYQQQgghhBBCCCGEEEIIITvwGfy+kxoTpNJigkw6TJBLjwkK8ZiglMFYUInAAqwQRKRBBR0q8FhXEKwVR0GLCvxCjeo6oyzkoIxnEvj5661acPO3yvFqpxdcV+Pj88VeNZ7cGB4ul1QFkv399KT4KBIpmGEwF4i9oL6DIN/3FzToL2ju8AvsBeE2aNFfQMFJBCkF0/R+bkHyCgSVuaDcVaC5zyvMBTkqyHYVaBZDKSpw5oJgLcMC5doXFBSoIMNutjcQBHJULmlhQYUKlmNQbs9kqGC5P2o3FqBBOVjMWkEOdcZQKam3dyqkkgP/g35zxmEpLhbjir0ZFz2tXHgbPR5deI+EMPKmig/hhU/fIkOYL4iYDbIyqpCXajp2Zy4yhNuxqUfbMCaEIraQZ9swJgQBQ0jBQr6eYXrzQrYIYdtC9uaFbDKayJajyTkL+VijyWA+mnBajGpDeFrMzAu5BNvwKoQBDaFHQ+jQEBo0hBoMYUBD8GgIHRpCi44mcAiJRQhoITvzQs63LGQxL2SOJnEhiHUI296bwNOixb1JYr5kz8yX7Odf6XDfBC9kd6yVzq+np69QIY/8AEJ45kt0T4hIM0VONm5CiLlVhLflS+CwdTGEVa2AnfOFTogaVAAfcg1QivpqzLFHD4LnrR0q8FAhqlux3PPUu0EFLSrooL6kLeaQwKMCTY4OfUjVoY+IOvTxSFiw81NtnbmgRwXeXDAg08IxBPIKBPX5BQ0FBxC0+wtSCg4gcBT853nruwiqfQXNHQT/LDiGD9Old6sEL2umn3MtqxDks9NotVbwfaG+FDfL6fznsjV32365cTXrtqoPdJKYrbmreIDvT42DCMYoIUEu4FvIKSpwgr6JvYEAfJm8QgUl+j58gb6Rn4Nvcv/p0jUmcODr8IQQQgghhBBCCCGEEEIIIYQQQgghs/wGp6uYgtiKODIAAAAASUVORK5CYII=",
    hash: (str)=>str.split("").reduce((a, c)=>(a << 5) - a + c.charCodeAt() | 0),
    colorHash: (str)=>[
            "#000000",
            "#333366",
            "#333399",
            "#3333CC",
            "#339933",
            "#339999",
            "#33CC33",
            "#33CC99",
            "#663333",
            "#663366",
            "#666633",
            "#666699",
            "#66CC33",
            "#66CCCC",
            "#993333",
            "#993366",
            "#993399",
            "#996633",
            "#999966",
            "#CC3333",
            "#CC3366",
            "#CC3399",
            "#CC33CC",
            "#CC6633",
            "#CC9933",
            "#CC99CC",
            "#CCCC33"
        ][Math.abs($30ef6c271b4e9124$var$util.hash(str)) % 27],
    backgroundHash: (str)=>{
        if (!str) return "background-color: #aaa;";
        let c1 = $30ef6c271b4e9124$var$util.colorHash(str);
        let c2 = $30ef6c271b4e9124$var$util.colorHash(str.split("").reverse().join("."));
        let deg = 45 * (Math.abs($30ef6c271b4e9124$var$util.hash(str)) % 4);
        return `background-color:${c1};background-image:linear-gradient(${deg}deg, ${c2} 15%, transparent 15% 30%, ${c2} 30% 45%, transparent 45% 60%, ${c2} 60% 75%, transparent 75% 90%, ${c2} 90%);`;
    },
    // Accepts a keydown event and checks if it's enter. Compatibility between browsers
    // We do it the permissive way
    is_it_enter: (e)=>{
        return e.keyCode == 13 || e.keyCode == 10 || e.key == "Enter" || e.key == "\u21B5" || e.code == "Enter";
    },
    getVersion: ()=>(document.querySelector("meta[name='zusam:version']") || {}).content || "unknown",
    getWidthBreakpoint: ()=>{
        if (window.innerWidth > 1800) return 1800;
        if (window.innerWidth > 1400) return 1400;
        if (window.innerWidth > 992) return 992;
        if (window.innerWidth > 768) return 768;
        if (window.innerWidth > 576) return 576;
        return window.innerWidth;
    }
};
var $30ef6c271b4e9124$export$2e2bcd8739ae039 = $30ef6c271b4e9124$var$util;


const $dcc08ede0b85ca51$var$http = {
    sendFile: (formData, loadFn, progressFn = null, errorFn = null)=>{
        return (0, $a43f12068c4c782d$export$2e2bcd8739ae039).get("apiKey").then((apiKey)=>{
            let xhr = new XMLHttpRequest();
            xhr.open("POST", `${document.baseURI}api/files`, true);
            xhr.setRequestHeader("X-AUTH-TOKEN", apiKey);
            xhr.addEventListener("load", (e)=>{
                if (e.target.status > 199 && e.target.status < 300) loadFn(JSON.parse(e.target.response));
                else if (errorFn) errorFn(e.target.statusText);
                else console.error(e.target.statusText);
            });
            if (progressFn) xhr.upload.onprogress = (e)=>progressFn({
                    loaded: e.loaded,
                    total: e.total
                });
            if (errorFn) xhr.addEventListener("error", (e)=>errorFn(e));
            xhr.send(formData);
        }).catch((error)=>(0, $7e84e1a08353bb30$export$2e2bcd8739ae039).add(error, "alert-danger"));
    },
    get: (url, nocache = false, delay = 0)=>{
        return (0, $a43f12068c4c782d$export$2e2bcd8739ae039).get("apiKey").then((x)=>new Promise((resolve)=>setTimeout(()=>resolve(x), delay))).then((apiKey)=>{
            url = (0, $30ef6c271b4e9124$export$2e2bcd8739ae039).toApp(url);
            if (!url) return;
            let h = {};
            if (apiKey) h["X-AUTH-TOKEN"] = apiKey;
            if (nocache) h["X-NOCACHE"] = "nocache";
            return fetch(url, {
                method: "GET",
                headers: new Headers(h)
            }).then((res)=>{
                if (res.ok) return res.json();
                return Promise.reject({
                    status: res.status,
                    statusText: res.statusText
                });
            }).catch((err)=>{
                if (err?.status) return Promise.reject(err);
                return Promise.reject({
                    networkError: true
                });
            });
        });
    },
    post: (url, data, delay = 0, contentType = "application/json")=>$dcc08ede0b85ca51$var$http.request(url, data, "POST", delay, contentType),
    put: (url, data, delay = 0, contentType = "application/json")=>$dcc08ede0b85ca51$var$http.request(url, data, "PUT", delay, contentType),
    delete: (url, data, delay = 0, contentType = "application/json")=>$dcc08ede0b85ca51$var$http.request(url, null, "DELETE", delay, contentType),
    request: (url, data, method, delay = 0, contentType = "application/json")=>{
        return (0, $a43f12068c4c782d$export$2e2bcd8739ae039).get("apiKey").then((x)=>new Promise((resolve)=>setTimeout(()=>resolve(x), delay))).then((apiKey)=>{
            url = (0, $30ef6c271b4e9124$export$2e2bcd8739ae039).toApp(url);
            if (!url) return;
            let h = {};
            if (apiKey) h["X-AUTH-TOKEN"] = apiKey;
            if (contentType) h["Content-type"] = contentType;
            let fetchOptions = {
                method: method,
                headers: new Headers(h)
            };
            if (data) fetchOptions.body = typeof data == "object" && data.constructor.name == "Object" ? JSON.stringify(data) : data;
            return fetch(url, fetchOptions).then((res)=>{
                if (!res.ok) return Promise.reject({
                    status: res.status,
                    statusText: res.statusText
                });
                try {
                    if (method != "DELETE") return res.json();
                    return {};
                } catch (exception) {
                    console.warn(exception.message);
                    return Promise.reject(exception.message);
                }
            }).catch((err)=>{
                if (err?.status) return Promise.reject(err);
                return Promise.reject({
                    networkError: true
                });
            });
        });
    }
};
var $dcc08ede0b85ca51$export$2e2bcd8739ae039 = $dcc08ede0b85ca51$var$http;



const $b8ff5357b6cef316$export$5cab88e8d254efac = (0, $a31e1c96daaf01b5$export$5fb5cc0d078610b)({});
function $b8ff5357b6cef316$export$c3a5c69940d9d6e0(api) {
    $b8ff5357b6cef316$export$5cab88e8d254efac.set(api);
}


const $2d00f79f92830cb9$var$api = {
    get info () {
        return (0, $b8ff5357b6cef316$export$5cab88e8d254efac).get();
    },
    update: ()=>(0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get("/api/info", true).then((r)=>{
            if (!r) return;
            (0, $b8ff5357b6cef316$export$c3a5c69940d9d6e0)(Object.assign({}, r));
            setTimeout(dispatchEvent(new CustomEvent("apiStateChange")));
            return r;
        }).catch(()=>null)
};
var $2d00f79f92830cb9$export$2e2bcd8739ae039 = $2d00f79f92830cb9$var$api;







const $b49847e1ffb70926$export$c73f0afda48eecf0 = (0, $a31e1c96daaf01b5$export$5fb5cc0d078610b)([]);
function $b49847e1ffb70926$export$7ef44197c3760235(notifications = []) {
    $b49847e1ffb70926$export$c73f0afda48eecf0.set(notifications);
}
function $b49847e1ffb70926$export$92eb0ea44f8c9242(notification) {
    $b49847e1ffb70926$export$c73f0afda48eecf0.set($b49847e1ffb70926$export$c73f0afda48eecf0.get().filter((n)=>n.id != notification.id));
}
function $b49847e1ffb70926$export$bdda8f9364ec9548(notification) {
    $b49847e1ffb70926$export$c73f0afda48eecf0.set($b49847e1ffb70926$export$c73f0afda48eecf0.get().map((n)=>n.id === notification.id ? Object.assign(n, {
            read: true
        }) : n));
}


const $3f4f2fd808a213d2$var$notifications = {
    LIMIT: 20,
    get () {
        return (0, $b49847e1ffb70926$export$c73f0afda48eecf0).get() || [];
    },
    update () {
        return (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get(`/api/me/notifications/${$3f4f2fd808a213d2$var$notifications.LIMIT + 1}`).then((r)=>{
            if (r) (0, $b49847e1ffb70926$export$7ef44197c3760235)(r);
        }).catch(()=>null);
    },
    isNew (id) {
        let list = (0, $b49847e1ffb70926$export$c73f0afda48eecf0).get();
        if (Array.isArray(list)) return list.filter((n)=>!n.read).some((n)=>$3f4f2fd808a213d2$var$notifications.matchNotification(n, id) || n.type == "new_comment" && n.fromMessage.id === id);
        return false;
    },
    removeAllNotifications () {
        let list = (0, $b49847e1ffb70926$export$c73f0afda48eecf0).get();
        if (Array.isArray(list)) list.forEach((n)=>{
            (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).delete(`/api/notifications/${n.id}`).then(()=>{
                (0, $b49847e1ffb70926$export$92eb0ea44f8c9242)(n);
            }).catch((err)=>console.warn(err));
        });
    },
    markAllNotificationsAsRead () {
        let list = (0, $b49847e1ffb70926$export$c73f0afda48eecf0).get();
        if (Array.isArray(list)) list.forEach((n)=>{
            (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).put(`/api/notifications/${n.id}`, {
                read: true
            }).then(()=>{
                (0, $b49847e1ffb70926$export$bdda8f9364ec9548)(n);
            }).catch((err)=>console.warn(err));
        });
    },
    removeMatchingNotifications (id) {
        return Promise.all((0, $b49847e1ffb70926$export$c73f0afda48eecf0).get().filter((n)=>$3f4f2fd808a213d2$var$notifications.matchNotification(n, id)).map((n)=>{
            (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).delete(`/api/notifications/${n.id}`).then(()=>{
                (0, $b49847e1ffb70926$export$92eb0ea44f8c9242)(n);
            }).catch((err)=>console.warn(err));
        }));
    },
    markAsRead (id) {
        return Promise.all((0, $b49847e1ffb70926$export$c73f0afda48eecf0).get().filter((n)=>$3f4f2fd808a213d2$var$notifications.matchNotification(n, id)).map((n)=>{
            (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).put(`/api/notifications/${n.id}`, {
                read: true
            }).then(()=>{
                (0, $b49847e1ffb70926$export$bdda8f9364ec9548)(n);
            }).catch((err)=>console.warn(err));
        }));
    },
    matchNotification (notif, id) {
        if (notif.id === id) return true;
        if (notif.target === id) return true;
        return false;
    }
};
var $3f4f2fd808a213d2$export$2e2bcd8739ae039 = $3f4f2fd808a213d2$var$notifications;





const $1648cda18d60f785$export$b294d243702b04e2 = (0, $a31e1c96daaf01b5$export$5fb5cc0d078610b)([]);
function $1648cda18d60f785$export$60ea320edcf8709a(bookmarks = []) {
    $1648cda18d60f785$export$b294d243702b04e2.set(bookmarks);
}
function $1648cda18d60f785$export$2db69b245b3902c8(bookmark) {
    (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).delete(`/api/bookmarks/${bookmark.id}`).catch((err)=>console.warn(err));
    $1648cda18d60f785$export$b294d243702b04e2.set($1648cda18d60f785$export$b294d243702b04e2.get().filter((b)=>b.id != bookmark.id));
}
function $1648cda18d60f785$export$72009cc673d27d80(message_id) {
    const current = $1648cda18d60f785$export$b294d243702b04e2.get();
    (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/bookmarks", {
        message_id: message_id
    }).then((bookmark)=>{
        if (bookmark) $1648cda18d60f785$export$60ea320edcf8709a([
            ...current,
            bookmark
        ]);
    }).catch(()=>null);
}


const $df5f845658677a96$var$bookmarks_utils = {
    LIMIT: 1000,
    get () {
        return (0, $1648cda18d60f785$export$b294d243702b04e2).get() || [];
    },
    update () {
        return (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get(`/api/me/bookmarks/${$df5f845658677a96$var$bookmarks_utils.LIMIT + 1}`).then((r)=>{
            if (r) (0, $1648cda18d60f785$export$60ea320edcf8709a)(r);
        }).catch(()=>null);
    }
};
var $df5f845658677a96$export$2e2bcd8739ae039 = $df5f845658677a96$var$bookmarks_utils;





const $e44fcdfc78a2fa42$export$b01d3b47943cf0fd = (0, $a31e1c96daaf01b5$export$5fb5cc0d078610b)({
    route: "",
    id: "",
    action: "",
    backUrl: "",
    entityType: "",
    search: "",
    entity: {}
});
function $e44fcdfc78a2fa42$export$a2bef380546524c1(newState) {
    $e44fcdfc78a2fa42$export$b01d3b47943cf0fd.set({
        ...$e44fcdfc78a2fa42$export$b01d3b47943cf0fd.get(),
        entity: newState.entity,
        backUrl: newState.backUrl
    });
}


const $f85ec4af9c25b4e6$var$router = {
    get () {
        return (0, $e44fcdfc78a2fa42$export$b01d3b47943cf0fd).get();
    },
    get route () {
        try {
            return $f85ec4af9c25b4e6$var$router.removeSubpath(location.pathname).slice(1).split("/")[0];
        } catch  {
            return "";
        }
    },
    get id () {
        try {
            return $f85ec4af9c25b4e6$var$router.removeSubpath(location.pathname).slice(1).split("/")[1];
        } catch  {
            return "";
        }
    },
    get action () {
        try {
            return $f85ec4af9c25b4e6$var$router.removeSubpath(location.pathname).slice(1).split("/")[2];
        } catch  {
            return "";
        }
    },
    get backUrl () {
        console.err("don't use backUrl");
        return (0, $e44fcdfc78a2fa42$export$b01d3b47943cf0fd).get()?.backUrl;
    },
    get search () {
        return location.search.slice(1);
    },
    getEntity () {
        if ($f85ec4af9c25b4e6$var$router.isEntity($f85ec4af9c25b4e6$var$router.route)) return (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039).get(`/api/${$f85ec4af9c25b4e6$var$router.route}/${$f85ec4af9c25b4e6$var$router.id}`);
        return Promise.resolve(null);
    },
    get entity () {
        console.err("don't use entity");
        return (0, $e44fcdfc78a2fa42$export$b01d3b47943cf0fd).get()?.entity;
    },
    removeSubpath: (path)=>path ? path.replace(new RegExp(`^${(0, $30ef6c271b4e9124$export$2e2bcd8739ae039).getSubpath()}`), "") : "",
    getParam: (param, searchParams = window.location.search.substring(1))=>{
        let res = searchParams.split("&").find((e)=>e.split("=")[0] === param);
        return res ? decodeURIComponent(res.split("=")[1]) : "";
    },
    getSegments: ()=>$f85ec4af9c25b4e6$var$router.removeSubpath(window.location.pathname).slice(1).split("?")[0].split("/"),
    // check if route is "outside": accessible to non connected user
    isOutside: ()=>[
            "login",
            "password-reset",
            "signup",
            "invitation",
            "stop-notification-emails",
            "public"
        ].includes($f85ec4af9c25b4e6$var$router.route || $f85ec4af9c25b4e6$var$router.getSegments()[0]),
    isEntity: ()=>[
            "messages",
            "groups",
            "users",
            "links",
            "files"
        ].includes($f85ec4af9c25b4e6$var$router.getSegments()[0]),
    getUrlComponents: (url)=>{
        let components = {};
        if (url) {
            components.url = new URL(url);
            components.path = components.url.pathname;
            components.search = components.url.search.slice(1);
            [components.route, components.id, components.action] = $f85ec4af9c25b4e6$var$router.removeSubpath(components.path).slice(1).split("/");
        }
        components.entityType = "";
        components.backUrl = "";
        return components;
    }
};
var $f85ec4af9c25b4e6$export$2e2bcd8739ae039 = $f85ec4af9c25b4e6$var$router;




const $cd2f6546c5cf5c32$export$5ea928c9faf85bd3 = (0, $7e84e1a08353bb30$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$644d8ea042df96a6 = (0, $2d00f79f92830cb9$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$7d6f1c8842f9f527 = (0, $dcc08ede0b85ca51$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$9a771d6906431624 = (0, $a1c13afdb4e96f13$export$9a771d6906431624);
const $cd2f6546c5cf5c32$export$a7357cdd1f0b0168 = (0, $cb95bcae1947788f$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$3e32638432616b6 = (0, $c6f88c2c6ea3c4b1$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$6008d97729a90c74 = (0, $3f4f2fd808a213d2$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$a4ea57bd994c1f0d = (0, $df5f845658677a96$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$5375cda95f0b0eb4 = (0, $f85ec4af9c25b4e6$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$ddcffe0146c8f882 = (0, $a43f12068c4c782d$export$2e2bcd8739ae039);
const $cd2f6546c5cf5c32$export$7debb50ef11d5e0b = (0, $30ef6c271b4e9124$export$2e2bcd8739ae039);



var $9SeGy = parcelRequire("9SeGy");



var $bJrD0 = parcelRequire("bJrD0");
/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $iisr1 = parcelRequire("iisr1");

var $iisr1 = parcelRequire("iisr1");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $c846480b5114588d$var$_extends() {
    $c846480b5114588d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c846480b5114588d$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $c846480b5114588d$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($c846480b5114588d$export$e19cd5f9376f8cee || ($c846480b5114588d$export$e19cd5f9376f8cee = {}));
const $c846480b5114588d$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $c846480b5114588d$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $c846480b5114588d$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $c846480b5114588d$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $c846480b5114588d$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $c846480b5114588d$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $c846480b5114588d$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $c846480b5114588d$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $c846480b5114588d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $c846480b5114588d$export$fe53371bee54353d(to);
    }
    return $c846480b5114588d$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $c846480b5114588d$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $c846480b5114588d$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $c846480b5114588d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $c846480b5114588d$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $c846480b5114588d$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $c846480b5114588d$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $c846480b5114588d$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $c846480b5114588d$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $c846480b5114588d$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $c846480b5114588d$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $c846480b5114588d$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $c846480b5114588d$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $c846480b5114588d$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $c846480b5114588d$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $c846480b5114588d$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $c846480b5114588d$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($c846480b5114588d$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $c846480b5114588d$export$e19cd5f9376f8cee.Push;
        let location = $c846480b5114588d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $c846480b5114588d$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $c846480b5114588d$export$e19cd5f9376f8cee.Replace;
        let location = $c846480b5114588d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $c846480b5114588d$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $c846480b5114588d$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $c846480b5114588d$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($c846480b5114588d$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($c846480b5114588d$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $c846480b5114588d$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($c846480b5114588d$var$ResultType || ($c846480b5114588d$var$ResultType = {}));
const $c846480b5114588d$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $c846480b5114588d$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $c846480b5114588d$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $c846480b5114588d$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $c846480b5114588d$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($c846480b5114588d$var$isIndexRoute(route)) {
            let indexRoute = $c846480b5114588d$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $c846480b5114588d$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $c846480b5114588d$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $c846480b5114588d$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $c846480b5114588d$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $c846480b5114588d$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $c846480b5114588d$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $c846480b5114588d$var$flattenRoutes(routes);
    $c846480b5114588d$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $c846480b5114588d$export$30d21fd6d7295f52(pathname);
        matches = $c846480b5114588d$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $c846480b5114588d$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $c846480b5114588d$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $c846480b5114588d$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $c846480b5114588d$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $c846480b5114588d$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $c846480b5114588d$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $c846480b5114588d$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $c846480b5114588d$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $c846480b5114588d$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $c846480b5114588d$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $c846480b5114588d$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $c846480b5114588d$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $c846480b5114588d$var$paramRe = /^:[\w-]+$/;
const $c846480b5114588d$var$dynamicSegmentValue = 3;
const $c846480b5114588d$var$indexRouteValue = 2;
const $c846480b5114588d$var$emptySegmentValue = 1;
const $c846480b5114588d$var$staticSegmentValue = 10;
const $c846480b5114588d$var$splatPenalty = -2;
const $c846480b5114588d$var$isSplat = (s)=>s === "*";
function $c846480b5114588d$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($c846480b5114588d$var$isSplat)) initialScore += $c846480b5114588d$var$splatPenalty;
    if (index) initialScore += $c846480b5114588d$var$indexRouteValue;
    return segments.filter((s)=>!$c846480b5114588d$var$isSplat(s)).reduce((score, segment)=>score + ($c846480b5114588d$var$paramRe.test(segment) ? $c846480b5114588d$var$dynamicSegmentValue : segment === "" ? $c846480b5114588d$var$emptySegmentValue : $c846480b5114588d$var$staticSegmentValue), initialScore);
}
function $c846480b5114588d$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $c846480b5114588d$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $c846480b5114588d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $c846480b5114588d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $c846480b5114588d$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $c846480b5114588d$export$a5c6d149b50c1d86($c846480b5114588d$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $c846480b5114588d$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $c846480b5114588d$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $c846480b5114588d$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $c846480b5114588d$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $c846480b5114588d$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $c846480b5114588d$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $c846480b5114588d$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $c846480b5114588d$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $c846480b5114588d$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $c846480b5114588d$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $c846480b5114588d$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $c846480b5114588d$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $c846480b5114588d$var$isAbsoluteUrl = (url)=>$c846480b5114588d$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $c846480b5114588d$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($c846480b5114588d$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $c846480b5114588d$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $c846480b5114588d$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $c846480b5114588d$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $c846480b5114588d$var$normalizeSearch(search),
        hash: $c846480b5114588d$var$normalizeHash(hash)
    };
}
function $c846480b5114588d$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $c846480b5114588d$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $c846480b5114588d$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $c846480b5114588d$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $c846480b5114588d$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $c846480b5114588d$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $c846480b5114588d$export$8ccf933b0513f8d0(toArg);
    else {
        to = $c846480b5114588d$var$_extends({}, toArg);
        $c846480b5114588d$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $c846480b5114588d$var$getInvalidPathError("?", "pathname", "search", to));
        $c846480b5114588d$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $c846480b5114588d$var$getInvalidPathError("#", "pathname", "hash", to));
        $c846480b5114588d$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $c846480b5114588d$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $c846480b5114588d$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $c846480b5114588d$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $c846480b5114588d$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $c846480b5114588d$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $c846480b5114588d$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $c846480b5114588d$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $c846480b5114588d$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $c846480b5114588d$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $c846480b5114588d$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $c846480b5114588d$export$4051a07651545597(data, init) {
    return new $c846480b5114588d$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $c846480b5114588d$export$42a99a7a4bc0e76a extends Error {
}
class $c846480b5114588d$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $c846480b5114588d$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $c846480b5114588d$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $c846480b5114588d$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $c846480b5114588d$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $c846480b5114588d$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $c846480b5114588d$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $c846480b5114588d$var$unwrapTrackedPromise(value) {
    if (!$c846480b5114588d$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $c846480b5114588d$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $c846480b5114588d$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $c846480b5114588d$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $c846480b5114588d$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $c846480b5114588d$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $c846480b5114588d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $c846480b5114588d$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $c846480b5114588d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $c846480b5114588d$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $c846480b5114588d$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $c846480b5114588d$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $c846480b5114588d$var$validMutationMethods = new Set($c846480b5114588d$var$validMutationMethodsArr);
const $c846480b5114588d$var$validRequestMethodsArr = [
    "get",
    ...$c846480b5114588d$var$validMutationMethodsArr
];
const $c846480b5114588d$var$validRequestMethods = new Set($c846480b5114588d$var$validRequestMethodsArr);
const $c846480b5114588d$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $c846480b5114588d$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $c846480b5114588d$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $c846480b5114588d$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $c846480b5114588d$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $c846480b5114588d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $c846480b5114588d$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $c846480b5114588d$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $c846480b5114588d$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $c846480b5114588d$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $c846480b5114588d$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $c846480b5114588d$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $c846480b5114588d$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $c846480b5114588d$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $c846480b5114588d$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $c846480b5114588d$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $c846480b5114588d$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$c846480b5114588d$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$c846480b5114588d$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $c846480b5114588d$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $c846480b5114588d$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $c846480b5114588d$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $c846480b5114588d$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$c846480b5114588d$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($c846480b5114588d$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $c846480b5114588d$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $c846480b5114588d$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $c846480b5114588d$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $c846480b5114588d$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $c846480b5114588d$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $c846480b5114588d$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $c846480b5114588d$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $c846480b5114588d$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $c846480b5114588d$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($c846480b5114588d$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $c846480b5114588d$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $c846480b5114588d$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $c846480b5114588d$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $c846480b5114588d$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $c846480b5114588d$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $c846480b5114588d$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $c846480b5114588d$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $c846480b5114588d$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $c846480b5114588d$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $c846480b5114588d$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $c846480b5114588d$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $c846480b5114588d$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $c846480b5114588d$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $c846480b5114588d$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $c846480b5114588d$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $c846480b5114588d$var$findNearestBoundary(matches).route.id,
            {
                type: $c846480b5114588d$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $c846480b5114588d$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($c846480b5114588d$var$isErrorResult(result) && $c846480b5114588d$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $c846480b5114588d$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $c846480b5114588d$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $c846480b5114588d$var$_extends({
            matches: updatedMatches || matches
        }, $c846480b5114588d$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $c846480b5114588d$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $c846480b5114588d$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $c846480b5114588d$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $c846480b5114588d$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $c846480b5114588d$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $c846480b5114588d$var$ResultType.error,
            error: $c846480b5114588d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($c846480b5114588d$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $c846480b5114588d$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($c846480b5114588d$var$isDeferredResult(result)) throw $c846480b5114588d$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($c846480b5114588d$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $c846480b5114588d$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $c846480b5114588d$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $c846480b5114588d$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $c846480b5114588d$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($c846480b5114588d$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $c846480b5114588d$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $c846480b5114588d$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $c846480b5114588d$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $c846480b5114588d$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $c846480b5114588d$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $c846480b5114588d$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $c846480b5114588d$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $c846480b5114588d$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $c846480b5114588d$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $c846480b5114588d$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$c846480b5114588d$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $c846480b5114588d$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $c846480b5114588d$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $c846480b5114588d$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $c846480b5114588d$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $c846480b5114588d$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $c846480b5114588d$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $c846480b5114588d$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $c846480b5114588d$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $c846480b5114588d$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $c846480b5114588d$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $c846480b5114588d$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $c846480b5114588d$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($c846480b5114588d$var$isRedirectResult(actionResult) || $c846480b5114588d$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $c846480b5114588d$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($c846480b5114588d$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $c846480b5114588d$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $c846480b5114588d$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($c846480b5114588d$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($c846480b5114588d$var$isDeferredResult(actionResult)) throw $c846480b5114588d$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $c846480b5114588d$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $c846480b5114588d$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $c846480b5114588d$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $c846480b5114588d$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $c846480b5114588d$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $c846480b5114588d$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $c846480b5114588d$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $c846480b5114588d$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $c846480b5114588d$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $c846480b5114588d$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $c846480b5114588d$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $c846480b5114588d$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $c846480b5114588d$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $c846480b5114588d$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $c846480b5114588d$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $c846480b5114588d$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($c846480b5114588d$var$isDeferredResult(result)) result = await $c846480b5114588d$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $c846480b5114588d$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($c846480b5114588d$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $c846480b5114588d$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($c846480b5114588d$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $c846480b5114588d$export$3e9cee6b33872309(!$c846480b5114588d$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $c846480b5114588d$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $c846480b5114588d$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $c846480b5114588d$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $c846480b5114588d$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($c846480b5114588d$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $c846480b5114588d$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $c846480b5114588d$export$e19cd5f9376f8cee.Replace : $c846480b5114588d$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $c846480b5114588d$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($c846480b5114588d$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $c846480b5114588d$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $c846480b5114588d$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $c846480b5114588d$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $c846480b5114588d$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $c846480b5114588d$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($c846480b5114588d$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $c846480b5114588d$var$ResultType.redirect,
                response: $c846480b5114588d$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $c846480b5114588d$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $c846480b5114588d$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $c846480b5114588d$var$ResultType.error,
                    error: $c846480b5114588d$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $c846480b5114588d$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $c846480b5114588d$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $c846480b5114588d$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $c846480b5114588d$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $c846480b5114588d$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $c846480b5114588d$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $c846480b5114588d$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $c846480b5114588d$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $c846480b5114588d$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $c846480b5114588d$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $c846480b5114588d$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $c846480b5114588d$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $c846480b5114588d$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $c846480b5114588d$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$c846480b5114588d$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $c846480b5114588d$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $c846480b5114588d$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $c846480b5114588d$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $c846480b5114588d$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $c846480b5114588d$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $c846480b5114588d$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $c846480b5114588d$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $c846480b5114588d$export$4d0306f8f6a4585b = Symbol("deferred");
function $c846480b5114588d$export$3336b097a6fbc59a(routes, opts) {
    $c846480b5114588d$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $c846480b5114588d$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $c846480b5114588d$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $c846480b5114588d$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $c846480b5114588d$var$createLocation("", $c846480b5114588d$export$fe53371bee54353d(url), null, "default");
        let matches = $c846480b5114588d$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$c846480b5114588d$var$isValidMethod(method) && method !== "HEAD") {
            let error = $c846480b5114588d$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $c846480b5114588d$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $c846480b5114588d$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $c846480b5114588d$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($c846480b5114588d$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $c846480b5114588d$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $c846480b5114588d$var$createLocation("", $c846480b5114588d$export$fe53371bee54353d(url), null, "default");
        let matches = $c846480b5114588d$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$c846480b5114588d$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $c846480b5114588d$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $c846480b5114588d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $c846480b5114588d$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $c846480b5114588d$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $c846480b5114588d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($c846480b5114588d$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$c846480b5114588d$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $c846480b5114588d$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($c846480b5114588d$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $c846480b5114588d$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $c846480b5114588d$var$isResponse(result) ? result : $c846480b5114588d$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($c846480b5114588d$var$isDataStrategyResult(e) && $c846480b5114588d$var$isResponse(e.result)) {
                if (e.type === $c846480b5114588d$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($c846480b5114588d$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $c846480b5114588d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $c846480b5114588d$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $c846480b5114588d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($c846480b5114588d$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($c846480b5114588d$var$isDeferredResult(result)) {
            let error = $c846480b5114588d$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $c846480b5114588d$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($c846480b5114588d$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($c846480b5114588d$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $c846480b5114588d$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $c846480b5114588d$var$_extends({}, context, {
                statusCode: $c846480b5114588d$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $c846480b5114588d$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $c846480b5114588d$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $c846480b5114588d$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $c846480b5114588d$var$isErrorResult(pendingActionResult[1]) ? $c846480b5114588d$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $c846480b5114588d$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $c846480b5114588d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $c846480b5114588d$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $c846480b5114588d$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $c846480b5114588d$var$callDataStrategyImpl(dataStrategy || $c846480b5114588d$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($c846480b5114588d$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $c846480b5114588d$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($c846480b5114588d$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $c846480b5114588d$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $c846480b5114588d$export$fec11da027c70692(routes, context, error) {
    let newContext = $c846480b5114588d$var$_extends({}, context, {
        statusCode: $c846480b5114588d$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $c846480b5114588d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $c846480b5114588d$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $c846480b5114588d$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $c846480b5114588d$export$cae722b0cc860f13(to ? to : ".", $c846480b5114588d$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $c846480b5114588d$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $c846480b5114588d$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $c846480b5114588d$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $c846480b5114588d$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $c846480b5114588d$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$c846480b5114588d$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$c846480b5114588d$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $c846480b5114588d$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $c846480b5114588d$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $c846480b5114588d$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$c846480b5114588d$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$c846480b5114588d$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $c846480b5114588d$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $c846480b5114588d$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $c846480b5114588d$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $c846480b5114588d$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $c846480b5114588d$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($c846480b5114588d$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $c846480b5114588d$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $c846480b5114588d$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $c846480b5114588d$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $c846480b5114588d$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $c846480b5114588d$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $c846480b5114588d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $c846480b5114588d$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $c846480b5114588d$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $c846480b5114588d$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $c846480b5114588d$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($c846480b5114588d$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $c846480b5114588d$var$shouldRevalidateLoader(match, $c846480b5114588d$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $c846480b5114588d$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $c846480b5114588d$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $c846480b5114588d$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $c846480b5114588d$var$shouldRevalidateLoader(fetcherMatch, $c846480b5114588d$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $c846480b5114588d$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $c846480b5114588d$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $c846480b5114588d$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $c846480b5114588d$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $c846480b5114588d$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $c846480b5114588d$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$c846480b5114588d$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $c846480b5114588d$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $c846480b5114588d$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$c846480b5114588d$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $c846480b5114588d$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $c846480b5114588d$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $c846480b5114588d$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$c846480b5114588d$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $c846480b5114588d$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $c846480b5114588d$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $c846480b5114588d$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $c846480b5114588d$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $c846480b5114588d$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $c846480b5114588d$var$ResultType.data,
                result: undefined
            });
        };
        return $c846480b5114588d$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $c846480b5114588d$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $c846480b5114588d$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $c846480b5114588d$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $c846480b5114588d$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $c846480b5114588d$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $c846480b5114588d$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $c846480b5114588d$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($c846480b5114588d$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $c846480b5114588d$var$ResultType.error,
                error: e
            };
        }
        if (type === $c846480b5114588d$var$ResultType.error) return {
            type: $c846480b5114588d$var$ResultType.error,
            error: new $c846480b5114588d$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $c846480b5114588d$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $c846480b5114588d$var$ResultType.error) {
        if ($c846480b5114588d$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $c846480b5114588d$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $c846480b5114588d$var$ResultType.error,
                error: new $c846480b5114588d$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $c846480b5114588d$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $c846480b5114588d$var$ResultType.error,
            error: result,
            statusCode: $c846480b5114588d$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($c846480b5114588d$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $c846480b5114588d$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($c846480b5114588d$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $c846480b5114588d$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $c846480b5114588d$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $c846480b5114588d$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $c846480b5114588d$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$c846480b5114588d$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $c846480b5114588d$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $c846480b5114588d$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($c846480b5114588d$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $c846480b5114588d$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $c846480b5114588d$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($c846480b5114588d$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $c846480b5114588d$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $c846480b5114588d$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $c846480b5114588d$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $c846480b5114588d$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $c846480b5114588d$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $c846480b5114588d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $c846480b5114588d$export$3e9cee6b33872309(!$c846480b5114588d$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($c846480b5114588d$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $c846480b5114588d$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $c846480b5114588d$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($c846480b5114588d$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $c846480b5114588d$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $c846480b5114588d$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $c846480b5114588d$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($c846480b5114588d$var$isErrorResult(result)) {
            let boundaryMatch = $c846480b5114588d$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $c846480b5114588d$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($c846480b5114588d$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $c846480b5114588d$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($c846480b5114588d$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $c846480b5114588d$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $c846480b5114588d$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $c846480b5114588d$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $c846480b5114588d$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $c846480b5114588d$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $c846480b5114588d$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $c846480b5114588d$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $c846480b5114588d$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $c846480b5114588d$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $c846480b5114588d$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $c846480b5114588d$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($c846480b5114588d$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $c846480b5114588d$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(path) : path;
    return $c846480b5114588d$export$fe53371bee54353d($c846480b5114588d$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $c846480b5114588d$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $c846480b5114588d$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $c846480b5114588d$var$ResultType.data || result.type === $c846480b5114588d$var$ResultType.error);
}
function $c846480b5114588d$var$isRedirectDataStrategyResultResult(result) {
    return $c846480b5114588d$var$isResponse(result.result) && $c846480b5114588d$var$redirectStatusCodes.has(result.result.status);
}
function $c846480b5114588d$var$isDeferredResult(result) {
    return result.type === $c846480b5114588d$var$ResultType.deferred;
}
function $c846480b5114588d$var$isErrorResult(result) {
    return result.type === $c846480b5114588d$var$ResultType.error;
}
function $c846480b5114588d$var$isRedirectResult(result) {
    return (result && result.type) === $c846480b5114588d$var$ResultType.redirect;
}
function $c846480b5114588d$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $c846480b5114588d$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $c846480b5114588d$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $c846480b5114588d$var$isRedirectResponse(result) {
    if (!$c846480b5114588d$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $c846480b5114588d$var$isValidMethod(method) {
    return $c846480b5114588d$var$validRequestMethods.has(method.toLowerCase());
}
function $c846480b5114588d$var$isMutationMethod(method) {
    return $c846480b5114588d$var$validMutationMethods.has(method.toLowerCase());
}
async function $c846480b5114588d$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$c846480b5114588d$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($c846480b5114588d$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $c846480b5114588d$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $c846480b5114588d$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($c846480b5114588d$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $c846480b5114588d$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $c846480b5114588d$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $c846480b5114588d$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $c846480b5114588d$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $c846480b5114588d$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $c846480b5114588d$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $c846480b5114588d$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $c846480b5114588d$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $c846480b5114588d$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $c846480b5114588d$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $c846480b5114588d$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $c846480b5114588d$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $c846480b5114588d$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $c846480b5114588d$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $c846480b5114588d$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $c846480b5114588d$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $c846480b5114588d$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $c846480b5114588d$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($c846480b5114588d$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $c846480b5114588d$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($c846480b5114588d$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $c846480b5114588d$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $iisr1 = parcelRequire("iisr1");

function $2e634cb2b6e12a73$var$_extends() {
    $2e634cb2b6e12a73$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2e634cb2b6e12a73$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $2e634cb2b6e12a73$export$3add0d5dce533e2e = /*#__PURE__*/ $iisr1.createContext(null);
const $2e634cb2b6e12a73$export$145dfa71566a64dc = /*#__PURE__*/ $iisr1.createContext(null);
const $2e634cb2b6e12a73$var$AwaitContext = /*#__PURE__*/ $iisr1.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $2e634cb2b6e12a73$export$26749e8557646306 = /*#__PURE__*/ $iisr1.createContext(null);
const $2e634cb2b6e12a73$export$c7914228fb69b0f5 = /*#__PURE__*/ $iisr1.createContext(null);
const $2e634cb2b6e12a73$export$9072aa6dd1f93057 = /*#__PURE__*/ $iisr1.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $2e634cb2b6e12a73$var$RouteErrorContext = /*#__PURE__*/ $iisr1.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $2e634cb2b6e12a73$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $iisr1.useContext($2e634cb2b6e12a73$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $2e634cb2b6e12a73$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $c846480b5114588d$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $2e634cb2b6e12a73$export$9c954a9d03d32f4a() {
    return $iisr1.useContext($2e634cb2b6e12a73$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $2e634cb2b6e12a73$export$45d76561a5302f2b() {
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return $iisr1.useContext($2e634cb2b6e12a73$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $2e634cb2b6e12a73$export$1b3f31771c5d07c() {
    return $iisr1.useContext($2e634cb2b6e12a73$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $2e634cb2b6e12a73$export$6c330e8992e8a295(pattern) {
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $2e634cb2b6e12a73$export$45d76561a5302f2b();
    return $iisr1.useMemo(()=>(0, $c846480b5114588d$export$81336c211d5ff295)(pattern, (0, $c846480b5114588d$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $2e634cb2b6e12a73$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $2e634cb2b6e12a73$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $iisr1.useContext($2e634cb2b6e12a73$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $iisr1.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $2e634cb2b6e12a73$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $iisr1.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $2e634cb2b6e12a73$var$useNavigateStable() : $2e634cb2b6e12a73$var$useNavigateUnstable();
}
function $2e634cb2b6e12a73$var$useNavigateUnstable() {
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let dataRouterContext = $iisr1.useContext($2e634cb2b6e12a73$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $iisr1.useContext($2e634cb2b6e12a73$export$26749e8557646306);
    let { matches: matches } = $iisr1.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2e634cb2b6e12a73$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $c846480b5114588d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $iisr1.useRef(false);
    $2e634cb2b6e12a73$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $iisr1.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $c846480b5114588d$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $c846480b5114588d$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $2e634cb2b6e12a73$var$OutletContext = /*#__PURE__*/ $iisr1.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $2e634cb2b6e12a73$export$4138103a3ae699cc() {
    return $iisr1.useContext($2e634cb2b6e12a73$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $2e634cb2b6e12a73$export$a3be3530d8e40d0b(context) {
    let outlet = $iisr1.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $2e634cb2b6e12a73$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $iisr1.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $2e634cb2b6e12a73$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $iisr1.useContext($2e634cb2b6e12a73$export$26749e8557646306);
    let { matches: matches } = $iisr1.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2e634cb2b6e12a73$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $c846480b5114588d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $iisr1.useMemo(()=>(0, $c846480b5114588d$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $2e634cb2b6e12a73$export$5d3fca4a98652595(routes, locationArg) {
    return $2e634cb2b6e12a73$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $2e634cb2b6e12a73$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $iisr1.useContext($2e634cb2b6e12a73$export$26749e8557646306);
    let { matches: parentMatches } = $iisr1.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $2e634cb2b6e12a73$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $c846480b5114588d$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $c846480b5114588d$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $2e634cb2b6e12a73$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $c846480b5114588d$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $c846480b5114588d$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2e634cb2b6e12a73$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $c846480b5114588d$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2e634cb2b6e12a73$var$DefaultErrorComponent() {
    let error = $2e634cb2b6e12a73$export$ed527bf60f6e05f2();
    let message = (0, $c846480b5114588d$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $iisr1.createElement($iisr1.Fragment, null, /*#__PURE__*/ $iisr1.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $iisr1.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $iisr1.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $2e634cb2b6e12a73$var$defaultErrorElement = /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$var$DefaultErrorComponent, null);
class $2e634cb2b6e12a73$var$RenderErrorBoundary extends $iisr1.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $2e634cb2b6e12a73$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $iisr1.useContext($2e634cb2b6e12a73$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2e634cb2b6e12a73$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $2e634cb2b6e12a73$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $2e634cb2b6e12a73$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $iisr1.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $2e634cb2b6e12a73$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($2e634cb2b6e12a73$var$DataRouterHook || {});
var $2e634cb2b6e12a73$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($2e634cb2b6e12a73$var$DataRouterStateHook || {});
function $2e634cb2b6e12a73$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $2e634cb2b6e12a73$var$useDataRouterContext(hookName) {
    let ctx = $iisr1.useContext($2e634cb2b6e12a73$export$3add0d5dce533e2e);
    !ctx && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2e634cb2b6e12a73$var$useDataRouterState(hookName) {
    let state = $iisr1.useContext($2e634cb2b6e12a73$export$145dfa71566a64dc);
    !state && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return state;
}
function $2e634cb2b6e12a73$var$useRouteContext(hookName) {
    let route = $iisr1.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    !route && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $2e634cb2b6e12a73$var$useCurrentRouteId(hookName) {
    let route = $2e634cb2b6e12a73$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $2e634cb2b6e12a73$export$5fc8298006ad9e58() {
    return $2e634cb2b6e12a73$var$useCurrentRouteId($2e634cb2b6e12a73$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2e634cb2b6e12a73$export$d0fd4b7106de2769() {
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2e634cb2b6e12a73$export$600dc272ed516c15() {
    let dataRouterContext = $2e634cb2b6e12a73$var$useDataRouterContext($2e634cb2b6e12a73$var$DataRouterHook.UseRevalidator);
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseRevalidator);
    return $iisr1.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2e634cb2b6e12a73$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseMatches);
    return $iisr1.useMemo(()=>matches.map((m)=>(0, $c846480b5114588d$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2e634cb2b6e12a73$export$1448a5050d252c4d() {
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2e634cb2b6e12a73$var$useCurrentRouteId($2e634cb2b6e12a73$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2e634cb2b6e12a73$export$fd5d37484eab868d(routeId) {
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2e634cb2b6e12a73$export$fdc00f3f26066d5e() {
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseActionData);
    let routeId = $2e634cb2b6e12a73$var$useCurrentRouteId($2e634cb2b6e12a73$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2e634cb2b6e12a73$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $iisr1.useContext($2e634cb2b6e12a73$var$RouteErrorContext);
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseRouteError);
    let routeId = $2e634cb2b6e12a73$var$useCurrentRouteId($2e634cb2b6e12a73$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $2e634cb2b6e12a73$export$78a72ddb39bdd145() {
    let value = $iisr1.useContext($2e634cb2b6e12a73$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $2e634cb2b6e12a73$export$17f53340677d5831() {
    let value = $iisr1.useContext($2e634cb2b6e12a73$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2e634cb2b6e12a73$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2e634cb2b6e12a73$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $2e634cb2b6e12a73$var$useDataRouterContext($2e634cb2b6e12a73$var$DataRouterHook.UseBlocker);
    let state = $2e634cb2b6e12a73$var$useDataRouterState($2e634cb2b6e12a73$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $iisr1.useState("");
    let blockerFunction = $iisr1.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $2e634cb2b6e12a73$var$_extends({}, currentLocation, {
                pathname: (0, $c846480b5114588d$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $2e634cb2b6e12a73$var$_extends({}, nextLocation, {
                pathname: (0, $c846480b5114588d$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $iisr1.useEffect(()=>{
        let key = String(++$2e634cb2b6e12a73$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $iisr1.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $c846480b5114588d$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $2e634cb2b6e12a73$var$useNavigateStable() {
    let { router: router } = $2e634cb2b6e12a73$var$useDataRouterContext($2e634cb2b6e12a73$var$DataRouterHook.UseNavigateStable);
    let id = $2e634cb2b6e12a73$var$useCurrentRouteId($2e634cb2b6e12a73$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $iisr1.useRef(false);
    $2e634cb2b6e12a73$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $iisr1.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $2e634cb2b6e12a73$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $2e634cb2b6e12a73$var$alreadyWarned$1 = {};
function $2e634cb2b6e12a73$var$warningOnce(key, cond, message) {
    if (!cond && !$2e634cb2b6e12a73$var$alreadyWarned$1[key]) $2e634cb2b6e12a73$var$alreadyWarned$1[key] = true;
}
const $2e634cb2b6e12a73$var$alreadyWarned = {};
function $2e634cb2b6e12a73$var$warnOnce(key, message) {}
const $2e634cb2b6e12a73$var$logDeprecation = (flag, msg, link)=>$2e634cb2b6e12a73$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $2e634cb2b6e12a73$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $2e634cb2b6e12a73$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $2e634cb2b6e12a73$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $2e634cb2b6e12a73$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $2e634cb2b6e12a73$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $2e634cb2b6e12a73$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $2e634cb2b6e12a73$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2e634cb2b6e12a73$var$START_TRANSITION = "startTransition";
const $2e634cb2b6e12a73$var$startTransitionImpl = $iisr1[$2e634cb2b6e12a73$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2e634cb2b6e12a73$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $iisr1.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iisr1.useCallback((newState)=>{
        if (v7_startTransition && $2e634cb2b6e12a73$var$startTransitionImpl) $2e634cb2b6e12a73$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $iisr1.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $iisr1.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $iisr1.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $iisr1.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $iisr1.useEffect(()=>$2e634cb2b6e12a73$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $iisr1.createElement($iisr1.Fragment, null, /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $2e634cb2b6e12a73$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $2e634cb2b6e12a73$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $2e634cb2b6e12a73$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $iisr1.useRef();
    if (historyRef.current == null) historyRef.current = (0, $c846480b5114588d$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iisr1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iisr1.useCallback((newState)=>{
        v7_startTransition && $2e634cb2b6e12a73$var$startTransitionImpl ? $2e634cb2b6e12a73$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iisr1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $iisr1.useEffect(()=>$2e634cb2b6e12a73$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $2e634cb2b6e12a73$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $iisr1.useContext($2e634cb2b6e12a73$export$26749e8557646306);
    let { matches: matches } = $iisr1.useContext($2e634cb2b6e12a73$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2e634cb2b6e12a73$export$45d76561a5302f2b();
    let navigate = $2e634cb2b6e12a73$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $c846480b5114588d$export$cae722b0cc860f13)(to, (0, $c846480b5114588d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $iisr1.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $2e634cb2b6e12a73$export$910ae8079b2c2852(props) {
    return $2e634cb2b6e12a73$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $2e634cb2b6e12a73$export$e7b0ac011bb776c6(_props) {
    (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $2e634cb2b6e12a73$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $c846480b5114588d$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$2e634cb2b6e12a73$export$9c954a9d03d32f4a() && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $iisr1.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $2e634cb2b6e12a73$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $c846480b5114588d$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $iisr1.useMemo(()=>{
        let trailingPathname = (0, $c846480b5114588d$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $2e634cb2b6e12a73$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $2e634cb2b6e12a73$export$5d3fca4a98652595($2e634cb2b6e12a73$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2e634cb2b6e12a73$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$var$ResolveAwait, null, children));
}
var $2e634cb2b6e12a73$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($2e634cb2b6e12a73$var$AwaitRenderStatus || {});
const $2e634cb2b6e12a73$var$neverSettledPromise = new Promise(()=>{});
class $2e634cb2b6e12a73$var$AwaitErrorBoundary extends $iisr1.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $2e634cb2b6e12a73$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2e634cb2b6e12a73$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2e634cb2b6e12a73$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $2e634cb2b6e12a73$var$AwaitRenderStatus.error : "_data" in promise ? $2e634cb2b6e12a73$var$AwaitRenderStatus.success : $2e634cb2b6e12a73$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2e634cb2b6e12a73$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2e634cb2b6e12a73$var$AwaitRenderStatus.error && promise._error instanceof (0, $c846480b5114588d$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $2e634cb2b6e12a73$var$neverSettledPromise;
        if (status === $2e634cb2b6e12a73$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2e634cb2b6e12a73$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2e634cb2b6e12a73$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $iisr1.createElement($2e634cb2b6e12a73$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $2e634cb2b6e12a73$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $2e634cb2b6e12a73$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $iisr1.createElement($iisr1.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $2e634cb2b6e12a73$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $iisr1.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $iisr1.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $iisr1.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2e634cb2b6e12a73$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2e634cb2b6e12a73$export$e7b0ac011bb776c6) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2e634cb2b6e12a73$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2e634cb2b6e12a73$export$daf73786167a7f72(matches) {
    return $2e634cb2b6e12a73$var$_renderMatches(matches);
}
function $2e634cb2b6e12a73$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $iisr1.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $iisr1.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $iisr1.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $2e634cb2b6e12a73$export$f30f7e456d254e83(routes, opts) {
    return (0, $c846480b5114588d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2e634cb2b6e12a73$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $c846480b5114588d$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $2e634cb2b6e12a73$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $34f84368c0c9d98a$var$_extends() {
    $34f84368c0c9d98a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $34f84368c0c9d98a$var$_extends.apply(this, arguments);
}
function $34f84368c0c9d98a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $34f84368c0c9d98a$var$defaultMethod = "get";
const $34f84368c0c9d98a$var$defaultEncType = "application/x-www-form-urlencoded";
function $34f84368c0c9d98a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $34f84368c0c9d98a$var$isButtonElement(object) {
    return $34f84368c0c9d98a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $34f84368c0c9d98a$var$isFormElement(object) {
    return $34f84368c0c9d98a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $34f84368c0c9d98a$var$isInputElement(object) {
    return $34f84368c0c9d98a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $34f84368c0c9d98a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $34f84368c0c9d98a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$34f84368c0c9d98a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $34f84368c0c9d98a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $34f84368c0c9d98a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $34f84368c0c9d98a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $34f84368c0c9d98a$var$_formDataSupportsSubmitter = null;
function $34f84368c0c9d98a$var$isFormDataSubmitterSupported() {
    if ($34f84368c0c9d98a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $34f84368c0c9d98a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $34f84368c0c9d98a$var$_formDataSupportsSubmitter = true;
    }
    return $34f84368c0c9d98a$var$_formDataSupportsSubmitter;
}
const $34f84368c0c9d98a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $34f84368c0c9d98a$var$getFormEncType(encType) {
    if (encType != null && !$34f84368c0c9d98a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $34f84368c0c9d98a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($34f84368c0c9d98a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $c846480b5114588d$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $34f84368c0c9d98a$var$defaultMethod;
        encType = $34f84368c0c9d98a$var$getFormEncType(target.getAttribute("enctype")) || $34f84368c0c9d98a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($34f84368c0c9d98a$var$isButtonElement(target) || $34f84368c0c9d98a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $c846480b5114588d$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $34f84368c0c9d98a$var$defaultMethod;
        encType = $34f84368c0c9d98a$var$getFormEncType(target.getAttribute("formenctype")) || $34f84368c0c9d98a$var$getFormEncType(form.getAttribute("enctype")) || $34f84368c0c9d98a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$34f84368c0c9d98a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($34f84368c0c9d98a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $34f84368c0c9d98a$var$defaultMethod;
        action = null;
        encType = $34f84368c0c9d98a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $34f84368c0c9d98a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $34f84368c0c9d98a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $34f84368c0c9d98a$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $34f84368c0c9d98a$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $34f84368c0c9d98a$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $34f84368c0c9d98a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $c846480b5114588d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $34f84368c0c9d98a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $c846480b5114588d$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $34f84368c0c9d98a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2e634cb2b6e12a73$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $34f84368c0c9d98a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $c846480b5114588d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $34f84368c0c9d98a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $c846480b5114588d$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $34f84368c0c9d98a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $2e634cb2b6e12a73$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $34f84368c0c9d98a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $34f84368c0c9d98a$var$_extends({}, state, {
        errors: $34f84368c0c9d98a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $34f84368c0c9d98a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $c846480b5114588d$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $34f84368c0c9d98a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $iisr1.createContext({
    isTransitioning: false
});
const $34f84368c0c9d98a$export$148fd98d095596d4 = /*#__PURE__*/ $iisr1.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $34f84368c0c9d98a$var$START_TRANSITION = "startTransition";
const $34f84368c0c9d98a$var$startTransitionImpl = $iisr1[$34f84368c0c9d98a$var$START_TRANSITION];
const $34f84368c0c9d98a$var$FLUSH_SYNC = "flushSync";
const $34f84368c0c9d98a$var$flushSyncImpl = $iisr1[$34f84368c0c9d98a$var$FLUSH_SYNC];
const $34f84368c0c9d98a$var$USE_ID = "useId";
const $34f84368c0c9d98a$var$useIdImpl = $iisr1[$34f84368c0c9d98a$var$USE_ID];
function $34f84368c0c9d98a$var$startTransitionSafe(cb) {
    if ($34f84368c0c9d98a$var$startTransitionImpl) $34f84368c0c9d98a$var$startTransitionImpl(cb);
    else cb();
}
function $34f84368c0c9d98a$var$flushSyncSafe(cb) {
    if ($34f84368c0c9d98a$var$flushSyncImpl) $34f84368c0c9d98a$var$flushSyncImpl(cb);
    else cb();
}
class $34f84368c0c9d98a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $34f84368c0c9d98a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $iisr1.useState(router.state);
    let [pendingState, setPendingState] = $iisr1.useState();
    let [vtContext, setVtContext] = $iisr1.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $iisr1.useState();
    let [transition, setTransition] = $iisr1.useState();
    let [interruption, setInterruption] = $iisr1.useState();
    let fetcherData = $iisr1.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $iisr1.useCallback((cb)=>{
        if (v7_startTransition) $34f84368c0c9d98a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $iisr1.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $34f84368c0c9d98a$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $34f84368c0c9d98a$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $34f84368c0c9d98a$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $34f84368c0c9d98a$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $34f84368c0c9d98a$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $iisr1.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $iisr1.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $34f84368c0c9d98a$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $iisr1.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $iisr1.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $iisr1.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $iisr1.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $iisr1.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $iisr1.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $iisr1.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $iisr1.useEffect(()=>(0, $2e634cb2b6e12a73$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $iisr1.createElement($iisr1.Fragment, null, /*#__PURE__*/ $iisr1.createElement((0, $2e634cb2b6e12a73$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $iisr1.createElement((0, $2e634cb2b6e12a73$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $iisr1.createElement($34f84368c0c9d98a$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $iisr1.createElement($34f84368c0c9d98a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $iisr1.createElement((0, $2e634cb2b6e12a73$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $iisr1.createElement($34f84368c0c9d98a$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $34f84368c0c9d98a$var$MemoizedDataRoutes = /*#__PURE__*/ $iisr1.memo($34f84368c0c9d98a$var$DataRoutes);
function $34f84368c0c9d98a$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $2e634cb2b6e12a73$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $34f84368c0c9d98a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $iisr1.useRef();
    if (historyRef.current == null) historyRef.current = (0, $c846480b5114588d$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iisr1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iisr1.useCallback((newState)=>{
        v7_startTransition && $34f84368c0c9d98a$var$startTransitionImpl ? $34f84368c0c9d98a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iisr1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $iisr1.useEffect(()=>(0, $2e634cb2b6e12a73$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $iisr1.createElement((0, $2e634cb2b6e12a73$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $34f84368c0c9d98a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $iisr1.useRef();
    if (historyRef.current == null) historyRef.current = (0, $c846480b5114588d$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iisr1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iisr1.useCallback((newState)=>{
        v7_startTransition && $34f84368c0c9d98a$var$startTransitionImpl ? $34f84368c0c9d98a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iisr1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $iisr1.useEffect(()=>(0, $2e634cb2b6e12a73$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $iisr1.createElement((0, $2e634cb2b6e12a73$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $34f84368c0c9d98a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $iisr1.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iisr1.useCallback((newState)=>{
        v7_startTransition && $34f84368c0c9d98a$var$startTransitionImpl ? $34f84368c0c9d98a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iisr1.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $iisr1.useEffect(()=>(0, $2e634cb2b6e12a73$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $iisr1.createElement((0, $2e634cb2b6e12a73$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $34f84368c0c9d98a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $34f84368c0c9d98a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $34f84368c0c9d98a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $iisr1.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $34f84368c0c9d98a$var$_objectWithoutPropertiesLoose(_ref7, $34f84368c0c9d98a$var$_excluded);
    let { basename: basename } = $iisr1.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $34f84368c0c9d98a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($34f84368c0c9d98a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $c846480b5114588d$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $2e634cb2b6e12a73$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $34f84368c0c9d98a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $iisr1.createElement("a", $34f84368c0c9d98a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $34f84368c0c9d98a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $iisr1.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $34f84368c0c9d98a$var$_objectWithoutPropertiesLoose(_ref8, $34f84368c0c9d98a$var$_excluded2);
    let path = (0, $2e634cb2b6e12a73$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    let routerState = $iisr1.useContext((0, $2e634cb2b6e12a73$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $iisr1.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $34f84368c0c9d98a$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $c846480b5114588d$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $iisr1.createElement($34f84368c0c9d98a$export$a6c7ac8248d6e38a, $34f84368c0c9d98a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $34f84368c0c9d98a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $iisr1.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $34f84368c0c9d98a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $34f84368c0c9d98a$var$_objectWithoutPropertiesLoose(_ref9, $34f84368c0c9d98a$var$_excluded3);
    let submit = $34f84368c0c9d98a$export$47c85c6e3a081d3();
    let formAction = $34f84368c0c9d98a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $iisr1.createElement("form", $34f84368c0c9d98a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $34f84368c0c9d98a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $34f84368c0c9d98a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $34f84368c0c9d98a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($34f84368c0c9d98a$var$DataRouterHook || ($34f84368c0c9d98a$var$DataRouterHook = {}));
var $34f84368c0c9d98a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($34f84368c0c9d98a$var$DataRouterStateHook || ($34f84368c0c9d98a$var$DataRouterStateHook = {}));
// Internal hooks
function $34f84368c0c9d98a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $34f84368c0c9d98a$var$useDataRouterContext(hookName) {
    let ctx = $iisr1.useContext((0, $2e634cb2b6e12a73$export$3add0d5dce533e2e));
    !ctx && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return ctx;
}
function $34f84368c0c9d98a$var$useDataRouterState(hookName) {
    let state = $iisr1.useContext((0, $2e634cb2b6e12a73$export$145dfa71566a64dc));
    !state && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $34f84368c0c9d98a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    let location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    let path = (0, $2e634cb2b6e12a73$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $iisr1.useCallback((event)=>{
        if ($34f84368c0c9d98a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $c846480b5114588d$export$fe53371bee54353d)(location) === (0, $c846480b5114588d$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $34f84368c0c9d98a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $iisr1.useRef($34f84368c0c9d98a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $iisr1.useRef(false);
    let location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    let searchParams = $iisr1.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $34f84368c0c9d98a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    let setSearchParams = $iisr1.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $34f84368c0c9d98a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $34f84368c0c9d98a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $34f84368c0c9d98a$var$fetcherId = 0;
let $34f84368c0c9d98a$var$getUniqueFetcherId = ()=>"__" + String(++$34f84368c0c9d98a$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $34f84368c0c9d98a$export$47c85c6e3a081d3() {
    let { router: router } = $34f84368c0c9d98a$var$useDataRouterContext($34f84368c0c9d98a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $iisr1.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    let currentRouteId = (0, $2e634cb2b6e12a73$export$5fc8298006ad9e58)();
    return $iisr1.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $34f84368c0c9d98a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $34f84368c0c9d98a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $34f84368c0c9d98a$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $34f84368c0c9d98a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $iisr1.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    let routeContext = $iisr1.useContext((0, $2e634cb2b6e12a73$export$9072aa6dd1f93057));
    !routeContext && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $34f84368c0c9d98a$var$_extends({}, (0, $2e634cb2b6e12a73$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $c846480b5114588d$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $c846480b5114588d$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $34f84368c0c9d98a$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $34f84368c0c9d98a$var$useDataRouterContext($34f84368c0c9d98a$var$DataRouterHook.UseFetcher);
    let state = $34f84368c0c9d98a$var$useDataRouterState($34f84368c0c9d98a$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $iisr1.useContext($34f84368c0c9d98a$export$148fd98d095596d4);
    let route = $iisr1.useContext((0, $2e634cb2b6e12a73$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    !route && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $34f84368c0c9d98a$var$useIdImpl ? $34f84368c0c9d98a$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $iisr1.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($34f84368c0c9d98a$var$getUniqueFetcherId());
    // Registration/cleanup
    $iisr1.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $iisr1.useCallback((href, opts)=>{
        !routeId && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $34f84368c0c9d98a$export$47c85c6e3a081d3();
    let submit = $iisr1.useCallback((target, opts)=>{
        submitImpl(target, $34f84368c0c9d98a$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $iisr1.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $iisr1.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $iisr1.createElement($34f84368c0c9d98a$export$a7fed597f4b8afd8, $34f84368c0c9d98a$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $c846480b5114588d$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $iisr1.useMemo(()=>$34f84368c0c9d98a$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $34f84368c0c9d98a$export$fa996778a3a31087() {
    let state = $34f84368c0c9d98a$var$useDataRouterState($34f84368c0c9d98a$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $34f84368c0c9d98a$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $34f84368c0c9d98a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $34f84368c0c9d98a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $34f84368c0c9d98a$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $34f84368c0c9d98a$var$useDataRouterContext($34f84368c0c9d98a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $34f84368c0c9d98a$var$useDataRouterState($34f84368c0c9d98a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $iisr1.useContext((0, $2e634cb2b6e12a73$export$26749e8557646306));
    let location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    let matches = (0, $2e634cb2b6e12a73$export$2378eb7f5ff86053)();
    let navigation = (0, $2e634cb2b6e12a73$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $iisr1.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $34f84368c0c9d98a$var$usePageHide($iisr1.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $34f84368c0c9d98a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $34f84368c0c9d98a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($34f84368c0c9d98a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $iisr1.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $34f84368c0c9d98a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $34f84368c0c9d98a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $iisr1.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($34f84368c0c9d98a$var$_extends({}, location, {
                    pathname: (0, $c846480b5114588d$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($34f84368c0c9d98a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $iisr1.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $34f84368c0c9d98a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $iisr1.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $34f84368c0c9d98a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $iisr1.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $34f84368c0c9d98a$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $2e634cb2b6e12a73$export$b273b3273281a049)(when);
    $iisr1.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $iisr1.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $34f84368c0c9d98a$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $iisr1.useContext($34f84368c0c9d98a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $c846480b5114588d$export$3e9cee6b33872309)(false);
    let { basename: basename } = $34f84368c0c9d98a$var$useDataRouterContext($34f84368c0c9d98a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $2e634cb2b6e12a73$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $c846480b5114588d$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $c846480b5114588d$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $c846480b5114588d$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $c846480b5114588d$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $20e92030a3e2ba32$exports = {};
$20e92030a3e2ba32$exports = import.meta.resolve("IA7EQ");


function $53140ff71bd6800b$export$2e2bcd8739ae039() {
    const [sending, setSending] = (0, $bJrD0.useState)(false);
    const [showResetPassword, setShowResetPassword] = (0, $bJrD0.useState)(false);
    const [allowEmails, setAllowEmails] = (0, $bJrD0.useState)(false);
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    (0, $bJrD0.useEffect)(()=>{
        // reroute if already logged in
        (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).get("apiKey").then((apiKey)=>apiKey && navigate("/"));
        (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6).update().then((info)=>{
            if (info) setAllowEmails(info.allow_email);
        });
    }, []);
    const sendPasswordReset = (e)=>{
        e.preventDefault();
        let login = document.getElementById("login").value || "";
        login.toLowerCase();
        setSending(true);
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/password-reset-mail", {
            mail: login
        }).then((res)=>{
            setSending(false);
            if (res && !res.message) (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("password_reset_mail_sent"));
            else if (res) (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t(res.message), "alert-danger");
            else (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error"), "alert-danger");
        }).catch(()=>{
            setSending(false);
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error"), "alert-danger");
        });
    };
    const sendLoginForm = (e)=>{
        e.preventDefault();
        setSending(true);
        let login = document.getElementById("login").value || "";
        login.toLowerCase();
        const password = document.getElementById("password").value;
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/login", {
            login: login,
            password: password
        }).then((res)=>{
            setSending(false);
            if (res && res.api_key) (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).set("apiKey", res.api_key).then(()=>{
                (0, $cd2f6546c5cf5c32$export$3e32638432616b6).update().then((user)=>{
                    navigate("/");
                });
            });
            else if (res && res.message) (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t(res.message), "alert-danger");
            else (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error"), "alert-danger");
        }).catch(()=>{
            setSending(false);
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error"), "alert-danger");
        });
    };
    return (0, $9SeGy.h)("div", {
        class: "login"
    }, (0, $9SeGy.h)("div", {
        class: "login-form"
    }, (0, $9SeGy.h)("img", {
        src: new URL($20e92030a3e2ba32$exports)
    }), !showResetPassword && (0, $9SeGy.h)("form", null, (0, $9SeGy.h)("div", {
        class: "form-group mb-3"
    }, (0, $9SeGy.h)("input", {
        type: "email",
        class: "form-control",
        required: true,
        id: "login",
        placeholder: t("login_placeholder")
    })), (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password",
        placeholder: t("password_placeholder")
    })), (0, $9SeGy.h)("div", {
        class: "forgot-password"
    }, (0, $9SeGy.h)("span", {
        onClick: ()=>setShowResetPassword(true)
    }, t("forgot_password"))), (0, $9SeGy.h)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendLoginForm(e),
        disabled: sending
    }, t("connect"))), !!showResetPassword && (0, $9SeGy.h)("div", null, allowEmails ? (0, $9SeGy.h)("form", null, (0, $9SeGy.h)("div", {
        class: "form-group mb-3"
    }, (0, $9SeGy.h)("input", {
        type: "email",
        class: "form-control",
        required: true,
        id: "login",
        placeholder: t("login_placeholder")
    })), (0, $9SeGy.h)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendPasswordReset(e),
        disabled: sending
    }, t("submit"))) : (0, $9SeGy.h)("div", {
        class: "welcome"
    }, t("email_disabled")))));
}



var $9SeGy = parcelRequire("9SeGy");



function $245fbd49526c814f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const sendNewPassword = (e)=>{
        e.preventDefault();
        (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).set("apiKey", "");
        const password = document.getElementById("password").value || "";
        const passwordConfirmation = document.getElementById("password_confirmation").value || "";
        const mail = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("mail");
        const key = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("key");
        if (mail && password) {
            if (password != passwordConfirmation) {
                (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("passwords_dont_match"));
                return;
            }
            (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/new-password", {
                mail: mail,
                key: key,
                password: password
            }).then((res)=>{
                if (res.api_key) {
                    (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).set("apiKey", res.api_key);
                    setTimeout(()=>navigate("/"), 100);
                } else (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t(res.message));
            }).catch((res)=>console.warn(res));
        }
    };
    return (0, $9SeGy.h)("div", {
        class: "login"
    }, (0, $9SeGy.h)("div", {
        class: "login-form"
    }, (0, $9SeGy.h)("h2", {
        class: "title"
    }, t("reset_password_title")), (0, $9SeGy.h)("form", null, (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password",
        placeholder: t("new_password_placeholder")
    })), (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password_confirmation",
        placeholder: t("confirm_password_placeholder")
    })), (0, $9SeGy.h)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendNewPassword(e)
    }, t("submit")))));
}



var $9SeGy = parcelRequire("9SeGy");




function $7cecaa63b21a4acb$export$2e2bcd8739ae039() {
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const sendSignupForm = (e)=>{
        e.preventDefault();
        let login = document.getElementById("login").value || "";
        login.toLowerCase();
        const password = document.getElementById("password").value;
        (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).set("apiKey", "");
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/signup", {
            login: login,
            password: password,
            invite_key: (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("inviteKey")
        }).then((res)=>{
            if (res && !res.message) {
                (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).set("apiKey", res.api_key);
                setTimeout(()=>navigate(res.group ? "/groups/" + res.group : "/"), 100);
            } else (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t(res.message));
        });
    };
    return (0, $9SeGy.h)("div", {
        class: "signup"
    }, (0, $9SeGy.h)("div", {
        class: "signup-form"
    }, (0, $9SeGy.h)("img", {
        src: new URL($20e92030a3e2ba32$exports)
    }), (0, $9SeGy.h)("div", {
        class: "welcome lead"
    }, t("invitation_welcome")), (0, $9SeGy.h)("form", null, (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("input", {
        type: "email",
        class: "form-control",
        required: true,
        id: "login",
        placeholder: t("login_placeholder")
    })), (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("input", {
        type: "password",
        class: "form-control",
        required: true,
        id: "password",
        placeholder: t("password_placeholder")
    })), (0, $9SeGy.h)("button", {
        type: "submit",
        class: "btn btn-light",
        onClick: (e)=>sendSignupForm(e)
    }, t("signup")))));
}



var $9SeGy = parcelRequire("9SeGy");


class $10fcb144e46b2198$var$StopNotificationEmails extends (0, $9SeGy.Component) {
    constructor(){
        super();
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api${window.location.pathname}`).then(()=>{
            this.setState({
                message: this.props.t("notification_emails_stopped")
            });
        }).catch((err)=>{
            console.warn(err);
            this.setState({
                message: this.props.t("error")
            });
        });
    }
    render() {
        return (0, $9SeGy.h)("div", null, this.state.message || "");
    }
}
var $10fcb144e46b2198$export$2e2bcd8739ae039 = (0, $ee5bb531210bb8d0$export$2dcb0053efd21124)()($10fcb144e46b2198$var$StopNotificationEmails);



var $9SeGy = parcelRequire("9SeGy");

var $9SeGy = parcelRequire("9SeGy");


var $9SeGy = parcelRequire("9SeGy");


var $9SeGy = parcelRequire("9SeGy");

function $6e64521ddde455b6$export$2e2bcd8739ae039(props) {
    return (0, $9SeGy.h)((0, $48e0eac2816dd5e6$export$2e2bcd8739ae039), {
        id: props.id,
        isChild: true
    });
}



var $bJrD0 = parcelRequire("bJrD0");

function $02bd391920972de4$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const [firstDisplayedChild, setFirstDisplayedChild] = (0, $bJrD0.useState)(0);
    const [lastDisplayedChild, setLastDisplayedChild] = (0, $bJrD0.useState)(0);
    const onNewChild = (event)=>{
        const newMsg = event.detail;
        if (newMsg.parent && (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getId(newMsg.parent) == props.id) // a big number to display all children until the new one. This is not elegant...
        // The issue is that we can't simply increment lastDisplayedChild as it is not defined here
        // Another issue is that a user could load a comment in the middle of the list and create a new one...
        // The real answer is to make a paginated list but that is for another time
        setLastDisplayedChild(1024);
    };
    const displayPreviousChildren = ()=>{
        setFirstDisplayedChild(Math.max(0, firstDisplayedChild - 10));
    };
    const displayNextChildren = ()=>{
        setLastDisplayedChild(Math.min(props.childMessages.length, lastDisplayedChild + 10));
    };
    (0, $bJrD0.useEffect)(()=>{
        window.addEventListener("newChild", onNewChild);
        let firstDisplayedChild = 0;
        let lastDisplayedChild = 0;
        if (props.childMessages.length) {
            let msgIndex = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).action ? props.childMessages.findIndex((e)=>e && e.id === (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).action) : -1;
            if (msgIndex != -1) {
                firstDisplayedChild = Math.max(0, msgIndex - 1);
                lastDisplayedChild = Math.min(props.childMessages.length, msgIndex + 1);
            } else {
                firstDisplayedChild = props.childMessages && props.childMessages.length - 5; // display the last 5 children
                lastDisplayedChild = props.childMessages && props.childMessages.length;
            }
        }
        setFirstDisplayedChild(firstDisplayedChild);
        setLastDisplayedChild(lastDisplayedChild);
    }, []);
    if (lastDisplayedChild - firstDisplayedChild < 1 || !props.childMessages) return null;
    return (0, $9SeGy.h)("div", {
        class: "children"
    }, firstDisplayedChild > 0 && (0, $9SeGy.h)("div", {
        class: "d-flex"
    }, (0, $9SeGy.h)("a", {
        class: "more-coms unselectable",
        onClick: ()=>displayPreviousChildren()
    }, t("previous_coms"))), props.childMessages.map((e, i)=>{
        if (i < firstDisplayedChild || i > lastDisplayedChild) return null;
        return (0, $9SeGy.h)((0, $6e64521ddde455b6$export$2e2bcd8739ae039), {
            id: e.id,
            key: e.id
        });
    }), lastDisplayedChild + 1 < props.childMessages.length && (0, $9SeGy.h)("div", {
        class: "d-flex"
    }, (0, $9SeGy.h)("span", {
        class: "more-coms unselectable",
        onClick: ()=>displayNextChildren()
    }, t("next_coms"))));
}



var $9SeGy = parcelRequire("9SeGy");

function $d385cb0a744355a5$export$2e2bcd8739ae039(props) {
    return (0, $9SeGy.h)("div", {
        class: "message-head d-flex"
    }, !props.isPublic && (0, $9SeGy.h)("div", null, (0, $9SeGy.h)("img", {
        className: `rounded-circle material-shadow avatar${props.author && props.author.name ? "" : " removed-user"}`,
        style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(props.author && props.author.name ? props.author && props.author.id : ""),
        src: props.author && props.author.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.author.avatar.id, 100, 100) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
        title: props.author && props.author.name ? props.author.name : ""
    })), !props.isChild && !props.isPublic && (0, $9SeGy.h)("div", {
        class: "infos"
    }, (0, $9SeGy.h)("span", {
        class: "capitalize author"
    }, props.author && props.author.name ? props.author.name : "")));
}



var $9SeGy = parcelRequire("9SeGy");



var $9SeGy = parcelRequire("9SeGy");
// Fontawesome icons taken from https://raw.githubusercontent.com/FortAwesome/Font-Awesome/master/js/all.js
function $3e9f5419b3244add$var$FaIcon() {
    const icons = {
        regular: {
            comment: [
                512,
                512,
                [],
                "f075",
                "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
            ],
            bookmark: [
                384,
                512,
                [],
                "f02e",
                "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
            ],
            images: [
                576,
                512,
                [],
                "f302",
                "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
            ],
            "check-circle": [
                512,
                512,
                [],
                "f058",
                "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
            ],
            "file-pdf": [
                384,
                512,
                [],
                "f1c1",
                "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
            ],
            bell: [
                448,
                512,
                [],
                "f0f3",
                "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
            ],
            "level-down-alt": [
                320,
                512,
                [],
                "f3be",
                "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
            ],
            house: [
                576,
                512,
                [],
                "f015",
                "M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
            ],
            thumbtack: [
                384,
                512,
                [],
                "f08d",
                "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
            ]
        },
        solid: {
            bookmark: [
                384,
                512,
                [],
                "f02e",
                "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
            ],
            comment: [
                512,
                512,
                [],
                "f075",
                "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
            ],
            "pencil-alt": [
                512,
                512,
                [],
                "f303",
                "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
            ],
            "arrow-left": [
                448,
                512,
                [],
                "f060",
                "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
            ],
            "caret-down": [
                320,
                512,
                [],
                "f0d7",
                "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
            ],
            film: [
                512,
                512,
                [],
                "f008",
                "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
            ],
            times: [
                352,
                512,
                [],
                "f00d",
                "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
            ],
            bell: [
                448,
                512,
                [],
                "f0f3",
                "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
            ],
            "ellipsis-h": [
                512,
                512,
                [],
                "f141",
                "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
            ],
            search: [
                512,
                512,
                [],
                "f002",
                "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
            ]
        }
    };
    const icon = icons[this.props.family][this.props.icon];
    if (icon) return (0, $9SeGy.h)("svg", {
        style: this.props.rotation ? `transform: rotate(${this.props.rotation})` : null,
        className: `fa-icon ${this.props.family} ${this.props.icon}`,
        viewBox: `0 0 ${icon[0]} ${icon[1]}`
    }, (0, $9SeGy.h)("path", {
        fill: "currentColor",
        d: icon[4]
    }));
}
var $3e9f5419b3244add$export$2e2bcd8739ae039 = $3e9f5419b3244add$var$FaIcon;


const $607f51540ffcd426$export$8b29a4b6778bf7f = (0, $3e9f5419b3244add$export$2e2bcd8739ae039);




var $9SeGy = parcelRequire("9SeGy");


var $9SeGy = parcelRequire("9SeGy");



var $bJrD0 = parcelRequire("bJrD0");

function $1d71a8627c3cc4ca$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const groupId = (0, $bJrD0.useState)(props.id);
    const [loaded, setLoaded] = (0, $bJrD0.useState)(false);
    const [search, setSearch] = (0, $bJrD0.useState)("");
    const [hashtags, setHashtags] = (0, $bJrD0.useState)("");
    const [messages, setMessages] = (0, $bJrD0.useState)([]);
    const loadMessages = ()=>{
        const search = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("q");
        const hashtags = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("hashtags");
        setSearch(search);
        setHashtags(hashtags);
        setLoaded(false);
        setMessages([]);
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/messages/search", {
            group: groupId,
            search: search,
            hashtags: hashtags
        }).then((res)=>{
            if (res && Array.isArray(res["messages"])) {
                setSearch(search);
                setMessages(res["messages"]);
                setLoaded(true);
            }
        }).catch(()=>null);
    };
    (0, $bJrD0.useEffect)(()=>{
        loadMessages();
        window.addEventListener("groupSearch", loadMessages);
        return ()=>{
            window.removeEventListener("groupSearch", loadMessages);
        };
    }, []);
    if (!Array.isArray(messages)) return;
    return (0, $9SeGy.h)("div", null, (0, $9SeGy.h)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $9SeGy.h)("div", {
        class: "search-results-container container-fluid d-flex justify-content-center flex-wrap"
    }, messages.length == 0 && !loaded && (0, $9SeGy.h)("p", null, (0, $9SeGy.h)("div", {
        class: "mt-5 spinner orange-spinner"
    }, (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null))), messages.length == 0 && loaded && (0, $9SeGy.h)("p", null, t("search_without_result")), messages.map((msg, i)=>{
        return (0, $9SeGy.h)((0, $6a345a2434031edc$export$423dfe6469a8e0dd), {
            tabindex: i + 1,
            key: msg.id,
            message: msg,
            groupId: groupId,
            search: search,
            hashtags: hashtags
        });
    }))));
}



var $9SeGy = parcelRequire("9SeGy");


function $86c0079f7dba3fbc$export$2e2bcd8739ae039() {
    let params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    return (0, $9SeGy.h)("main", null, (0, $9SeGy.h)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $9SeGy.h)("div", {
        class: "content"
    }, (0, $9SeGy.h)("article", {
        class: "mb-3"
    }, (0, $9SeGy.h)("div", {
        class: "container pb-3"
    }, (0, $9SeGy.h)((0, $520fa8871428281e$export$8eb86eb08c0b5c12), {
        key: params.id,
        id: params.id
    })))));
}



var $9SeGy = parcelRequire("9SeGy");



function $bdb02e7be54f3bf7$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    return (0, $9SeGy.h)((0, $9SeGy.Fragment), null, this.props.groups && (0, $9SeGy.h)("div", {
        class: "nav-link dropdown groups unselectable",
        tabindex: "-1",
        onClick: (e)=>e.currentTarget.classList.toggle("active")
    }, (0, $9SeGy.h)("div", {
        class: "unselectable pr-1"
    }, t("groups"), " ", (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "caret-down"
    })), (0, $9SeGy.h)("div", {
        class: "dropdown-menu dropdown-left"
    }, this.props.groups.filter((e)=>!!e).map((e)=>(0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
            key: e.id,
            to: `/groups/${e.id}`,
            class: "d-block seamless-link unselectable"
        }, e.name)), (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        to: "/create-group",
        class: "seamless-link unselectable"
    }, `+ ${t("create_a_group")}`))));
}



var $9SeGy = parcelRequire("9SeGy");




function $c8922817e0b73ac9$export$5830513599693295($store, keys, listener) {
    let keysSet = new Set(keys).add(undefined);
    return $store.listen((value, oldValue, changed)=>{
        if (keysSet.has(changed)) listener(value, oldValue, changed);
    });
}
function $c8922817e0b73ac9$export$cfd6baa0b82a37e5($store, keys, listener) {
    let unbind = $c8922817e0b73ac9$export$5830513599693295($store, keys, listener);
    listener($store.value);
    return unbind;
}



var $bJrD0 = parcelRequire("bJrD0");
function $7ba8b1ffcfbcdb40$export$6ccbb43953eebf8(store, opts = {}) {
    let [, forceRender] = (0, $bJrD0.useState)({});
    let [valueBeforeEffect] = (0, $bJrD0.useState)(store.get());
    (0, $bJrD0.useEffect)(()=>{
        valueBeforeEffect !== store.get() && forceRender({});
    }, []);
    (0, $bJrD0.useEffect)(()=>{
        let batching, timer, unlisten;
        let rerender = ()=>{
            if (!batching) {
                batching = 1;
                timer = setTimeout(()=>{
                    batching = undefined;
                    forceRender({});
                });
            }
        };
        if (opts.keys) unlisten = (0, $c8922817e0b73ac9$export$5830513599693295)(store, opts.keys, rerender);
        else unlisten = store.listen(rerender);
        return ()=>{
            unlisten();
            clearTimeout(timer);
        };
    }, [
        store,
        '' + opts.keys
    ]);
    return store.get();
}





function $a069a14e59ed06ba$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const me = (0, $7ba8b1ffcfbcdb40$export$6ccbb43953eebf8)((0, $5332018adf75499b$export$a94cb3a0c5b0c060));
    return (0, $9SeGy.h)("div", {
        class: "main-nav nav align-items-center z-index-100"
    }, (0, $9SeGy.h)("div", {
        class: "navbar-block"
    }, (0, $9SeGy.h)("div", {
        class: "menu dropdown cursor-pointer",
        tabindex: "-1",
        onClick: (e)=>e.currentTarget.classList.toggle("active")
    }, (0, $9SeGy.h)("div", {
        class: "rounded-circle avatar unselectable"
    }, (0, $9SeGy.h)("img", {
        class: "rounded-circle",
        style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(me.id),
        src: me.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(me.avatar["id"], 80, 80) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
        onError: (e)=>e.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar
    })), (0, $9SeGy.h)("div", {
        class: "dropdown-menu dropdown-right"
    }, (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "d-block seamless-link capitalize",
        to: "/bookmarks"
    }, t("bookmarks")), (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "d-block seamless-link capitalize",
        to: `/users/${me.id}/settings`
    }, t("settings")), (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "d-block seamless-link capitalize",
        to: "/logout"
    }, t("logout")))), (0, $9SeGy.h)((0, $520fa8871428281e$export$2d8ae0bb40c793f6), null), (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        to: "/feed",
        class: `seamless-link nav-link feed-button unselectable ${(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).route === "feed" ? "feed-active" : ""}`,
        title: t("feed_group"),
        "aria-label": t("feed_group")
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "regular",
        icon: "house"
    }))), [
        "messages",
        "groups"
    ].includes((0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).route) && (0, $9SeGy.h)((0, $be03c4de42ac64ff$export$4b85d3515bd863a5), null), (0, $9SeGy.h)("div", {
        class: "navbar-block"
    }, (0, $9SeGy.h)((0, $520fa8871428281e$export$ffe0a8eecde78dfa), {
        groups: me.groups
    })));
}



var $9SeGy = parcelRequire("9SeGy");






function $664ade9a4f66382d$var$_extends() {
    return $664ade9a4f66382d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $664ade9a4f66382d$var$_extends.apply(null, arguments);
}
function $664ade9a4f66382d$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const notifications = (0, $7ba8b1ffcfbcdb40$export$6ccbb43953eebf8)((0, $b49847e1ffb70926$export$c73f0afda48eecf0));
    if (!notifications) return null;
    return (0, $9SeGy.h)("div", {
        className: `menu dropdown${notifications.length ? " cursor-pointer" : ""}`,
        title: t("notifications"),
        tabindex: "-1",
        onClick: (e)=>notifications.length && e.currentTarget.classList.toggle("active")
    }, (0, $9SeGy.h)("div", {
        class: "unselectable button-with-count"
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: notifications.length ? "solid" : "regular",
        icon: "bell"
    }), !!notifications.filter((n)=>!n.read).length && (0, $9SeGy.h)("div", {
        class: "unread-badge"
    })), (0, $9SeGy.h)("div", {
        class: "dropdown-menu dropdown-right notifications-menu"
    }, (0, $9SeGy.h)("div", {
        class: "notification-header"
    }, (0, $9SeGy.h)("strong", {
        class: "capitalize"
    }, t("notifications")), (0, $9SeGy.h)("div", {
        class: "action capitalize",
        onClick: ()=>{
            (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).markAllNotificationsAsRead();
        }
    }, t("mark_all_as_read"))), notifications?.length && notifications.sort((a, b)=>b.createdAt - a.createdAt).slice(0, (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).LIMIT).map((e)=>(0, $9SeGy.h)((0, $be03c4de42ac64ff$export$14834abbfce3b8cd), $664ade9a4f66382d$var$_extends({
            key: e.id + e.read
        }, e)))));
}


const $520fa8871428281e$export$8eb86eb08c0b5c12 = (0, $1d71a8627c3cc4ca$export$2e2bcd8739ae039);
const $520fa8871428281e$export$5cc34a6155e65c0e = (0, $86c0079f7dba3fbc$export$2e2bcd8739ae039);
const $520fa8871428281e$export$ffe0a8eecde78dfa = (0, $bdb02e7be54f3bf7$export$2e2bcd8739ae039);
const $520fa8871428281e$export$42cfbb80f7861e77 = (0, $a069a14e59ed06ba$export$2e2bcd8739ae039);
const $520fa8871428281e$export$2d8ae0bb40c793f6 = (0, $664ade9a4f66382d$export$2e2bcd8739ae039);





function $6f8b52f4496f3b9a$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const bookmarks = (0, $7ba8b1ffcfbcdb40$export$6ccbb43953eebf8)((0, $1648cda18d60f785$export$b294d243702b04e2));
    if (!bookmarks) return (0, $9SeGy.h)("main", null, (0, $9SeGy.h)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $9SeGy.h)("div", {
        class: "content"
    }, (0, $9SeGy.h)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $9SeGy.h)("div", {
        class: "message-container container-fluid d-flex justify-content-center flex-wrap"
    }, t("you_have_no_bookmarks")))));
    if (!Array.isArray(bookmarks) || bookmarks.length < 1) return;
    return (0, $9SeGy.h)("main", null, (0, $9SeGy.h)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $9SeGy.h)("div", {
        class: "content"
    }, (0, $9SeGy.h)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $9SeGy.h)("div", {
        class: "message-container container-fluid d-flex justify-content-center flex-wrap"
    }, bookmarks.map((b, i)=>{
        return (0, $9SeGy.h)((0, $6a345a2434031edc$export$84c965ec8b6b0f92), {
            tabindex: i + 1,
            key: b.message.id,
            id: b.message.id
        });
    })))));
}



var $9SeGy = parcelRequire("9SeGy");



class $dd2a1b0379ca9bf9$var$CreateGroup extends (0, $9SeGy.Component) {
    constructor(){
        super();
        this.postNewGroup = this.postNewGroup.bind(this);
    }
    postNewGroup(event) {
        event.preventDefault();
        const name = document.querySelector("#create_group_form input[name='name']").value;
        let group = {};
        if (name) group.name = name;
        else return false;
        group.createdAt = Math.floor(Date.now() / 1000);
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/groups", group).then((res)=>{
            if (res?.id) window.location = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(`/groups/${res.id}`);
        }).catch(()=>null);
    }
    render() {
        return (0, $9SeGy.h)("main", null, (0, $9SeGy.h)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $9SeGy.h)("div", {
            class: "content"
        }, (0, $9SeGy.h)("div", {
            class: "container mt-2"
        }, (0, $9SeGy.h)("div", {
            class: "group-settings"
        }, (0, $9SeGy.h)("div", {
            class: "card"
        }, (0, $9SeGy.h)("div", {
            class: "card-body"
        }, (0, $9SeGy.h)("div", {
            class: "container-fluid p-1"
        }, (0, $9SeGy.h)("div", {
            class: "row"
        }, (0, $9SeGy.h)("div", {
            class: "col-12 col-md-10"
        }, (0, $9SeGy.h)("form", {
            id: "create_group_form",
            class: "mb-1"
        }, (0, $9SeGy.h)("div", {
            class: "form-group"
        }, (0, $9SeGy.h)("label", {
            for: "name"
        }, this.props.t("name"), ": "), (0, $9SeGy.h)("input", {
            type: "text",
            name: "name",
            minlength: "1",
            maxlength: "128",
            placeholder: this.props.t("name_input"),
            class: "form-control",
            required: true
        })), (0, $9SeGy.h)("button", {
            onClick: (e)=>this.postNewGroup(e),
            class: "btn btn-primary"
        }, this.props.t("create_the_group"))))))))))));
    }
}
var $dd2a1b0379ca9bf9$export$2e2bcd8739ae039 = (0, $ee5bb531210bb8d0$export$2dcb0053efd21124)()($dd2a1b0379ca9bf9$var$CreateGroup);



var $9SeGy = parcelRequire("9SeGy");




function $4016a5cf4497ca7a$export$2e2bcd8739ae039() {
    let params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    return (0, $9SeGy.h)("main", null, (0, $9SeGy.h)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $9SeGy.h)("div", {
        class: "content"
    }, (0, $9SeGy.h)("div", null, (0, $9SeGy.h)("div", null, (0, $9SeGy.h)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $9SeGy.h)("div", {
        class: "message-container container-fluid d-flex justify-content-center flex-wrap"
    }, (0, $9SeGy.h)((0, $6a345a2434031edc$export$89085c7857c3f940), {
        key: params.id,
        id: params.id
    })))), (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "write-button material-shadow seamless-link",
        to: `/groups/${params.id}/write`
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "pencil-alt"
    })))));
}



var $9SeGy = parcelRequire("9SeGy");




function $0b07cfe23f8797f2$export$2e2bcd8739ae039() {
    return (0, $9SeGy.h)("main", null, (0, $9SeGy.h)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $9SeGy.h)("div", {
        class: "content"
    }, (0, $9SeGy.h)("div", null, (0, $9SeGy.h)("div", null, (0, $9SeGy.h)("article", {
        id: "group",
        class: "justify-content-center d-flex"
    }, (0, $9SeGy.h)("div", {
        class: "message-container container-fluid d-flex justify-content-center flex-wrap"
    }, (0, $9SeGy.h)((0, $6a345a2434031edc$export$89085c7857c3f940), {
        key: "feed",
        isFeed: true
    })))), (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "write-button material-shadow seamless-link",
        to: "/share"
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "pencil-alt"
    })))));
}



var $9SeGy = parcelRequire("9SeGy");


function $aed7e74f78402a69$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    // duration relative to event
    const humanTime = (timestamp)=>{
        if (!timestamp) return null;
        const duration = Math.abs(Math.round((Date.now() / 1000 - timestamp) / 60));
        if (duration < 1) return t("just_now");
        if (duration < 60) return t("ago", {
            duration: `${duration}mn`
        });
        if (duration < 1440) return t("ago", {
            duration: `${Math.floor(duration / 60)}h`
        });
        return (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanFullDate(timestamp).split(" ")[0];
    };
    return (0, $9SeGy.h)((0, $9SeGy.Fragment), null, humanTime(props.timestamp));
}



var $9SeGy = parcelRequire("9SeGy");


var $bJrD0 = parcelRequire("bJrD0");



function $73f3a1fb1b71c71a$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const [target, setTarget] = (0, $bJrD0.useState)(null);
    const [action, setAction] = (0, $bJrD0.useState)(null);
    const [title, setTitle] = (0, $bJrD0.useState)(null);
    const [author, setAuthor] = (0, $bJrD0.useState)(null);
    const [notification, setNotification] = (0, $bJrD0.useState)(null);
    const getMiniature = (notification)=>{
        let imgSrc = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar;
        if (notification?.miniature && notification.type != "global_notification") imgSrc = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(notification?.miniature?.id, 80, 80);
        return (0, $9SeGy.h)("img", {
            style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(notification?.fromUser?.id),
            src: imgSrc,
            onError: (e)=>setMiniatureOnError(e)
        });
    };
    const setMiniatureOnError = (event)=>{
        event.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar;
    };
    const getAction = (notification)=>{
        switch(notification?.type){
            case "new_message":
                return t("has_posted_in");
            case "new_comment":
                return t("has_commented_on");
            case "user_joined_group":
                return t("has_joined");
            case "user_left_group":
                return t("has_left");
            case "group_name_change":
                return t("changed_group_name");
            default:
                return "";
        }
    };
    const getObject = (notification)=>{
        switch(notification?.type){
            case "new_message":
                return (0, $9SeGy.h)((0, $9SeGy.Fragment), null, (0, $9SeGy.h)("strong", null, notification?.fromGroup.name), title && (0, $9SeGy.h)((0, $9SeGy.Fragment), null, (0, $9SeGy.h)("br", null), (0, $9SeGy.h)("small", null, (0, $9SeGy.h)("em", null, (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).limitStrSize(title, 50)))));
            case "new_comment":
                return (0, $9SeGy.h)("span", null, `${t("the_message_from")} `, (0, $9SeGy.h)("strong", null, notification?.parentAuthorName), title && (0, $9SeGy.h)((0, $9SeGy.Fragment), null, (0, $9SeGy.h)("br", null), (0, $9SeGy.h)("small", null, (0, $9SeGy.h)("em", null, (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).limitStrSize(title, 50)))));
            case "user_joined_group":
            case "user_left_group":
                return (0, $9SeGy.h)("strong", null, notification?.fromGroup.name);
            case "group_name_change":
                return (0, $9SeGy.h)("span", null, (0, $9SeGy.h)("strong", null, notification.data["previousGroupName"]), ` ${t("to")} `, (0, $9SeGy.h)("strong", null, notification.data["newGroupName"]));
            case "global_notification":
                return notification.data["text"];
            default:
                return "";
        }
    };
    const getTarget = (notification, message_id)=>{
        switch(notification?.type){
            case "user_joined_group":
            case "user_left_group":
            case "group_name_change":
                return `/groups/${notification.fromGroup.id}`;
            case "new_message":
                return `/messages/${notification.target}`;
            case "new_comment":
                return `/messages/${message_id}/${notification.target}`;
            case "global_notification":
                return notification.target;
            default:
                return "";
        }
    };
    (0, $bJrD0.useEffect)(()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/notifications/${props.id}`, false, 100).then((n)=>{
            if (n) {
                setTarget(getTarget(n, n.fromMessage?.id));
                setAction(getAction(n));
                setTitle(n.title);
                if (n?.fromUser?.id) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/users/${n.fromUser.id}`).then((u)=>{
                    if (u) setAuthor(u);
                }).catch(()=>null);
                setNotification(n);
            }
        }).catch(()=>null);
    }, []);
    if (!notification) return null;
    return (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        key: props.id,
        class: `notification seamless-link unselectable ${!notification.read ? "unread" : ""}`,
        to: target,
        title: title
    }, (0, $9SeGy.h)("div", {
        class: "miniature unselectable"
    }, getMiniature(notification)), (0, $9SeGy.h)("div", {
        class: "infos"
    }, (0, $9SeGy.h)("div", {
        class: "description"
    }, notification.type != "global_notification" && (0, $9SeGy.h)((0, $9SeGy.Fragment), null, (0, $9SeGy.h)("strong", null, author?.name || "--"), (0, $9SeGy.h)("span", null, ` ${action} `)), getObject(notification)), (0, $9SeGy.h)("div", {
        class: "date"
    }, (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanTime(notification.createdAt))), (0, $9SeGy.h)("div", {
        class: "options dropdown",
        onClick: (e)=>{
            e.stopPropagation();
            e.preventDefault();
            e?.target?.closest(".dropdown")?.classList.toggle("active");
        }
    }, (0, $9SeGy.h)("div", {
        class: "none-if-follows-empty"
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "ellipsis-h"
    })), (0, $9SeGy.h)("div", {
        class: "dropdown-menu dropdown-options"
    }, (0, $9SeGy.h)("a", {
        class: "seamless-link capitalize",
        onClick: ()=>(0, $cd2f6546c5cf5c32$export$6008d97729a90c74).removeMatchingNotifications(notification.id)
    }, t("delete")))));
}



var $9SeGy = parcelRequire("9SeGy");



var $bJrD0 = parcelRequire("bJrD0");
function $2ed7e499aaac665f$export$2e2bcd8739ae039() {
    const params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    const [message, setMessage] = (0, $bJrD0.useState)(null);
    (0, $bJrD0.useEffect)(()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/groups/${params.id}/random`).then((m)=>{
            if (m) setMessage(m);
        }).catch(()=>null);
    }, []);
    if (message) return (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$444b3ab0cb9aec40), {
        to: `/messages/${message.id}`,
        replace: true
    });
}



var $9SeGy = parcelRequire("9SeGy");




function $a06567713ad1b415$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    function search(evt) {
        evt.preventDefault();
        (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getEntity().then((entity)=>{
            if (!entity) return;
            let group_id = null;
            switch(entity.entityType){
                case "group":
                    group_id = entity.id;
                    break;
                case "message":
                    group_id = entity.group.id;
                    break;
                default:
            }
            // https://stackoverflow.com/a/37511463
            let searchTerms = document.getElementById("search").value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(" ");
            navigate(`/groups/${group_id}/search?q=${searchTerms.join("+")}`);
            window.dispatchEvent(new CustomEvent("groupSearch"));
        }).catch(()=>null);
    }
    return (0, $9SeGy.h)("form", {
        class: "navbar-block search-block",
        onSubmit: (e)=>search(e)
    }, (0, $9SeGy.h)("div", {
        class: "input-group"
    }, (0, $9SeGy.h)("input", {
        class: "form-control",
        type: "text",
        id: "search",
        placeholder: t("search_in_group"),
        value: (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("q").replace(/\+/g, " ")
    }), (0, $9SeGy.h)("div", {
        class: "input-group-append"
    }, (0, $9SeGy.h)("button", {
        class: "btn btn-secondary",
        type: "submit"
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "search"
    })))));
}



var $9SeGy = parcelRequire("9SeGy");


var $9SeGy = parcelRequire("9SeGy");



function $37e28339f35f2974$export$2e2bcd8739ae039() {
    let params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    return (0, $9SeGy.h)("main", null, (0, $9SeGy.h)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $9SeGy.h)("div", {
        class: "content"
    }, (0, $9SeGy.h)("article", {
        class: "mb-3"
    }, (0, $9SeGy.h)("div", {
        class: "container pb-3"
    }, (0, $9SeGy.h)((0, $b0c42e92c84db02f$export$d7a960146e1a269e), {
        focus: true,
        group: params.id
    })))));
}



var $9SeGy = parcelRequire("9SeGy");





var $bJrD0 = parcelRequire("bJrD0");
// trick from https://stackoverflow.com/a/53837442
function $fe5a7484fb575b8e$var$useForceUpdate() {
    const setValue = (0, $bJrD0.useState)(0)[1]; // integer state
    return ()=>setValue((value)=>value + 1); // update state to force render
}
function $fe5a7484fb575b8e$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const [files, setFiles] = (0, $bJrD0.useState)(props?.files || []);
    const [sending, setSending] = (0, $bJrD0.useState)(false);
    const [uploading, setUploading] = (0, $bJrD0.useState)(false);
    const forceUpdate = $fe5a7484fb575b8e$var$useForceUpdate();
    const writerId = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).genId();
    const editorRef = (0, $bJrD0.useRef)(null);
    // This allows to have the latest state of files in callbacks
    // https://stackoverflow.com/a/60643670
    const currentFiles = (0, $bJrD0.useRef)();
    currentFiles.current = files;
    const setForm = (writerForm, files = [], title = "", text = "")=>{
        setFiles(files);
        Array.from(writerForm.current.getElementsByClassName("title-input")).map((e)=>e.value = title);
        editorRef.current.setText(text);
    };
    const updateFile = (id, file)=>{
        setFiles(currentFiles.current.map((f)=>f.id === id ? Object.assign(f, file) : f));
    };
    const invertFiles = (id_a, id_b)=>{
        const index_a = files.findIndex((e)=>e.id === id_a);
        const index_b = files.findIndex((e)=>e.id === id_b);
        [files[index_a], files[index_b]] = [
            files[index_b],
            files[index_a]
        ];
        setFiles(files);
        forceUpdate();
    };
    const removeFile = (id)=>{
        setFiles(files.filter((f)=>f.id != id));
    };
    const uploadFile = (fileId)=>{
        const formData = new FormData();
        let file = files.find((e)=>e.id == fileId);
        if (!file || !file.inputFile) {
            // TODO handle this properly
            console.error(files, file, fileId);
            throw "error";
        }
        formData.append("file", file.inputFile);
        updateFile(fileId, Object.assign(file, {
            status: "uploading"
        }));
        setUploading(true);
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).sendFile(formData, (file)=>{
            setUploading(false);
            updateFile(fileId, Object.assign({
                status: "ready"
            }, file));
        }, (e)=>{
            updateFile(fileId, {
                status: "uploading",
                progress: Math.floor(e.loaded / e.total * 100)
            });
        }, (e)=>{
            setUploading(false);
            console.warn(e);
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error_upload"), "alert-danger");
            removeFile(fileId);
        });
    };
    const putMessage = (msg, writerForm)=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/messages/${props.messageId}`, msg).then((res)=>{
            setForm(writerForm, [], "", "");
            setSending(false);
            if (!res) {
                (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error_new_message"), "alert-danger");
                return;
            }
            window.dispatchEvent(new CustomEvent("editMessage", {
                detail: res
            }));
        }).catch(()=>{
            setSending(false);
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error_new_message"), "alert-danger");
        });
        setSending(true);
    };
    const postMessage = (msg, writerForm)=>{
        msg = Object.assign(msg, {
            createdAt: Math.floor(Date.now() / 1000),
            author: (0, $cd2f6546c5cf5c32$export$3e32638432616b6).id,
            group: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getId(props.group),
            children: [],
            lastActivityDate: Math.floor(Date.now() / 1000)
        });
        if (props.parent) msg.parent = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getId(props.parent);
        // don't post if there is nothing to post
        let json;
        try {
            json = JSON.parse(msg.data.text);
        } catch  {
            json = "";
        }
        if (!msg.files.length && !json.textOnly.trim() && !msg.data.title) {
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("empty_message"), "alert-danger");
            return;
        }
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post("/api/messages", msg).then((res)=>{
            if (!res) {
                setSending(false);
                (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error_new_message"), "alert-danger");
                return;
            }
            if (props.isChild) {
                setSending(false);
                window.dispatchEvent(new CustomEvent("newChild", {
                    detail: res
                }));
            } else navigate(`/messages/${res.id}`);
            setForm(writerForm, [], "", "");
        }).catch(()=>{
            setSending(false);
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error_new_message"), "alert-danger");
        });
        setSending(true);
    };
    const sendMessage = (writerForm, data)=>{
        let type;
        try {
            let obj = JSON.parse(data.text);
            // Only one insert is done if there are no style attributes, so check if that attribute
            // matches the text only version (in case there's just one segment and it's styled)
            if (obj.delta.ops[0].insert === obj.textOnly) type = "standard";
            else type = "rich_text";
        } catch  {
            type = "standard";
        }
        let msg = {
            files: files.filter((e)=>!e?.removed).filter((e)=>[
                    "ready",
                    "raw"
                ].includes(e?.status)).map((e)=>e?.id).filter((e)=>!!e),
            data: {
                title: data?.title,
                text: data?.text
            },
            type: type
        };
        if (props.messageId) putMessage(msg, writerForm);
        else postMessage(msg, writerForm);
    };
    // toggle state (removed or not) of a file
    const toggleFile = (id)=>{
        setFiles(files.map((f)=>{
            if (f.id == id) f.removed = !f.removed;
            return f;
        }));
    };
    const addFiles = (mimetype, input_files)=>{
        let list = Array.from(input_files).map((e)=>({
                inputFile: e,
                type: mimetype,
                id: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).genId(),
                progress: 0,
                status: "initial"
            }));
        setFiles([
            ...files,
            ...list
        ]);
    };
    const inputFile = (mimetype, multiple = false)=>{
        const input = document.createElement("input");
        document.body.appendChild(input);
        input.style.display = "none";
        input.type = "file";
        input.accept = mimetype;
        if (multiple) input.multiple = "multiple";
        input.addEventListener("change", (event)=>{
            addFiles(mimetype, event.target.files);
        });
        input.click();
    };
    (0, $bJrD0.useEffect)(()=>{
        if (files.filter((e)=>e.status === "uploading").length < 2) {
            for(let i = 0; i < files.length; i++)if (files[i].status == "initial" && !!files[i].inputFile) {
                uploadFile(files[i].id);
                break;
            }
        }
    }, [
        files
    ]);
    return (0, $9SeGy.h)((0, $b0c42e92c84db02f$export$29beae8571dce55f), {
        id: writerId,
        sending: sending,
        uploading: uploading,
        inputFile: inputFile,
        sendMessage: sendMessage,
        cancel: props.cancel,
        files: files,
        toggleFile: toggleFile,
        invertFiles: invertFiles,
        addFiles: addFiles,
        group: props.group,
        isChild: props.isChild,
        text: props.text,
        title: props.title,
        editorRef: editorRef
    });
}



var $9SeGy = parcelRequire("9SeGy");



var $9SeGy = parcelRequire("9SeGy");


var $bJrD0 = parcelRequire("bJrD0");

var $9SeGy = parcelRequire("9SeGy");
class $471cd1c649eea7ba$export$2e2bcd8739ae039 extends (0, $9SeGy.Component) {
    render() {
        const embedUrl = `${this.props.url}/size=large/bgcol=f5f5f5/linkcol=0687f5/minimal=true/tracklist=false/`;
        if (this.state.revealed) return (0, $9SeGy.h)("div", {
            class: "bandcamp-embed embed-responsive embed-responsive-1by1"
        }, (0, $9SeGy.h)("iframe", {
            class: "embed-responsive-item",
            src: embedUrl
        }));
        return (0, $9SeGy.h)("div", {
            class: "embed-preview",
            onClick: ()=>this.setState({
                    revealed: true
                })
        }, (0, $9SeGy.h)("div", {
            class: "bandcamp"
        }), (0, $9SeGy.h)("img", {
            src: this.props.preview
        }));
    }
}



var $9SeGy = parcelRequire("9SeGy");
class $1dd5e274a4fb4aa6$export$2e2bcd8739ae039 extends (0, $9SeGy.Component) {
    render() {
        if (this.state.revealed) return (0, $9SeGy.h)("div", {
            class: "embed-responsive embed-responsive-16by9"
        }, (0, $9SeGy.h)("iframe", {
            allowfullscreen: true,
            class: "embed-responsive-item",
            referrerpolicy: "strict-origin-when-cross-origin",
            src: this.props.url
        }));
        return (0, $9SeGy.h)("div", {
            class: "embed-preview",
            onClick: ()=>this.setState({
                    revealed: true
                })
        }, (0, $9SeGy.h)("div", {
            className: this.props.playBtnClass
        }), (0, $9SeGy.h)("img", {
            src: this.props.preview
        }));
    }
}


var $42107f3179039eb0$exports = {};
!function(e, t) {
    $42107f3179039eb0$exports = t();
}($42107f3179039eb0$exports, function() {
    "use strict";
    function e(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function t(e, t) {
        for(var i = 0; i < t.length; i++){
            var s = t[i];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, n(s.key), s);
        }
    }
    function i(e, i, n) {
        return i && t(e.prototype, i), n && t(e, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function n(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var i = e[Symbol.toPrimitive];
            if (void 0 !== i) {
                var n = i.call(e, t || "default");
                if ("object" != typeof n) return n;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }
    function s(e) {
        return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
    }
    var l = Date.now();
    function o() {
        var e = {}, t = !0, i = 0, n = arguments.length;
        "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (t = arguments[0], i++);
        for(var s = function(i) {
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t && "[object Object]" === Object.prototype.toString.call(i[n]) ? e[n] = o(!0, e[n], i[n]) : e[n] = i[n]);
        }; i < n; i++){
            var l = arguments[i];
            s(l);
        }
        return e;
    }
    function r(e, t) {
        if ((E(e) || e === window || e === document) && (e = [
            e
        ]), L(e) || I(e) || (e = [
            e
        ]), 0 != M(e)) {
            if (L(e) && !I(e)) for(var i = e.length, n = 0; n < i && !1 !== t.call(e[n], e[n], n, e); n++);
            else if (I(e)) {
                for(var s in e)if (P(e, s) && !1 === t.call(e[s], e[s], s, e)) break;
            }
        }
    }
    function a(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = e[l] = e[l] || [], s = {
            all: n,
            evt: null,
            found: null
        };
        return t && i && M(n) > 0 && r(n, function(e, n) {
            if (e.eventName == t && e.fn.toString() == i.toString()) return s.found = !0, s.evt = n, !1;
        }), s;
    }
    function h(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = t.onElement, n = t.withCallback, s = t.avoidDuplicate, l = void 0 === s || s, o = t.once, h = void 0 !== o && o, d = t.useCapture, c = void 0 !== d && d, u = arguments.length > 2 ? arguments[2] : void 0, g = i || [];
        function v(e) {
            C(n) && n.call(u, e, this), h && v.destroy();
        }
        return k(g) && (g = document.querySelectorAll(g)), v.destroy = function() {
            r(g, function(t) {
                var i = a(t, e, v);
                i.found && i.all.splice(i.evt, 1), t.removeEventListener && t.removeEventListener(e, v, c);
            });
        }, r(g, function(t) {
            var i = a(t, e, v);
            (t.addEventListener && l && !i.found || !l) && (t.addEventListener(e, v, c), i.all.push({
                eventName: e,
                fn: v
            }));
        }), v;
    }
    function d(e, t) {
        r(t.split(" "), function(t) {
            return e.classList.add(t);
        });
    }
    function c(e, t) {
        r(t.split(" "), function(t) {
            return e.classList.remove(t);
        });
    }
    function u(e, t) {
        return e.classList.contains(t);
    }
    function g(e, t) {
        for(; e !== document.body;){
            if (!(e = e.parentElement)) return !1;
            if ("function" == typeof e.matches ? e.matches(t) : e.msMatchesSelector(t)) return e;
        }
    }
    function v(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (!e || "" === t) return !1;
        if ("none" === t) return C(i) && i(), !1;
        var n = b(), s = t.split(" ");
        r(s, function(t) {
            d(e, "g" + t);
        }), h(n, {
            onElement: e,
            avoidDuplicate: !1,
            once: !0,
            withCallback: function(e, t) {
                r(s, function(e) {
                    c(t, "g" + e);
                }), C(i) && i();
            }
        });
    }
    function f(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        if ("" === t) return e.style.webkitTransform = "", e.style.MozTransform = "", e.style.msTransform = "", e.style.OTransform = "", e.style.transform = "", !1;
        e.style.webkitTransform = t, e.style.MozTransform = t, e.style.msTransform = t, e.style.OTransform = t, e.style.transform = t;
    }
    function p(e) {
        e.style.display = "block";
    }
    function m(e) {
        e.style.display = "none";
    }
    function y(e) {
        var t = document.createDocumentFragment(), i = document.createElement("div");
        for(i.innerHTML = e; i.firstChild;)t.appendChild(i.firstChild);
        return t;
    }
    function x() {
        return {
            width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        };
    }
    function b() {
        var e, t = document.createElement("fakeelement"), i = {
            animation: "animationend",
            OAnimation: "oAnimationEnd",
            MozAnimation: "animationend",
            WebkitAnimation: "webkitAnimationEnd"
        };
        for(e in i)if (void 0 !== t.style[e]) return i[e];
    }
    function S(e, t, i, n) {
        if (e()) t();
        else {
            var s;
            i || (i = 100);
            var l = setInterval(function() {
                e() && (clearInterval(l), s && clearTimeout(s), t());
            }, i);
            n && (s = setTimeout(function() {
                clearInterval(l);
            }, n));
        }
    }
    function w(e, t, i) {
        if (O(e)) console.error("Inject assets error");
        else if (C(t) && (i = t, t = !1), k(t) && t in window) C(i) && i();
        else {
            var n;
            if (-1 !== e.indexOf(".css")) {
                if ((n = document.querySelectorAll('link[href="' + e + '"]')) && n.length > 0) return void (C(i) && i());
                var s = document.getElementsByTagName("head")[0], l = s.querySelectorAll('link[rel="stylesheet"]'), o = document.createElement("link");
                return o.rel = "stylesheet", o.type = "text/css", o.href = e, o.media = "all", l ? s.insertBefore(o, l[0]) : s.appendChild(o), void (C(i) && i());
            }
            if ((n = document.querySelectorAll('script[src="' + e + '"]')) && n.length > 0) {
                if (C(i)) {
                    if (k(t)) return S(function() {
                        return void 0 !== window[t];
                    }, function() {
                        i();
                    }), !1;
                    i();
                }
            } else {
                var r = document.createElement("script");
                r.type = "text/javascript", r.src = e, r.onload = function() {
                    if (C(i)) {
                        if (k(t)) return S(function() {
                            return void 0 !== window[t];
                        }, function() {
                            i();
                        }), !1;
                        i();
                    }
                }, document.body.appendChild(r);
            }
        }
    }
    function T() {
        return "navigator" in window && window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i);
    }
    function C(e) {
        return "function" == typeof e;
    }
    function k(e) {
        return "string" == typeof e;
    }
    function E(e) {
        return !(!e || !e.nodeType || 1 != e.nodeType);
    }
    function A(e) {
        return Array.isArray(e);
    }
    function L(e) {
        return e && e.length && isFinite(e.length);
    }
    function I(e) {
        return "object" === s(e) && null != e && !C(e) && !A(e);
    }
    function O(e) {
        return null == e;
    }
    function P(e, t) {
        return null !== e && hasOwnProperty.call(e, t);
    }
    function M(e) {
        if (I(e)) {
            if (e.keys) return e.keys().length;
            var t = 0;
            for(var i in e)P(e, i) && t++;
            return t;
        }
        return e.length;
    }
    function z(e) {
        return !isNaN(parseFloat(e)) && isFinite(e);
    }
    function X() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1, t = document.querySelectorAll(".gbtn[data-taborder]:not(.disabled)");
        if (!t.length) return !1;
        if (1 == t.length) return t[0];
        "string" == typeof e && (e = parseInt(e));
        var i = [];
        r(t, function(e) {
            i.push(e.getAttribute("data-taborder"));
        });
        var n = Math.max.apply(Math, i.map(function(e) {
            return parseInt(e);
        })), s = e < 0 ? 1 : e + 1;
        s > n && (s = "1");
        var l = i.filter(function(e) {
            return e >= parseInt(s);
        }), o = l.sort()[0];
        return document.querySelector('.gbtn[data-taborder="'.concat(o, '"]'));
    }
    function Y(e) {
        if (e.events.hasOwnProperty("keyboard")) return !1;
        e.events.keyboard = h("keydown", {
            onElement: window,
            withCallback: function(t, i) {
                var n = (t = t || window.event).keyCode;
                if (9 == n) {
                    var s = document.querySelector(".gbtn.focused");
                    if (!s) {
                        var l = !(!document.activeElement || !document.activeElement.nodeName) && document.activeElement.nodeName.toLocaleLowerCase();
                        if ("input" == l || "textarea" == l || "button" == l) return;
                    }
                    t.preventDefault();
                    var o = document.querySelectorAll(".gbtn[data-taborder]");
                    if (!o || o.length <= 0) return;
                    if (!s) {
                        var r = X();
                        return void (r && (r.focus(), d(r, "focused")));
                    }
                    var a = X(s.getAttribute("data-taborder"));
                    c(s, "focused"), a && (a.focus(), d(a, "focused"));
                }
                39 == n && e.nextSlide(), 37 == n && e.prevSlide(), 27 == n && e.close();
            }
        });
    }
    var q = i(function t(i, n) {
        var s = this, l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        if (e(this, t), this.img = i, this.slide = n, this.onclose = l, this.img.setZoomEvents) return !1;
        this.active = !1, this.zoomedIn = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.img.addEventListener("mousedown", function(e) {
            return s.dragStart(e);
        }, !1), this.img.addEventListener("mouseup", function(e) {
            return s.dragEnd(e);
        }, !1), this.img.addEventListener("mousemove", function(e) {
            return s.drag(e);
        }, !1), this.img.addEventListener("click", function(e) {
            return s.slide.classList.contains("dragging-nav") ? (s.zoomOut(), !1) : s.zoomedIn ? void (s.zoomedIn && !s.dragging && s.zoomOut()) : s.zoomIn();
        }, !1), this.img.setZoomEvents = !0;
    }, [
        {
            key: "zoomIn",
            value: function() {
                var e = this.widowWidth();
                if (!(this.zoomedIn || e <= 768)) {
                    var t = this.img;
                    if (t.setAttribute("data-style", t.getAttribute("style")), t.style.maxWidth = t.naturalWidth + "px", t.style.maxHeight = t.naturalHeight + "px", t.naturalWidth > e) {
                        var i = e / 2 - t.naturalWidth / 2;
                        this.setTranslate(this.img.parentNode, i, 0);
                    }
                    this.slide.classList.add("zoomed"), this.zoomedIn = !0;
                }
            }
        },
        {
            key: "zoomOut",
            value: function() {
                this.img.parentNode.setAttribute("style", ""), this.img.setAttribute("style", this.img.getAttribute("data-style")), this.slide.classList.remove("zoomed"), this.zoomedIn = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.onclose && "function" == typeof this.onclose && this.onclose();
            }
        },
        {
            key: "dragStart",
            value: function(e) {
                e.preventDefault(), this.zoomedIn ? ("touchstart" === e.type ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset), e.target === this.img && (this.active = !0, this.img.classList.add("dragging"))) : this.active = !1;
            }
        },
        {
            key: "dragEnd",
            value: function(e) {
                var t = this;
                e.preventDefault(), this.initialX = this.currentX, this.initialY = this.currentY, this.active = !1, setTimeout(function() {
                    t.dragging = !1, t.img.isDragging = !1, t.img.classList.remove("dragging");
                }, 100);
            }
        },
        {
            key: "drag",
            value: function(e) {
                this.active && (e.preventDefault(), "touchmove" === e.type ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.img.isDragging = !0, this.dragging = !0, this.setTranslate(this.img, this.currentX, this.currentY));
            }
        },
        {
            key: "onMove",
            value: function(e) {
                if (this.zoomedIn) {
                    var t = e.clientX - this.img.naturalWidth / 2, i = e.clientY - this.img.naturalHeight / 2;
                    this.setTranslate(this.img, t, i);
                }
            }
        },
        {
            key: "setTranslate",
            value: function(e, t, i) {
                e.style.transform = "translate3d(" + t + "px, " + i + "px, 0)";
            }
        },
        {
            key: "widowWidth",
            value: function() {
                return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            }
        }
    ]), N = i(function t() {
        var i = this, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        e(this, t);
        var s = n.dragEl, l = n.toleranceX, o = void 0 === l ? 40 : l, r = n.toleranceY, a = void 0 === r ? 65 : r, h = n.slide, d = void 0 === h ? null : h, c = n.instance, u = void 0 === c ? null : c;
        this.el = s, this.active = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.direction = null, this.lastDirection = null, this.toleranceX = o, this.toleranceY = a, this.toleranceReached = !1, this.dragContainer = this.el, this.slide = d, this.instance = u, this.el.addEventListener("mousedown", function(e) {
            return i.dragStart(e);
        }, !1), this.el.addEventListener("mouseup", function(e) {
            return i.dragEnd(e);
        }, !1), this.el.addEventListener("mousemove", function(e) {
            return i.drag(e);
        }, !1);
    }, [
        {
            key: "dragStart",
            value: function(e) {
                if (this.slide.classList.contains("zoomed")) this.active = !1;
                else {
                    "touchstart" === e.type ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset);
                    var t = e.target.nodeName.toLowerCase();
                    e.target.classList.contains("nodrag") || g(e.target, ".nodrag") || -1 !== [
                        "input",
                        "select",
                        "textarea",
                        "button",
                        "a"
                    ].indexOf(t) ? this.active = !1 : (e.preventDefault(), (e.target === this.el || "img" !== t && g(e.target, ".gslide-inline")) && (this.active = !0, this.el.classList.add("dragging"), this.dragContainer = g(e.target, ".ginner-container")));
                }
            }
        },
        {
            key: "dragEnd",
            value: function(e) {
                var t = this;
                e && e.preventDefault(), this.initialX = 0, this.initialY = 0, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.active = !1, this.doSlideChange && (this.instance.preventOutsideClick = !0, "right" == this.doSlideChange && this.instance.prevSlide(), "left" == this.doSlideChange && this.instance.nextSlide()), this.doSlideClose && this.instance.close(), this.toleranceReached || this.setTranslate(this.dragContainer, 0, 0, !0), setTimeout(function() {
                    t.instance.preventOutsideClick = !1, t.toleranceReached = !1, t.lastDirection = null, t.dragging = !1, t.el.isDragging = !1, t.el.classList.remove("dragging"), t.slide.classList.remove("dragging-nav"), t.dragContainer.style.transform = "", t.dragContainer.style.transition = "";
                }, 100);
            }
        },
        {
            key: "drag",
            value: function(e) {
                if (this.active) {
                    e.preventDefault(), this.slide.classList.add("dragging-nav"), "touchmove" === e.type ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.el.isDragging = !0, this.dragging = !0, this.doSlideChange = !1, this.doSlideClose = !1;
                    var t = Math.abs(this.currentX), i = Math.abs(this.currentY);
                    if (t > 0 && t >= Math.abs(this.currentY) && (!this.lastDirection || "x" == this.lastDirection)) {
                        this.yOffset = 0, this.lastDirection = "x", this.setTranslate(this.dragContainer, this.currentX, 0);
                        var n = this.shouldChange();
                        if (!this.instance.settings.dragAutoSnap && n && (this.doSlideChange = n), this.instance.settings.dragAutoSnap && n) return this.instance.preventOutsideClick = !0, this.toleranceReached = !0, this.active = !1, this.instance.preventOutsideClick = !0, this.dragEnd(null), "right" == n && this.instance.prevSlide(), void ("left" == n && this.instance.nextSlide());
                    }
                    if (this.toleranceY > 0 && i > 0 && i >= t && (!this.lastDirection || "y" == this.lastDirection)) {
                        this.xOffset = 0, this.lastDirection = "y", this.setTranslate(this.dragContainer, 0, this.currentY);
                        var s = this.shouldClose();
                        return !this.instance.settings.dragAutoSnap && s && (this.doSlideClose = !0), void (this.instance.settings.dragAutoSnap && s && this.instance.close());
                    }
                }
            }
        },
        {
            key: "shouldChange",
            value: function() {
                var e = !1;
                if (Math.abs(this.currentX) >= this.toleranceX) {
                    var t = this.currentX > 0 ? "right" : "left";
                    ("left" == t && this.slide !== this.slide.parentNode.lastChild || "right" == t && this.slide !== this.slide.parentNode.firstChild) && (e = t);
                }
                return e;
            }
        },
        {
            key: "shouldClose",
            value: function() {
                var e = !1;
                return Math.abs(this.currentY) >= this.toleranceY && (e = !0), e;
            }
        },
        {
            key: "setTranslate",
            value: function(e, t, i) {
                var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                e.style.transition = n ? "all .2s ease" : "", e.style.transform = "translate3d(".concat(t, "px, ").concat(i, "px, 0)");
            }
        }
    ]);
    function D(e, t, i, n) {
        var s = e.querySelector(".gslide-media"), l = new Image, o = "gSlideTitle_" + i, r = "gSlideDesc_" + i;
        l.addEventListener("load", function() {
            C(n) && n();
        }, !1), l.src = t.href, "" != t.sizes && "" != t.srcset && (l.sizes = t.sizes, l.srcset = t.srcset), l.alt = "", O(t.alt) || "" === t.alt || (l.alt = t.alt), "" !== t.title && l.setAttribute("aria-labelledby", o), "" !== t.description && l.setAttribute("aria-describedby", r), t.hasOwnProperty("_hasCustomWidth") && t._hasCustomWidth && (l.style.width = t.width), t.hasOwnProperty("_hasCustomHeight") && t._hasCustomHeight && (l.style.height = t.height), s.insertBefore(l, s.firstChild);
    }
    function _(e, t, i, n) {
        var s = this, l = e.querySelector(".ginner-container"), o = "gvideo" + i, r = e.querySelector(".gslide-media"), a = this.getAllPlayers();
        d(l, "gvideo-container"), r.insertBefore(y('<div class="gvideo-wrapper"></div>'), r.firstChild);
        var h = e.querySelector(".gvideo-wrapper");
        w(this.settings.plyr.css, "Plyr");
        var c = t.href, u = null == t ? void 0 : t.videoProvider, g = !1;
        r.style.maxWidth = t.width, w(this.settings.plyr.js, "Plyr", function() {
            if (!u && c.match(/vimeo\.com\/([0-9]*)/) && (u = "vimeo"), !u && (c.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || c.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || c.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/) || c.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/)) && (u = "youtube"), "local" === u || !u) {
                u = "local";
                var l = '<video id="' + o + '" ';
                l += 'style="background:#000; max-width: '.concat(t.width, ';" '), l += 'preload="metadata" ', l += 'x-webkit-airplay="allow" ', l += "playsinline ", l += "controls ", l += 'class="gvideo-local">', l += '<source src="'.concat(c, '">'), g = y(l += "</video>");
            }
            var r = g || y('<div id="'.concat(o, '" data-plyr-provider="').concat(u, '" data-plyr-embed-id="').concat(c, '"></div>'));
            d(h, "".concat(u, "-video gvideo")), h.appendChild(r), h.setAttribute("data-id", o), h.setAttribute("data-index", i);
            var v = P(s.settings.plyr, "config") ? s.settings.plyr.config : {}, f = new Plyr("#" + o, v);
            f.on("ready", function(e) {
                a[o] = e.detail.plyr, C(n) && n();
            }), S(function() {
                return e.querySelector("iframe") && "true" == e.querySelector("iframe").dataset.ready;
            }, function() {
                s.resize(e);
            }), f.on("enterfullscreen", W), f.on("exitfullscreen", W);
        });
    }
    function W(e) {
        var t = g(e.target, ".gslide-media");
        "enterfullscreen" === e.type && d(t, "fullscreen"), "exitfullscreen" === e.type && c(t, "fullscreen");
    }
    function B(e, t, i, n) {
        var s, l = this, o = e.querySelector(".gslide-media"), r = !(!P(t, "href") || !t.href) && t.href.split("#").pop().trim(), a = !(!P(t, "content") || !t.content) && t.content;
        if (a && (k(a) && (s = y('<div class="ginlined-content">'.concat(a, "</div>"))), E(a))) {
            "none" == a.style.display && (a.style.display = "block");
            var c = document.createElement("div");
            c.className = "ginlined-content", c.appendChild(a), s = c;
        }
        if (r) {
            var u = document.getElementById(r);
            if (!u) return !1;
            var g = u.cloneNode(!0);
            g.style.height = t.height, g.style.maxWidth = t.width, d(g, "ginlined-content"), s = g;
        }
        if (!s) return console.error("Unable to append inline slide content", t), !1;
        o.style.height = t.height, o.style.width = t.width, o.appendChild(s), this.events["inlineclose" + r] = h("click", {
            onElement: o.querySelectorAll(".gtrigger-close"),
            withCallback: function(e) {
                e.preventDefault(), l.close();
            }
        }), C(n) && n();
    }
    function H(e, t, i, n) {
        var s = e.querySelector(".gslide-media"), l = function(e) {
            var t = e.url, i = e.allow, n = e.callback, s = e.appendTo, l = document.createElement("iframe");
            return l.className = "vimeo-video gvideo", l.src = t, l.style.width = "100%", l.style.height = "100%", i && l.setAttribute("allow", i), l.onload = function() {
                l.onload = null, d(l, "node-ready"), C(n) && n();
            }, s && s.appendChild(l), l;
        }({
            url: t.href,
            callback: n
        });
        s.parentNode.style.maxWidth = t.width, s.parentNode.style.height = t.height, s.appendChild(l);
    }
    var j = i(function t() {
        var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        e(this, t), this.defaults = {
            href: "",
            sizes: "",
            srcset: "",
            title: "",
            type: "",
            videoProvider: "",
            description: "",
            alt: "",
            descPosition: "bottom",
            effect: "",
            width: "",
            height: "",
            content: !1,
            zoomable: !0,
            draggable: !0
        }, I(i) && (this.defaults = o(this.defaults, i));
    }, [
        {
            key: "sourceType",
            value: function(e) {
                var t = e;
                return null !== (e = e.toLowerCase()).match(/\.(jpeg|jpg|jpe|gif|png|apn|webp|avif|svg)/) ? "image" : e.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || e.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || e.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/) || e.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/) || e.match(/vimeo\.com\/([0-9]*)/) || null !== e.match(/\.(mp4|ogg|webm|mov)/) ? "video" : null !== e.match(/\.(mp3|wav|wma|aac|ogg)/) ? "audio" : e.indexOf("#") > -1 && "" !== t.split("#").pop().trim() ? "inline" : e.indexOf("goajax=true") > -1 ? "ajax" : "external";
            }
        },
        {
            key: "parseConfig",
            value: function(e, t) {
                var i = this, n = o({
                    descPosition: t.descPosition
                }, this.defaults);
                if (I(e) && !E(e)) {
                    P(e, "type") || (P(e, "content") && e.content ? e.type = "inline" : P(e, "href") && (e.type = this.sourceType(e.href)));
                    var s = o(n, e);
                    return this.setSize(s, t), s;
                }
                var l = "", a = e.getAttribute("data-glightbox"), h = e.nodeName.toLowerCase();
                if ("a" === h && (l = e.href), "img" === h && (l = e.src, n.alt = e.alt), n.href = l, r(n, function(s, l) {
                    P(t, l) && "width" !== l && (n[l] = t[l]);
                    var o = e.dataset[l];
                    O(o) || (n[l] = i.sanitizeValue(o));
                }), n.content && (n.type = "inline"), !n.type && l && (n.type = this.sourceType(l)), O(a)) {
                    if (!n.title && "a" == h) {
                        var d = e.title;
                        O(d) || "" === d || (n.title = d);
                    }
                    if (!n.title && "img" == h) {
                        var c = e.alt;
                        O(c) || "" === c || (n.title = c);
                    }
                } else {
                    var u = [];
                    r(n, function(e, t) {
                        u.push(";\\s?" + t);
                    }), u = u.join("\\s?:|"), "" !== a.trim() && r(n, function(e, t) {
                        var s = a, l = new RegExp("s?" + t + "s?:s?(.*?)(" + u + "s?:|$)"), o = s.match(l);
                        if (o && o.length && o[1]) {
                            var r = o[1].trim().replace(/;\s*$/, "");
                            n[t] = i.sanitizeValue(r);
                        }
                    });
                }
                if (n.description && "." === n.description.substring(0, 1)) {
                    var g;
                    try {
                        g = document.querySelector(n.description).innerHTML;
                    } catch (e) {
                        if (!(e instanceof DOMException)) throw e;
                    }
                    g && (n.description = g);
                }
                if (!n.description) {
                    var v = e.querySelector(".glightbox-desc");
                    v && (n.description = v.innerHTML);
                }
                return this.setSize(n, t, e), this.slideConfig = n, n;
            }
        },
        {
            key: "setSize",
            value: function(e, t) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = "video" == e.type ? this.checkSize(t.videosWidth) : this.checkSize(t.width), s = this.checkSize(t.height);
                return e.width = P(e, "width") && "" !== e.width ? this.checkSize(e.width) : n, e.height = P(e, "height") && "" !== e.height ? this.checkSize(e.height) : s, i && "image" == e.type && (e._hasCustomWidth = !!i.dataset.width, e._hasCustomHeight = !!i.dataset.height), e;
            }
        },
        {
            key: "checkSize",
            value: function(e) {
                return z(e) ? "".concat(e, "px") : e;
            }
        },
        {
            key: "sanitizeValue",
            value: function(e) {
                return "true" !== e && "false" !== e ? e : "true" === e;
            }
        }
    ]), V = i(function t(i, n, s) {
        e(this, t), this.element = i, this.instance = n, this.index = s;
    }, [
        {
            key: "setContent",
            value: function() {
                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if (u(t, "loaded")) return !1;
                var n = this.instance.settings, s = this.slideConfig, l = T();
                C(n.beforeSlideLoad) && n.beforeSlideLoad({
                    index: this.index,
                    slide: t,
                    player: !1
                });
                var o = s.type, r = s.descPosition, a = t.querySelector(".gslide-media"), h = t.querySelector(".gslide-title"), c = t.querySelector(".gslide-desc"), g = t.querySelector(".gdesc-inner"), v = i, f = "gSlideTitle_" + this.index, p = "gSlideDesc_" + this.index;
                if (C(n.afterSlideLoad) && (v = function() {
                    C(i) && i(), n.afterSlideLoad({
                        index: e.index,
                        slide: t,
                        player: e.instance.getSlidePlayerInstance(e.index)
                    });
                }), "" == s.title && "" == s.description ? g && g.parentNode.parentNode.removeChild(g.parentNode) : (h && "" !== s.title ? (h.id = f, h.innerHTML = s.title) : h.parentNode.removeChild(h), c && "" !== s.description ? (c.id = p, l && n.moreLength > 0 ? (s.smallDescription = this.slideShortDesc(s.description, n.moreLength, n.moreText), c.innerHTML = s.smallDescription, this.descriptionEvents(c, s)) : c.innerHTML = s.description) : c.parentNode.removeChild(c), d(a.parentNode, "desc-".concat(r)), d(g.parentNode, "description-".concat(r))), d(a, "gslide-".concat(o)), d(t, "loaded"), "video" !== o) {
                    if ("external" !== o) return "inline" === o ? (B.apply(this.instance, [
                        t,
                        s,
                        this.index,
                        v
                    ]), void (s.draggable && new N({
                        dragEl: t.querySelector(".gslide-inline"),
                        toleranceX: n.dragToleranceX,
                        toleranceY: n.dragToleranceY,
                        slide: t,
                        instance: this.instance
                    }))) : void ("image" !== o ? C(v) && v() : D(t, s, this.index, function() {
                        var i = t.querySelector("img");
                        s.draggable && new N({
                            dragEl: i,
                            toleranceX: n.dragToleranceX,
                            toleranceY: n.dragToleranceY,
                            slide: t,
                            instance: e.instance
                        }), s.zoomable && i.naturalWidth > i.offsetWidth && (d(i, "zoomable"), new q(i, t, function() {
                            e.instance.resize();
                        })), C(v) && v();
                    }));
                    H.apply(this, [
                        t,
                        s,
                        this.index,
                        v
                    ]);
                } else _.apply(this.instance, [
                    t,
                    s,
                    this.index,
                    v
                ]);
            }
        },
        {
            key: "slideShortDesc",
            value: function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50, i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = document.createElement("div");
                n.innerHTML = e;
                var s = n.innerText, l = i;
                if ((e = s.trim()).length <= t) return e;
                var o = e.substr(0, t - 1);
                return l ? (n = null, o + '... <a href="#" class="desc-more">' + i + "</a>") : o;
            }
        },
        {
            key: "descriptionEvents",
            value: function(e, t) {
                var i = this, n = e.querySelector(".desc-more");
                if (!n) return !1;
                h("click", {
                    onElement: n,
                    withCallback: function(e, n) {
                        e.preventDefault();
                        var s = document.body, l = g(n, ".gslide-desc");
                        if (!l) return !1;
                        l.innerHTML = t.description, d(s, "gdesc-open");
                        var o = h("click", {
                            onElement: [
                                s,
                                g(l, ".gslide-description")
                            ],
                            withCallback: function(e, n) {
                                "a" !== e.target.nodeName.toLowerCase() && (c(s, "gdesc-open"), d(s, "gdesc-closed"), l.innerHTML = t.smallDescription, i.descriptionEvents(l, t), setTimeout(function() {
                                    c(s, "gdesc-closed");
                                }, 400), o.destroy());
                            }
                        });
                    }
                });
            }
        },
        {
            key: "create",
            value: function() {
                return y(this.instance.settings.slideHTML);
            }
        },
        {
            key: "getConfig",
            value: function() {
                E(this.element) || this.element.hasOwnProperty("draggable") || (this.element.draggable = this.instance.settings.draggable);
                var e = new j(this.instance.settings.slideExtraAttributes);
                return this.slideConfig = e.parseConfig(this.element, this.instance.settings), this.slideConfig;
            }
        }
    ]);
    function F(e) {
        return Math.sqrt(e.x * e.x + e.y * e.y);
    }
    function R(e, t) {
        var i = function(e, t) {
            var i = F(e) * F(t);
            if (0 === i) return 0;
            var n = function(e, t) {
                return e.x * t.x + e.y * t.y;
            }(e, t) / i;
            return n > 1 && (n = 1), Math.acos(n);
        }(e, t);
        return function(e, t) {
            return e.x * t.y - t.x * e.y;
        }(e, t) > 0 && (i *= -1), 180 * i / Math.PI;
    }
    var G = i(function t(i) {
        e(this, t), this.handlers = [], this.el = i;
    }, [
        {
            key: "add",
            value: function(e) {
                this.handlers.push(e);
            }
        },
        {
            key: "del",
            value: function(e) {
                e || (this.handlers = []);
                for(var t = this.handlers.length; t >= 0; t--)this.handlers[t] === e && this.handlers.splice(t, 1);
            }
        },
        {
            key: "dispatch",
            value: function() {
                for(var e = 0, t = this.handlers.length; e < t; e++){
                    var i = this.handlers[e];
                    "function" == typeof i && i.apply(this.el, arguments);
                }
            }
        }
    ]);
    function Z(e, t) {
        var i = new G(e);
        return i.add(t), i;
    }
    var U = i(function t(i, n) {
        e(this, t), this.element = "string" == typeof i ? document.querySelector(i) : i, this.start = this.start.bind(this), this.move = this.move.bind(this), this.end = this.end.bind(this), this.cancel = this.cancel.bind(this), this.element.addEventListener("touchstart", this.start, !1), this.element.addEventListener("touchmove", this.move, !1), this.element.addEventListener("touchend", this.end, !1), this.element.addEventListener("touchcancel", this.cancel, !1), this.preV = {
            x: null,
            y: null
        }, this.pinchStartLen = null, this.zoom = 1, this.isDoubleTap = !1;
        var s = function() {};
        this.rotate = Z(this.element, n.rotate || s), this.touchStart = Z(this.element, n.touchStart || s), this.multipointStart = Z(this.element, n.multipointStart || s), this.multipointEnd = Z(this.element, n.multipointEnd || s), this.pinch = Z(this.element, n.pinch || s), this.swipe = Z(this.element, n.swipe || s), this.tap = Z(this.element, n.tap || s), this.doubleTap = Z(this.element, n.doubleTap || s), this.longTap = Z(this.element, n.longTap || s), this.singleTap = Z(this.element, n.singleTap || s), this.pressMove = Z(this.element, n.pressMove || s), this.twoFingerPressMove = Z(this.element, n.twoFingerPressMove || s), this.touchMove = Z(this.element, n.touchMove || s), this.touchEnd = Z(this.element, n.touchEnd || s), this.touchCancel = Z(this.element, n.touchCancel || s), this.translateContainer = this.element, this._cancelAllHandler = this.cancelAll.bind(this), window.addEventListener("scroll", this._cancelAllHandler), this.delta = null, this.last = null, this.now = null, this.tapTimeout = null, this.singleTapTimeout = null, this.longTapTimeout = null, this.swipeTimeout = null, this.x1 = this.x2 = this.y1 = this.y2 = null, this.preTapPosition = {
            x: null,
            y: null
        };
    }, [
        {
            key: "start",
            value: function(e) {
                if (e.touches) {
                    if (e.target && e.target.nodeName && [
                        "a",
                        "button",
                        "input"
                    ].indexOf(e.target.nodeName.toLowerCase()) >= 0) console.log("ignore drag for this touched element", e.target.nodeName.toLowerCase());
                    else {
                        this.now = Date.now(), this.x1 = e.touches[0].pageX, this.y1 = e.touches[0].pageY, this.delta = this.now - (this.last || this.now), this.touchStart.dispatch(e, this.element), null !== this.preTapPosition.x && (this.isDoubleTap = this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30, this.isDoubleTap && clearTimeout(this.singleTapTimeout)), this.preTapPosition.x = this.x1, this.preTapPosition.y = this.y1, this.last = this.now;
                        var t = this.preV;
                        if (e.touches.length > 1) {
                            this._cancelLongTap(), this._cancelSingleTap();
                            var i = {
                                x: e.touches[1].pageX - this.x1,
                                y: e.touches[1].pageY - this.y1
                            };
                            t.x = i.x, t.y = i.y, this.pinchStartLen = F(t), this.multipointStart.dispatch(e, this.element);
                        }
                        this._preventTap = !1, this.longTapTimeout = setTimeout((function() {
                            this.longTap.dispatch(e, this.element), this._preventTap = !0;
                        }).bind(this), 750);
                    }
                }
            }
        },
        {
            key: "move",
            value: function(e) {
                if (e.touches) {
                    var t = this.preV, i = e.touches.length, n = e.touches[0].pageX, s = e.touches[0].pageY;
                    if (this.isDoubleTap = !1, i > 1) {
                        var l = e.touches[1].pageX, o = e.touches[1].pageY, r = {
                            x: e.touches[1].pageX - n,
                            y: e.touches[1].pageY - s
                        };
                        null !== t.x && (this.pinchStartLen > 0 && (e.zoom = F(r) / this.pinchStartLen, this.pinch.dispatch(e, this.element)), e.angle = R(r, t), this.rotate.dispatch(e, this.element)), t.x = r.x, t.y = r.y, null !== this.x2 && null !== this.sx2 ? (e.deltaX = (n - this.x2 + l - this.sx2) / 2, e.deltaY = (s - this.y2 + o - this.sy2) / 2) : (e.deltaX = 0, e.deltaY = 0), this.twoFingerPressMove.dispatch(e, this.element), this.sx2 = l, this.sy2 = o;
                    } else {
                        if (null !== this.x2) {
                            e.deltaX = n - this.x2, e.deltaY = s - this.y2;
                            var a = Math.abs(this.x1 - this.x2), h = Math.abs(this.y1 - this.y2);
                            (a > 10 || h > 10) && (this._preventTap = !0);
                        } else e.deltaX = 0, e.deltaY = 0;
                        this.pressMove.dispatch(e, this.element);
                    }
                    this.touchMove.dispatch(e, this.element), this._cancelLongTap(), this.x2 = n, this.y2 = s, i > 1 && e.preventDefault();
                }
            }
        },
        {
            key: "end",
            value: function(e) {
                if (e.changedTouches) {
                    this._cancelLongTap();
                    var t = this;
                    e.touches.length < 2 && (this.multipointEnd.dispatch(e, this.element), this.sx2 = this.sy2 = null), this.x2 && Math.abs(this.x1 - this.x2) > 30 || this.y2 && Math.abs(this.y1 - this.y2) > 30 ? (e.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2), this.swipeTimeout = setTimeout(function() {
                        t.swipe.dispatch(e, t.element);
                    }, 0)) : (this.tapTimeout = setTimeout(function() {
                        t._preventTap || t.tap.dispatch(e, t.element), t.isDoubleTap && (t.doubleTap.dispatch(e, t.element), t.isDoubleTap = !1);
                    }, 0), t.isDoubleTap || (t.singleTapTimeout = setTimeout(function() {
                        t.singleTap.dispatch(e, t.element);
                    }, 250))), this.touchEnd.dispatch(e, this.element), this.preV.x = 0, this.preV.y = 0, this.zoom = 1, this.pinchStartLen = null, this.x1 = this.x2 = this.y1 = this.y2 = null;
                }
            }
        },
        {
            key: "cancelAll",
            value: function() {
                this._preventTap = !0, clearTimeout(this.singleTapTimeout), clearTimeout(this.tapTimeout), clearTimeout(this.longTapTimeout), clearTimeout(this.swipeTimeout);
            }
        },
        {
            key: "cancel",
            value: function(e) {
                this.cancelAll(), this.touchCancel.dispatch(e, this.element);
            }
        },
        {
            key: "_cancelLongTap",
            value: function() {
                clearTimeout(this.longTapTimeout);
            }
        },
        {
            key: "_cancelSingleTap",
            value: function() {
                clearTimeout(this.singleTapTimeout);
            }
        },
        {
            key: "_swipeDirection",
            value: function(e, t, i, n) {
                return Math.abs(e - t) >= Math.abs(i - n) ? e - t > 0 ? "Left" : "Right" : i - n > 0 ? "Up" : "Down";
            }
        },
        {
            key: "on",
            value: function(e, t) {
                this[e] && this[e].add(t);
            }
        },
        {
            key: "off",
            value: function(e, t) {
                this[e] && this[e].del(t);
            }
        },
        {
            key: "destroy",
            value: function() {
                return this.singleTapTimeout && clearTimeout(this.singleTapTimeout), this.tapTimeout && clearTimeout(this.tapTimeout), this.longTapTimeout && clearTimeout(this.longTapTimeout), this.swipeTimeout && clearTimeout(this.swipeTimeout), this.element.removeEventListener("touchstart", this.start), this.element.removeEventListener("touchmove", this.move), this.element.removeEventListener("touchend", this.end), this.element.removeEventListener("touchcancel", this.cancel), this.rotate.del(), this.touchStart.del(), this.multipointStart.del(), this.multipointEnd.del(), this.pinch.del(), this.swipe.del(), this.tap.del(), this.doubleTap.del(), this.longTap.del(), this.singleTap.del(), this.pressMove.del(), this.twoFingerPressMove.del(), this.touchMove.del(), this.touchEnd.del(), this.touchCancel.del(), this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = this.twoFingerPressMove = null, window.removeEventListener("scroll", this._cancelAllHandler), null;
            }
        }
    ]);
    function $(e) {
        var t = function() {
            var e, t = document.createElement("fakeelement"), i = {
                transition: "transitionend",
                OTransition: "oTransitionEnd",
                MozTransition: "transitionend",
                WebkitTransition: "webkitTransitionEnd"
            };
            for(e in i)if (void 0 !== t.style[e]) return i[e];
        }(), i = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, n = u(e, "gslide-media") ? e : e.querySelector(".gslide-media"), s = g(n, ".ginner-container"), l = e.querySelector(".gslide-description");
        i > 769 && (n = s), d(n, "greset"), f(n, "translate3d(0, 0, 0)"), h(t, {
            onElement: n,
            once: !0,
            withCallback: function(e, t) {
                c(n, "greset");
            }
        }), n.style.opacity = "", l && (l.style.opacity = "");
    }
    function J(e) {
        if (e.events.hasOwnProperty("touch")) return !1;
        var t, i, n, s = x(), l = s.width, o = s.height, r = !1, a = null, h = null, v = null, p = !1, m = 1, y = 1, b = !1, S = !1, w = null, T = null, C = null, k = null, E = 0, A = 0, L = !1, I = !1, O = {}, P = {}, M = 0, z = 0, X = document.getElementById("glightbox-slider"), Y = document.querySelector(".goverlay"), q = new U(X, {
            touchStart: function(t) {
                if (r = !0, (u(t.targetTouches[0].target, "ginner-container") || g(t.targetTouches[0].target, ".gslide-desc") || "a" == t.targetTouches[0].target.nodeName.toLowerCase()) && (r = !1), g(t.targetTouches[0].target, ".gslide-inline") && !u(t.targetTouches[0].target.parentNode, "gslide-inline") && (r = !1), r) {
                    if (P = t.targetTouches[0], O.pageX = t.targetTouches[0].pageX, O.pageY = t.targetTouches[0].pageY, M = t.targetTouches[0].clientX, z = t.targetTouches[0].clientY, a = e.activeSlide, h = a.querySelector(".gslide-media"), n = a.querySelector(".gslide-inline"), v = null, u(h, "gslide-image") && (v = h.querySelector("img")), (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) > 769 && (h = a.querySelector(".ginner-container")), c(Y, "greset"), t.pageX > 20 && t.pageX < window.innerWidth - 20) return;
                    t.preventDefault();
                }
            },
            touchMove: function(s) {
                if (r && (P = s.targetTouches[0], !b && !S)) {
                    if (n && n.offsetHeight > o) {
                        var a = O.pageX - P.pageX;
                        if (Math.abs(a) <= 13) return !1;
                    }
                    p = !0;
                    var d, c = s.targetTouches[0].clientX, u = s.targetTouches[0].clientY, g = M - c, m = z - u;
                    if (Math.abs(g) > Math.abs(m) ? (L = !1, I = !0) : (I = !1, L = !0), t = P.pageX - O.pageX, E = 100 * t / l, i = P.pageY - O.pageY, A = 100 * i / o, L && v && (d = 1 - Math.abs(i) / o, Y.style.opacity = d, e.settings.touchFollowAxis && (E = 0)), I && (d = 1 - Math.abs(t) / l, h.style.opacity = d, e.settings.touchFollowAxis && (A = 0)), !v) return f(h, "translate3d(".concat(E, "%, 0, 0)"));
                    f(h, "translate3d(".concat(E, "%, ").concat(A, "%, 0)"));
                }
            },
            touchEnd: function() {
                if (r) {
                    if (p = !1, S || b) return C = w, void (k = T);
                    var t = Math.abs(parseInt(A)), i = Math.abs(parseInt(E));
                    if (!(t > 29 && v)) return t < 29 && i < 25 ? (d(Y, "greset"), Y.style.opacity = 1, $(h)) : void 0;
                    e.close();
                }
            },
            multipointEnd: function() {
                setTimeout(function() {
                    b = !1;
                }, 50);
            },
            multipointStart: function() {
                b = !0, m = y || 1;
            },
            pinch: function(e) {
                if (!v || p) return !1;
                b = !0, v.scaleX = v.scaleY = m * e.zoom;
                var t = m * e.zoom;
                if (S = !0, t <= 1) return S = !1, t = 1, k = null, C = null, w = null, T = null, void v.setAttribute("style", "");
                t > 4.5 && (t = 4.5), v.style.transform = "scale3d(".concat(t, ", ").concat(t, ", 1)"), y = t;
            },
            pressMove: function(e) {
                if (S && !b) {
                    var t = P.pageX - O.pageX, i = P.pageY - O.pageY;
                    C && (t += C), k && (i += k), w = t, T = i;
                    var n = "translate3d(".concat(t, "px, ").concat(i, "px, 0)");
                    y && (n += " scale3d(".concat(y, ", ").concat(y, ", 1)")), f(v, n);
                }
            },
            swipe: function(t) {
                if (!S) {
                    if (b) b = !1;
                    else {
                        if ("Left" == t.direction) {
                            if (e.index == e.elements.length - 1) return $(h);
                            e.nextSlide();
                        }
                        if ("Right" == t.direction) {
                            if (0 == e.index) return $(h);
                            e.prevSlide();
                        }
                    }
                }
            }
        });
        e.events.touch = q;
    }
    var K = T(), Q = null !== T() || void 0 !== document.createTouch || "ontouchstart" in window || "onmsgesturechange" in window || navigator.msMaxTouchPoints, ee = document.getElementsByTagName("html")[0], te = {
        selector: ".glightbox",
        elements: null,
        skin: "clean",
        theme: "clean",
        closeButton: !0,
        startAt: null,
        autoplayVideos: !0,
        autofocusVideos: !0,
        descPosition: "bottom",
        width: "900px",
        height: "506px",
        videosWidth: "960px",
        beforeSlideChange: null,
        afterSlideChange: null,
        beforeSlideLoad: null,
        afterSlideLoad: null,
        slideInserted: null,
        slideRemoved: null,
        slideExtraAttributes: null,
        onOpen: null,
        onClose: null,
        loop: !1,
        zoomable: !0,
        draggable: !0,
        dragAutoSnap: !1,
        dragToleranceX: 40,
        dragToleranceY: 65,
        preload: !0,
        oneSlidePerOpen: !1,
        touchNavigation: !0,
        touchFollowAxis: !0,
        keyboardNavigation: !0,
        closeOnOutsideClick: !0,
        plugins: !1,
        plyr: {
            css: "https://cdn.plyr.io/3.6.12/plyr.css",
            js: "https://cdn.plyr.io/3.6.12/plyr.js",
            config: {
                ratio: "16:9",
                fullscreen: {
                    enabled: !0,
                    iosNative: !0
                },
                youtube: {
                    noCookie: !0,
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3
                },
                vimeo: {
                    byline: !1,
                    portrait: !1,
                    title: !1,
                    transparent: !1
                }
            }
        },
        openEffect: "zoom",
        closeEffect: "zoom",
        slideEffect: "slide",
        moreText: "See more",
        moreLength: 60,
        cssEfects: {
            fade: {
                in: "fadeIn",
                out: "fadeOut"
            },
            zoom: {
                in: "zoomIn",
                out: "zoomOut"
            },
            slide: {
                in: "slideInRight",
                out: "slideOutLeft"
            },
            slideBack: {
                in: "slideInLeft",
                out: "slideOutRight"
            },
            none: {
                in: "none",
                out: "none"
            }
        },
        svg: {
            close: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>',
            next: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>',
            prev: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>'
        },
        slideHTML: '<div class="gslide">\n    <div class="gslide-inner-content">\n        <div class="ginner-container">\n            <div class="gslide-media">\n            </div>\n            <div class="gslide-description">\n                <div class="gdesc-inner">\n                    <h4 class="gslide-title"></h4>\n                    <div class="gslide-desc"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>',
        lightboxHTML: '<div id="glightbox-body" class="glightbox-container" tabindex="-1" role="dialog" aria-hidden="false">\n    <div class="gloader visible"></div>\n    <div class="goverlay"></div>\n    <div class="gcontainer">\n    <div id="glightbox-slider" class="gslider"></div>\n    <button class="gclose gbtn" aria-label="Close" data-taborder="3">{closeSVG}</button>\n    <button class="gprev gbtn" aria-label="Previous" data-taborder="2">{prevSVG}</button>\n    <button class="gnext gbtn" aria-label="Next" data-taborder="1">{nextSVG}</button>\n</div>\n</div>'
    }, ie = i(function t() {
        var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        e(this, t), this.customOptions = i, this.settings = o(te, i), this.effectsClasses = this.getAnimationClasses(), this.videoPlayers = {}, this.apiEvents = [], this.fullElementsList = !1;
    }, [
        {
            key: "init",
            value: function() {
                var e = this, t = this.getSelector();
                t && (this.baseEvents = h("click", {
                    onElement: t,
                    withCallback: function(t, i) {
                        t.preventDefault(), e.open(i);
                    }
                })), this.elements = this.getElements();
            }
        },
        {
            key: "open",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                if (0 === this.elements.length) return !1;
                this.activeSlide = null, this.prevActiveSlideIndex = null, this.prevActiveSlide = null;
                var i = z(t) ? t : this.settings.startAt;
                if (E(e)) {
                    var n = e.getAttribute("data-gallery");
                    n && (this.fullElementsList = this.elements, this.elements = this.getGalleryElements(this.elements, n)), O(i) && (i = this.getElementIndex(e)) < 0 && (i = 0);
                }
                z(i) || (i = 0), this.build(), v(this.overlay, "none" === this.settings.openEffect ? "none" : this.settings.cssEfects.fade.in);
                var s = document.body, l = window.innerWidth - document.documentElement.clientWidth;
                if (l > 0) {
                    var o = document.createElement("style");
                    o.type = "text/css", o.className = "gcss-styles", o.innerText = ".gscrollbar-fixer {margin-right: ".concat(l, "px}"), document.head.appendChild(o), d(s, "gscrollbar-fixer");
                }
                d(s, "glightbox-open"), d(ee, "glightbox-open"), K && (d(document.body, "glightbox-mobile"), this.settings.slideEffect = "slide"), this.showSlide(i, !0), 1 === this.elements.length ? (d(this.prevButton, "glightbox-button-hidden"), d(this.nextButton, "glightbox-button-hidden")) : (c(this.prevButton, "glightbox-button-hidden"), c(this.nextButton, "glightbox-button-hidden")), this.lightboxOpen = !0, this.trigger("open"), C(this.settings.onOpen) && this.settings.onOpen(), Q && this.settings.touchNavigation && J(this), this.settings.keyboardNavigation && Y(this);
            }
        },
        {
            key: "openAt",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                this.open(null, e);
            }
        },
        {
            key: "showSlide",
            value: function() {
                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                p(this.loader), this.index = parseInt(t);
                var n = this.slidesContainer.querySelector(".current");
                n && c(n, "current"), this.slideAnimateOut();
                var s = this.slidesContainer.querySelectorAll(".gslide")[t];
                if (u(s, "loaded")) this.slideAnimateIn(s, i), m(this.loader);
                else {
                    p(this.loader);
                    var l = this.elements[t], o = {
                        index: this.index,
                        slide: s,
                        slideNode: s,
                        slideConfig: l.slideConfig,
                        slideIndex: this.index,
                        trigger: l.node,
                        player: null
                    };
                    this.trigger("slide_before_load", o), l.instance.setContent(s, function() {
                        m(e.loader), e.resize(), e.slideAnimateIn(s, i), e.trigger("slide_after_load", o);
                    });
                }
                this.slideDescription = s.querySelector(".gslide-description"), this.slideDescriptionContained = this.slideDescription && u(this.slideDescription.parentNode, "gslide-media"), this.settings.preload && (this.preloadSlide(t + 1), this.preloadSlide(t - 1)), this.updateNavigationClasses(), this.activeSlide = s;
            }
        },
        {
            key: "preloadSlide",
            value: function(e) {
                var t = this;
                if (e < 0 || e > this.elements.length - 1) return !1;
                if (O(this.elements[e])) return !1;
                var i = this.slidesContainer.querySelectorAll(".gslide")[e];
                if (u(i, "loaded")) return !1;
                var n = this.elements[e], s = n.type, l = {
                    index: e,
                    slide: i,
                    slideNode: i,
                    slideConfig: n.slideConfig,
                    slideIndex: e,
                    trigger: n.node,
                    player: null
                };
                this.trigger("slide_before_load", l), "video" === s || "external" === s ? setTimeout(function() {
                    n.instance.setContent(i, function() {
                        t.trigger("slide_after_load", l);
                    });
                }, 200) : n.instance.setContent(i, function() {
                    t.trigger("slide_after_load", l);
                });
            }
        },
        {
            key: "prevSlide",
            value: function() {
                this.goToSlide(this.index - 1);
            }
        },
        {
            key: "nextSlide",
            value: function() {
                this.goToSlide(this.index + 1);
            }
        },
        {
            key: "goToSlide",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (this.prevActiveSlide = this.activeSlide, this.prevActiveSlideIndex = this.index, !this.loop() && (e < 0 || e > this.elements.length - 1)) return !1;
                e < 0 ? e = this.elements.length - 1 : e >= this.elements.length && (e = 0), this.showSlide(e);
            }
        },
        {
            key: "insertSlide",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
                t < 0 && (t = this.elements.length);
                var i = new V(e, this, t), n = i.getConfig(), s = o({}, n), l = i.create(), r = this.elements.length - 1;
                s.index = t, s.node = !1, s.instance = i, s.slideConfig = n, this.elements.splice(t, 0, s);
                var a = null, h = null;
                if (this.slidesContainer) {
                    if (t > r) this.slidesContainer.appendChild(l);
                    else {
                        var d = this.slidesContainer.querySelectorAll(".gslide")[t];
                        this.slidesContainer.insertBefore(l, d);
                    }
                    (this.settings.preload && 0 == this.index && 0 == t || this.index - 1 == t || this.index + 1 == t) && this.preloadSlide(t), 0 === this.index && 0 === t && (this.index = 1), this.updateNavigationClasses(), a = this.slidesContainer.querySelectorAll(".gslide")[t], h = this.getSlidePlayerInstance(t), s.slideNode = a;
                }
                this.trigger("slide_inserted", {
                    index: t,
                    slide: a,
                    slideNode: a,
                    slideConfig: n,
                    slideIndex: t,
                    trigger: null,
                    player: h
                }), C(this.settings.slideInserted) && this.settings.slideInserted({
                    index: t,
                    slide: a,
                    player: h
                });
            }
        },
        {
            key: "removeSlide",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1;
                if (e < 0 || e > this.elements.length - 1) return !1;
                var t = this.slidesContainer && this.slidesContainer.querySelectorAll(".gslide")[e];
                t && (this.getActiveSlideIndex() == e && (e == this.elements.length - 1 ? this.prevSlide() : this.nextSlide()), t.parentNode.removeChild(t)), this.elements.splice(e, 1), this.trigger("slide_removed", e), C(this.settings.slideRemoved) && this.settings.slideRemoved(e);
            }
        },
        {
            key: "slideAnimateIn",
            value: function(e, t) {
                var i = this, n = e.querySelector(".gslide-media"), s = e.querySelector(".gslide-description"), l = {
                    index: this.prevActiveSlideIndex,
                    slide: this.prevActiveSlide,
                    slideNode: this.prevActiveSlide,
                    slideIndex: this.prevActiveSlide,
                    slideConfig: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                    trigger: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                    player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                }, o = {
                    index: this.index,
                    slide: this.activeSlide,
                    slideNode: this.activeSlide,
                    slideConfig: this.elements[this.index].slideConfig,
                    slideIndex: this.index,
                    trigger: this.elements[this.index].node,
                    player: this.getSlidePlayerInstance(this.index)
                };
                if (n.offsetWidth > 0 && s && (m(s), s.style.display = ""), c(e, this.effectsClasses), t) v(e, this.settings.cssEfects[this.settings.openEffect].in, function() {
                    i.settings.autoplayVideos && i.slidePlayerPlay(e), i.trigger("slide_changed", {
                        prev: l,
                        current: o
                    }), C(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [
                        l,
                        o
                    ]);
                });
                else {
                    var r = this.settings.slideEffect, a = "none" !== r ? this.settings.cssEfects[r].in : r;
                    this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (a = this.settings.cssEfects.slideBack.in), v(e, a, function() {
                        i.settings.autoplayVideos && i.slidePlayerPlay(e), i.trigger("slide_changed", {
                            prev: l,
                            current: o
                        }), C(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [
                            l,
                            o
                        ]);
                    });
                }
                setTimeout(function() {
                    i.resize(e);
                }, 100), d(e, "current");
            }
        },
        {
            key: "slideAnimateOut",
            value: function() {
                if (!this.prevActiveSlide) return !1;
                var e = this.prevActiveSlide;
                c(e, this.effectsClasses), d(e, "prev");
                var t = this.settings.slideEffect, i = "none" !== t ? this.settings.cssEfects[t].out : t;
                this.slidePlayerPause(e), this.trigger("slide_before_change", {
                    prev: {
                        index: this.prevActiveSlideIndex,
                        slide: this.prevActiveSlide,
                        slideNode: this.prevActiveSlide,
                        slideIndex: this.prevActiveSlideIndex,
                        slideConfig: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                        trigger: O(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                        player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                    },
                    current: {
                        index: this.index,
                        slide: this.activeSlide,
                        slideNode: this.activeSlide,
                        slideIndex: this.index,
                        slideConfig: this.elements[this.index].slideConfig,
                        trigger: this.elements[this.index].node,
                        player: this.getSlidePlayerInstance(this.index)
                    }
                }), C(this.settings.beforeSlideChange) && this.settings.beforeSlideChange.apply(this, [
                    {
                        index: this.prevActiveSlideIndex,
                        slide: this.prevActiveSlide,
                        player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                    },
                    {
                        index: this.index,
                        slide: this.activeSlide,
                        player: this.getSlidePlayerInstance(this.index)
                    }
                ]), this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (i = this.settings.cssEfects.slideBack.out), v(e, i, function() {
                    var t = e.querySelector(".ginner-container"), i = e.querySelector(".gslide-media"), n = e.querySelector(".gslide-description");
                    t.style.transform = "", i.style.transform = "", c(i, "greset"), i.style.opacity = "", n && (n.style.opacity = ""), c(e, "prev");
                });
            }
        },
        {
            key: "getAllPlayers",
            value: function() {
                return this.videoPlayers;
            }
        },
        {
            key: "getSlidePlayerInstance",
            value: function(e) {
                var t = "gvideo" + e, i = this.getAllPlayers();
                return !(!P(i, t) || !i[t]) && i[t];
            }
        },
        {
            key: "stopSlideVideo",
            value: function(e) {
                if (E(e)) {
                    var t = e.querySelector(".gvideo-wrapper");
                    t && (e = t.getAttribute("data-index"));
                }
                console.log("stopSlideVideo is deprecated, use slidePlayerPause");
                var i = this.getSlidePlayerInstance(e);
                i && i.playing && i.pause();
            }
        },
        {
            key: "slidePlayerPause",
            value: function(e) {
                if (E(e)) {
                    var t = e.querySelector(".gvideo-wrapper");
                    t && (e = t.getAttribute("data-index"));
                }
                var i = this.getSlidePlayerInstance(e);
                i && i.playing && i.pause();
            }
        },
        {
            key: "playSlideVideo",
            value: function(e) {
                if (E(e)) {
                    var t = e.querySelector(".gvideo-wrapper");
                    t && (e = t.getAttribute("data-index"));
                }
                console.log("playSlideVideo is deprecated, use slidePlayerPlay");
                var i = this.getSlidePlayerInstance(e);
                i && !i.playing && i.play();
            }
        },
        {
            key: "slidePlayerPlay",
            value: function(e) {
                var t;
                if (!K || null !== (t = this.settings.plyr.config) && void 0 !== t && t.muted) {
                    if (E(e)) {
                        var i = e.querySelector(".gvideo-wrapper");
                        i && (e = i.getAttribute("data-index"));
                    }
                    var n = this.getSlidePlayerInstance(e);
                    n && !n.playing && (n.play(), this.settings.autofocusVideos && n.elements.container.focus());
                }
            }
        },
        {
            key: "setElements",
            value: function(e) {
                var t = this;
                this.settings.elements = !1;
                var i = [];
                e && e.length && r(e, function(e, n) {
                    var s = new V(e, t, n), l = s.getConfig(), r = o({}, l);
                    r.slideConfig = l, r.instance = s, r.index = n, i.push(r);
                }), this.elements = i, this.lightboxOpen && (this.slidesContainer.innerHTML = "", this.elements.length && (r(this.elements, function() {
                    var e = y(t.settings.slideHTML);
                    t.slidesContainer.appendChild(e);
                }), this.showSlide(0, !0)));
            }
        },
        {
            key: "getElementIndex",
            value: function(e) {
                var t = !1;
                return r(this.elements, function(i, n) {
                    if (P(i, "node") && i.node == e) return t = n, !0;
                }), t;
            }
        },
        {
            key: "getElements",
            value: function() {
                var e = this, t = [];
                this.elements = this.elements ? this.elements : [], !O(this.settings.elements) && A(this.settings.elements) && this.settings.elements.length && r(this.settings.elements, function(i, n) {
                    var s = new V(i, e, n), l = s.getConfig(), r = o({}, l);
                    r.node = !1, r.index = n, r.instance = s, r.slideConfig = l, t.push(r);
                });
                var i = !1;
                return this.getSelector() && (i = document.querySelectorAll(this.getSelector())), i ? (r(i, function(i, n) {
                    var s = new V(i, e, n), l = s.getConfig(), r = o({}, l);
                    r.node = i, r.index = n, r.instance = s, r.slideConfig = l, r.gallery = i.getAttribute("data-gallery"), t.push(r);
                }), t) : t;
            }
        },
        {
            key: "getGalleryElements",
            value: function(e, t) {
                return e.filter(function(e) {
                    return e.gallery == t;
                });
            }
        },
        {
            key: "getSelector",
            value: function() {
                return !this.settings.elements && (this.settings.selector && "data-" == this.settings.selector.substring(0, 5) ? "*[".concat(this.settings.selector, "]") : this.settings.selector);
            }
        },
        {
            key: "getActiveSlide",
            value: function() {
                return this.slidesContainer.querySelectorAll(".gslide")[this.index];
            }
        },
        {
            key: "getActiveSlideIndex",
            value: function() {
                return this.index;
            }
        },
        {
            key: "getAnimationClasses",
            value: function() {
                var e = [];
                for(var t in this.settings.cssEfects)if (this.settings.cssEfects.hasOwnProperty(t)) {
                    var i = this.settings.cssEfects[t];
                    e.push("g".concat(i.in)), e.push("g".concat(i.out));
                }
                return e.join(" ");
            }
        },
        {
            key: "build",
            value: function() {
                var e = this;
                if (this.built) return !1;
                var t = document.body.childNodes, i = [];
                r(t, function(e) {
                    e.parentNode == document.body && "#" !== e.nodeName.charAt(0) && e.hasAttribute && !e.hasAttribute("aria-hidden") && (i.push(e), e.setAttribute("aria-hidden", "true"));
                });
                var n = P(this.settings.svg, "next") ? this.settings.svg.next : "", s = P(this.settings.svg, "prev") ? this.settings.svg.prev : "", l = P(this.settings.svg, "close") ? this.settings.svg.close : "", o = this.settings.lightboxHTML;
                o = y(o = (o = (o = o.replace(/{nextSVG}/g, n)).replace(/{prevSVG}/g, s)).replace(/{closeSVG}/g, l)), document.body.appendChild(o);
                var a = document.getElementById("glightbox-body");
                this.modal = a;
                var c = a.querySelector(".gclose");
                this.prevButton = a.querySelector(".gprev"), this.nextButton = a.querySelector(".gnext"), this.overlay = a.querySelector(".goverlay"), this.loader = a.querySelector(".gloader"), this.slidesContainer = document.getElementById("glightbox-slider"), this.bodyHiddenChildElms = i, this.events = {}, d(this.modal, "glightbox-" + this.settings.skin), this.settings.closeButton && c && (this.events.close = h("click", {
                    onElement: c,
                    withCallback: function(t, i) {
                        t.preventDefault(), e.close();
                    }
                })), c && !this.settings.closeButton && c.parentNode.removeChild(c), this.nextButton && (this.events.next = h("click", {
                    onElement: this.nextButton,
                    withCallback: function(t, i) {
                        t.preventDefault(), e.nextSlide();
                    }
                })), this.prevButton && (this.events.prev = h("click", {
                    onElement: this.prevButton,
                    withCallback: function(t, i) {
                        t.preventDefault(), e.prevSlide();
                    }
                })), this.settings.closeOnOutsideClick && (this.events.outClose = h("click", {
                    onElement: a,
                    withCallback: function(t, i) {
                        e.preventOutsideClick || u(document.body, "glightbox-mobile") || g(t.target, ".ginner-container") || g(t.target, ".gbtn") || u(t.target, "gnext") || u(t.target, "gprev") || e.close();
                    }
                })), r(this.elements, function(t, i) {
                    e.slidesContainer.appendChild(t.instance.create()), t.slideNode = e.slidesContainer.querySelectorAll(".gslide")[i];
                }), Q && d(document.body, "glightbox-touch"), this.events.resize = h("resize", {
                    onElement: window,
                    withCallback: function() {
                        e.resize();
                    }
                }), this.built = !0;
            }
        },
        {
            key: "resize",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if ((e = e || this.activeSlide) && !u(e, "zoomed")) {
                    var t = x(), i = e.querySelector(".gvideo-wrapper"), n = e.querySelector(".gslide-image"), s = this.slideDescription, l = t.width, o = t.height;
                    if (l <= 768 ? d(document.body, "glightbox-mobile") : c(document.body, "glightbox-mobile"), i || n) {
                        var r = !1;
                        if (s && (u(s, "description-bottom") || u(s, "description-top")) && !u(s, "gabsolute") && (r = !0), n) {
                            if (l <= 768) n.querySelector("img");
                            else if (r) {
                                var a, h, g = s.offsetHeight, v = n.querySelector("img"), f = null === (a = this.elements[this.index]) || void 0 === a ? void 0 : a.node, p = "100vh";
                                f && (p = null !== (h = f.getAttribute("data-height")) && void 0 !== h ? h : p), v.setAttribute("style", "max-height: calc(".concat(p, " - ").concat(g, "px)")), s.setAttribute("style", "max-width: ".concat(v.offsetWidth, "px;"));
                            }
                        }
                        if (i) {
                            var m = P(this.settings.plyr.config, "ratio") ? this.settings.plyr.config.ratio : "";
                            if (!m) {
                                var y = i.clientWidth, b = i.clientHeight, S = y / b;
                                m = "".concat(y / S, ":").concat(b / S);
                            }
                            var w = m.split(":"), T = this.settings.videosWidth, C = this.settings.videosWidth, k = (C = z(T) || -1 !== T.indexOf("px") ? parseInt(T) : -1 !== T.indexOf("vw") ? l * parseInt(T) / 100 : -1 !== T.indexOf("vh") ? o * parseInt(T) / 100 : -1 !== T.indexOf("%") ? l * parseInt(T) / 100 : parseInt(i.clientWidth)) / (parseInt(w[0]) / parseInt(w[1]));
                            if (k = Math.floor(k), r && (o -= s.offsetHeight), C > l || k > o || o < k && l > C) {
                                var E = i.offsetWidth, A = i.offsetHeight, L = o / A, I = {
                                    width: E * L,
                                    height: A * L
                                };
                                i.parentNode.setAttribute("style", "max-width: ".concat(I.width, "px")), r && s.setAttribute("style", "max-width: ".concat(I.width, "px;"));
                            } else i.parentNode.style.maxWidth = "".concat(T), r && s.setAttribute("style", "max-width: ".concat(T, ";"));
                        }
                    }
                }
            }
        },
        {
            key: "reload",
            value: function() {
                this.init();
            }
        },
        {
            key: "updateNavigationClasses",
            value: function() {
                var e = this.loop();
                c(this.nextButton, "disabled"), c(this.prevButton, "disabled"), 0 == this.index && this.elements.length - 1 == 0 ? (d(this.prevButton, "disabled"), d(this.nextButton, "disabled")) : 0 !== this.index || e ? this.index !== this.elements.length - 1 || e || d(this.nextButton, "disabled") : d(this.prevButton, "disabled");
            }
        },
        {
            key: "loop",
            value: function() {
                var e = P(this.settings, "loopAtEnd") ? this.settings.loopAtEnd : null;
                return e = P(this.settings, "loop") ? this.settings.loop : e, e;
            }
        },
        {
            key: "close",
            value: function() {
                var e = this;
                if (!this.lightboxOpen) {
                    if (this.events) {
                        for(var t in this.events)this.events.hasOwnProperty(t) && this.events[t].destroy();
                        this.events = null;
                    }
                    return !1;
                }
                if (this.closing) return !1;
                this.closing = !0, this.slidePlayerPause(this.activeSlide), this.fullElementsList && (this.elements = this.fullElementsList), this.bodyHiddenChildElms.length && r(this.bodyHiddenChildElms, function(e) {
                    e.removeAttribute("aria-hidden");
                }), d(this.modal, "glightbox-closing"), v(this.overlay, "none" == this.settings.openEffect ? "none" : this.settings.cssEfects.fade.out), v(this.activeSlide, this.settings.cssEfects[this.settings.closeEffect].out, function() {
                    if (e.activeSlide = null, e.prevActiveSlideIndex = null, e.prevActiveSlide = null, e.built = !1, e.events) {
                        for(var t in e.events)e.events.hasOwnProperty(t) && e.events[t].destroy();
                        e.events = null;
                    }
                    var i = document.body;
                    c(ee, "glightbox-open"), c(i, "glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"), e.modal.parentNode.removeChild(e.modal), e.trigger("close"), C(e.settings.onClose) && e.settings.onClose();
                    var n = document.querySelector(".gcss-styles");
                    n && n.parentNode.removeChild(n), e.lightboxOpen = !1, e.closing = null;
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.close(), this.clearAllEvents(), this.baseEvents && this.baseEvents.destroy();
            }
        },
        {
            key: "on",
            value: function(e, t) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                if (!e || !C(t)) throw new TypeError("Event name and callback must be defined");
                this.apiEvents.push({
                    evt: e,
                    once: i,
                    callback: t
                });
            }
        },
        {
            key: "once",
            value: function(e, t) {
                this.on(e, t, !0);
            }
        },
        {
            key: "trigger",
            value: function(e) {
                var t = this, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n = [];
                r(this.apiEvents, function(t, s) {
                    var l = t.evt, o = t.once, r = t.callback;
                    l == e && (r(i), o && n.push(s));
                }), n.length && r(n, function(e) {
                    return t.apiEvents.splice(e, 1);
                });
            }
        },
        {
            key: "clearAllEvents",
            value: function() {
                this.apiEvents.splice(0, this.apiEvents.length);
            }
        },
        {
            key: "version",
            value: function() {
                return "3.3.1";
            }
        }
    ]);
    return function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = new ie(e);
        return t.init(), t;
    };
});


function $9745ce6cd249f9c5$export$2e2bcd8739ae039(props) {
    const [lightbox, setLightbox] = (0, $bJrD0.useState)(null);
    (0, $bJrD0.useEffect)(()=>{
        setLightbox((0, (/*@__PURE__*/$parcel$interopDefault($42107f3179039eb0$exports)))({
            autoplayVideos: false,
            draggable: true,
            loop: false,
            touchNavigation: true,
            zoomable: true,
            elements: []
        }));
    }, []);
    const openLightbox = (evt)=>{
        evt.preventDefault();
        evt.stopPropagation();
        if (lightbox != null && Array.from(document.getElementsByClassName("glightbox")).length > 0) {
            const elements = Array.from(document.getElementsByClassName("glightbox")).map((e)=>{
                const r = {
                    href: e.href
                };
                if (e?.dataset?.width) r.width = e?.dataset?.width;
                if (e?.dataset?.height) r.height = e?.dataset?.height;
                if (e?.dataset?.type) r.type = e?.dataset?.type;
                if (e?.dataset?.srcset) r.srcset = e?.dataset?.srcset;
                if (e?.dataset?.sizes) r.sizes = e?.dataset?.sizes;
                return r;
            });
            lightbox.setElements(elements);
            lightbox.open(null, elements.findIndex((e)=>e.href === evt.target.closest(".glightbox").href));
        }
    };
    const getPreview = ()=>{
        if (props?.data?.exception) console.warn(props.data);
        if (props.data["providerName"]) {
            if ("peertube" == props.data["providerName"].toLowerCase()) {
                // default embed code
                if (props.data["code"]) return (0, $9SeGy.h)("div", {
                    class: "embed-container",
                    dangerouslySetInnerHTML: {
                        __html: props.data["code"]
                    }
                });
            }
            if ("soundcloud" == props.data["providerName"].toLowerCase()) {
                if (props.data["code"]) return (0, $9SeGy.h)((0, $1dd5e274a4fb4aa6$export$2e2bcd8739ae039), {
                    preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                    url: `${props.data["code"].match(/https:\/\/[^"\s]+/)[0]}&auto_play=true`,
                    playBtnClass: "soundcloud"
                });
            }
            if ("bandcamp" == props.data["providerName"].toLowerCase()) {
                if (props.data["code"]) {
                    let id = props.data["code"].match(/https:\/\/.*album=\d+/);
                    if (!id) id = props.data["code"].match(/https:\/\/.*track=\d+/);
                    if (id) return (0, $9SeGy.h)((0, $471cd1c649eea7ba$export$2e2bcd8739ae039), {
                        preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: id[0]
                    });
                }
            }
            if ("lichess.org" == props.data["providerName"].toLowerCase()) {
                let url = props?.data?.url && typeof props?.data.url == "string" ? props.data?.url : props.url;
                if ((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).isValidUrl(url) && !url.match(/embed/) && !url.match(/study/) && !url.match(/blog/)) {
                    url = new URL(url.replace("lichess.org/", "lichess.org/embed/"));
                    let id;
                    try {
                        id = url.pathname.split("/").slice(-1)[0];
                    } catch (e) {
                        id = "";
                    }
                    url = new URL(url.href.replace(id, id.slice(0, 8)));
                    if (id) return (0, $9SeGy.h)((0, $1dd5e274a4fb4aa6$export$2e2bcd8739ae039), {
                        preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 270, 270),
                        url: url,
                        playBtnClass: "lichess"
                    });
                }
            }
            if ("youtube" == props.data["providerName"].toLowerCase()) {
                let url = props.url;
                if (props?.preview?.id && url) {
                    url = new URL(url);
                    let video_id;
                    let playlist_id;
                    if (url.host == "www.youtube.com" || url.host == "m.youtube.com" || url.host == "youtube.com" || url.host == "music.youtube.com") {
                        if (url.pathname.match(/shorts/)) {
                            video_id = [
                                `v=${url.pathname.split("/").slice(-1)[0]}`
                            ];
                            playlist_id = [];
                        } else if (url.pathname.match(/embed/)) {
                            video_id = [
                                `v=${url.pathname.split("/").slice(-1)[0]}`
                            ];
                            playlist_id = [];
                        } else {
                            video_id = url.search.substring(1).split("&").filter((e)=>e.match(/^v=/));
                            playlist_id = url.search.substring(1).split("&").filter((e)=>e.match(/^list=/));
                        }
                    }
                    if (url.host == "youtu.be") {
                        video_id = [
                            `v=${url.pathname.slice(1)}`
                        ];
                        playlist_id = [];
                    }
                    let timecode = (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("t", url.search.substring(1));
                    if (playlist_id.length && video_id.length) return (0, $9SeGy.h)((0, $1dd5e274a4fb4aa6$export$2e2bcd8739ae039), {
                        preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: `https://youtube.com/embed/${video_id[0].split("=")[1]}?autoplay=1&controls=2&wmode=opaque&list=${playlist_id[0].split("=")[1]}${timecode ? `&start=${timecode}` : ""}`,
                        playBtnClass: "youtube"
                    });
                    if (playlist_id.length) return (0, $9SeGy.h)((0, $1dd5e274a4fb4aa6$export$2e2bcd8739ae039), {
                        preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: `https://youtube.com/embed/videoseries?list=${playlist_id[0].split("=")[1]}&autoplay=1&controls=2&wmode=opaque${timecode ? `&start=${timecode}` : ""}`,
                        playBtnClass: "youtube"
                    });
                    if (video_id.length) return (0, $9SeGy.h)((0, $1dd5e274a4fb4aa6$export$2e2bcd8739ae039), {
                        preview: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 1024, 270),
                        url: `https://youtube.com/embed/${video_id[0].split("=")[1]}?autoplay=1&controls=2&wmode=opaque${timecode ? `&start=${timecode}` : ""}`,
                        playBtnClass: "youtube"
                    });
                }
            }
        }
        if (props.data["content-type"] == "image/gif") return (0, $9SeGy.h)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $9SeGy.h)("img", {
            href: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(props.url),
            class: "img-fluid",
            "data-origin": props.url,
            "data-src": props.url,
            src: props.url
        }));
        if (/image/.test(props.data["content-type"])) return (0, $9SeGy.h)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $9SeGy.h)("a", {
            href: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(props.url),
            class: "glightbox",
            "data-type": "image",
            "data-srcset": `${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 720)} 720w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 1366)} 1366w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 2048)} 2048w`,
            "data-sizes": "(max-width: 992px) 720px, (max-width: 1400px) 1366px, 2048px",
            onClick: (e)=>openLightbox(e)
        }, (0, $9SeGy.h)("img", {
            href: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(props.url),
            class: "img-fluid cursor-pointer",
            "data-origin": props.url,
            "data-src": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 1366),
            src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.preview.id, 2048)
        })));
        // application/ogg: https://developer.mozilla.org/en-US/docs/Web/HTTP/Configuring_servers_for_Ogg_media
        if (/video/.test(props.data["content-type"]) || props.data["content-type"] == "application/ogg") return (0, $9SeGy.h)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $9SeGy.h)("video", {
            class: "img-fluid",
            controls: true,
            src: props.url
        }));
        if (/audio/.test(props.data["content-type"])) return (0, $9SeGy.h)("div", {
            class: "container d-flex justify-content-center flex-wrap align-items-center"
        }, (0, $9SeGy.h)("audio", {
            class: "w-100",
            controls: true
        }, (0, $9SeGy.h)("source", {
            src: props.url
        })));
        if (props.data["title"] && (props.preview || props.data["description"])) return (0, $9SeGy.h)("a", {
            class: "preview-card seamless-link d-inline-block",
            target: "_blank",
            rel: "noreferrer",
            href: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(props.url)
        }, (0, $9SeGy.h)("div", {
            class: "card",
            style: "max-width: 480px"
        }, props.preview && (0, $9SeGy.h)("img", {
            class: "card-img-top",
            src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.preview.id, 320, 180)
        }), (0, $9SeGy.h)("div", {
            class: "card-body p-1"
        }, (0, $9SeGy.h)("h5", null, props.data["title"]), props.data["description"] && (0, $9SeGy.h)("p", null, (0, $9SeGy.h)("small", null, props.data["description"].slice(0, 500))))));
        return null;
    };
    if (!props.url || !props.data) return null;
    let preview = getPreview();
    if (preview) return (0, $9SeGy.h)("p", {
        class: "text-center card-text"
    }, preview);
    return null;
}



var $9SeGy = parcelRequire("9SeGy");

function $b7ceefe51d9ca40b$export$2e2bcd8739ae039(props) {
    const toggleFile = (evt)=>{
        evt.stopPropagation();
        evt.preventDefault();
        if (typeof props.toggleFile == "function") props.toggleFile(evt.target.closest(".file-embed").id);
    };
    if (!props.files || props.files.length === 0) return null;
    if (props.files && props.files.length > 3) return (0, $9SeGy.h)("div", {
        class: "file-grid"
    }, props.files.map((e)=>(0, $9SeGy.h)((0, $c72cf4b6b78e8f8e$export$40e4fb50d87564f1), {
            key: e.id,
            invertFiles: props.invertFiles,
            toggleFile: toggleFile,
            file: e,
            inWriter: props.inWriter
        })));
    return (0, $9SeGy.h)("div", {
        class: "d-flex justify-content-center flex-wrap"
    }, props.files.map((e)=>(0, $9SeGy.h)((0, $c72cf4b6b78e8f8e$export$48621228a997a4e0), {
            key: e.id,
            toggleFile: toggleFile,
            invertFiles: props.invertFiles,
            file: e,
            inWriter: props.inWriter
        })));
}



var $9SeGy = parcelRequire("9SeGy");




var $bJrD0 = parcelRequire("bJrD0");

function $374de5a37ad6a81a$export$2e2bcd8739ae039(props) {
    const [lightbox, setLightbox] = (0, $bJrD0.useState)(null);
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const filePath = props.file.contentUrl ? `/files/${props.file.contentUrl}` : null;
    let url = filePath;
    (0, $bJrD0.useEffect)(()=>{
        setLightbox((0, (/*@__PURE__*/$parcel$interopDefault($42107f3179039eb0$exports)))({
            autoplayVideos: false,
            draggable: true,
            loop: false,
            touchNavigation: true,
            zoomable: true,
            elements: []
        }));
    }, []);
    const openLightbox = (evt)=>{
        if (!props.inWriter) {
            evt.preventDefault();
            evt.stopPropagation();
            if (lightbox != null && Array.from(document.getElementsByClassName("glightbox")).length > 0) {
                const elements = Array.from(document.getElementsByClassName("glightbox")).map((e)=>{
                    const r = {
                        href: e.href
                    };
                    if (e?.dataset?.width) r.width = e?.dataset?.width;
                    if (e?.dataset?.height) r.height = e?.dataset?.height;
                    if (e?.dataset?.type) r.type = e?.dataset?.type;
                    if (e?.dataset?.srcset) r.srcset = e?.dataset?.srcset;
                    if (e?.dataset?.sizes) r.sizes = e?.dataset?.sizes;
                    return r;
                });
                lightbox.setElements(elements);
                lightbox.open(null, elements.findIndex((e)=>e.href === evt.target.closest(".glightbox").href));
            }
        }
    };
    if (props.file.contentUrl) {
        if (/video/.test(props.file.type)) {
            if (props.file.status == "ready") return (0, $9SeGy.h)("video", {
                draggable: "false",
                poster: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 1280, 720),
                class: "file-embed img-fluid contained-height video",
                controls: "true",
                src: url,
                id: props.file.id
            });
            return (0, $9SeGy.h)("a", {
                class: "file-embed file-loading image video-uploaded",
                id: props.file.id
            }, (0, $9SeGy.h)("img", {
                class: "img-fluid video-raw",
                src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.file.id, 320, 180)
            }), (0, $9SeGy.h)("div", {
                class: "video-not-ready"
            }, t("video_not_ready")));
        }
        if (/pdf/.test(props.file.type)) return (0, $9SeGy.h)("a", {
            "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
            draggable: "false",
            href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(url) : undefined,
            className: `glightbox file-embed pdf-outline image${props.file.removed ? " removed" : ""}`,
            id: props.file.id,
            "data-width": "calc(90vw - 10px)",
            "data-height": "100vh",
            onClick: (e)=>openLightbox(e)
        }, (0, $9SeGy.h)("img", {
            class: "img-fluid",
            src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 420, 994)
        }), (0, $9SeGy.h)("div", {
            class: "remove-button",
            style: props.file.removed ? "color:red" : "",
            onClick: (e)=>props.toggleFile(e)
        }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
            family: "solid",
            icon: "times"
        })));
        if (/image/.test(props.file.type)) {
            if (props.file.type == "image/gif") return (0, $9SeGy.h)("a", {
                "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
                draggable: "false",
                href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                className: `glightbox file-embed image${props.file.removed ? " removed" : ""}`,
                id: props.file.id,
                "data-type": "image",
                onClick: (e)=>openLightbox(e)
            }, (0, $9SeGy.h)("img", {
                class: "img-fluid",
                src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath)
            }), (0, $9SeGy.h)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
            return (0, $9SeGy.h)("a", {
                "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
                draggable: "false",
                "data-type": "image",
                "data-srcset": `${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 720)} 720w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 1366)} 1366w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 2048)} 2048w`,
                "data-sizes": "(max-width: 992px) 720px, (max-width: 1400px) 1366px, 2048px",
                href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                className: `glightbox file-embed image${props.file.removed ? " removed" : ""}`,
                id: props.file.id,
                onClick: (e)=>openLightbox(e)
            }, (0, $9SeGy.h)("img", {
                class: "img-fluid",
                src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 720)
            }), (0, $9SeGy.h)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
        }
    }
    if (props.file.status == "loading") return (0, $9SeGy.h)("div", {
        class: "file-embed file-placeholder",
        id: props.file.id
    });
    return (0, $9SeGy.h)("div", {
        class: "file-embed file-placeholder",
        id: props.file.id
    }, props.file["error"] ? (0, $9SeGy.h)("div", {
        class: "orange-error"
    }, "\xD7") : (0, $9SeGy.h)("div", {
        class: "spinner orange-spinner"
    }, (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null)), (0, $9SeGy.h)("div", {
        class: "progress-bar"
    }, (0, $9SeGy.h)("div", {
        style: {
            width: `${props.file.progress}%`
        }
    })));
}



var $9SeGy = parcelRequire("9SeGy");

var $bJrD0 = parcelRequire("bJrD0");


var $a64402709a5ef811$exports = {};
/*! mobile-drag-drop 3.0.0-rc.0 | Copyright (c) 2022 Tim Ruffles | MIT License */ !function(t, i) {
    i($a64402709a5ef811$exports);
}($a64402709a5ef811$exports, function(t) {
    "use strict";
    var c = "dnd-poly-", s = [
        "none",
        "copy",
        "copyLink",
        "copyMove",
        "link",
        "linkMove",
        "move",
        "all"
    ], f = [
        "none",
        "copy",
        "move",
        "link"
    ];
    function i() {
        var t = !1;
        try {
            var i = Object.defineProperty({}, "passive", {
                get: function() {
                    t = !0;
                }
            });
            window.addEventListener("test", null, i);
        } catch (t) {}
        return t;
    }
    var e = i();
    function l(t) {
        return t && t.tagName;
    }
    function h(t, i, s) {
        void 0 === s && (s = !0), document.addEventListener(t, i, !!e && {
            passive: s
        });
    }
    function n(t, i) {
        document.removeEventListener(t, i);
    }
    function u(t, i, s, n) {
        void 0 === n && (n = !1);
        var h = e ? {
            passive: !0,
            capture: n
        } : n;
        return t.addEventListener(i, s, h), {
            off: function() {
                t.removeEventListener(i, s, h);
            }
        };
    }
    function o(t) {
        return 0 === t.length ? 0 : t.reduce(function(t, i) {
            return i + t;
        }, 0) / t.length;
    }
    function r(t, i) {
        for(var s = 0; s < t.changedTouches.length; s++)if (t.changedTouches[s].identifier === i) return !0;
        return !1;
    }
    function a(t, i, s) {
        for(var n = [], h = [], e = 0; e < i.touches.length; e++){
            var r = i.touches[e];
            n.push(r[t + "X"]), h.push(r[t + "Y"]);
        }
        s.x = o(n), s.y = o(h);
    }
    var d = [
        "",
        "-webkit-"
    ];
    function v(t, i, s, n, h) {
        var e = i.x, i = i.y;
        n && (e += n.x, i += n.y), (h = void 0 === h || h) && (e -= parseInt(t.offsetWidth, 10) / 2, i -= parseInt(t.offsetHeight, 10) / 2);
        for(var r = "translate3d(" + e + "px," + i + "px, 0)", o = 0; o < d.length; o++){
            var u = d[o] + "transform";
            t.style[u] = r + " " + s[o];
        }
    }
    var p = (Object.defineProperty(g.prototype, "dropEffect", {
        get: function() {
            return this.t;
        },
        set: function(t) {
            0 !== this.i.mode && -1 < s.indexOf(t) && (this.t = t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(g.prototype, "types", {
        get: function() {
            if (0 !== this.i.mode) return Object.freeze(this.i.types);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(g.prototype, "effectAllowed", {
        get: function() {
            return this.i.effectAllowed;
        },
        set: function(t) {
            2 === this.i.mode && -1 < s.indexOf(t) && (this.i.effectAllowed = t);
        },
        enumerable: !1,
        configurable: !0
    }), g.prototype.setData = function(t, i) {
        if (2 === this.i.mode) {
            if (-1 < t.indexOf(" ")) throw new Error("illegal arg: type contains space");
            this.i.data[t] = i, -1 === this.i.types.indexOf(t) && this.i.types.push(t);
        }
    }, g.prototype.getData = function(t) {
        if (1 === this.i.mode || 2 === this.i.mode) return this.i.data[t] || "";
    }, g.prototype.clearData = function(t) {
        2 === this.i.mode && (t && this.i.data[t] ? (delete this.i.data[t], -1 < (t = this.i.types.indexOf(t)) && this.i.types.splice(t, 1)) : (this.i.data = {}, this.i.types = []));
    }, g.prototype.setDragImage = function(t, i, s) {
        2 === this.i.mode && this.h(t, i, s);
    }, g);
    function g(t, i) {
        this.i = t, this.h = i, this.t = f[0];
    }
    function m(t, i) {
        return t ? t === s[0] ? f[0] : 0 === t.indexOf(s[1]) || t === s[7] ? f[1] : 0 === t.indexOf(s[4]) ? f[3] : t === s[6] ? f[2] : f[1] : 3 === i.nodeType && "A" === i.tagName ? f[3] : f[1];
    }
    function y(u, t, a, i, s, n, c) {
        void 0 === c && (c = null);
        s = function(t, i, s, n, h, e, r) {
            void 0 === c && (r = null);
            var o = a.changedTouches[0], n = new Event(u, {
                bubbles: !0,
                cancelable: n
            });
            n.dataTransfer = e, n.relatedTarget = r, n.screenX = o.screenX, n.screenY = o.screenY, n.clientX = o.clientX, n.clientY = o.clientY, n.pageX = o.pageX, n.pageY = o.pageY;
            t = t.getBoundingClientRect();
            return n.offsetX = n.clientX - t.left, n.offsetY = n.clientY - t.top, n;
        }(t, 0, 0, n = void 0 === n || n, document.defaultView, s, c), s = !t.dispatchEvent(s);
        return i.mode = 0, s;
    }
    function b(t, i) {
        if (!t || t === s[7]) return i;
        if (i === f[1]) {
            if (0 === t.indexOf(f[1])) return f[1];
        } else if (i === f[3]) {
            if (0 === t.indexOf(f[3]) || -1 < t.indexOf("Link")) return f[3];
        } else if (i === f[2] && (0 === t.indexOf(f[2]) || -1 < t.indexOf("Move"))) return f[2];
        return f[0];
    }
    var w = (x.prototype.o = function() {
        var n = this;
        this.u = 1, this.l = f[0], this.v = {
            data: {},
            effectAllowed: void 0,
            mode: 3,
            types: []
        }, this.p = {
            x: null,
            y: null
        }, this.g = {
            x: null,
            y: null
        };
        var h = this.m;
        if (this.I = new p(this.v, function(t, i, s) {
            h = t, "number" != typeof i && "number" != typeof s || (n.j = {
                x: i || 0,
                y: s || 0
            });
        }), this.v.mode = 2, this.I.dropEffect = f[0], y("dragstart", this.m, this.k, this.v, this.I)) return this.u = 3, this.C(), !1;
        a("page", this.k, this.g);
        var i, t, s = this.S.dragImageSetup(h);
        return this.A = (i = s, d.map(function(t) {
            t = i.style[t + "transform"];
            return t && "none" !== t ? t.replace(/translate\(\D*\d+[^,]*,\D*\d+[^,]*\)\s*/g, "") : "";
        })), s.style.position = "absolute", s.style.left = "0px", s.style.top = "0px", s.style.zIndex = "999999", s.classList.add("dnd-poly-drag-image"), s.classList.add("dnd-poly-icon"), this.O = s, this.j || (this.S.dragImageOffset ? this.j = {
            x: this.S.dragImageOffset.x,
            y: this.S.dragImageOffset.y
        } : this.S.dragImageCenterOnTouch ? (t = getComputedStyle(h), this.j = {
            x: 0 - parseInt(t.marginLeft, 10),
            y: 0 - parseInt(t.marginTop, 10)
        }) : (s = h.getBoundingClientRect(), t = getComputedStyle(h), this.j = {
            x: s.left - this.M.clientX - parseInt(t.marginLeft, 10) + s.width / 2,
            y: s.top - this.M.clientY - parseInt(t.marginTop, 10) + s.height / 2
        })), v(this.O, this.g, this.A, this.j, this.S.dragImageCenterOnTouch), document.body.appendChild(this.O), this.D = window.setInterval(function() {
            n.F || (n.F = !0, n.N(), n.F = !1);
        }, this.S.iterationInterval), !0;
    }, x.prototype.C = function() {
        this.D && (clearInterval(this.D), this.D = null), n("touchmove", this.P), n("touchend", this.T), n("touchcancel", this.T), this.O && (this.O.parentNode.removeChild(this.O), this.O = null), this.L(this.S, this.k, this.u);
    }, x.prototype._ = function(t) {
        var s = this;
        if (!1 !== r(t, this.M.identifier)) {
            if (this.k = t, 0 === this.u) {
                var i = void 0;
                if (this.S.dragStartConditionOverride) try {
                    i = this.S.dragStartConditionOverride(t);
                } catch (t) {
                    i = !1;
                }
                else i = 1 === t.touches.length;
                return i ? void (!0 === this.o() && (this.H.preventDefault(), t.preventDefault())) : void this.C();
            }
            if (t.preventDefault(), a("client", t, this.p), a("page", t, this.g), this.S.dragImageTranslateOverride) try {
                var n = !1;
                if (this.S.dragImageTranslateOverride(t, {
                    x: this.p.x,
                    y: this.p.y
                }, this.V, function(t, i) {
                    s.O && (n = !0, s.p.x += t, s.p.y += i, s.g.x += t, s.g.y += i, v(s.O, s.g, s.A, s.j, s.S.dragImageCenterOnTouch));
                }), n) return;
            } catch (t) {}
            v(this.O, this.g, this.A, this.j, this.S.dragImageCenterOnTouch);
        }
    }, x.prototype.X = function(t) {
        if (!1 !== r(t, this.M.identifier)) {
            if (this.S.dragImageTranslateOverride) try {
                this.S.dragImageTranslateOverride(void 0, void 0, void 0, function() {});
            } catch (t) {}
            0 !== this.u ? (t.preventDefault(), this.u = "touchcancel" === t.type ? 3 : 2) : this.C();
        }
    }, x.prototype.N = function() {
        var t = this, i = this.l;
        this.v.mode = 3, this.I.dropEffect = f[0];
        var s, n, h, e, r, o = y("drag", this.m, this.k, this.v, this.I);
        if (o && (this.l = f[0]), o || 2 === this.u || 3 === this.u) return this.Y(this.u) ? (e = this.m, s = this.O, n = this.A, a = function() {
            t.q();
        }, void ("hidden" !== (r = getComputedStyle(e)).visibility && "none" !== r.display ? (s.classList.add("dnd-poly-snapback"), h = getComputedStyle(s), o = parseFloat(h.transitionDuration), isNaN(o) || 0 === o ? a() : ((e = {
            x: (u = e.getBoundingClientRect()).left,
            y: u.top
        }).x += document.body.scrollLeft || document.documentElement.scrollLeft, e.y += document.body.scrollTop || document.documentElement.scrollTop, e.x -= parseInt(r.marginLeft, 10), e.y -= parseInt(r.marginTop, 10), u = parseFloat(h.transitionDelay), u = Math.round(1e3 * (o + u)), v(s, e, n, void 0, !1), setTimeout(a, u))) : a())) : void this.q();
        var u = this.S.elementFromPoint(this.p.x, this.p.y), a = this.B;
        u !== this.V && u !== this.B && (this.V = u, null !== this.B && (this.v.mode = 3, this.I.dropEffect = f[0], y("dragexit", this.B, this.k, this.v, this.I, !1)), null === this.V ? this.B = this.V : (this.v.mode = 3, this.I.dropEffect = m(this.v.effectAllowed, this.m), y("dragenter", this.V, this.k, this.v, this.I) ? (this.B = this.V, this.l = b(this.I.effectAllowed, this.I.dropEffect)) : this.V !== document.body && (this.B = document.body))), a !== this.B && l(a) && (this.v.mode = 3, this.I.dropEffect = f[0], y("dragleave", a, this.k, this.v, this.I, !1, this.B)), l(this.B) && (this.v.mode = 3, this.I.dropEffect = m(this.v.effectAllowed, this.m), !1 === y("dragover", this.B, this.k, this.v, this.I) ? this.l = f[0] : this.l = b(this.I.effectAllowed, this.I.dropEffect)), i !== this.l && this.O.classList.remove(c + i);
        i = c + this.l;
        this.O.classList.add(i);
    }, x.prototype.Y = function(t) {
        t = this.l === f[0] || null === this.B || 3 === t;
        return t ? l(this.B) && (this.v.mode = 3, this.I.dropEffect = f[0], y("dragleave", this.B, this.k, this.v, this.I, !1)) : l(this.B) && (this.v.mode = 1, this.I.dropEffect = this.l, !0 === y("drop", this.B, this.k, this.v, this.I) ? this.l = this.I.dropEffect : this.l = f[0]), t;
    }, x.prototype.q = function() {
        this.v.mode = 3, this.I.dropEffect = this.l, y("dragend", this.m, this.k, this.v, this.I, !1), this.u = 2, this.C();
    }, x);
    function x(t, i, s, n) {
        this.H = t, this.S = i, this.m = s, this.L = n, this.u = 0, this.V = null, this.B = null, this.k = t, this.M = t.changedTouches[0], this.P = this._.bind(this), this.T = this.X.bind(this), h("touchmove", this.P, !1), h("touchend", this.T, !1), h("touchcancel", this.T, !1);
    }
    var I, j = {
        iterationInterval: 150,
        tryFindDraggableTarget: function(t) {
            for(var i = 0, s = t.composedPath(); i < s.length; i++){
                var n = s[i];
                do if (!1 !== n.draggable) {
                    if (!0 === n.draggable) return n;
                    if (n.getAttribute && "true" === n.getAttribute("draggable")) return n;
                }
                while ((n = n.parentNode) && n !== document.body);
            }
        },
        dragImageSetup: function(t) {
            var i = t.cloneNode(!0);
            return function t(i, s) {
                if (1 === i.nodeType) {
                    for(var n, h, e = getComputedStyle(i), r = 0; r < e.length; r++){
                        var o = e[r];
                        s.style.setProperty(o, e.getPropertyValue(o), e.getPropertyPriority(o));
                    }
                    s.style.pointerEvents = "none", s.removeAttribute("id"), s.removeAttribute("class"), s.removeAttribute("draggable"), "CANVAS" === s.nodeName && (n = s, h = (h = i).getContext("2d").getImageData(0, 0, h.width, h.height), n.getContext("2d").putImageData(h, 0, 0));
                }
                if (i.hasChildNodes()) for(r = 0; r < i.childNodes.length; r++)t(i.childNodes[r], s.childNodes[r]);
                !function t(i) {
                    if (i instanceof HTMLElement && (i.style.pointerEvents = "none"), i.children && i.children.length) for(var s = 0; s < i.children.length; s++)t(i.children[s]);
                    if (i.shadowRoot && i.shadowRoot.children.length) for(s = 0; s < i.shadowRoot.children.length; s++)t(i.shadowRoot.children[s]);
                }(s);
            }(t, i), i;
        },
        elementFromPoint: function(t, i) {
            var s = document.elementFromPoint(t, i);
            if (s) {
                for(; s.shadowRoot;){
                    var n = s.shadowRoot.elementFromPoint(t, i);
                    if (null === n || n === s) break;
                    s = n;
                }
                return s;
            }
        }
    };
    function k(i) {
        if (!I) {
            var t = j.tryFindDraggableTarget(i);
            if (t) try {
                I = new w(i, j, t, S);
            } catch (t) {
                throw S(j, i, 3), t;
            }
        }
    }
    function C(t) {
        function i(t) {
            h.off(), e.off(), r.off(), o.off(), s && s.dispatchEvent(new CustomEvent("dnd-poly-dragstart-cancel", {
                bubbles: !0,
                cancelable: !0
            })), clearTimeout(n);
        }
        var s = t.target;
        s && s.dispatchEvent(new CustomEvent("dnd-poly-dragstart-pending", {
            bubbles: !0,
            cancelable: !0
        }));
        var n = window.setTimeout(function() {
            h.off(), e.off(), r.off(), o.off(), k(t);
        }, j.holdToDrag), h = u(s, "touchend", i), e = u(s, "touchcancel", i), r = u(s, "touchmove", i), o = u(window, "scroll", i, !0);
    }
    function S(t, i, s) {
        if (0 === s && t.defaultActionOverride) try {
            t.defaultActionOverride(i), i.defaultPrevented;
        } catch (t) {}
        I = null;
    }
    t.polyfill = function(i) {
        if (i && Object.keys(i).forEach(function(t) {
            j[t] = i[t];
        }), !j.forceApply) {
            t = (t = !!window.chrome || /chrome/i.test(navigator.userAgent), {
                dragEvents: "ondragstart" in document.documentElement,
                draggable: "draggable" in document.documentElement,
                userAgentSupportingNativeDnD: !(/iPad|iPhone|iPod|Android/.test(navigator.userAgent) || t && "ontouchstart" in document.documentElement)
            });
            if (t.userAgentSupportingNativeDnD && t.draggable && t.dragEvents) return !1;
        }
        var t;
        return j.holdToDrag ? h("touchstart", C, !1) : h("touchstart", k, !1), !0;
    }, t.supportsPassiveEventListener = i, Object.defineProperty(t, "G", {
        value: !0
    });
});



function $469480f865369d3d$export$2e2bcd8739ae039(props) {
    const [lightbox, setLightbox] = (0, $bJrD0.useState)(null);
    const filePath = props.file.contentUrl ? `/files/${props.file.contentUrl}` : null;
    let url = filePath;
    const innerRef = (0, $bJrD0.useRef)(null);
    (0, $a64402709a5ef811$exports.polyfill)({
        tryFindDraggableTarget: (e)=>{
            if (!props.inWriter) return undefined;
            const cp = e.composedPath();
            for (const o of cp){
                let el = o;
                do {
                    if (el.draggable === false) continue;
                    if (el.draggable === true) return el;
                    if (el.getAttribute && el.getAttribute("draggable") === "true") return el;
                }while ((el = el.parentNode) && el !== document.body);
            }
        }
    });
    (0, $bJrD0.useEffect)(()=>{
        setLightbox((0, (/*@__PURE__*/$parcel$interopDefault($42107f3179039eb0$exports)))({
            autoplayVideos: false,
            draggable: true,
            loop: false,
            touchNavigation: true,
            zoomable: true,
            elements: []
        }));
    }, []);
    const openLightbox = (evt)=>{
        if (!props.inWriter) {
            evt.preventDefault();
            evt.stopPropagation();
            if (lightbox != null && Array.from(document.getElementsByClassName("glightbox")).length > 0) {
                const elements = Array.from(document.getElementsByClassName("glightbox")).map((e)=>{
                    const r = {
                        href: e.href
                    };
                    if (e?.dataset?.width) r.width = e?.dataset?.width;
                    if (e?.dataset?.height) r.height = e?.dataset?.height;
                    if (e?.dataset?.type) r.type = e?.dataset?.type;
                    if (e?.dataset?.srcset) r.srcset = e?.dataset?.srcset;
                    if (e?.dataset?.sizes) r.sizes = e?.dataset?.sizes;
                    return r;
                });
                lightbox.setElements(elements);
                lightbox.open(null, elements.findIndex((e)=>e.href === evt.target.closest(".glightbox").href));
            }
        }
    };
    const fileDragStart = (e)=>{
        e.target.style.opacity = "0.4";
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("id", props.file.id);
        document.querySelectorAll(".remove-button").forEach((e)=>e.style.display = "none");
    };
    const fileDragEnd = (e)=>{
        e.target.style.opacity = "1";
        document.querySelectorAll(".remove-button").forEach((e)=>e.style.display = "block");
        document.querySelectorAll(".drag-over").forEach((e)=>e.classList.remove("drag-over"));
    };
    const fileDragEnter = (e)=>{
        e.preventDefault();
        innerRef.current.classList.add("drag-over");
        return false;
    };
    const fileDragLeave = (e)=>{
        e.preventDefault();
        innerRef.current.classList.remove("drag-over");
        return false;
    };
    // necessary to declare a drop target
    const fileDragOver = (e)=>{
        e.preventDefault();
        return false;
    };
    const fileDrop = (e)=>{
        // stops the browser from redirecting.
        e.preventDefault();
        props.invertFiles(e.dataTransfer.getData("id"), props.file.id);
        return false;
    };
    (0, $bJrD0.useEffect)(()=>{
        if (props.inWriter && props.file.status == "ready" && innerRef && innerRef.current) {
            innerRef.current.addEventListener("dragstart", fileDragStart);
            innerRef.current.addEventListener("dragend", fileDragEnd);
            innerRef.current.addEventListener("dragover", fileDragOver);
            innerRef.current.addEventListener("dragenter", fileDragEnter);
            innerRef.current.addEventListener("dragleave", fileDragLeave);
            innerRef.current.addEventListener("drop", fileDrop);
            return ()=>{
                innerRef.current.removeEventListener("dragstart", fileDragStart);
                innerRef.current.removeEventListener("dragend", fileDragEnd);
                innerRef.current.removeEventListener("dragover", fileDragOver);
                innerRef.current.removeEventListener("dragenter", fileDragEnter);
                innerRef.current.removeEventListener("dragleave", fileDragLeave);
                innerRef.current.removeEventListener("drop", fileDrop);
            };
        }
    }, []);
    switch(props.file.status){
        case "raw":
            return (0, $9SeGy.h)("a", {
                class: "file-embed file-loading rounded",
                id: props.file.id
            }, (0, $9SeGy.h)("div", {
                class: "miniature"
            }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "regular",
                icon: "check-circle"
            })));
        case "loading":
            return (0, $9SeGy.h)("a", {
                class: "file-embed file-loading rounded",
                id: props.file.id
            }, (0, $9SeGy.h)("div", {
                class: "miniature"
            }));
        case "uploading":
        case "initial":
            return (0, $9SeGy.h)("a", {
                class: "file-embed file-loading rounded",
                id: props.file.id
            }, (0, $9SeGy.h)("div", {
                class: "miniature video-raw",
                style: `background-image:url("${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $9SeGy.h)("div", {
                class: "spinner orange-spinner"
            }, (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null)), props.file && props.file.progress > 0 && (0, $9SeGy.h)("div", {
                class: "progress-bar"
            }, (0, $9SeGy.h)("div", {
                style: {
                    width: `${props.file.progress}%`
                }
            })));
        case "ready":
        default:
            if (/pdf/.test(props.file.type) || /video/.test(props.file.type)) return (0, $9SeGy.h)("a", {
                ref: innerRef,
                draggable: !!props.inWriter,
                "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
                href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(url) : undefined,
                className: `${!props.inWriter ? "glightbox " : ""}file-embed rounded ${props.file.removed ? " removed" : ""}`,
                id: props.file.id,
                "data-width": "calc(90vw - 10px)",
                "data-height": "100vh",
                onClick: (e)=>openLightbox(e)
            }, (0, $9SeGy.h)("div", {
                className: `miniature${props.file.removed ? " removed" : ""}`,
                style: `background-image:url("${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $9SeGy.h)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
            if (props.file.type == "image/gif") return (0, $9SeGy.h)("a", {
                ref: innerRef,
                draggable: !!props.inWriter,
                "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
                href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                class: `${!props.inWriter ? "glightbox " : ""}file-embed rounded`,
                id: props.file.id,
                "data-type": "image",
                onClick: (e)=>openLightbox(e)
            }, (0, $9SeGy.h)("div", {
                className: `miniature${props.file.removed ? " removed" : ""}`,
                style: `background-image:url("${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $9SeGy.h)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
            if (/image/.test(props.file.type)) return (0, $9SeGy.h)("a", {
                ref: innerRef,
                draggable: !!props.inWriter,
                "data-origin": (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath),
                "data-type": "image",
                "data-srcset": `${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 720)} 720w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 1366)} 1366w, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).thumbnail(props.file.id, 2048)} 2048w`,
                "data-sizes": "(max-width: 992px) 720px, (max-width: 1400px) 1366px, 2048px",
                href: !props.inWriter ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).toApp(filePath) : undefined,
                class: `${!props.inWriter ? "glightbox " : ""}file-embed rounded`,
                id: props.file.id,
                onClick: (e)=>openLightbox(e)
            }, (0, $9SeGy.h)("div", {
                className: `miniature${props.file.removed ? " removed" : ""}`,
                style: `background-image:url("${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props.file.id, 160, 160)}")`
            }), (0, $9SeGy.h)("div", {
                class: "remove-button",
                style: props.file.removed ? "color:red" : "",
                onClick: (e)=>props.toggleFile(e)
            }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
                family: "solid",
                icon: "times"
            })));
    }
}


const $c72cf4b6b78e8f8e$export$330d558700ffa676 = (0, $9745ce6cd249f9c5$export$2e2bcd8739ae039);
const $c72cf4b6b78e8f8e$export$ca445ff2f74d7dc4 = (0, $b7ceefe51d9ca40b$export$2e2bcd8739ae039);
const $c72cf4b6b78e8f8e$export$48621228a997a4e0 = (0, $374de5a37ad6a81a$export$2e2bcd8739ae039);
const $c72cf4b6b78e8f8e$export$40e4fb50d87564f1 = (0, $469480f865369d3d$export$2e2bcd8739ae039);



var $9SeGy = parcelRequire("9SeGy");

var $bJrD0 = parcelRequire("bJrD0");
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $64e7f827a9435ee9$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $64e7f827a9435ee9$export$2e2bcd8739ae039 = $64e7f827a9435ee9$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $dbc29436ab37b802$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $dbc29436ab37b802$export$2e2bcd8739ae039 = $dbc29436ab37b802$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2813c3144586cb07$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $dbc29436ab37b802$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $2813c3144586cb07$export$2e2bcd8739ae039 = $2813c3144586cb07$var$assocIndexOf;


/** Used for built-in method references. */ var $4b17ae4658c186d0$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $4b17ae4658c186d0$var$splice = $4b17ae4658c186d0$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4b17ae4658c186d0$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $2813c3144586cb07$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $4b17ae4658c186d0$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $4b17ae4658c186d0$export$2e2bcd8739ae039 = $4b17ae4658c186d0$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c57758256122f621$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $2813c3144586cb07$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $c57758256122f621$export$2e2bcd8739ae039 = $c57758256122f621$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e463be5b687526dd$var$listCacheHas(key) {
    return (0, $2813c3144586cb07$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $e463be5b687526dd$export$2e2bcd8739ae039 = $e463be5b687526dd$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $fcf1e120d9eb6177$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $2813c3144586cb07$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $fcf1e120d9eb6177$export$2e2bcd8739ae039 = $fcf1e120d9eb6177$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ca06a6c0f5058429$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$ca06a6c0f5058429$var$ListCache.prototype.clear = (0, $64e7f827a9435ee9$export$2e2bcd8739ae039);
$ca06a6c0f5058429$var$ListCache.prototype['delete'] = (0, $4b17ae4658c186d0$export$2e2bcd8739ae039);
$ca06a6c0f5058429$var$ListCache.prototype.get = (0, $c57758256122f621$export$2e2bcd8739ae039);
$ca06a6c0f5058429$var$ListCache.prototype.has = (0, $e463be5b687526dd$export$2e2bcd8739ae039);
$ca06a6c0f5058429$var$ListCache.prototype.set = (0, $fcf1e120d9eb6177$export$2e2bcd8739ae039);
var $ca06a6c0f5058429$export$2e2bcd8739ae039 = $ca06a6c0f5058429$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $5a5f05992998720e$var$stackClear() {
    this.__data__ = new (0, $ca06a6c0f5058429$export$2e2bcd8739ae039);
    this.size = 0;
}
var $5a5f05992998720e$export$2e2bcd8739ae039 = $5a5f05992998720e$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $74399dd86030fb10$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $74399dd86030fb10$export$2e2bcd8739ae039 = $74399dd86030fb10$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b8cfb16383c4d992$var$stackGet(key) {
    return this.__data__.get(key);
}
var $b8cfb16383c4d992$export$2e2bcd8739ae039 = $b8cfb16383c4d992$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $98f9f49d3221c964$var$stackHas(key) {
    return this.__data__.has(key);
}
var $98f9f49d3221c964$export$2e2bcd8739ae039 = $98f9f49d3221c964$var$stackHas;




var $iVn1G = parcelRequire("iVn1G");
/** Built-in value references. */ var $df164a84fc8de2ea$var$Symbol = (0, $iVn1G.default).Symbol;
var $df164a84fc8de2ea$export$2e2bcd8739ae039 = $df164a84fc8de2ea$var$Symbol;



/** Used for built-in method references. */ var $e8b62ac2cd4f87d3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e8b62ac2cd4f87d3$var$hasOwnProperty = $e8b62ac2cd4f87d3$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e8b62ac2cd4f87d3$var$nativeObjectToString = $e8b62ac2cd4f87d3$var$objectProto.toString;
/** Built-in value references. */ var $e8b62ac2cd4f87d3$var$symToStringTag = (0, $df164a84fc8de2ea$export$2e2bcd8739ae039) ? (0, $df164a84fc8de2ea$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e8b62ac2cd4f87d3$var$getRawTag(value) {
    var isOwn = $e8b62ac2cd4f87d3$var$hasOwnProperty.call(value, $e8b62ac2cd4f87d3$var$symToStringTag), tag = value[$e8b62ac2cd4f87d3$var$symToStringTag];
    try {
        value[$e8b62ac2cd4f87d3$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e8b62ac2cd4f87d3$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e8b62ac2cd4f87d3$var$symToStringTag] = tag;
        else delete value[$e8b62ac2cd4f87d3$var$symToStringTag];
    }
    return result;
}
var $e8b62ac2cd4f87d3$export$2e2bcd8739ae039 = $e8b62ac2cd4f87d3$var$getRawTag;


/** Used for built-in method references. */ var $448823fe2e2c03b8$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $448823fe2e2c03b8$var$nativeObjectToString = $448823fe2e2c03b8$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $448823fe2e2c03b8$var$objectToString(value) {
    return $448823fe2e2c03b8$var$nativeObjectToString.call(value);
}
var $448823fe2e2c03b8$export$2e2bcd8739ae039 = $448823fe2e2c03b8$var$objectToString;


/** `Object#toString` result references. */ var $fdccbd91d6abc4f1$var$nullTag = '[object Null]', $fdccbd91d6abc4f1$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $fdccbd91d6abc4f1$var$symToStringTag = (0, $df164a84fc8de2ea$export$2e2bcd8739ae039) ? (0, $df164a84fc8de2ea$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $fdccbd91d6abc4f1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $fdccbd91d6abc4f1$var$undefinedTag : $fdccbd91d6abc4f1$var$nullTag;
    return $fdccbd91d6abc4f1$var$symToStringTag && $fdccbd91d6abc4f1$var$symToStringTag in Object(value) ? (0, $e8b62ac2cd4f87d3$export$2e2bcd8739ae039)(value) : (0, $448823fe2e2c03b8$export$2e2bcd8739ae039)(value);
}
var $fdccbd91d6abc4f1$export$2e2bcd8739ae039 = $fdccbd91d6abc4f1$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $93c2a573e5654f1c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $93c2a573e5654f1c$export$2e2bcd8739ae039 = $93c2a573e5654f1c$var$isObject;


/** `Object#toString` result references. */ var $720c027e6702105e$var$asyncTag = '[object AsyncFunction]', $720c027e6702105e$var$funcTag = '[object Function]', $720c027e6702105e$var$genTag = '[object GeneratorFunction]', $720c027e6702105e$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $720c027e6702105e$var$isFunction(value) {
    if (!(0, $93c2a573e5654f1c$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $fdccbd91d6abc4f1$export$2e2bcd8739ae039)(value);
    return tag == $720c027e6702105e$var$funcTag || tag == $720c027e6702105e$var$genTag || tag == $720c027e6702105e$var$asyncTag || tag == $720c027e6702105e$var$proxyTag;
}
var $720c027e6702105e$export$2e2bcd8739ae039 = $720c027e6702105e$var$isFunction;



var $iVn1G = parcelRequire("iVn1G");
/** Used to detect overreaching core-js shims. */ var $8d6ff34b48af35d9$var$coreJsData = (0, $iVn1G.default)['__core-js_shared__'];
var $8d6ff34b48af35d9$export$2e2bcd8739ae039 = $8d6ff34b48af35d9$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $a073e4ea1b1279ab$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $8d6ff34b48af35d9$export$2e2bcd8739ae039) && (0, $8d6ff34b48af35d9$export$2e2bcd8739ae039).keys && (0, $8d6ff34b48af35d9$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $a073e4ea1b1279ab$var$isMasked(func) {
    return !!$a073e4ea1b1279ab$var$maskSrcKey && $a073e4ea1b1279ab$var$maskSrcKey in func;
}
var $a073e4ea1b1279ab$export$2e2bcd8739ae039 = $a073e4ea1b1279ab$var$isMasked;



/** Used for built-in method references. */ var $979e61571b0ba362$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $979e61571b0ba362$var$funcToString = $979e61571b0ba362$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $979e61571b0ba362$var$toSource(func) {
    if (func != null) {
        try {
            return $979e61571b0ba362$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $979e61571b0ba362$export$2e2bcd8739ae039 = $979e61571b0ba362$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8a40a2c27bb24180$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8a40a2c27bb24180$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8a40a2c27bb24180$var$funcProto = Function.prototype, $8a40a2c27bb24180$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8a40a2c27bb24180$var$funcToString = $8a40a2c27bb24180$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8a40a2c27bb24180$var$hasOwnProperty = $8a40a2c27bb24180$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8a40a2c27bb24180$var$reIsNative = RegExp('^' + $8a40a2c27bb24180$var$funcToString.call($8a40a2c27bb24180$var$hasOwnProperty).replace($8a40a2c27bb24180$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8a40a2c27bb24180$var$baseIsNative(value) {
    if (!(0, $93c2a573e5654f1c$export$2e2bcd8739ae039)(value) || (0, $a073e4ea1b1279ab$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $720c027e6702105e$export$2e2bcd8739ae039)(value) ? $8a40a2c27bb24180$var$reIsNative : $8a40a2c27bb24180$var$reIsHostCtor;
    return pattern.test((0, $979e61571b0ba362$export$2e2bcd8739ae039)(value));
}
var $8a40a2c27bb24180$export$2e2bcd8739ae039 = $8a40a2c27bb24180$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $80aba4767337f251$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $80aba4767337f251$export$2e2bcd8739ae039 = $80aba4767337f251$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $8b5fb0ec341a7744$var$getNative(object, key) {
    var value = (0, $80aba4767337f251$export$2e2bcd8739ae039)(object, key);
    return (0, $8a40a2c27bb24180$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $8b5fb0ec341a7744$export$2e2bcd8739ae039 = $8b5fb0ec341a7744$var$getNative;



var $iVn1G = parcelRequire("iVn1G");
/* Built-in method references that are verified to be native. */ var $3573bc93ddb5f9de$var$Map = (0, $8b5fb0ec341a7744$export$2e2bcd8739ae039)((0, $iVn1G.default), 'Map');
var $3573bc93ddb5f9de$export$2e2bcd8739ae039 = $3573bc93ddb5f9de$var$Map;



/* Built-in method references that are verified to be native. */ var $0bc46c1710603fda$var$nativeCreate = (0, $8b5fb0ec341a7744$export$2e2bcd8739ae039)(Object, 'create');
var $0bc46c1710603fda$export$2e2bcd8739ae039 = $0bc46c1710603fda$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $76700b3d457e131e$var$hashClear() {
    this.__data__ = (0, $0bc46c1710603fda$export$2e2bcd8739ae039) ? (0, $0bc46c1710603fda$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $76700b3d457e131e$export$2e2bcd8739ae039 = $76700b3d457e131e$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $aa95579051e6ae42$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $aa95579051e6ae42$export$2e2bcd8739ae039 = $aa95579051e6ae42$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $eff324f8e6454d0e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $eff324f8e6454d0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $eff324f8e6454d0e$var$hasOwnProperty = $eff324f8e6454d0e$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $eff324f8e6454d0e$var$hashGet(key) {
    var data = this.__data__;
    if (0, $0bc46c1710603fda$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $eff324f8e6454d0e$var$HASH_UNDEFINED ? undefined : result;
    }
    return $eff324f8e6454d0e$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $eff324f8e6454d0e$export$2e2bcd8739ae039 = $eff324f8e6454d0e$var$hashGet;



/** Used for built-in method references. */ var $20bbe45dae6a6d1f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $20bbe45dae6a6d1f$var$hasOwnProperty = $20bbe45dae6a6d1f$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $20bbe45dae6a6d1f$var$hashHas(key) {
    var data = this.__data__;
    return (0, $0bc46c1710603fda$export$2e2bcd8739ae039) ? data[key] !== undefined : $20bbe45dae6a6d1f$var$hasOwnProperty.call(data, key);
}
var $20bbe45dae6a6d1f$export$2e2bcd8739ae039 = $20bbe45dae6a6d1f$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $1cd01d4a87cd9a1c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $1cd01d4a87cd9a1c$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $0bc46c1710603fda$export$2e2bcd8739ae039) && value === undefined ? $1cd01d4a87cd9a1c$var$HASH_UNDEFINED : value;
    return this;
}
var $1cd01d4a87cd9a1c$export$2e2bcd8739ae039 = $1cd01d4a87cd9a1c$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $66a9cb7b8aedc3a0$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$66a9cb7b8aedc3a0$var$Hash.prototype.clear = (0, $76700b3d457e131e$export$2e2bcd8739ae039);
$66a9cb7b8aedc3a0$var$Hash.prototype['delete'] = (0, $aa95579051e6ae42$export$2e2bcd8739ae039);
$66a9cb7b8aedc3a0$var$Hash.prototype.get = (0, $eff324f8e6454d0e$export$2e2bcd8739ae039);
$66a9cb7b8aedc3a0$var$Hash.prototype.has = (0, $20bbe45dae6a6d1f$export$2e2bcd8739ae039);
$66a9cb7b8aedc3a0$var$Hash.prototype.set = (0, $1cd01d4a87cd9a1c$export$2e2bcd8739ae039);
var $66a9cb7b8aedc3a0$export$2e2bcd8739ae039 = $66a9cb7b8aedc3a0$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7c55c8c2977fd7f7$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $66a9cb7b8aedc3a0$export$2e2bcd8739ae039),
        'map': new ((0, $3573bc93ddb5f9de$export$2e2bcd8739ae039) || (0, $ca06a6c0f5058429$export$2e2bcd8739ae039)),
        'string': new (0, $66a9cb7b8aedc3a0$export$2e2bcd8739ae039)
    };
}
var $7c55c8c2977fd7f7$export$2e2bcd8739ae039 = $7c55c8c2977fd7f7$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $637391d8aad515e3$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $637391d8aad515e3$export$2e2bcd8739ae039 = $637391d8aad515e3$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6b2338beebb32a2f$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $637391d8aad515e3$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $6b2338beebb32a2f$export$2e2bcd8739ae039 = $6b2338beebb32a2f$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $35b882a75a172c0a$var$mapCacheDelete(key) {
    var result = (0, $6b2338beebb32a2f$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $35b882a75a172c0a$export$2e2bcd8739ae039 = $35b882a75a172c0a$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1c7df6b56f759154$var$mapCacheGet(key) {
    return (0, $6b2338beebb32a2f$export$2e2bcd8739ae039)(this, key).get(key);
}
var $1c7df6b56f759154$export$2e2bcd8739ae039 = $1c7df6b56f759154$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d671876857abb3f4$var$mapCacheHas(key) {
    return (0, $6b2338beebb32a2f$export$2e2bcd8739ae039)(this, key).has(key);
}
var $d671876857abb3f4$export$2e2bcd8739ae039 = $d671876857abb3f4$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $d029e4bef773889d$var$mapCacheSet(key, value) {
    var data = (0, $6b2338beebb32a2f$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $d029e4bef773889d$export$2e2bcd8739ae039 = $d029e4bef773889d$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7a59bad03a5ce0e2$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$7a59bad03a5ce0e2$var$MapCache.prototype.clear = (0, $7c55c8c2977fd7f7$export$2e2bcd8739ae039);
$7a59bad03a5ce0e2$var$MapCache.prototype['delete'] = (0, $35b882a75a172c0a$export$2e2bcd8739ae039);
$7a59bad03a5ce0e2$var$MapCache.prototype.get = (0, $1c7df6b56f759154$export$2e2bcd8739ae039);
$7a59bad03a5ce0e2$var$MapCache.prototype.has = (0, $d671876857abb3f4$export$2e2bcd8739ae039);
$7a59bad03a5ce0e2$var$MapCache.prototype.set = (0, $d029e4bef773889d$export$2e2bcd8739ae039);
var $7a59bad03a5ce0e2$export$2e2bcd8739ae039 = $7a59bad03a5ce0e2$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $95a87bd3bddc7709$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $95a87bd3bddc7709$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $ca06a6c0f5058429$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $3573bc93ddb5f9de$export$2e2bcd8739ae039) || pairs.length < $95a87bd3bddc7709$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $7a59bad03a5ce0e2$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $95a87bd3bddc7709$export$2e2bcd8739ae039 = $95a87bd3bddc7709$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b0d2ef4e4882cf33$var$Stack(entries) {
    var data = this.__data__ = new (0, $ca06a6c0f5058429$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$b0d2ef4e4882cf33$var$Stack.prototype.clear = (0, $5a5f05992998720e$export$2e2bcd8739ae039);
$b0d2ef4e4882cf33$var$Stack.prototype['delete'] = (0, $74399dd86030fb10$export$2e2bcd8739ae039);
$b0d2ef4e4882cf33$var$Stack.prototype.get = (0, $b8cfb16383c4d992$export$2e2bcd8739ae039);
$b0d2ef4e4882cf33$var$Stack.prototype.has = (0, $98f9f49d3221c964$export$2e2bcd8739ae039);
$b0d2ef4e4882cf33$var$Stack.prototype.set = (0, $95a87bd3bddc7709$export$2e2bcd8739ae039);
var $b0d2ef4e4882cf33$export$2e2bcd8739ae039 = $b0d2ef4e4882cf33$var$Stack;



var $28782a0851b63c00$var$defineProperty = function() {
    try {
        var func = (0, $8b5fb0ec341a7744$export$2e2bcd8739ae039)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $28782a0851b63c00$export$2e2bcd8739ae039 = $28782a0851b63c00$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $02f5ea9d04bb07fb$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $28782a0851b63c00$export$2e2bcd8739ae039)) (0, $28782a0851b63c00$export$2e2bcd8739ae039)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $02f5ea9d04bb07fb$export$2e2bcd8739ae039 = $02f5ea9d04bb07fb$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $9c413e1f645d4b68$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $dbc29436ab37b802$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $02f5ea9d04bb07fb$export$2e2bcd8739ae039)(object, key, value);
}
var $9c413e1f645d4b68$export$2e2bcd8739ae039 = $9c413e1f645d4b68$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $349446d00f31638a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $349446d00f31638a$export$2e2bcd8739ae039 = $349446d00f31638a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $b2f6beeaf13674f7$var$baseFor = (0, $349446d00f31638a$export$2e2bcd8739ae039)();
var $b2f6beeaf13674f7$export$2e2bcd8739ae039 = $b2f6beeaf13674f7$var$baseFor;




var $236az = parcelRequire("236az");

var $iVn1G = parcelRequire("iVn1G");
/** Built-in value references. */ var $83305cda8efe6c03$var$Uint8Array = (0, $iVn1G.default).Uint8Array;
var $83305cda8efe6c03$export$2e2bcd8739ae039 = $83305cda8efe6c03$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $ca5a74d92c48812b$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $83305cda8efe6c03$export$2e2bcd8739ae039)(result).set(new (0, $83305cda8efe6c03$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $ca5a74d92c48812b$export$2e2bcd8739ae039 = $ca5a74d92c48812b$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $eda49e0fceb12242$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $ca5a74d92c48812b$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $eda49e0fceb12242$export$2e2bcd8739ae039 = $eda49e0fceb12242$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $6009eaa83171db0e$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $6009eaa83171db0e$export$2e2bcd8739ae039 = $6009eaa83171db0e$var$copyArray;



/** Built-in value references. */ var $f14178630249d474$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $f14178630249d474$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $93c2a573e5654f1c$export$2e2bcd8739ae039)(proto)) return {};
        if ($f14178630249d474$var$objectCreate) return $f14178630249d474$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $f14178630249d474$export$2e2bcd8739ae039 = $f14178630249d474$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $90e09751e96f1c48$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $90e09751e96f1c48$export$2e2bcd8739ae039 = $90e09751e96f1c48$var$overArg;


/** Built-in value references. */ var $95b36e26b327bbac$var$getPrototype = (0, $90e09751e96f1c48$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $95b36e26b327bbac$export$2e2bcd8739ae039 = $95b36e26b327bbac$var$getPrototype;


/** Used for built-in method references. */ var $3f5aa1a0ade22f80$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $3f5aa1a0ade22f80$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $3f5aa1a0ade22f80$var$objectProto;
    return value === proto;
}
var $3f5aa1a0ade22f80$export$2e2bcd8739ae039 = $3f5aa1a0ade22f80$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $684f74942bd33206$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $3f5aa1a0ade22f80$export$2e2bcd8739ae039)(object) ? (0, $f14178630249d474$export$2e2bcd8739ae039)((0, $95b36e26b327bbac$export$2e2bcd8739ae039)(object)) : {};
}
var $684f74942bd33206$export$2e2bcd8739ae039 = $684f74942bd33206$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $26b42760ff368506$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $26b42760ff368506$export$2e2bcd8739ae039 = $26b42760ff368506$var$isObjectLike;


/** `Object#toString` result references. */ var $5d3870c6a62e7110$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $5d3870c6a62e7110$var$baseIsArguments(value) {
    return (0, $26b42760ff368506$export$2e2bcd8739ae039)(value) && (0, $fdccbd91d6abc4f1$export$2e2bcd8739ae039)(value) == $5d3870c6a62e7110$var$argsTag;
}
var $5d3870c6a62e7110$export$2e2bcd8739ae039 = $5d3870c6a62e7110$var$baseIsArguments;



/** Used for built-in method references. */ var $cf391c46f49a2abc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cf391c46f49a2abc$var$hasOwnProperty = $cf391c46f49a2abc$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $cf391c46f49a2abc$var$propertyIsEnumerable = $cf391c46f49a2abc$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $cf391c46f49a2abc$var$isArguments = (0, $5d3870c6a62e7110$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $5d3870c6a62e7110$export$2e2bcd8739ae039) : function(value) {
    return (0, $26b42760ff368506$export$2e2bcd8739ae039)(value) && $cf391c46f49a2abc$var$hasOwnProperty.call(value, 'callee') && !$cf391c46f49a2abc$var$propertyIsEnumerable.call(value, 'callee');
};
var $cf391c46f49a2abc$export$2e2bcd8739ae039 = $cf391c46f49a2abc$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e1e43c41826225f5$var$isArray = Array.isArray;
var $e1e43c41826225f5$export$2e2bcd8739ae039 = $e1e43c41826225f5$var$isArray;



/** Used as references for various `Number` constants. */ var $ae9e2e5c65c2074a$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $ae9e2e5c65c2074a$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $ae9e2e5c65c2074a$var$MAX_SAFE_INTEGER;
}
var $ae9e2e5c65c2074a$export$2e2bcd8739ae039 = $ae9e2e5c65c2074a$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $630d935e7198011d$var$isArrayLike(value) {
    return value != null && (0, $ae9e2e5c65c2074a$export$2e2bcd8739ae039)(value.length) && !(0, $720c027e6702105e$export$2e2bcd8739ae039)(value);
}
var $630d935e7198011d$export$2e2bcd8739ae039 = $630d935e7198011d$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $f2c9eeb156e03382$var$isArrayLikeObject(value) {
    return (0, $26b42760ff368506$export$2e2bcd8739ae039)(value) && (0, $630d935e7198011d$export$2e2bcd8739ae039)(value);
}
var $f2c9eeb156e03382$export$2e2bcd8739ae039 = $f2c9eeb156e03382$var$isArrayLikeObject;



var $gOuvx = parcelRequire("gOuvx");





/** `Object#toString` result references. */ var $28bde0497bc97fbf$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $28bde0497bc97fbf$var$funcProto = Function.prototype, $28bde0497bc97fbf$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $28bde0497bc97fbf$var$funcToString = $28bde0497bc97fbf$var$funcProto.toString;
/** Used to check objects for own properties. */ var $28bde0497bc97fbf$var$hasOwnProperty = $28bde0497bc97fbf$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $28bde0497bc97fbf$var$objectCtorString = $28bde0497bc97fbf$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $28bde0497bc97fbf$var$isPlainObject(value) {
    if (!(0, $26b42760ff368506$export$2e2bcd8739ae039)(value) || (0, $fdccbd91d6abc4f1$export$2e2bcd8739ae039)(value) != $28bde0497bc97fbf$var$objectTag) return false;
    var proto = (0, $95b36e26b327bbac$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $28bde0497bc97fbf$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $28bde0497bc97fbf$var$funcToString.call(Ctor) == $28bde0497bc97fbf$var$objectCtorString;
}
var $28bde0497bc97fbf$export$2e2bcd8739ae039 = $28bde0497bc97fbf$var$isPlainObject;





/** `Object#toString` result references. */ var $e70b61ee79834351$var$argsTag = '[object Arguments]', $e70b61ee79834351$var$arrayTag = '[object Array]', $e70b61ee79834351$var$boolTag = '[object Boolean]', $e70b61ee79834351$var$dateTag = '[object Date]', $e70b61ee79834351$var$errorTag = '[object Error]', $e70b61ee79834351$var$funcTag = '[object Function]', $e70b61ee79834351$var$mapTag = '[object Map]', $e70b61ee79834351$var$numberTag = '[object Number]', $e70b61ee79834351$var$objectTag = '[object Object]', $e70b61ee79834351$var$regexpTag = '[object RegExp]', $e70b61ee79834351$var$setTag = '[object Set]', $e70b61ee79834351$var$stringTag = '[object String]', $e70b61ee79834351$var$weakMapTag = '[object WeakMap]';
var $e70b61ee79834351$var$arrayBufferTag = '[object ArrayBuffer]', $e70b61ee79834351$var$dataViewTag = '[object DataView]', $e70b61ee79834351$var$float32Tag = '[object Float32Array]', $e70b61ee79834351$var$float64Tag = '[object Float64Array]', $e70b61ee79834351$var$int8Tag = '[object Int8Array]', $e70b61ee79834351$var$int16Tag = '[object Int16Array]', $e70b61ee79834351$var$int32Tag = '[object Int32Array]', $e70b61ee79834351$var$uint8Tag = '[object Uint8Array]', $e70b61ee79834351$var$uint8ClampedTag = '[object Uint8ClampedArray]', $e70b61ee79834351$var$uint16Tag = '[object Uint16Array]', $e70b61ee79834351$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $e70b61ee79834351$var$typedArrayTags = {};
$e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$float32Tag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$float64Tag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$int8Tag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$int16Tag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$int32Tag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$uint8Tag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$uint8ClampedTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$uint16Tag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$uint32Tag] = true;
$e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$argsTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$arrayTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$arrayBufferTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$boolTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$dataViewTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$dateTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$errorTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$funcTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$mapTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$numberTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$objectTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$regexpTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$setTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$stringTag] = $e70b61ee79834351$var$typedArrayTags[$e70b61ee79834351$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $e70b61ee79834351$var$baseIsTypedArray(value) {
    return (0, $26b42760ff368506$export$2e2bcd8739ae039)(value) && (0, $ae9e2e5c65c2074a$export$2e2bcd8739ae039)(value.length) && !!$e70b61ee79834351$var$typedArrayTags[(0, $fdccbd91d6abc4f1$export$2e2bcd8739ae039)(value)];
}
var $e70b61ee79834351$export$2e2bcd8739ae039 = $e70b61ee79834351$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $351c0f28de3092c5$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $351c0f28de3092c5$export$2e2bcd8739ae039 = $351c0f28de3092c5$var$baseUnary;



var $jiWCt = parcelRequire("jiWCt");
/* Node.js helper references. */ var $8cd2e40924fc0dca$var$nodeIsTypedArray = (0, $jiWCt.default) && (0, $jiWCt.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $8cd2e40924fc0dca$var$isTypedArray = $8cd2e40924fc0dca$var$nodeIsTypedArray ? (0, $351c0f28de3092c5$export$2e2bcd8739ae039)($8cd2e40924fc0dca$var$nodeIsTypedArray) : (0, $e70b61ee79834351$export$2e2bcd8739ae039);
var $8cd2e40924fc0dca$export$2e2bcd8739ae039 = $8cd2e40924fc0dca$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $29c0a89cf5c48e03$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var $29c0a89cf5c48e03$export$2e2bcd8739ae039 = $29c0a89cf5c48e03$var$safeGet;




/** Used for built-in method references. */ var $84792e76731e08dc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $84792e76731e08dc$var$hasOwnProperty = $84792e76731e08dc$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $84792e76731e08dc$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($84792e76731e08dc$var$hasOwnProperty.call(object, key) && (0, $dbc29436ab37b802$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $02f5ea9d04bb07fb$export$2e2bcd8739ae039)(object, key, value);
}
var $84792e76731e08dc$export$2e2bcd8739ae039 = $84792e76731e08dc$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $3f0629f91a10f8c7$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $02f5ea9d04bb07fb$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $84792e76731e08dc$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $3f0629f91a10f8c7$export$2e2bcd8739ae039 = $3f0629f91a10f8c7$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $619255f9f9bf4a7a$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $619255f9f9bf4a7a$export$2e2bcd8739ae039 = $619255f9f9bf4a7a$var$baseTimes;





var $gOuvx = parcelRequire("gOuvx");
/** Used as references for various `Number` constants. */ var $9d474d218bfd304b$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $9d474d218bfd304b$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $9d474d218bfd304b$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $9d474d218bfd304b$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $9d474d218bfd304b$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $9d474d218bfd304b$export$2e2bcd8739ae039 = $9d474d218bfd304b$var$isIndex;



/** Used for built-in method references. */ var $d042652bb199f871$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d042652bb199f871$var$hasOwnProperty = $d042652bb199f871$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $d042652bb199f871$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $e1e43c41826225f5$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $cf391c46f49a2abc$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $gOuvx.default)(value), isType = !isArr && !isArg && !isBuff && (0, $8cd2e40924fc0dca$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $619255f9f9bf4a7a$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $d042652bb199f871$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $9d474d218bfd304b$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $d042652bb199f871$export$2e2bcd8739ae039 = $d042652bb199f871$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $39e87f4fb17bd415$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $39e87f4fb17bd415$export$2e2bcd8739ae039 = $39e87f4fb17bd415$var$nativeKeysIn;


/** Used for built-in method references. */ var $10d71806dfac88d9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $10d71806dfac88d9$var$hasOwnProperty = $10d71806dfac88d9$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $10d71806dfac88d9$var$baseKeysIn(object) {
    if (!(0, $93c2a573e5654f1c$export$2e2bcd8739ae039)(object)) return (0, $39e87f4fb17bd415$export$2e2bcd8739ae039)(object);
    var isProto = (0, $3f5aa1a0ade22f80$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$10d71806dfac88d9$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $10d71806dfac88d9$export$2e2bcd8739ae039 = $10d71806dfac88d9$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $db4124ed23017656$var$keysIn(object) {
    return (0, $630d935e7198011d$export$2e2bcd8739ae039)(object) ? (0, $d042652bb199f871$export$2e2bcd8739ae039)(object, true) : (0, $10d71806dfac88d9$export$2e2bcd8739ae039)(object);
}
var $db4124ed23017656$export$2e2bcd8739ae039 = $db4124ed23017656$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $db38d431067d9a62$var$toPlainObject(value) {
    return (0, $3f0629f91a10f8c7$export$2e2bcd8739ae039)(value, (0, $db4124ed23017656$export$2e2bcd8739ae039)(value));
}
var $db38d431067d9a62$export$2e2bcd8739ae039 = $db38d431067d9a62$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $f0b650f032be586b$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $29c0a89cf5c48e03$export$2e2bcd8739ae039)(object, key), srcValue = (0, $29c0a89cf5c48e03$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $9c413e1f645d4b68$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $e1e43c41826225f5$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $gOuvx.default)(srcValue), isTyped = !isArr && !isBuff && (0, $8cd2e40924fc0dca$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $e1e43c41826225f5$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $f2c9eeb156e03382$export$2e2bcd8739ae039)(objValue)) newValue = (0, $6009eaa83171db0e$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $236az.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $eda49e0fceb12242$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $28bde0497bc97fbf$export$2e2bcd8739ae039)(srcValue) || (0, $cf391c46f49a2abc$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $cf391c46f49a2abc$export$2e2bcd8739ae039)(objValue)) newValue = (0, $db38d431067d9a62$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $93c2a573e5654f1c$export$2e2bcd8739ae039)(objValue) || (0, $720c027e6702105e$export$2e2bcd8739ae039)(objValue)) newValue = (0, $684f74942bd33206$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, $9c413e1f645d4b68$export$2e2bcd8739ae039)(object, key, newValue);
}
var $f0b650f032be586b$export$2e2bcd8739ae039 = $f0b650f032be586b$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $e9b64300f7d9388e$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $b2f6beeaf13674f7$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $b0d2ef4e4882cf33$export$2e2bcd8739ae039));
        if ((0, $93c2a573e5654f1c$export$2e2bcd8739ae039)(srcValue)) (0, $f0b650f032be586b$export$2e2bcd8739ae039)(object, source, key, srcIndex, $e9b64300f7d9388e$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $29c0a89cf5c48e03$export$2e2bcd8739ae039)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $9c413e1f645d4b68$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $db4124ed23017656$export$2e2bcd8739ae039));
}
var $e9b64300f7d9388e$export$2e2bcd8739ae039 = $e9b64300f7d9388e$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $af759cf5734bacfd$var$identity(value) {
    return value;
}
var $af759cf5734bacfd$export$2e2bcd8739ae039 = $af759cf5734bacfd$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $25cf1d76055f3449$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $25cf1d76055f3449$export$2e2bcd8739ae039 = $25cf1d76055f3449$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $b14349e61c29cf60$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $b14349e61c29cf60$var$overRest(func, start, transform) {
    start = $b14349e61c29cf60$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $b14349e61c29cf60$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $25cf1d76055f3449$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $b14349e61c29cf60$export$2e2bcd8739ae039 = $b14349e61c29cf60$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $87aa1e8f9566bec8$var$constant(value) {
    return function() {
        return value;
    };
}
var $87aa1e8f9566bec8$export$2e2bcd8739ae039 = $87aa1e8f9566bec8$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $102c9d1c7a2585b0$var$baseSetToString = !(0, $28782a0851b63c00$export$2e2bcd8739ae039) ? (0, $af759cf5734bacfd$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $28782a0851b63c00$export$2e2bcd8739ae039)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $87aa1e8f9566bec8$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $102c9d1c7a2585b0$export$2e2bcd8739ae039 = $102c9d1c7a2585b0$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $1286742f2109eb96$var$HOT_COUNT = 800, $1286742f2109eb96$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1286742f2109eb96$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $1286742f2109eb96$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $1286742f2109eb96$var$nativeNow(), remaining = $1286742f2109eb96$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $1286742f2109eb96$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $1286742f2109eb96$export$2e2bcd8739ae039 = $1286742f2109eb96$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $ed18d6f3dacfabdd$var$setToString = (0, $1286742f2109eb96$export$2e2bcd8739ae039)((0, $102c9d1c7a2585b0$export$2e2bcd8739ae039));
var $ed18d6f3dacfabdd$export$2e2bcd8739ae039 = $ed18d6f3dacfabdd$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $aac7347089851915$var$baseRest(func, start) {
    return (0, $ed18d6f3dacfabdd$export$2e2bcd8739ae039)((0, $b14349e61c29cf60$export$2e2bcd8739ae039)(func, start, (0, $af759cf5734bacfd$export$2e2bcd8739ae039)), func + '');
}
var $aac7347089851915$export$2e2bcd8739ae039 = $aac7347089851915$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $bc5ee9429626e114$var$isIterateeCall(value, index, object) {
    if (!(0, $93c2a573e5654f1c$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, $630d935e7198011d$export$2e2bcd8739ae039)(object) && (0, $9d474d218bfd304b$export$2e2bcd8739ae039)(index, object.length) : type == 'string' && index in object) return (0, $dbc29436ab37b802$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $bc5ee9429626e114$export$2e2bcd8739ae039 = $bc5ee9429626e114$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $022f2633ec0538cd$var$createAssigner(assigner) {
    return (0, $aac7347089851915$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, $bc5ee9429626e114$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $022f2633ec0538cd$export$2e2bcd8739ae039 = $022f2633ec0538cd$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $0d18bb024fdf2a99$var$merge = (0, $022f2633ec0538cd$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $e9b64300f7d9388e$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $0d18bb024fdf2a99$export$2e2bcd8739ae039 = $0d18bb024fdf2a99$var$merge;


var $6a96e64db7f6a5d6$exports = {};

$parcel$export($6a96e64db7f6a5d6$exports, "Scope", () => $6a96e64db7f6a5d6$export$775b6bb06e53a214);
$parcel$export($6a96e64db7f6a5d6$exports, "Attributor", () => $6a96e64db7f6a5d6$export$217610c4183502d0);
$parcel$export($6a96e64db7f6a5d6$exports, "Registry", () => $6a96e64db7f6a5d6$export$4d9facee29974f3);
$parcel$export($6a96e64db7f6a5d6$exports, "ClassAttributor", () => $6a96e64db7f6a5d6$export$651d45509677cf07);
$parcel$export($6a96e64db7f6a5d6$exports, "StyleAttributor", () => $6a96e64db7f6a5d6$export$7c8099bbfe87b94d);
$parcel$export($6a96e64db7f6a5d6$exports, "AttributorStore", () => $6a96e64db7f6a5d6$export$68ad86ab95e8de42);
$parcel$export($6a96e64db7f6a5d6$exports, "LeafBlot", () => $6a96e64db7f6a5d6$export$7420b9c542181544);
$parcel$export($6a96e64db7f6a5d6$exports, "ParentBlot", () => $6a96e64db7f6a5d6$export$e43113f0aad76fe);
$parcel$export($6a96e64db7f6a5d6$exports, "InlineBlot", () => $6a96e64db7f6a5d6$export$f67a34bc25a7a861);
$parcel$export($6a96e64db7f6a5d6$exports, "BlockBlot", () => $6a96e64db7f6a5d6$export$4f7f03641f7bfc8c);
$parcel$export($6a96e64db7f6a5d6$exports, "ContainerBlot", () => $6a96e64db7f6a5d6$export$c898d510319704c0);
$parcel$export($6a96e64db7f6a5d6$exports, "EmbedBlot", () => $6a96e64db7f6a5d6$export$297a1fa96f55f00f);
$parcel$export($6a96e64db7f6a5d6$exports, "ScrollBlot", () => $6a96e64db7f6a5d6$export$7175329dad7a46f1);
$parcel$export($6a96e64db7f6a5d6$exports, "TextBlot", () => $6a96e64db7f6a5d6$export$10ac0c5716409de6);
var $6a96e64db7f6a5d6$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($6a96e64db7f6a5d6$export$775b6bb06e53a214 || {});
class $6a96e64db7f6a5d6$export$217610c4183502d0 {
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $6a96e64db7f6a5d6$export$775b6bb06e53a214.TYPE & $6a96e64db7f6a5d6$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $6a96e64db7f6a5d6$export$775b6bb06e53a214.LEVEL | attributeBit : $6a96e64db7f6a5d6$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
}
class $6a96e64db7f6a5d6$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $6a96e64db7f6a5d6$var$_Registry = class _Registry {
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $6a96e64db7f6a5d6$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $6a96e64db7f6a5d6$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $6a96e64db7f6a5d6$export$775b6bb06e53a214.LEVEL & $6a96e64db7f6a5d6$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $6a96e64db7f6a5d6$export$775b6bb06e53a214.LEVEL & $6a96e64db7f6a5d6$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $6a96e64db7f6a5d6$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $6a96e64db7f6a5d6$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $6a96e64db7f6a5d6$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $6a96e64db7f6a5d6$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
};
$6a96e64db7f6a5d6$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $6a96e64db7f6a5d6$export$4d9facee29974f3 = $6a96e64db7f6a5d6$var$_Registry;
function $6a96e64db7f6a5d6$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $6a96e64db7f6a5d6$var$ClassAttributor extends $6a96e64db7f6a5d6$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $6a96e64db7f6a5d6$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($6a96e64db7f6a5d6$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $6a96e64db7f6a5d6$export$651d45509677cf07 = $6a96e64db7f6a5d6$var$ClassAttributor;
function $6a96e64db7f6a5d6$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $6a96e64db7f6a5d6$var$StyleAttributor extends $6a96e64db7f6a5d6$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$6a96e64db7f6a5d6$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$6a96e64db7f6a5d6$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$6a96e64db7f6a5d6$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $6a96e64db7f6a5d6$export$7c8099bbfe87b94d = $6a96e64db7f6a5d6$var$StyleAttributor;
class $6a96e64db7f6a5d6$var$AttributorStore {
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $6a96e64db7f6a5d6$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $6a96e64db7f6a5d6$export$217610c4183502d0.keys(this.domNode), classes = $6a96e64db7f6a5d6$export$651d45509677cf07.keys(this.domNode), styles = $6a96e64db7f6a5d6$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $6a96e64db7f6a5d6$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $6a96e64db7f6a5d6$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
}
const $6a96e64db7f6a5d6$export$68ad86ab95e8de42 = $6a96e64db7f6a5d6$var$AttributorStore, $6a96e64db7f6a5d6$var$_ShadowBlot = class _ShadowBlot {
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $6a96e64db7f6a5d6$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
    static create(rawValue) {
        if (this.tagName == null) throw new $6a96e64db7f6a5d6$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $6a96e64db7f6a5d6$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $6a96e64db7f6a5d6$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $6a96e64db7f6a5d6$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $6a96e64db7f6a5d6$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
};
$6a96e64db7f6a5d6$var$_ShadowBlot.blotName = "abstract";
let $6a96e64db7f6a5d6$var$ShadowBlot = $6a96e64db7f6a5d6$var$_ShadowBlot;
const $6a96e64db7f6a5d6$var$_LeafBlot = class _LeafBlot extends $6a96e64db7f6a5d6$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$6a96e64db7f6a5d6$var$_LeafBlot.scope = $6a96e64db7f6a5d6$export$775b6bb06e53a214.INLINE_BLOT;
let $6a96e64db7f6a5d6$var$LeafBlot = $6a96e64db7f6a5d6$var$_LeafBlot;
const $6a96e64db7f6a5d6$export$7420b9c542181544 = $6a96e64db7f6a5d6$var$LeafBlot;
class $6a96e64db7f6a5d6$var$LinkedList {
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
}
function $6a96e64db7f6a5d6$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($6a96e64db7f6a5d6$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $6a96e64db7f6a5d6$var$_ParentBlot = class _ParentBlot extends $6a96e64db7f6a5d6$var$ShadowBlot {
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $6a96e64db7f6a5d6$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $6a96e64db7f6a5d6$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $6a96e64db7f6a5d6$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $6a96e64db7f6a5d6$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $6a96e64db7f6a5d6$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
};
$6a96e64db7f6a5d6$var$_ParentBlot.uiClass = "";
let $6a96e64db7f6a5d6$var$ParentBlot = $6a96e64db7f6a5d6$var$_ParentBlot;
const $6a96e64db7f6a5d6$export$e43113f0aad76fe = $6a96e64db7f6a5d6$var$ParentBlot;
function $6a96e64db7f6a5d6$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $6a96e64db7f6a5d6$var$_InlineBlot = class _InlineBlot extends $6a96e64db7f6a5d6$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $6a96e64db7f6a5d6$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $6a96e64db7f6a5d6$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $6a96e64db7f6a5d6$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $6a96e64db7f6a5d6$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $6a96e64db7f6a5d6$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
};
$6a96e64db7f6a5d6$var$_InlineBlot.allowedChildren = [
    $6a96e64db7f6a5d6$var$_InlineBlot,
    $6a96e64db7f6a5d6$export$7420b9c542181544
], $6a96e64db7f6a5d6$var$_InlineBlot.blotName = "inline", $6a96e64db7f6a5d6$var$_InlineBlot.scope = $6a96e64db7f6a5d6$export$775b6bb06e53a214.INLINE_BLOT, $6a96e64db7f6a5d6$var$_InlineBlot.tagName = "SPAN";
let $6a96e64db7f6a5d6$var$InlineBlot = $6a96e64db7f6a5d6$var$_InlineBlot;
const $6a96e64db7f6a5d6$export$f67a34bc25a7a861 = $6a96e64db7f6a5d6$var$InlineBlot, $6a96e64db7f6a5d6$var$_BlockBlot = class _BlockBlot extends $6a96e64db7f6a5d6$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $6a96e64db7f6a5d6$export$68ad86ab95e8de42(this.domNode);
    }
    format(name, value) {
        const format = this.scroll.query(name, $6a96e64db7f6a5d6$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $6a96e64db7f6a5d6$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $6a96e64db7f6a5d6$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $6a96e64db7f6a5d6$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
};
$6a96e64db7f6a5d6$var$_BlockBlot.blotName = "block", $6a96e64db7f6a5d6$var$_BlockBlot.scope = $6a96e64db7f6a5d6$export$775b6bb06e53a214.BLOCK_BLOT, $6a96e64db7f6a5d6$var$_BlockBlot.tagName = "P", $6a96e64db7f6a5d6$var$_BlockBlot.allowedChildren = [
    $6a96e64db7f6a5d6$export$f67a34bc25a7a861,
    $6a96e64db7f6a5d6$var$_BlockBlot,
    $6a96e64db7f6a5d6$export$7420b9c542181544
];
let $6a96e64db7f6a5d6$var$BlockBlot = $6a96e64db7f6a5d6$var$_BlockBlot;
const $6a96e64db7f6a5d6$export$4f7f03641f7bfc8c = $6a96e64db7f6a5d6$var$BlockBlot, $6a96e64db7f6a5d6$var$_ContainerBlot = class _ContainerBlot extends $6a96e64db7f6a5d6$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$6a96e64db7f6a5d6$var$_ContainerBlot.blotName = "container", $6a96e64db7f6a5d6$var$_ContainerBlot.scope = $6a96e64db7f6a5d6$export$775b6bb06e53a214.BLOCK_BLOT;
let $6a96e64db7f6a5d6$var$ContainerBlot = $6a96e64db7f6a5d6$var$_ContainerBlot;
const $6a96e64db7f6a5d6$export$c898d510319704c0 = $6a96e64db7f6a5d6$var$ContainerBlot;
class $6a96e64db7f6a5d6$var$EmbedBlot extends $6a96e64db7f6a5d6$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $6a96e64db7f6a5d6$export$297a1fa96f55f00f = $6a96e64db7f6a5d6$var$EmbedBlot, $6a96e64db7f6a5d6$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $6a96e64db7f6a5d6$var$MAX_OPTIMIZE_ITERATIONS = 100, $6a96e64db7f6a5d6$var$_ScrollBlot = class _ScrollBlot extends $6a96e64db7f6a5d6$export$e43113f0aad76fe {
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $6a96e64db7f6a5d6$var$OBSERVER_CONFIG), this.attach();
    }
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $6a96e64db7f6a5d6$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $6a96e64db7f6a5d6$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $6a96e64db7f6a5d6$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $6a96e64db7f6a5d6$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
};
$6a96e64db7f6a5d6$var$_ScrollBlot.blotName = "scroll", $6a96e64db7f6a5d6$var$_ScrollBlot.defaultChild = $6a96e64db7f6a5d6$export$4f7f03641f7bfc8c, $6a96e64db7f6a5d6$var$_ScrollBlot.allowedChildren = [
    $6a96e64db7f6a5d6$export$4f7f03641f7bfc8c,
    $6a96e64db7f6a5d6$export$c898d510319704c0
], $6a96e64db7f6a5d6$var$_ScrollBlot.scope = $6a96e64db7f6a5d6$export$775b6bb06e53a214.BLOCK_BLOT, $6a96e64db7f6a5d6$var$_ScrollBlot.tagName = "DIV";
let $6a96e64db7f6a5d6$var$ScrollBlot = $6a96e64db7f6a5d6$var$_ScrollBlot;
const $6a96e64db7f6a5d6$export$7175329dad7a46f1 = $6a96e64db7f6a5d6$var$ScrollBlot, $6a96e64db7f6a5d6$var$_TextBlot = class _TextBlot extends $6a96e64db7f6a5d6$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
};
$6a96e64db7f6a5d6$var$_TextBlot.blotName = "text", $6a96e64db7f6a5d6$var$_TextBlot.scope = $6a96e64db7f6a5d6$export$775b6bb06e53a214.INLINE_BLOT;
let $6a96e64db7f6a5d6$var$TextBlot = $6a96e64db7f6a5d6$var$_TextBlot;
const $6a96e64db7f6a5d6$export$10ac0c5716409de6 = $6a96e64db7f6a5d6$var$TextBlot;


var $a839195070a4070f$exports = {};
"use strict";
Object.defineProperty($a839195070a4070f$exports, "__esModule", {
    value: true
});
$a839195070a4070f$exports.AttributeMap = $a839195070a4070f$exports.OpIterator = $a839195070a4070f$exports.Op = void 0;
var $ad71fb025894dcfe$exports = {};
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $ad71fb025894dcfe$var$DIFF_DELETE = -1;
var $ad71fb025894dcfe$var$DIFF_INSERT = 1;
var $ad71fb025894dcfe$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $ad71fb025894dcfe$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $ad71fb025894dcfe$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $ad71fb025894dcfe$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $ad71fb025894dcfe$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $ad71fb025894dcfe$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $ad71fb025894dcfe$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $ad71fb025894dcfe$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $ad71fb025894dcfe$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $ad71fb025894dcfe$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $ad71fb025894dcfe$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $ad71fb025894dcfe$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $ad71fb025894dcfe$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $ad71fb025894dcfe$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $ad71fb025894dcfe$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $ad71fb025894dcfe$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $ad71fb025894dcfe$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $ad71fb025894dcfe$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $ad71fb025894dcfe$var$DIFF_DELETE,
            text1
        ],
        [
            $ad71fb025894dcfe$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $ad71fb025894dcfe$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $ad71fb025894dcfe$var$diff_main(text1_a, text2_a);
        var diffs_b = $ad71fb025894dcfe$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $ad71fb025894dcfe$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $ad71fb025894dcfe$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $ad71fb025894dcfe$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $ad71fb025894dcfe$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $ad71fb025894dcfe$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $ad71fb025894dcfe$var$DIFF_DELETE,
            text1
        ],
        [
            $ad71fb025894dcfe$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $ad71fb025894dcfe$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $ad71fb025894dcfe$var$diff_main(text1a, text2a);
    var diffsb = $ad71fb025894dcfe$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $ad71fb025894dcfe$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($ad71fb025894dcfe$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $ad71fb025894dcfe$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $ad71fb025894dcfe$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($ad71fb025894dcfe$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $ad71fb025894dcfe$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $ad71fb025894dcfe$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $ad71fb025894dcfe$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $ad71fb025894dcfe$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $ad71fb025894dcfe$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $ad71fb025894dcfe$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $ad71fb025894dcfe$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $ad71fb025894dcfe$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $ad71fb025894dcfe$var$diff_cleanupMerge(diffs);
    $ad71fb025894dcfe$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $ad71fb025894dcfe$var$DIFF_DELETE && diffs[pointer][0] == $ad71fb025894dcfe$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $ad71fb025894dcfe$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $ad71fb025894dcfe$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $ad71fb025894dcfe$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $ad71fb025894dcfe$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $ad71fb025894dcfe$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $ad71fb025894dcfe$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $ad71fb025894dcfe$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $ad71fb025894dcfe$var$whitespaceRegex_ = /\s/;
var $ad71fb025894dcfe$var$linebreakRegex_ = /[\r\n]/;
var $ad71fb025894dcfe$var$blanklineEndRegex_ = /\n\r?\n$/;
var $ad71fb025894dcfe$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $ad71fb025894dcfe$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($ad71fb025894dcfe$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($ad71fb025894dcfe$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($ad71fb025894dcfe$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($ad71fb025894dcfe$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($ad71fb025894dcfe$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($ad71fb025894dcfe$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($ad71fb025894dcfe$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($ad71fb025894dcfe$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $ad71fb025894dcfe$var$DIFF_EQUAL && diffs[pointer + 1][0] == $ad71fb025894dcfe$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $ad71fb025894dcfe$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $ad71fb025894dcfe$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $ad71fb025894dcfe$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $ad71fb025894dcfe$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $ad71fb025894dcfe$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $ad71fb025894dcfe$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $ad71fb025894dcfe$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $ad71fb025894dcfe$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $ad71fb025894dcfe$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($ad71fb025894dcfe$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $ad71fb025894dcfe$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $ad71fb025894dcfe$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $ad71fb025894dcfe$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $ad71fb025894dcfe$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $ad71fb025894dcfe$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $ad71fb025894dcfe$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $ad71fb025894dcfe$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $ad71fb025894dcfe$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $ad71fb025894dcfe$var$DIFF_EQUAL && diffs[pointer + 1][0] === $ad71fb025894dcfe$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $ad71fb025894dcfe$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $ad71fb025894dcfe$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $ad71fb025894dcfe$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $ad71fb025894dcfe$var$starts_with_pair_end(str) {
    return $ad71fb025894dcfe$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $ad71fb025894dcfe$var$ends_with_pair_start(str) {
    return $ad71fb025894dcfe$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $ad71fb025894dcfe$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $ad71fb025894dcfe$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($ad71fb025894dcfe$var$ends_with_pair_start(before) || $ad71fb025894dcfe$var$starts_with_pair_end(after)) return null;
    return $ad71fb025894dcfe$var$remove_empty_tuples([
        [
            $ad71fb025894dcfe$var$DIFF_EQUAL,
            before
        ],
        [
            $ad71fb025894dcfe$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $ad71fb025894dcfe$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $ad71fb025894dcfe$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $ad71fb025894dcfe$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $ad71fb025894dcfe$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $ad71fb025894dcfe$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $ad71fb025894dcfe$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $ad71fb025894dcfe$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $ad71fb025894dcfe$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$ad71fb025894dcfe$var$diff.INSERT = $ad71fb025894dcfe$var$DIFF_INSERT;
$ad71fb025894dcfe$var$diff.DELETE = $ad71fb025894dcfe$var$DIFF_DELETE;
$ad71fb025894dcfe$var$diff.EQUAL = $ad71fb025894dcfe$var$DIFF_EQUAL;
$ad71fb025894dcfe$exports = $ad71fb025894dcfe$var$diff;



var $4nFPU = parcelRequire("4nFPU");

var $dvnvv = parcelRequire("dvnvv");
var $aece1e0a7da7d486$exports = {};
"use strict";
Object.defineProperty($aece1e0a7da7d486$exports, "__esModule", {
    value: true
});

var $4nFPU = parcelRequire("4nFPU");

var $dvnvv = parcelRequire("dvnvv");
var $aece1e0a7da7d486$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        let attributes = $4nFPU(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== 'object') a = {};
        if (typeof b !== 'object') b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$dvnvv(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== 'object') return b;
        if (typeof b !== 'object') return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($aece1e0a7da7d486$var$AttributeMap || ($aece1e0a7da7d486$var$AttributeMap = {}));
$aece1e0a7da7d486$exports.default = $aece1e0a7da7d486$var$AttributeMap;


$a839195070a4070f$exports.AttributeMap = $aece1e0a7da7d486$exports.default;
var $b00480459ad0ef68$exports = {};
"use strict";
Object.defineProperty($b00480459ad0ef68$exports, "__esModule", {
    value: true
});
var $b00480459ad0ef68$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === 'number') return op.delete;
        else if (typeof op.retain === 'number') return op.retain;
        else if (typeof op.retain === 'object' && op.retain !== null) return 1;
        else return typeof op.insert === 'string' ? op.insert.length : 1;
    }
    Op.length = length;
})($b00480459ad0ef68$var$Op || ($b00480459ad0ef68$var$Op = {}));
$b00480459ad0ef68$exports.default = $b00480459ad0ef68$var$Op;


$a839195070a4070f$exports.Op = $b00480459ad0ef68$exports.default;
var $f2f523d2d910e6cd$exports = {};
"use strict";
Object.defineProperty($f2f523d2d910e6cd$exports, "__esModule", {
    value: true
});

class $f2f523d2d910e6cd$var$Iterator {
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $b00480459ad0ef68$exports.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === 'number') return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === 'number') retOp.retain = length;
                else if (typeof nextOp.retain === 'object' && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === 'string') retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $b00480459ad0ef68$exports.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === 'number') return 'delete';
            else if (typeof op.retain === 'number' || typeof op.retain === 'object' && op.retain !== null) return 'retain';
            else return 'insert';
        }
        return 'retain';
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
}
$f2f523d2d910e6cd$exports.default = $f2f523d2d910e6cd$var$Iterator;


$a839195070a4070f$exports.OpIterator = $f2f523d2d910e6cd$exports.default;
const $a839195070a4070f$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $a839195070a4070f$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== 'object' || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== 'object' || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $a839195070a4070f$var$Delta {
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === 'string' && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === 'number' && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $4nFPU(newOp);
        if (typeof lastOp === 'object') {
            if (typeof newOp.delete === 'number' && typeof lastOp.delete === 'number') {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === 'number' && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== 'object') {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($dvnvv(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === 'number' && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $b00480459ad0ef68$exports.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $b00480459ad0ef68$exports.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $f2f523d2d910e6cd$exports.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $b00480459ad0ef68$exports.default.length(nextOp);
        }
        return new $a839195070a4070f$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $f2f523d2d910e6cd$exports.default(this.ops);
        const otherIter = new $f2f523d2d910e6cd$exports.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $a839195070a4070f$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else if (thisIter.peekType() === 'delete') delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === 'number') newOp.retain = typeof otherOp.retain === 'number' ? length : otherOp.retain;
                    else if (typeof otherOp.retain === 'number') {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? 'insert' : 'retain';
                        const [embedType, thisData, otherData] = $a839195070a4070f$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $a839195070a4070f$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === 'retain')
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $aece1e0a7da7d486$exports.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $dvnvv(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $a839195070a4070f$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === 'number' && (typeof thisOp.retain === 'number' || typeof thisOp.retain === 'object' && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $a839195070a4070f$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $a839195070a4070f$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === 'string' ? op.insert : $a839195070a4070f$var$NULL_CHARACTER;
                const prep = delta === other ? 'on' : 'with';
                throw new Error('diff() called ' + prep + ' non-document');
            }).join('');
        });
        const retDelta = new $a839195070a4070f$var$Delta();
        const diffResult = $ad71fb025894dcfe$exports(strings[0], strings[1], cursor, true);
        const thisIter = new $f2f523d2d910e6cd$exports.default(this.ops);
        const otherIter = new $f2f523d2d910e6cd$exports.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $ad71fb025894dcfe$exports.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $ad71fb025894dcfe$exports.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $ad71fb025894dcfe$exports.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($dvnvv(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $aece1e0a7da7d486$exports.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = '\n') {
        const iter = new $f2f523d2d910e6cd$exports.default(this.ops);
        let line = new $a839195070a4070f$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== 'insert') return;
            const thisOp = iter.peek();
            const start = $b00480459ad0ef68$exports.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $a839195070a4070f$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $a839195070a4070f$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($b00480459ad0ef68$exports.default.length(op));
            else if (typeof op.retain === 'number' && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === 'number') {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($b00480459ad0ef68$exports.default.length(baseOp), $aece1e0a7da7d486$exports.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === 'object' && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $f2f523d2d910e6cd$exports.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $a839195070a4070f$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $a839195070a4070f$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $aece1e0a7da7d486$exports.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === 'number') return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $f2f523d2d910e6cd$exports.default(this.ops);
        const otherIter = new $f2f523d2d910e6cd$exports.default(other.ops);
        const delta = new $a839195070a4070f$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) delta.retain($b00480459ad0ef68$exports.default.length(thisIter.next()));
            else if (otherIter.peekType() === 'insert') delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === 'object' && otherData !== null ? otherData : length;
                    if (typeof thisData === 'object' && thisData !== null && typeof otherData === 'object' && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $a839195070a4070f$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $aece1e0a7da7d486$exports.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $f2f523d2d910e6cd$exports.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === 'delete') {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === 'insert' && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
}
$a839195070a4070f$var$Delta.Op = $b00480459ad0ef68$exports.default;
$a839195070a4070f$var$Delta.OpIterator = $f2f523d2d910e6cd$exports.default;
$a839195070a4070f$var$Delta.AttributeMap = $aece1e0a7da7d486$exports.default;
$a839195070a4070f$var$Delta.handlers = {};
$a839195070a4070f$exports.default = $a839195070a4070f$var$Delta;
$a839195070a4070f$exports = $a839195070a4070f$var$Delta;
$a839195070a4070f$exports.default = $a839195070a4070f$var$Delta;



/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $1a60ec8871bd2d17$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $1a60ec8871bd2d17$export$2e2bcd8739ae039 = $1a60ec8871bd2d17$var$arrayEach;







/* Built-in method references for those with the same name as other `lodash` methods. */ var $d56ab425ed6c0504$var$nativeKeys = (0, $90e09751e96f1c48$export$2e2bcd8739ae039)(Object.keys, Object);
var $d56ab425ed6c0504$export$2e2bcd8739ae039 = $d56ab425ed6c0504$var$nativeKeys;


/** Used for built-in method references. */ var $c852532953196771$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c852532953196771$var$hasOwnProperty = $c852532953196771$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c852532953196771$var$baseKeys(object) {
    if (!(0, $3f5aa1a0ade22f80$export$2e2bcd8739ae039)(object)) return (0, $d56ab425ed6c0504$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($c852532953196771$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $c852532953196771$export$2e2bcd8739ae039 = $c852532953196771$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0247d2bbf743bc1a$var$keys(object) {
    return (0, $630d935e7198011d$export$2e2bcd8739ae039)(object) ? (0, $d042652bb199f871$export$2e2bcd8739ae039)(object) : (0, $c852532953196771$export$2e2bcd8739ae039)(object);
}
var $0247d2bbf743bc1a$export$2e2bcd8739ae039 = $0247d2bbf743bc1a$var$keys;


/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $afbdfd9bbbb8839b$var$baseAssign(object, source) {
    return object && (0, $3f0629f91a10f8c7$export$2e2bcd8739ae039)(source, (0, $0247d2bbf743bc1a$export$2e2bcd8739ae039)(source), object);
}
var $afbdfd9bbbb8839b$export$2e2bcd8739ae039 = $afbdfd9bbbb8839b$var$baseAssign;




/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $2cf6c8a73d2025a7$var$baseAssignIn(object, source) {
    return object && (0, $3f0629f91a10f8c7$export$2e2bcd8739ae039)(source, (0, $db4124ed23017656$export$2e2bcd8739ae039)(source), object);
}
var $2cf6c8a73d2025a7$export$2e2bcd8739ae039 = $2cf6c8a73d2025a7$var$baseAssignIn;



var $236az = parcelRequire("236az");


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $383a2e6283bfe720$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $383a2e6283bfe720$export$2e2bcd8739ae039 = $383a2e6283bfe720$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $e4ecaf1013201d81$var$stubArray() {
    return [];
}
var $e4ecaf1013201d81$export$2e2bcd8739ae039 = $e4ecaf1013201d81$var$stubArray;


/** Used for built-in method references. */ var $63b0c6fa5be836d8$var$objectProto = Object.prototype;
/** Built-in value references. */ var $63b0c6fa5be836d8$var$propertyIsEnumerable = $63b0c6fa5be836d8$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $63b0c6fa5be836d8$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $63b0c6fa5be836d8$var$getSymbols = !$63b0c6fa5be836d8$var$nativeGetSymbols ? (0, $e4ecaf1013201d81$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $383a2e6283bfe720$export$2e2bcd8739ae039)($63b0c6fa5be836d8$var$nativeGetSymbols(object), function(symbol) {
        return $63b0c6fa5be836d8$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $63b0c6fa5be836d8$export$2e2bcd8739ae039 = $63b0c6fa5be836d8$var$getSymbols;


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $34a546720d327866$var$copySymbols(source, object) {
    return (0, $3f0629f91a10f8c7$export$2e2bcd8739ae039)(source, (0, $63b0c6fa5be836d8$export$2e2bcd8739ae039)(source), object);
}
var $34a546720d327866$export$2e2bcd8739ae039 = $34a546720d327866$var$copySymbols;



/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $f3de146aa0489594$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $f3de146aa0489594$export$2e2bcd8739ae039 = $f3de146aa0489594$var$arrayPush;





/* Built-in method references for those with the same name as other `lodash` methods. */ var $3df5a57134608f03$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $3df5a57134608f03$var$getSymbolsIn = !$3df5a57134608f03$var$nativeGetSymbols ? (0, $e4ecaf1013201d81$export$2e2bcd8739ae039) : function(object) {
    var result = [];
    while(object){
        (0, $f3de146aa0489594$export$2e2bcd8739ae039)(result, (0, $63b0c6fa5be836d8$export$2e2bcd8739ae039)(object));
        object = (0, $95b36e26b327bbac$export$2e2bcd8739ae039)(object);
    }
    return result;
};
var $3df5a57134608f03$export$2e2bcd8739ae039 = $3df5a57134608f03$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $f0aea56dcdbb79a6$var$copySymbolsIn(source, object) {
    return (0, $3f0629f91a10f8c7$export$2e2bcd8739ae039)(source, (0, $3df5a57134608f03$export$2e2bcd8739ae039)(source), object);
}
var $f0aea56dcdbb79a6$export$2e2bcd8739ae039 = $f0aea56dcdbb79a6$var$copySymbolsIn;




/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $51ce3e82e2b3b31b$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $e1e43c41826225f5$export$2e2bcd8739ae039)(object) ? result : (0, $f3de146aa0489594$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $51ce3e82e2b3b31b$export$2e2bcd8739ae039 = $51ce3e82e2b3b31b$var$baseGetAllKeys;




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $046c603b9316ca84$var$getAllKeys(object) {
    return (0, $51ce3e82e2b3b31b$export$2e2bcd8739ae039)(object, (0, $0247d2bbf743bc1a$export$2e2bcd8739ae039), (0, $63b0c6fa5be836d8$export$2e2bcd8739ae039));
}
var $046c603b9316ca84$export$2e2bcd8739ae039 = $046c603b9316ca84$var$getAllKeys;





/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0bc2f1e66d5251dd$var$getAllKeysIn(object) {
    return (0, $51ce3e82e2b3b31b$export$2e2bcd8739ae039)(object, (0, $db4124ed23017656$export$2e2bcd8739ae039), (0, $3df5a57134608f03$export$2e2bcd8739ae039));
}
var $0bc2f1e66d5251dd$export$2e2bcd8739ae039 = $0bc2f1e66d5251dd$var$getAllKeysIn;




var $iVn1G = parcelRequire("iVn1G");
/* Built-in method references that are verified to be native. */ var $9be7b620d3618eaf$var$DataView = (0, $8b5fb0ec341a7744$export$2e2bcd8739ae039)((0, $iVn1G.default), 'DataView');
var $9be7b620d3618eaf$export$2e2bcd8739ae039 = $9be7b620d3618eaf$var$DataView;





var $iVn1G = parcelRequire("iVn1G");
/* Built-in method references that are verified to be native. */ var $54e8ab85f40d839c$var$Promise = (0, $8b5fb0ec341a7744$export$2e2bcd8739ae039)((0, $iVn1G.default), 'Promise');
var $54e8ab85f40d839c$export$2e2bcd8739ae039 = $54e8ab85f40d839c$var$Promise;




var $iVn1G = parcelRequire("iVn1G");
/* Built-in method references that are verified to be native. */ var $ee26370b9d1e7121$var$Set = (0, $8b5fb0ec341a7744$export$2e2bcd8739ae039)((0, $iVn1G.default), 'Set');
var $ee26370b9d1e7121$export$2e2bcd8739ae039 = $ee26370b9d1e7121$var$Set;




var $iVn1G = parcelRequire("iVn1G");
/* Built-in method references that are verified to be native. */ var $c1b7aa85b0a63297$var$WeakMap = (0, $8b5fb0ec341a7744$export$2e2bcd8739ae039)((0, $iVn1G.default), 'WeakMap');
var $c1b7aa85b0a63297$export$2e2bcd8739ae039 = $c1b7aa85b0a63297$var$WeakMap;




/** `Object#toString` result references. */ var $a24abd576db57982$var$mapTag = '[object Map]', $a24abd576db57982$var$objectTag = '[object Object]', $a24abd576db57982$var$promiseTag = '[object Promise]', $a24abd576db57982$var$setTag = '[object Set]', $a24abd576db57982$var$weakMapTag = '[object WeakMap]';
var $a24abd576db57982$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $a24abd576db57982$var$dataViewCtorString = (0, $979e61571b0ba362$export$2e2bcd8739ae039)((0, $9be7b620d3618eaf$export$2e2bcd8739ae039)), $a24abd576db57982$var$mapCtorString = (0, $979e61571b0ba362$export$2e2bcd8739ae039)((0, $3573bc93ddb5f9de$export$2e2bcd8739ae039)), $a24abd576db57982$var$promiseCtorString = (0, $979e61571b0ba362$export$2e2bcd8739ae039)((0, $54e8ab85f40d839c$export$2e2bcd8739ae039)), $a24abd576db57982$var$setCtorString = (0, $979e61571b0ba362$export$2e2bcd8739ae039)((0, $ee26370b9d1e7121$export$2e2bcd8739ae039)), $a24abd576db57982$var$weakMapCtorString = (0, $979e61571b0ba362$export$2e2bcd8739ae039)((0, $c1b7aa85b0a63297$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $a24abd576db57982$var$getTag = (0, $fdccbd91d6abc4f1$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $9be7b620d3618eaf$export$2e2bcd8739ae039) && $a24abd576db57982$var$getTag(new (0, $9be7b620d3618eaf$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $a24abd576db57982$var$dataViewTag || (0, $3573bc93ddb5f9de$export$2e2bcd8739ae039) && $a24abd576db57982$var$getTag(new (0, $3573bc93ddb5f9de$export$2e2bcd8739ae039)) != $a24abd576db57982$var$mapTag || (0, $54e8ab85f40d839c$export$2e2bcd8739ae039) && $a24abd576db57982$var$getTag((0, $54e8ab85f40d839c$export$2e2bcd8739ae039).resolve()) != $a24abd576db57982$var$promiseTag || (0, $ee26370b9d1e7121$export$2e2bcd8739ae039) && $a24abd576db57982$var$getTag(new (0, $ee26370b9d1e7121$export$2e2bcd8739ae039)) != $a24abd576db57982$var$setTag || (0, $c1b7aa85b0a63297$export$2e2bcd8739ae039) && $a24abd576db57982$var$getTag(new (0, $c1b7aa85b0a63297$export$2e2bcd8739ae039)) != $a24abd576db57982$var$weakMapTag) $a24abd576db57982$var$getTag = function(value) {
    var result = (0, $fdccbd91d6abc4f1$export$2e2bcd8739ae039)(value), Ctor = result == $a24abd576db57982$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $979e61571b0ba362$export$2e2bcd8739ae039)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $a24abd576db57982$var$dataViewCtorString:
            return $a24abd576db57982$var$dataViewTag;
        case $a24abd576db57982$var$mapCtorString:
            return $a24abd576db57982$var$mapTag;
        case $a24abd576db57982$var$promiseCtorString:
            return $a24abd576db57982$var$promiseTag;
        case $a24abd576db57982$var$setCtorString:
            return $a24abd576db57982$var$setTag;
        case $a24abd576db57982$var$weakMapCtorString:
            return $a24abd576db57982$var$weakMapTag;
    }
    return result;
};
var $a24abd576db57982$export$2e2bcd8739ae039 = $a24abd576db57982$var$getTag;


/** Used for built-in method references. */ var $c2d17c39492b1bd6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c2d17c39492b1bd6$var$hasOwnProperty = $c2d17c39492b1bd6$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $c2d17c39492b1bd6$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $c2d17c39492b1bd6$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $c2d17c39492b1bd6$export$2e2bcd8739ae039 = $c2d17c39492b1bd6$var$initCloneArray;




/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $3eff886253dcfe49$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $ca5a74d92c48812b$export$2e2bcd8739ae039)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $3eff886253dcfe49$export$2e2bcd8739ae039 = $3eff886253dcfe49$var$cloneDataView;


/** Used to match `RegExp` flags from their coerced string values. */ var $1ded88c019f08bf0$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $1ded88c019f08bf0$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $1ded88c019f08bf0$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $1ded88c019f08bf0$export$2e2bcd8739ae039 = $1ded88c019f08bf0$var$cloneRegExp;



/** Used to convert symbols to primitives and strings. */ var $62dea56e50f8b0c2$var$symbolProto = (0, $df164a84fc8de2ea$export$2e2bcd8739ae039) ? (0, $df164a84fc8de2ea$export$2e2bcd8739ae039).prototype : undefined, $62dea56e50f8b0c2$var$symbolValueOf = $62dea56e50f8b0c2$var$symbolProto ? $62dea56e50f8b0c2$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $62dea56e50f8b0c2$var$cloneSymbol(symbol) {
    return $62dea56e50f8b0c2$var$symbolValueOf ? Object($62dea56e50f8b0c2$var$symbolValueOf.call(symbol)) : {};
}
var $62dea56e50f8b0c2$export$2e2bcd8739ae039 = $62dea56e50f8b0c2$var$cloneSymbol;



/** `Object#toString` result references. */ var $ea293ded2161574b$var$boolTag = '[object Boolean]', $ea293ded2161574b$var$dateTag = '[object Date]', $ea293ded2161574b$var$mapTag = '[object Map]', $ea293ded2161574b$var$numberTag = '[object Number]', $ea293ded2161574b$var$regexpTag = '[object RegExp]', $ea293ded2161574b$var$setTag = '[object Set]', $ea293ded2161574b$var$stringTag = '[object String]', $ea293ded2161574b$var$symbolTag = '[object Symbol]';
var $ea293ded2161574b$var$arrayBufferTag = '[object ArrayBuffer]', $ea293ded2161574b$var$dataViewTag = '[object DataView]', $ea293ded2161574b$var$float32Tag = '[object Float32Array]', $ea293ded2161574b$var$float64Tag = '[object Float64Array]', $ea293ded2161574b$var$int8Tag = '[object Int8Array]', $ea293ded2161574b$var$int16Tag = '[object Int16Array]', $ea293ded2161574b$var$int32Tag = '[object Int32Array]', $ea293ded2161574b$var$uint8Tag = '[object Uint8Array]', $ea293ded2161574b$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ea293ded2161574b$var$uint16Tag = '[object Uint16Array]', $ea293ded2161574b$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ea293ded2161574b$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ea293ded2161574b$var$arrayBufferTag:
            return (0, $ca5a74d92c48812b$export$2e2bcd8739ae039)(object);
        case $ea293ded2161574b$var$boolTag:
        case $ea293ded2161574b$var$dateTag:
            return new Ctor(+object);
        case $ea293ded2161574b$var$dataViewTag:
            return (0, $3eff886253dcfe49$export$2e2bcd8739ae039)(object, isDeep);
        case $ea293ded2161574b$var$float32Tag:
        case $ea293ded2161574b$var$float64Tag:
        case $ea293ded2161574b$var$int8Tag:
        case $ea293ded2161574b$var$int16Tag:
        case $ea293ded2161574b$var$int32Tag:
        case $ea293ded2161574b$var$uint8Tag:
        case $ea293ded2161574b$var$uint8ClampedTag:
        case $ea293ded2161574b$var$uint16Tag:
        case $ea293ded2161574b$var$uint32Tag:
            return (0, $eda49e0fceb12242$export$2e2bcd8739ae039)(object, isDeep);
        case $ea293ded2161574b$var$mapTag:
            return new Ctor;
        case $ea293ded2161574b$var$numberTag:
        case $ea293ded2161574b$var$stringTag:
            return new Ctor(object);
        case $ea293ded2161574b$var$regexpTag:
            return (0, $1ded88c019f08bf0$export$2e2bcd8739ae039)(object);
        case $ea293ded2161574b$var$setTag:
            return new Ctor;
        case $ea293ded2161574b$var$symbolTag:
            return (0, $62dea56e50f8b0c2$export$2e2bcd8739ae039)(object);
    }
}
var $ea293ded2161574b$export$2e2bcd8739ae039 = $ea293ded2161574b$var$initCloneByTag;





var $gOuvx = parcelRequire("gOuvx");


/** `Object#toString` result references. */ var $09cb4a38c67676ed$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $09cb4a38c67676ed$var$baseIsMap(value) {
    return (0, $26b42760ff368506$export$2e2bcd8739ae039)(value) && (0, $a24abd576db57982$export$2e2bcd8739ae039)(value) == $09cb4a38c67676ed$var$mapTag;
}
var $09cb4a38c67676ed$export$2e2bcd8739ae039 = $09cb4a38c67676ed$var$baseIsMap;




var $jiWCt = parcelRequire("jiWCt");
/* Node.js helper references. */ var $925d841abb781d6a$var$nodeIsMap = (0, $jiWCt.default) && (0, $jiWCt.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $925d841abb781d6a$var$isMap = $925d841abb781d6a$var$nodeIsMap ? (0, $351c0f28de3092c5$export$2e2bcd8739ae039)($925d841abb781d6a$var$nodeIsMap) : (0, $09cb4a38c67676ed$export$2e2bcd8739ae039);
var $925d841abb781d6a$export$2e2bcd8739ae039 = $925d841abb781d6a$var$isMap;





/** `Object#toString` result references. */ var $6e58adadac15a00a$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $6e58adadac15a00a$var$baseIsSet(value) {
    return (0, $26b42760ff368506$export$2e2bcd8739ae039)(value) && (0, $a24abd576db57982$export$2e2bcd8739ae039)(value) == $6e58adadac15a00a$var$setTag;
}
var $6e58adadac15a00a$export$2e2bcd8739ae039 = $6e58adadac15a00a$var$baseIsSet;




var $jiWCt = parcelRequire("jiWCt");
/* Node.js helper references. */ var $b3e9490efdb0abe3$var$nodeIsSet = (0, $jiWCt.default) && (0, $jiWCt.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $b3e9490efdb0abe3$var$isSet = $b3e9490efdb0abe3$var$nodeIsSet ? (0, $351c0f28de3092c5$export$2e2bcd8739ae039)($b3e9490efdb0abe3$var$nodeIsSet) : (0, $6e58adadac15a00a$export$2e2bcd8739ae039);
var $b3e9490efdb0abe3$export$2e2bcd8739ae039 = $b3e9490efdb0abe3$var$isSet;




/** Used to compose bitmasks for cloning. */ var $1a79d83cf67c59ad$var$CLONE_DEEP_FLAG = 1, $1a79d83cf67c59ad$var$CLONE_FLAT_FLAG = 2, $1a79d83cf67c59ad$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $1a79d83cf67c59ad$var$argsTag = '[object Arguments]', $1a79d83cf67c59ad$var$arrayTag = '[object Array]', $1a79d83cf67c59ad$var$boolTag = '[object Boolean]', $1a79d83cf67c59ad$var$dateTag = '[object Date]', $1a79d83cf67c59ad$var$errorTag = '[object Error]', $1a79d83cf67c59ad$var$funcTag = '[object Function]', $1a79d83cf67c59ad$var$genTag = '[object GeneratorFunction]', $1a79d83cf67c59ad$var$mapTag = '[object Map]', $1a79d83cf67c59ad$var$numberTag = '[object Number]', $1a79d83cf67c59ad$var$objectTag = '[object Object]', $1a79d83cf67c59ad$var$regexpTag = '[object RegExp]', $1a79d83cf67c59ad$var$setTag = '[object Set]', $1a79d83cf67c59ad$var$stringTag = '[object String]', $1a79d83cf67c59ad$var$symbolTag = '[object Symbol]', $1a79d83cf67c59ad$var$weakMapTag = '[object WeakMap]';
var $1a79d83cf67c59ad$var$arrayBufferTag = '[object ArrayBuffer]', $1a79d83cf67c59ad$var$dataViewTag = '[object DataView]', $1a79d83cf67c59ad$var$float32Tag = '[object Float32Array]', $1a79d83cf67c59ad$var$float64Tag = '[object Float64Array]', $1a79d83cf67c59ad$var$int8Tag = '[object Int8Array]', $1a79d83cf67c59ad$var$int16Tag = '[object Int16Array]', $1a79d83cf67c59ad$var$int32Tag = '[object Int32Array]', $1a79d83cf67c59ad$var$uint8Tag = '[object Uint8Array]', $1a79d83cf67c59ad$var$uint8ClampedTag = '[object Uint8ClampedArray]', $1a79d83cf67c59ad$var$uint16Tag = '[object Uint16Array]', $1a79d83cf67c59ad$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $1a79d83cf67c59ad$var$cloneableTags = {};
$1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$argsTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$arrayTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$arrayBufferTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$dataViewTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$boolTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$dateTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$float32Tag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$float64Tag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$int8Tag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$int16Tag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$int32Tag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$mapTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$numberTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$objectTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$regexpTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$setTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$stringTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$symbolTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$uint8Tag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$uint8ClampedTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$uint16Tag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$uint32Tag] = true;
$1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$errorTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$funcTag] = $1a79d83cf67c59ad$var$cloneableTags[$1a79d83cf67c59ad$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $1a79d83cf67c59ad$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $1a79d83cf67c59ad$var$CLONE_DEEP_FLAG, isFlat = bitmask & $1a79d83cf67c59ad$var$CLONE_FLAT_FLAG, isFull = bitmask & $1a79d83cf67c59ad$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $93c2a573e5654f1c$export$2e2bcd8739ae039)(value)) return value;
    var isArr = (0, $e1e43c41826225f5$export$2e2bcd8739ae039)(value);
    if (isArr) {
        result = (0, $c2d17c39492b1bd6$export$2e2bcd8739ae039)(value);
        if (!isDeep) return (0, $6009eaa83171db0e$export$2e2bcd8739ae039)(value, result);
    } else {
        var tag = (0, $a24abd576db57982$export$2e2bcd8739ae039)(value), isFunc = tag == $1a79d83cf67c59ad$var$funcTag || tag == $1a79d83cf67c59ad$var$genTag;
        if ((0, $gOuvx.default)(value)) return (0, $236az.default)(value, isDeep);
        if (tag == $1a79d83cf67c59ad$var$objectTag || tag == $1a79d83cf67c59ad$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $684f74942bd33206$export$2e2bcd8739ae039)(value);
            if (!isDeep) return isFlat ? (0, $f0aea56dcdbb79a6$export$2e2bcd8739ae039)(value, (0, $2cf6c8a73d2025a7$export$2e2bcd8739ae039)(result, value)) : (0, $34a546720d327866$export$2e2bcd8739ae039)(value, (0, $afbdfd9bbbb8839b$export$2e2bcd8739ae039)(result, value));
        } else {
            if (!$1a79d83cf67c59ad$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $ea293ded2161574b$export$2e2bcd8739ae039)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $b0d2ef4e4882cf33$export$2e2bcd8739ae039));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $b3e9490efdb0abe3$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue) {
        result.add($1a79d83cf67c59ad$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $925d841abb781d6a$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue, key) {
        result.set(key, $1a79d83cf67c59ad$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $0bc2f1e66d5251dd$export$2e2bcd8739ae039) : (0, $046c603b9316ca84$export$2e2bcd8739ae039) : isFlat ? (0, $db4124ed23017656$export$2e2bcd8739ae039) : (0, $0247d2bbf743bc1a$export$2e2bcd8739ae039);
    var props = isArr ? undefined : keysFunc(value);
    (0, $1a60ec8871bd2d17$export$2e2bcd8739ae039)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $84792e76731e08dc$export$2e2bcd8739ae039)(result, key, $1a79d83cf67c59ad$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $1a79d83cf67c59ad$export$2e2bcd8739ae039 = $1a79d83cf67c59ad$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $4f6f5140da0ed5e7$var$CLONE_DEEP_FLAG = 1, $4f6f5140da0ed5e7$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $4f6f5140da0ed5e7$var$cloneDeep(value) {
    return (0, $1a79d83cf67c59ad$export$2e2bcd8739ae039)(value, $4f6f5140da0ed5e7$var$CLONE_DEEP_FLAG | $4f6f5140da0ed5e7$var$CLONE_SYMBOLS_FLAG);
}
var $4f6f5140da0ed5e7$export$2e2bcd8739ae039 = $4f6f5140da0ed5e7$var$cloneDeep;



/** Used to stand-in for `undefined` hash values. */ var $ec4160da25bb788e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $ec4160da25bb788e$var$setCacheAdd(value) {
    this.__data__.set(value, $ec4160da25bb788e$var$HASH_UNDEFINED);
    return this;
}
var $ec4160da25bb788e$export$2e2bcd8739ae039 = $ec4160da25bb788e$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $18cb1861e8c64e99$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $18cb1861e8c64e99$export$2e2bcd8739ae039 = $18cb1861e8c64e99$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $6f6d258c4108ab4c$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $7a59bad03a5ce0e2$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$6f6d258c4108ab4c$var$SetCache.prototype.add = $6f6d258c4108ab4c$var$SetCache.prototype.push = (0, $ec4160da25bb788e$export$2e2bcd8739ae039);
$6f6d258c4108ab4c$var$SetCache.prototype.has = (0, $18cb1861e8c64e99$export$2e2bcd8739ae039);
var $6f6d258c4108ab4c$export$2e2bcd8739ae039 = $6f6d258c4108ab4c$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $e5b842d8974c7c03$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $e5b842d8974c7c03$export$2e2bcd8739ae039 = $e5b842d8974c7c03$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4155dd0cd2052d7c$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $4155dd0cd2052d7c$export$2e2bcd8739ae039 = $4155dd0cd2052d7c$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $e2ccf83c42a09d13$var$COMPARE_PARTIAL_FLAG = 1, $e2ccf83c42a09d13$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $e2ccf83c42a09d13$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e2ccf83c42a09d13$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $e2ccf83c42a09d13$var$COMPARE_UNORDERED_FLAG ? new (0, $6f6d258c4108ab4c$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $e5b842d8974c7c03$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $4155dd0cd2052d7c$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var $e2ccf83c42a09d13$export$2e2bcd8739ae039 = $e2ccf83c42a09d13$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $4141a745237d1836$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $4141a745237d1836$export$2e2bcd8739ae039 = $4141a745237d1836$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $faf8bfb50e5afe5f$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $faf8bfb50e5afe5f$export$2e2bcd8739ae039 = $faf8bfb50e5afe5f$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $00a3db7f613fe504$var$COMPARE_PARTIAL_FLAG = 1, $00a3db7f613fe504$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $00a3db7f613fe504$var$boolTag = '[object Boolean]', $00a3db7f613fe504$var$dateTag = '[object Date]', $00a3db7f613fe504$var$errorTag = '[object Error]', $00a3db7f613fe504$var$mapTag = '[object Map]', $00a3db7f613fe504$var$numberTag = '[object Number]', $00a3db7f613fe504$var$regexpTag = '[object RegExp]', $00a3db7f613fe504$var$setTag = '[object Set]', $00a3db7f613fe504$var$stringTag = '[object String]', $00a3db7f613fe504$var$symbolTag = '[object Symbol]';
var $00a3db7f613fe504$var$arrayBufferTag = '[object ArrayBuffer]', $00a3db7f613fe504$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $00a3db7f613fe504$var$symbolProto = (0, $df164a84fc8de2ea$export$2e2bcd8739ae039) ? (0, $df164a84fc8de2ea$export$2e2bcd8739ae039).prototype : undefined, $00a3db7f613fe504$var$symbolValueOf = $00a3db7f613fe504$var$symbolProto ? $00a3db7f613fe504$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $00a3db7f613fe504$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $00a3db7f613fe504$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $00a3db7f613fe504$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $83305cda8efe6c03$export$2e2bcd8739ae039)(object), new (0, $83305cda8efe6c03$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $00a3db7f613fe504$var$boolTag:
        case $00a3db7f613fe504$var$dateTag:
        case $00a3db7f613fe504$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $dbc29436ab37b802$export$2e2bcd8739ae039)(+object, +other);
        case $00a3db7f613fe504$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $00a3db7f613fe504$var$regexpTag:
        case $00a3db7f613fe504$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $00a3db7f613fe504$var$mapTag:
            var convert = (0, $4141a745237d1836$export$2e2bcd8739ae039);
        case $00a3db7f613fe504$var$setTag:
            var isPartial = bitmask & $00a3db7f613fe504$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $faf8bfb50e5afe5f$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $00a3db7f613fe504$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $e2ccf83c42a09d13$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $00a3db7f613fe504$var$symbolTag:
            if ($00a3db7f613fe504$var$symbolValueOf) return $00a3db7f613fe504$var$symbolValueOf.call(object) == $00a3db7f613fe504$var$symbolValueOf.call(other);
    }
    return false;
}
var $00a3db7f613fe504$export$2e2bcd8739ae039 = $00a3db7f613fe504$var$equalByTag;



/** Used to compose bitmasks for value comparisons. */ var $667ab7d3f4935ffa$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $667ab7d3f4935ffa$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $667ab7d3f4935ffa$var$hasOwnProperty = $667ab7d3f4935ffa$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $667ab7d3f4935ffa$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $667ab7d3f4935ffa$var$COMPARE_PARTIAL_FLAG, objProps = (0, $046c603b9316ca84$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $046c603b9316ca84$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $667ab7d3f4935ffa$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var $667ab7d3f4935ffa$export$2e2bcd8739ae039 = $667ab7d3f4935ffa$var$equalObjects;





var $gOuvx = parcelRequire("gOuvx");

/** Used to compose bitmasks for value comparisons. */ var $8909554aad5e1037$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $8909554aad5e1037$var$argsTag = '[object Arguments]', $8909554aad5e1037$var$arrayTag = '[object Array]', $8909554aad5e1037$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $8909554aad5e1037$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8909554aad5e1037$var$hasOwnProperty = $8909554aad5e1037$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $8909554aad5e1037$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $e1e43c41826225f5$export$2e2bcd8739ae039)(object), othIsArr = (0, $e1e43c41826225f5$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $8909554aad5e1037$var$arrayTag : (0, $a24abd576db57982$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $8909554aad5e1037$var$arrayTag : (0, $a24abd576db57982$export$2e2bcd8739ae039)(other);
    objTag = objTag == $8909554aad5e1037$var$argsTag ? $8909554aad5e1037$var$objectTag : objTag;
    othTag = othTag == $8909554aad5e1037$var$argsTag ? $8909554aad5e1037$var$objectTag : othTag;
    var objIsObj = objTag == $8909554aad5e1037$var$objectTag, othIsObj = othTag == $8909554aad5e1037$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $gOuvx.default)(object)) {
        if (!(0, $gOuvx.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $b0d2ef4e4882cf33$export$2e2bcd8739ae039));
        return objIsArr || (0, $8cd2e40924fc0dca$export$2e2bcd8739ae039)(object) ? (0, $e2ccf83c42a09d13$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $00a3db7f613fe504$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $8909554aad5e1037$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $8909554aad5e1037$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $8909554aad5e1037$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $b0d2ef4e4882cf33$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $b0d2ef4e4882cf33$export$2e2bcd8739ae039));
    return (0, $667ab7d3f4935ffa$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $8909554aad5e1037$export$2e2bcd8739ae039 = $8909554aad5e1037$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $04187b6ede021955$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $26b42760ff368506$export$2e2bcd8739ae039)(value) && !(0, $26b42760ff368506$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $8909554aad5e1037$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $04187b6ede021955$var$baseIsEqual, stack);
}
var $04187b6ede021955$export$2e2bcd8739ae039 = $04187b6ede021955$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $09c2bf1171a90432$var$isEqual(value, other) {
    return (0, $04187b6ede021955$export$2e2bcd8739ae039)(value, other);
}
var $09c2bf1171a90432$export$2e2bcd8739ae039 = $09c2bf1171a90432$var$isEqual;







class $01df5b50ebe61a4f$var$Break extends (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return '';
    }
}
$01df5b50ebe61a4f$var$Break.blotName = 'break';
$01df5b50ebe61a4f$var$Break.tagName = 'BR';
var $01df5b50ebe61a4f$export$2e2bcd8739ae039 = $01df5b50ebe61a4f$var$Break;





class $0223954ca10581a2$export$2e2bcd8739ae039 extends (0, $6a96e64db7f6a5d6$export$10ac0c5716409de6) {
}
// https://lodash.com/docs#escape
const $0223954ca10581a2$var$entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
function $0223954ca10581a2$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>$0223954ca10581a2$var$entityMap[s]);
}


class $ef46692c8d3ac68f$var$Inline extends (0, $6a96e64db7f6a5d6$export$f67a34bc25a7a861) {
    static allowedChildren = [
        $ef46692c8d3ac68f$var$Inline,
        (0, $01df5b50ebe61a4f$export$2e2bcd8739ae039),
        (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f),
        (0, $0223954ca10581a2$export$2e2bcd8739ae039)
    ];
    // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
    static order = [
        'cursor',
        'inline',
        // Must be lower
        'link',
        // Chrome wants <a> to be lower
        'underline',
        'strike',
        'italic',
        'bold',
        'script',
        'code' // Must be higher
    ];
    static compare(self, other) {
        const selfIndex = $ef46692c8d3ac68f$var$Inline.order.indexOf(self);
        const otherIndex = $ef46692c8d3ac68f$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($ef46692c8d3ac68f$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $ef46692c8d3ac68f$var$Inline && $ef46692c8d3ac68f$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
var $ef46692c8d3ac68f$export$2e2bcd8739ae039 = $ef46692c8d3ac68f$var$Inline;



const $7936fb1ed367d695$var$NEWLINE_LENGTH = 1;
class $7936fb1ed367d695$export$2e2bcd8739ae039 extends (0, $6a96e64db7f6a5d6$export$4f7f03641f7bfc8c) {
    cache = {};
    delta() {
        if (this.cache.delta == null) this.cache.delta = $7936fb1ed367d695$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split('\n');
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $01df5b50ebe61a4f$export$2e2bcd8739ae039)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $7936fb1ed367d695$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $7936fb1ed367d695$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
}
$7936fb1ed367d695$export$2e2bcd8739ae039.blotName = 'block';
$7936fb1ed367d695$export$2e2bcd8739ae039.tagName = 'P';
$7936fb1ed367d695$export$2e2bcd8739ae039.defaultChild = (0, $01df5b50ebe61a4f$export$2e2bcd8739ae039);
$7936fb1ed367d695$export$2e2bcd8739ae039.allowedChildren = [
    (0, $01df5b50ebe61a4f$export$2e2bcd8739ae039),
    (0, $ef46692c8d3ac68f$export$2e2bcd8739ae039),
    (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f),
    (0, $0223954ca10581a2$export$2e2bcd8739ae039)
];
class $7936fb1ed367d695$export$48b9f0688962d028 extends (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f) {
    attach() {
        super.attach();
        this.attributes = new (0, $6a96e64db7f6a5d6$export$68ad86ab95e8de42)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split('\n');
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($7936fb1ed367d695$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create('text', text), ref);
    }
}
$7936fb1ed367d695$export$48b9f0688962d028.scope = (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $7936fb1ed367d695$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $6a96e64db7f6a5d6$export$7420b9c542181544)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $7936fb1ed367d695$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))()).insert('\n', $7936fb1ed367d695$export$e4bb5a6163449612(blot));
}
function $7936fb1ed367d695$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ('formats' in blot && typeof blot.formats === 'function') {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats['code-token'];
    }
    if (blot.parent == null || blot.parent.statics.blotName === 'scroll' || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $7936fb1ed367d695$export$e4bb5a6163449612(blot.parent, formats, filter);
}





class $838ba222167c4d97$var$Cursor extends (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f) {
    static blotName = 'cursor';
    static className = 'ql-cursor';
    static tagName = 'span';
    static CONTENTS = '\uFEFF';
    static value() {
        return undefined;
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($838ba222167c4d97$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $838ba222167c4d97$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $838ba222167c4d97$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $0223954ca10581a2$export$2e2bcd8739ae039) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $0223954ca10581a2$export$2e2bcd8739ae039) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : '';
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($838ba222167c4d97$var$Cursor.CONTENTS).join('');
        textNode.data = $838ba222167c4d97$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === 'characterData' && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === 'A') {
                this.savedLength = $838ba222167c4d97$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return '';
    }
}
var $838ba222167c4d97$export$2e2bcd8739ae039 = $838ba222167c4d97$var$Cursor;





var $e66f5e687dd086ab$exports = {};
'use strict';
var $e66f5e687dd086ab$var$has = Object.prototype.hasOwnProperty, $e66f5e687dd086ab$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $e66f5e687dd086ab$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $e66f5e687dd086ab$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $e66f5e687dd086ab$var$Events().__proto__) $e66f5e687dd086ab$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $e66f5e687dd086ab$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $e66f5e687dd086ab$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $e66f5e687dd086ab$var$EE(fn, context || emitter, once), evt = $e66f5e687dd086ab$var$prefix ? $e66f5e687dd086ab$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $e66f5e687dd086ab$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $e66f5e687dd086ab$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $e66f5e687dd086ab$var$EventEmitter() {
    this._events = new $e66f5e687dd086ab$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $e66f5e687dd086ab$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($e66f5e687dd086ab$var$has.call(events, name)) names.push($e66f5e687dd086ab$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $e66f5e687dd086ab$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $e66f5e687dd086ab$var$prefix ? $e66f5e687dd086ab$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $e66f5e687dd086ab$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $e66f5e687dd086ab$var$prefix ? $e66f5e687dd086ab$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $e66f5e687dd086ab$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $e66f5e687dd086ab$var$prefix ? $e66f5e687dd086ab$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $e66f5e687dd086ab$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $e66f5e687dd086ab$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $e66f5e687dd086ab$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $e66f5e687dd086ab$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $e66f5e687dd086ab$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $e66f5e687dd086ab$var$prefix ? $e66f5e687dd086ab$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $e66f5e687dd086ab$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $e66f5e687dd086ab$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $e66f5e687dd086ab$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $e66f5e687dd086ab$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $e66f5e687dd086ab$var$prefix ? $e66f5e687dd086ab$var$prefix + event : event;
        if (this._events[evt]) $e66f5e687dd086ab$var$clearEvent(this, evt);
    } else {
        this._events = new $e66f5e687dd086ab$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$e66f5e687dd086ab$var$EventEmitter.prototype.off = $e66f5e687dd086ab$var$EventEmitter.prototype.removeListener;
$e66f5e687dd086ab$var$EventEmitter.prototype.addListener = $e66f5e687dd086ab$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$e66f5e687dd086ab$var$EventEmitter.prefixed = $e66f5e687dd086ab$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$e66f5e687dd086ab$var$EventEmitter.EventEmitter = $e66f5e687dd086ab$var$EventEmitter;
$e66f5e687dd086ab$exports = $e66f5e687dd086ab$var$EventEmitter;


var $9ffa927ca45856f2$export$2e2bcd8739ae039 = new WeakMap();


const $2b9568fe518fbc26$var$levels = [
    'error',
    'warn',
    'log',
    'info'
];
let $2b9568fe518fbc26$var$level = 'warn';
function $2b9568fe518fbc26$var$debug(method) {
    if ($2b9568fe518fbc26$var$level) {
        if ($2b9568fe518fbc26$var$levels.indexOf(method) <= $2b9568fe518fbc26$var$levels.indexOf($2b9568fe518fbc26$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $2b9568fe518fbc26$var$namespace(ns) {
    return $2b9568fe518fbc26$var$levels.reduce((logger, method)=>{
        logger[method] = $2b9568fe518fbc26$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$2b9568fe518fbc26$var$namespace.level = (newLevel)=>{
    $2b9568fe518fbc26$var$level = newLevel;
};
$2b9568fe518fbc26$var$debug.level = $2b9568fe518fbc26$var$namespace.level;
var $2b9568fe518fbc26$export$2e2bcd8739ae039 = $2b9568fe518fbc26$var$namespace;


const $1afdc0502a30db43$var$debug = (0, $2b9568fe518fbc26$export$2e2bcd8739ae039)('quill:events');
const $1afdc0502a30db43$var$EVENTS = [
    'selectionchange',
    'mousedown',
    'mouseup',
    'click'
];
$1afdc0502a30db43$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll('.ql-container')).forEach((node)=>{
            const quill = (0, $9ffa927ca45856f2$export$2e2bcd8739ae039).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $1afdc0502a30db43$var$Emitter extends (0, $e66f5e687dd086ab$exports.EventEmitter) {
    static events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_BLOT_MOUNT: 'scroll-blot-mount',
        SCROLL_BLOT_UNMOUNT: 'scroll-blot-unmount',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SCROLL_EMBED_UPDATE: 'scroll-embed-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change',
        COMPOSITION_BEFORE_START: 'composition-before-start',
        COMPOSITION_START: 'composition-start',
        COMPOSITION_BEFORE_END: 'composition-before-end',
        COMPOSITION_END: 'composition-end'
    };
    static sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
    };
    constructor(){
        super();
        this.domListeners = {};
        this.on('error', $1afdc0502a30db43$var$debug.error);
    }
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $1afdc0502a30db43$var$debug.log.call($1afdc0502a30db43$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
}
var $1afdc0502a30db43$export$2e2bcd8739ae039 = $1afdc0502a30db43$var$Emitter;



const $a5020f719d503ef6$var$debug = (0, $2b9568fe518fbc26$export$2e2bcd8739ae039)('quill:selection');
class $a5020f719d503ef6$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $a5020f719d503ef6$var$Selection {
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create('cursor', this);
        // savedRange is last non-null range
        this.savedRange = new $a5020f719d503ef6$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM('selectionchange', document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER), 1);
        });
        this.emitter.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === 'characterData' || mutation.type === 'childList' || mutation.type === 'attributes' && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.SILENT);
            }
        });
        this.update((0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.SILENT);
    }
    handleComposition() {
        this.emitter.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM('mousedown', document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM('mouseup', document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $6a96e64db7f6a5d6$export$7420b9c542181544)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = 'left';
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = 'right';
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = 'right';
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $a5020f719d503ef6$var$debug.info('getNativeRange', range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ('isConnected' in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $a5020f719d503ef6$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $6a96e64db7f6a5d6$export$7420b9c542181544)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $a5020f719d503ef6$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$a5020f719d503ef6$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$a5020f719d503ef6$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $a5020f719d503ef6$var$debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === 'BR') {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.API;
        if (typeof force === 'string') {
            source = force;
            force = false;
        }
        $a5020f719d503ef6$var$debug.info('setRange', range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $09c2bf1171a90432$export$2e2bcd8739ae039)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SELECTION_CHANGE,
                (0, $4f6f5140da0ed5e7$export$2e2bcd8739ae039)(this.lastRange),
                (0, $4f6f5140da0ed5e7$export$2e2bcd8739ae039)(oldRange),
                source
            ];
            this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
        }
    }
}
function $a5020f719d503ef6$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $a5020f719d503ef6$export$2e2bcd8739ae039 = $a5020f719d503ef6$var$Selection;


const $1d98dbd418614b4d$var$ASCII = /^[ -~]*$/;
class $1d98dbd418614b4d$var$Editor {
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $1d98dbd418614b4d$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))();
        const normalizedOps = $1d98dbd418614b4d$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $a839195070a4070f$exports.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === 'string') {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith('\n') && (scrollLength <= index || !!this.scroll.descendant((0, $7936fb1ed367d695$export$48b9f0688962d028), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $0d18bb024fdf2a99$export$2e2bcd8739ae039)({}, (0, $7936fb1ed367d695$export$e4bb5a6163449612)(line));
                    if (line instanceof (0, $7936fb1ed367d695$export$2e2bcd8739ae039)) {
                        const [leaf] = line.descendant((0, $6a96e64db7f6a5d6$export$7420b9c542181544), offset);
                        if (leaf) formats = (0, $0d18bb024fdf2a99$export$2e2bcd8739ae039)(formats, (0, $7936fb1ed367d695$export$e4bb5a6163449612)(leaf));
                    }
                    attributes = (0, $a839195070a4070f$exports.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === 'object') {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $7936fb1ed367d695$export$48b9f0688962d028), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $6a96e64db7f6a5d6$export$7420b9c542181544), index - 1);
                        if (leaf instanceof (0, $0223954ca10581a2$export$2e2bcd8739ae039)) {
                            const text = leaf.value();
                            if (text[offset] !== '\n') isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f) && leaf.statics.scope === (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $6a96e64db7f6a5d6$export$7420b9c542181544), index);
                        if (leaf) {
                            const formats = (0, $0d18bb024fdf2a99$export$2e2bcd8739ae039)({}, (0, $7936fb1ed367d695$export$e4bb5a6163449612)(leaf));
                            attributes = (0, $a839195070a4070f$exports.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === 'object') {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === 'number') {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $a839195070a4070f$exports.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).retain(length, (0, $4f6f5140da0ed5e7$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).retain(length, (0, $4f6f5140da0ed5e7$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $7936fb1ed367d695$export$2e2bcd8739ae039)) lines.push(blot);
            else if (blot instanceof (0, $6a96e64db7f6a5d6$export$7420b9c542181544)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $6a96e64db7f6a5d6$export$7420b9c542181544), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $7936fb1ed367d695$export$e4bb5a6163449612)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $1d98dbd418614b4d$var$combineFormats((0, $7936fb1ed367d695$export$e4bb5a6163449612)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $1d98dbd418614b4d$var$convertHTML(line, lineOffset, length, true);
            return $1d98dbd418614b4d$var$convertHTML(this.scroll, index, length, true);
        }
        return '';
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === 'string').map((op)=>op.insert).join('');
    }
    insertContents(index, contents) {
        const normalizedDelta = $1d98dbd418614b4d$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).insert(text, (0, $4f6f5140da0ed5e7$export$2e2bcd8739ae039)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $7936fb1ed367d695$export$2e2bcd8739ae039).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $01df5b50ebe61a4f$export$2e2bcd8739ae039);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === 'characterData' && // @ts-expect-error Fix me later
        mutations[0].target.data.match($1d98dbd418614b4d$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $7936fb1ed367d695$export$e4bb5a6163449612)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $838ba222167c4d97$export$2e2bcd8739ae039).CONTENTS, '');
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $1d98dbd418614b4d$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $1d98dbd418614b4d$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $09c2bf1171a90432$export$2e2bcd8739ae039)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
}
function $1d98dbd418614b4d$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $1d98dbd418614b4d$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$1d98dbd418614b4d$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $1d98dbd418614b4d$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$1d98dbd418614b4d$var$convertHTML(child, offset, length)}${$1d98dbd418614b4d$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$1d98dbd418614b4d$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$1d98dbd418614b4d$var$convertHTML(child, offset, length)}${$1d98dbd418614b4d$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $1d98dbd418614b4d$var$getListType(types.pop());
    return `</li></${endTag}>${$1d98dbd418614b4d$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $1d98dbd418614b4d$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ('html' in blot && typeof blot.html === 'function') return blot.html(index, length);
    if (blot instanceof (0, $0223954ca10581a2$export$2e2bcd8739ae039)) {
        const escapedText = (0, $0223954ca10581a2$export$96e6fc3a139b2555)(blot.value().slice(index, index + length));
        return escapedText.replaceAll(' ', '&nbsp;');
    }
    if (blot instanceof (0, $6a96e64db7f6a5d6$export$e43113f0aad76fe)) {
        // TODO fix API
        if (blot.statics.blotName === 'list-container') {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = 'formats' in child && typeof child.formats === 'function' ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $1d98dbd418614b4d$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($1d98dbd418614b4d$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === 'list') return parts.join('');
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === '<table') return `<table style="border: 1px solid #000;">${parts.join('')}<${end}`;
        return `${start}>${parts.join('')}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : '';
}
function $1d98dbd418614b4d$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $1d98dbd418614b4d$var$getListType(type) {
    const tag = type === 'ordered' ? 'ol' : 'ul';
    switch(type){
        case 'checked':
            return [
                tag,
                ' data-list="checked"'
            ];
        case 'unchecked':
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ''
            ];
    }
}
function $1d98dbd418614b4d$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === 'string') {
            const text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))());
}
function $1d98dbd418614b4d$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $a5020f719d503ef6$export$9a58ef0d7ad3278c)(index + amount, length);
}
function $1d98dbd418614b4d$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === 'string') {
            const lines = op.insert.split('\n');
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: '\n',
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $1d98dbd418614b4d$export$2e2bcd8739ae039 = $1d98dbd418614b4d$var$Editor;





class $62fec3ecd9958ea0$var$Module {
    static DEFAULTS = {};
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
var $62fec3ecd9958ea0$export$2e2bcd8739ae039 = $62fec3ecd9958ea0$var$Module;





const $d9edc4b08d80ecb5$var$GUARD_TEXT = '\uFEFF';
class $d9edc4b08d80ecb5$var$Embed extends (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f) {
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement('span');
        this.contentNode.setAttribute('contenteditable', 'false');
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($d9edc4b08d80ecb5$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($d9edc4b08d80ecb5$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($d9edc4b08d80ecb5$var$GUARD_TEXT).join('');
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $0223954ca10581a2$export$2e2bcd8739ae039)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $0223954ca10581a2$export$2e2bcd8739ae039)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $d9edc4b08d80ecb5$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === 'characterData' && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
}
var $d9edc4b08d80ecb5$export$2e2bcd8739ae039 = $d9edc4b08d80ecb5$var$Embed;



class $f19cb1343450aa70$var$Composition {
    isComposing = false;
    constructor(scroll, emitter){
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
    setupListeners() {
        this.scroll.domNode.addEventListener('compositionstart', (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener('compositionend', (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $d9edc4b08d80ecb5$export$2e2bcd8739ae039))) {
            this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
}
var $f19cb1343450aa70$export$2e2bcd8739ae039 = $f19cb1343450aa70$var$Composition;


class $e05344d517000266$var$Theme {
    static DEFAULTS = {
        modules: {}
    };
    static themes = {
        default: $e05344d517000266$var$Theme
    };
    modules = {};
    constructor(quill, options){
        this.quill = quill;
        this.options = options;
    }
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
}
var $e05344d517000266$export$2e2bcd8739ae039 = $e05344d517000266$var$Theme;


const $5547738c3308bac5$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $5547738c3308bac5$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = 'offsetWidth' in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = 'offsetHeight' in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $5547738c3308bac5$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $5547738c3308bac5$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $5547738c3308bac5$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $5547738c3308bac5$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $5547738c3308bac5$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $5547738c3308bac5$var$paddingValueToInt(style.scrollPaddingLeft), $5547738c3308bac5$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $5547738c3308bac5$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $5547738c3308bac5$var$paddingValueToInt(style.scrollPaddingTop), $5547738c3308bac5$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === 'fixed' ? null : $5547738c3308bac5$var$getParentElement(current);
    }
};
var $5547738c3308bac5$export$2e2bcd8739ae039 = $5547738c3308bac5$var$scrollRectIntoView;



const $41492e62654edb4d$var$MAX_REGISTER_ITERATIONS = 100;
const $41492e62654edb4d$var$CORE_FORMATS = [
    'block',
    'break',
    'cursor',
    'inline',
    'scroll',
    'text'
];
const $41492e62654edb4d$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $6a96e64db7f6a5d6$export$4d9facee29974f3)();
    $41492e62654edb4d$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = 'blotName' in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $41492e62654edb4d$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $41492e62654edb4d$export$2e2bcd8739ae039 = $41492e62654edb4d$var$createRegistryWithFormats;


const $6c63a051452c3514$var$debug = (0, $2b9568fe518fbc26$export$2e2bcd8739ae039)('quill');
const $6c63a051452c3514$export$bc58ce2776ecdb6f = new $6a96e64db7f6a5d6$exports.Registry();
$6a96e64db7f6a5d6$exports.ParentBlot.uiClass = 'ql-ui';
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $6c63a051452c3514$export$2e2bcd8739ae039 {
    static DEFAULTS = {
        bounds: null,
        modules: {
            clipboard: true,
            keyboard: true,
            history: true,
            uploader: true
        },
        placeholder: '',
        readOnly: false,
        registry: $6c63a051452c3514$export$bc58ce2776ecdb6f,
        theme: 'default'
    };
    static events = (0, $1afdc0502a30db43$export$2e2bcd8739ae039).events;
    static sources = (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources;
    static version = "2.0.3";
    static imports = {
        delta: (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports))),
        parchment: $6a96e64db7f6a5d6$exports,
        'core/module': (0, $62fec3ecd9958ea0$export$2e2bcd8739ae039),
        'core/theme': (0, $e05344d517000266$export$2e2bcd8739ae039)
    };
    static debug(limit) {
        if (limit === true) limit = 'log';
        (0, $2b9568fe518fbc26$export$2e2bcd8739ae039).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $9ffa927ca45856f2$export$2e2bcd8739ae039).get(node) || $6c63a051452c3514$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $6c63a051452c3514$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== 'string') {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = 'attrName' in target ? target.attrName : target.blotName;
            if (typeof name === 'string') // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $6c63a051452c3514$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith('blots/') || path.startsWith('formats/')) && target && typeof target !== 'boolean' && target.blotName !== 'abstract') $6c63a051452c3514$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === 'function') target.register($6c63a051452c3514$export$bc58ce2776ecdb6f);
        }
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $6c63a051452c3514$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $6c63a051452c3514$var$debug.error('Invalid Quill container', container);
            return;
        }
        if (this.options.debug) $6c63a051452c3514$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add('ql-container');
        this.container.innerHTML = '';
        (0, $9ffa927ca45856f2$export$2e2bcd8739ae039).set(this.container, this);
        this.root = this.addContainer('ql-editor');
        this.root.classList.add('ql-blank');
        this.emitter = new (0, $1afdc0502a30db43$export$2e2bcd8739ae039)();
        const scrollBlotName = $6a96e64db7f6a5d6$exports.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !('blotName' in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $1d98dbd418614b4d$export$2e2bcd8739ae039)(this.scroll);
        this.selection = new (0, $a5020f719d503ef6$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.composition = new (0, $f19cb1343450aa70$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule('keyboard');
        this.clipboard = this.theme.addModule('clipboard');
        this.history = this.theme.addModule('history');
        this.uploader = this.theme.addModule('uploader');
        this.theme.addModule('input');
        this.theme.addModule('uiNode');
        this.theme.init();
        this.emitter.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.TEXT_CHANGE) this.root.classList.toggle('ql-blank', this.editor.isBlank());
        });
        this.emitter.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $6c63a051452c3514$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $6c63a051452c3514$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $6c63a051452c3514$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: '\n'
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute('data-placeholder', this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === 'string') {
            const className = container;
            container = document.createElement('div');
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $6c63a051452c3514$export$e336952123c0bccd(index, length, source);
        return $6c63a051452c3514$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle('ql-disabled', !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.API;
        return $6c63a051452c3514$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))();
            if (range == null) return change;
            if (this.scroll.query(name, $6a96e64db7f6a5d6$exports.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $6c63a051452c3514$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $6c63a051452c3514$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $6c63a051452c3514$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $6c63a051452c3514$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === 'number') bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $6c63a051452c3514$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === 'number') return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== 'number') return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $6c63a051452c3514$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === 'number') length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $6c63a051452c3514$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $6c63a051452c3514$export$2e2bcd8739ae039.sources.API;
        return $6c63a051452c3514$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $6c63a051452c3514$export$e336952123c0bccd(index, 0, name, value, source);
        return $6c63a051452c3514$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $6c63a051452c3514$export$e336952123c0bccd(index, length, source);
        return $6c63a051452c3514$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $5547738c3308bac5$export$2e2bcd8739ae039)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn('Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.');
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.API;
        return $6c63a051452c3514$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $6c63a051452c3514$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $6c63a051452c3514$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $a5020f719d503ef6$export$9a58ef0d7ad3278c)(Math.max(0, index), length), source);
            if (source !== (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.API;
        return $6c63a051452c3514$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
}
function $6c63a051452c3514$var$resolveSelector(selector) {
    return typeof selector === 'string' ? document.querySelector(selector) : selector;
}
function $6c63a051452c3514$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $6c63a051452c3514$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $6c63a051452c3514$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $6c63a051452c3514$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error('Invalid Quill container');
    const shouldUseDefaultTheme = !options.theme || options.theme === $6c63a051452c3514$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $e05344d517000266$export$2e2bcd8739ae039) : $6c63a051452c3514$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $6c63a051452c3514$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $6c63a051452c3514$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $0d18bb024fdf2a99$export$2e2bcd8739ae039)({}, $6c63a051452c3514$var$expandModuleConfig(quillModuleDefaults), $6c63a051452c3514$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$6c63a051452c3514$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$6c63a051452c3514$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $6c63a051452c3514$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $41492e62654edb4d$export$2e2bcd8739ae039)(options.formats, config.registry, $6c63a051452c3514$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $6c63a051452c3514$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $6c63a051452c3514$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $0d18bb024fdf2a99$export$2e2bcd8739ae039)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $6c63a051452c3514$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $6c63a051452c3514$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $6c63a051452c3514$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $6c63a051452c3514$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $6c63a051452c3514$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === 'number' && typeof index.length === 'number') {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== 'number') {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== 'number') {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === 'object') {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === 'string') {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $6c63a051452c3514$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === 'number' ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === 'function') [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $a5020f719d503ef6$export$9a58ef0d7ad3278c)(start, end - start);
}





class $9f0c19bdc7022f30$var$Container extends (0, $6a96e64db7f6a5d6$export$c898d510319704c0) {
}
var $9f0c19bdc7022f30$export$2e2bcd8739ae039 = $9f0c19bdc7022f30$var$Container;











function $5582395c1372c6cd$var$isLine(blot) {
    return blot instanceof (0, $7936fb1ed367d695$export$2e2bcd8739ae039) || blot instanceof (0, $7936fb1ed367d695$export$48b9f0688962d028);
}
function $5582395c1372c6cd$var$isUpdatable(blot) {
    return typeof blot.updateContent === 'function';
}
class $5582395c1372c6cd$var$Scroll extends (0, $6a96e64db7f6a5d6$export$7175329dad7a46f1) {
    static blotName = 'scroll';
    static className = 'ql-editor';
    static tagName = 'DIV';
    static defaultChild = (0, $7936fb1ed367d695$export$2e2bcd8739ae039);
    static allowedChildren = [
        (0, $7936fb1ed367d695$export$2e2bcd8739ae039),
        (0, $7936fb1ed367d695$export$48b9f0688962d028),
        (0, $9f0c19bdc7022f30$export$2e2bcd8739ae039)
    ];
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener('dragstart', (e)=>this.handleDragStart(e));
    }
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $7936fb1ed367d695$export$48b9f0688962d028) || last instanceof (0, $7936fb1ed367d695$export$48b9f0688962d028)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $01df5b50ebe61a4f$export$2e2bcd8739ae039) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute('contenteditable', enabled ? 'true' : 'false');
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert('\n')));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === 'block' && (first.delta.length() === 0 || !this.descendant((0, $7936fb1ed367d695$export$48b9f0688962d028), index)[0] && index < this.length());
            const delta = first.type === 'block' ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert({
                [first.key]: first.value
            });
            $5582395c1372c6cd$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === 'block' ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, '\n');
            const formats = (0, $7936fb1ed367d695$export$e4bb5a6163449612)(this.line(index)[0]);
            const attributes = (0, $a839195070a4070f$exports.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === 'block') {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $5582395c1372c6cd$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === 'block' && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $5582395c1372c6cd$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute('contenteditable') === 'true';
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $6a96e64db7f6a5d6$export$7420b9c542181544) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($5582395c1372c6cd$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($5582395c1372c6cd$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $6a96e64db7f6a5d6$export$c898d510319704c0)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER;
        if (typeof mutations === 'string') source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$5582395c1372c6cd$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $7936fb1ed367d695$export$48b9f0688962d028), index);
        if (blot && blot.statics.blotName === key && $5582395c1372c6cd$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === 'string') {
                const splitted = insert.split('\n');
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: 'block',
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))();
                    renderBlocks.push({
                        type: 'blockEmbed',
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: 'block',
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK & (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
}
function $5582395c1372c6cd$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $a839195070a4070f$exports.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === 'string') {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $6a96e64db7f6a5d6$export$7420b9c542181544), index);
                const formats = (0, $7936fb1ed367d695$export$e4bb5a6163449612)(leaf);
                attributes = (0, $a839195070a4070f$exports.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === 'object') {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $6a96e64db7f6a5d6$export$7420b9c542181544), index);
                    const formats = (0, $7936fb1ed367d695$export$e4bb5a6163449612)(leaf);
                    attributes = (0, $a839195070a4070f$exports.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $5582395c1372c6cd$export$2e2bcd8739ae039 = $5582395c1372c6cd$var$Scroll;










const $b88e03f2e2231de6$var$config = {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        'right',
        'center',
        'justify'
    ]
};
const $b88e03f2e2231de6$export$2ef0f9fb04a51388 = new (0, $6a96e64db7f6a5d6$export$217610c4183502d0)('align', 'align', $b88e03f2e2231de6$var$config);
const $b88e03f2e2231de6$export$7f3685f5846c07da = new (0, $6a96e64db7f6a5d6$export$651d45509677cf07)('align', 'ql-align', $b88e03f2e2231de6$var$config);
const $b88e03f2e2231de6$export$d2060f5d114c9fe8 = new (0, $6a96e64db7f6a5d6$export$7c8099bbfe87b94d)('align', 'text-align', $b88e03f2e2231de6$var$config);




class $db342fd56e369e0d$export$c992e3369f248f6e extends (0, $6a96e64db7f6a5d6$export$7c8099bbfe87b94d) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith('rgb(')) return value;
        value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
        const hex = value.split(',').map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join('');
        return `#${hex}`;
    }
}
const $db342fd56e369e0d$export$42795dcf0ec6f3c8 = new (0, $6a96e64db7f6a5d6$export$651d45509677cf07)('color', 'ql-color', {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE
});
const $db342fd56e369e0d$export$1415f56796d9a5a9 = new $db342fd56e369e0d$export$c992e3369f248f6e('color', 'color', {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE
});


const $d96f3d57b3588768$export$8aa96c8963152b12 = new (0, $6a96e64db7f6a5d6$export$651d45509677cf07)('background', 'ql-bg', {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE
});
const $d96f3d57b3588768$export$dc1cbcab4c682ef = new (0, $db342fd56e369e0d$export$c992e3369f248f6e)('background', 'background-color', {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE
});









class $5c0b3cffc90a1532$export$3b131632d3d15165 extends (0, $9f0c19bdc7022f30$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute('spellcheck', 'false');
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? '' : child.domNode.innerText).join('\n').slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $0223954ca10581a2$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
}
class $5c0b3cffc90a1532$export$2e2bcd8739ae039 extends (0, $7936fb1ed367d695$export$2e2bcd8739ae039) {
    static TAB = '  ';
    static register() {
        (0, $6c63a051452c3514$export$2e2bcd8739ae039).register($5c0b3cffc90a1532$export$3b131632d3d15165);
    }
}
class $5c0b3cffc90a1532$export$52f0f02147b12c03 extends (0, $ef46692c8d3ac68f$export$2e2bcd8739ae039) {
}
$5c0b3cffc90a1532$export$52f0f02147b12c03.blotName = 'code';
$5c0b3cffc90a1532$export$52f0f02147b12c03.tagName = 'CODE';
$5c0b3cffc90a1532$export$2e2bcd8739ae039.blotName = 'code-block';
$5c0b3cffc90a1532$export$2e2bcd8739ae039.className = 'ql-code-block';
$5c0b3cffc90a1532$export$2e2bcd8739ae039.tagName = 'DIV';
$5c0b3cffc90a1532$export$3b131632d3d15165.blotName = 'code-block-container';
$5c0b3cffc90a1532$export$3b131632d3d15165.className = 'ql-code-block-container';
$5c0b3cffc90a1532$export$3b131632d3d15165.tagName = 'DIV';
$5c0b3cffc90a1532$export$3b131632d3d15165.allowedChildren = [
    $5c0b3cffc90a1532$export$2e2bcd8739ae039
];
$5c0b3cffc90a1532$export$2e2bcd8739ae039.allowedChildren = [
    (0, $0223954ca10581a2$export$2e2bcd8739ae039),
    (0, $01df5b50ebe61a4f$export$2e2bcd8739ae039),
    (0, $838ba222167c4d97$export$2e2bcd8739ae039)
];
$5c0b3cffc90a1532$export$2e2bcd8739ae039.requiredContainer = $5c0b3cffc90a1532$export$3b131632d3d15165;




const $d9816cce0476f347$var$config = {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        'rtl'
    ]
};
const $d9816cce0476f347$export$4158215dafad9efa = new (0, $6a96e64db7f6a5d6$export$217610c4183502d0)('direction', 'dir', $d9816cce0476f347$var$config);
const $d9816cce0476f347$export$630028b3af294dec = new (0, $6a96e64db7f6a5d6$export$651d45509677cf07)('direction', 'ql-direction', $d9816cce0476f347$var$config);
const $d9816cce0476f347$export$175979e518d1dfd1 = new (0, $6a96e64db7f6a5d6$export$7c8099bbfe87b94d)('direction', 'direction', $d9816cce0476f347$var$config);



const $5a73a06410542650$var$config = {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE,
    whitelist: [
        'serif',
        'monospace'
    ]
};
const $5a73a06410542650$export$78a99ee601572ab = new (0, $6a96e64db7f6a5d6$export$651d45509677cf07)('font', 'ql-font', $5a73a06410542650$var$config);
class $5a73a06410542650$var$FontStyleAttributor extends (0, $6a96e64db7f6a5d6$export$7c8099bbfe87b94d) {
    value(node) {
        return super.value(node).replace(/["']/g, '');
    }
}
const $5a73a06410542650$export$23b468d4ca3f8c96 = new $5a73a06410542650$var$FontStyleAttributor('font', 'font-family', $5a73a06410542650$var$config);



const $8047ded6c01b115d$export$c84684d52bca9684 = new (0, $6a96e64db7f6a5d6$export$651d45509677cf07)('size', 'ql-size', {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE,
    whitelist: [
        'small',
        'large',
        'huge'
    ]
});
const $8047ded6c01b115d$export$5443b95a30e89ac5 = new (0, $6a96e64db7f6a5d6$export$7c8099bbfe87b94d)('size', 'font-size', {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE,
    whitelist: [
        '10px',
        '18px',
        '32px'
    ]
});








const $333c6520bc9e571e$var$debug = (0, $2b9568fe518fbc26$export$2e2bcd8739ae039)('quill:keyboard');
const $333c6520bc9e571e$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
class $333c6520bc9e571e$export$2e2bcd8739ae039 extends (0, $62fec3ecd9958ea0$export$2e2bcd8739ae039) {
    static match(evt, binding) {
        if ([
            'altKey',
            'ctrlKey',
            'metaKey',
            'shiftKey'
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: 'Enter',
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: 'Enter',
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: 'Backspace'
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: 'Delete'
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: 'Backspace'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Delete'
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: 'Backspace',
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $333c6520bc9e571e$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $333c6520bc9e571e$var$debug.warn('Attempted to add invalid keyboard binding', binding);
            return;
        }
        if (typeof context === 'function') context = {
            handler: context
        };
        if (typeof handler === 'function') handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener('keydown', (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === 'Enter' || evt.key === 'Backspace');
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$333c6520bc9e571e$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $6c63a051452c3514$export$2e2bcd8739ae039).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $6a96e64db7f6a5d6$export$10ac0c5716409de6) ? leafStart.value().slice(0, offsetStart) : '';
            const suffixText = leafEnd instanceof (0, $6a96e64db7f6a5d6$export$10ac0c5716409de6) ? leafEnd.value().slice(offsetEnd) : '';
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === 'object') {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $09c2bf1171a90432$export$2e2bcd8739ae039)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === 'block' && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $a839195070a4070f$exports.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $a839195070a4070f$exports.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $333c6520bc9e571e$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index).delete(range.length).insert('\n', lineFormats);
        this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.focus();
    }
}
const $333c6520bc9e571e$var$defaultOptions = {
    bindings: {
        bold: $333c6520bc9e571e$var$makeFormatHandler('bold'),
        italic: $333c6520bc9e571e$var$makeFormatHandler('italic'),
        underline: $333c6520bc9e571e$var$makeFormatHandler('underline'),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: 'Tab',
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '+1', (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        outdent: {
            key: 'Tab',
            shiftKey: true,
            format: [
                'blockquote',
                'indent',
                'list'
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format('indent', '-1', (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        'outdent backspace': {
            key: 'Backspace',
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                'indent',
                'list'
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format('indent', '-1', (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                else if (context.format.list != null) this.quill.format('list', false, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'indent code-block': $333c6520bc9e571e$var$makeCodeBlockHandler(true),
        'outdent code-block': $333c6520bc9e571e$var$makeCodeBlockHandler(false),
        'remove tab': {
            key: 'Tab',
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            }
        },
        tab: {
            key: 'Tab',
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index).delete(range.length).insert('\t');
                this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        'blockquote empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'blockquote'
            ],
            empty: true,
            handler () {
                this.quill.format('blockquote', false, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'list empty enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'list'
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'checklist enter': {
            key: 'Enter',
            collapsed: true,
            format: {
                list: 'checked'
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: 'checked'
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index).insert('\n', formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: 'unchecked'
                });
                this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'header enter': {
            key: 'Enter',
            collapsed: true,
            format: [
                'header'
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index).insert('\n', context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        'table backspace': {
            key: 'Backspace',
            format: [
                'table'
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        'table delete': {
            key: 'Delete',
            format: [
                'table'
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        'table enter': {
            key: 'Enter',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range) {
                const module = this.quill.getModule('table');
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $333c6520bc9e571e$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).insert('\n');
                        this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                    }
                }
            }
        },
        'table tab': {
            key: 'Tab',
            shiftKey: null,
            format: [
                'table'
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            }
        },
        'list autofill': {
            key: ' ',
            shiftKey: null,
            collapsed: true,
            format: {
                'code-block': false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query('list') == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case '[]':
                    case '[ ]':
                        value = 'unchecked';
                        break;
                    case '[x]':
                        value = 'checked';
                        break;
                    case '-':
                    case '*':
                        value = 'bullet';
                        break;
                    default:
                        value = 'ordered';
                }
                this.quill.insertText(range.index, ' ', (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        'code exit': {
            key: 'Enter',
            collapsed: true,
            format: [
                'code-block'
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()['code-block']){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            'code-block': null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        'embed left': $333c6520bc9e571e$var$makeEmbedArrowHandler('ArrowLeft', false),
        'embed left shift': $333c6520bc9e571e$var$makeEmbedArrowHandler('ArrowLeft', true),
        'embed right': $333c6520bc9e571e$var$makeEmbedArrowHandler('ArrowRight', false),
        'embed right shift': $333c6520bc9e571e$var$makeEmbedArrowHandler('ArrowRight', true),
        'table down': $333c6520bc9e571e$var$makeTableArrowHandler(false),
        'table up': $333c6520bc9e571e$var$makeTableArrowHandler(true)
    }
};
$333c6520bc9e571e$export$2e2bcd8739ae039.DEFAULTS = $333c6520bc9e571e$var$defaultOptions;
function $333c6520bc9e571e$var$makeCodeBlockHandler(indent) {
    return {
        key: 'Tab',
        shiftKey: !indent,
        format: {
            'code-block': true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query('code-block');
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(index, length, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
        }
    };
}
function $333c6520bc9e571e$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === 'ArrowLeft' ? 'prefix' : 'suffix';
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === 'ArrowRight') index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f))) return true;
            if (key === 'ArrowLeft') {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            return false;
        }
    };
}
function $333c6520bc9e571e$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        }
    };
}
function $333c6520bc9e571e$var$makeTableArrowHandler(up) {
    return {
        key: up ? 'ArrowUp' : 'ArrowDown',
        collapsed: true,
        format: [
            'table'
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? 'prev' : 'next';
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === 'table-row') {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                }
            }
            return false;
        }
    };
}
function $333c6520bc9e571e$export$a3295358bff77e(binding) {
    if (typeof binding === 'string' || typeof binding === 'number') binding = {
        key: binding
    };
    else if (typeof binding === 'object') binding = (0, $4f6f5140da0ed5e7$export$2e2bcd8739ae039)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$333c6520bc9e571e$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $333c6520bc9e571e$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $a839195070a4070f$exports.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
    quill.setSelection(range.index, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
}
function $333c6520bc9e571e$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}


const $1d95547c07daf417$var$normalWeightRegexp = /font-weight:\s*normal/;
const $1d95547c07daf417$var$blockTagNames = [
    'P',
    'OL',
    'UL'
];
const $1d95547c07daf417$var$isBlockElement = (element)=>{
    return element && $1d95547c07daf417$var$blockTagNames.includes(element.tagName);
};
const $1d95547c07daf417$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll('br')).filter((br)=>$1d95547c07daf417$var$isBlockElement(br.previousElementSibling) && $1d95547c07daf417$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $1d95547c07daf417$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute('style')?.match($1d95547c07daf417$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $1d95547c07daf417$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $1d95547c07daf417$var$normalizeFontWeight(doc);
        $1d95547c07daf417$var$normalizeEmptyLines(doc);
    }
}


const $903298cf7f08de0d$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $903298cf7f08de0d$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $903298cf7f08de0d$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $903298cf7f08de0d$var$parseListItem = (element, html)=>{
    const style = element.getAttribute('style');
    const idMatch = style?.match($903298cf7f08de0d$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($903298cf7f08de0d$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, 'i');
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === 'bullet' ? 'bullet' : 'ordered';
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $903298cf7f08de0d$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll('[style*=mso-list]'));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute('style') || '').match($903298cf7f08de0d$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$903298cf7f08de0d$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement('ul');
        childListItems.forEach((listItem)=>{
            const li = document.createElement('li');
            li.setAttribute('data-list', listItem.type);
            if (listItem.indent > 1) li.setAttribute('class', `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $903298cf7f08de0d$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute('xmlns:w') === 'urn:schemas-microsoft-com:office:word') $903298cf7f08de0d$var$normalizeListItem(doc);
}


const $d7f27b0598361263$var$NORMALIZERS = [
    (0, $903298cf7f08de0d$export$2e2bcd8739ae039),
    (0, $1d95547c07daf417$export$2e2bcd8739ae039)
];
const $d7f27b0598361263$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $d7f27b0598361263$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $d7f27b0598361263$export$2e2bcd8739ae039 = $d7f27b0598361263$var$normalizeExternalHTML;


const $e7b0f9c7c7a848ff$var$debug = (0, $2b9568fe518fbc26$export$2e2bcd8739ae039)('quill:clipboard');
const $e7b0f9c7c7a848ff$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $e7b0f9c7c7a848ff$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $e7b0f9c7c7a848ff$export$c695b9637111f586
    ],
    [
        'br',
        $e7b0f9c7c7a848ff$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $e7b0f9c7c7a848ff$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $e7b0f9c7c7a848ff$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $e7b0f9c7c7a848ff$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $e7b0f9c7c7a848ff$var$matchStyles
    ],
    [
        'li',
        $e7b0f9c7c7a848ff$var$matchIndent
    ],
    [
        'ol, ul',
        $e7b0f9c7c7a848ff$var$matchList
    ],
    [
        'pre',
        $e7b0f9c7c7a848ff$var$matchCodeBlock
    ],
    [
        'tr',
        $e7b0f9c7c7a848ff$var$matchTable
    ],
    [
        'b',
        $e7b0f9c7c7a848ff$var$createMatchAlias('bold')
    ],
    [
        'i',
        $e7b0f9c7c7a848ff$var$createMatchAlias('italic')
    ],
    [
        'strike',
        $e7b0f9c7c7a848ff$var$createMatchAlias('strike')
    ],
    [
        'style',
        $e7b0f9c7c7a848ff$var$matchIgnore
    ]
];
const $e7b0f9c7c7a848ff$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $b88e03f2e2231de6$export$2ef0f9fb04a51388),
    (0, $d9816cce0476f347$export$4158215dafad9efa)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $e7b0f9c7c7a848ff$var$STYLE_ATTRIBUTORS = [
    (0, $b88e03f2e2231de6$export$d2060f5d114c9fe8),
    (0, $d96f3d57b3588768$export$dc1cbcab4c682ef),
    (0, $db342fd56e369e0d$export$1415f56796d9a5a9),
    (0, $d9816cce0476f347$export$175979e518d1dfd1),
    (0, $5a73a06410542650$export$23b468d4ca3f8c96),
    (0, $8047ded6c01b115d$export$5443b95a30e89ac5)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $e7b0f9c7c7a848ff$export$2e2bcd8739ae039 extends (0, $62fec3ecd9958ea0$export$2e2bcd8739ae039) {
    static DEFAULTS = {
        matchers: []
    };
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener('copy', (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener('cut', (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener('paste', this.onCapturePaste.bind(this));
        this.matchers = [];
        $e7b0f9c7c7a848ff$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $5c0b3cffc90a1532$export$2e2bcd8739ae039).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert(text || '', {
            [(0, $5c0b3cffc90a1532$export$2e2bcd8739ae039).blotName]: formats[(0, $5c0b3cffc90a1532$export$2e2bcd8739ae039).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert(text || '', formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($e7b0f9c7c7a848ff$var$deltaEndsWith(delta, '\n') && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $d7f27b0598361263$export$2e2bcd8739ae039)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $e7b0f9c7c7a848ff$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.API;
        if (typeof index === 'string') {
            const delta = this.convert({
                html: index,
                text: ''
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ''
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData('text/plain', text);
        e.clipboardData?.setData('text/html', html);
        if (isCut) (0, $333c6520bc9e571e$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== '#').join('\n');
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData('text/html');
        let text = e.clipboardData?.getData('text/plain');
        if (!html && !text) {
            const urlList = e.clipboardData?.getData('text/uri-list');
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === 'IMG') {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $e7b0f9c7c7a848ff$var$debug.log('onPaste', pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
}
function $e7b0f9c7c7a848ff$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))());
}
function $e7b0f9c7c7a848ff$var$deltaEndsWith(delta, text) {
    let endText = '';
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== 'string') break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $e7b0f9c7c7a848ff$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f)) return false;
    return [
        'address',
        'article',
        'blockquote',
        'canvas',
        'dd',
        'div',
        'dl',
        'dt',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'header',
        'iframe',
        'li',
        'main',
        'nav',
        'ol',
        'output',
        'p',
        'pre',
        'section',
        'table',
        'td',
        'tr',
        'ul',
        'video'
    ].includes(node.tagName.toLowerCase());
}
function $e7b0f9c7c7a848ff$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$e7b0f9c7c7a848ff$var$isLine(node.previousElementSibling, scroll) && !$e7b0f9c7c7a848ff$var$isLine(node.nextElementSibling, scroll);
}
const $e7b0f9c7c7a848ff$var$preNodes = new WeakMap();
function $e7b0f9c7c7a848ff$var$isPre(node) {
    if (node == null) return false;
    if (!$e7b0f9c7c7a848ff$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === 'PRE') $e7b0f9c7c7a848ff$var$preNodes.set(node, true);
        else $e7b0f9c7c7a848ff$var$preNodes.set(node, $e7b0f9c7c7a848ff$var$isPre(node.parentNode));
    }
    return $e7b0f9c7c7a848ff$var$preNodes.get(node);
}
function $e7b0f9c7c7a848ff$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $e7b0f9c7c7a848ff$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))();
}
function $e7b0f9c7c7a848ff$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $e7b0f9c7c7a848ff$var$applyFormat(delta, format, true, scroll);
    };
}
function $e7b0f9c7c7a848ff$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $6a96e64db7f6a5d6$export$217610c4183502d0).keys(node);
    const classes = (0, $6a96e64db7f6a5d6$export$651d45509677cf07).keys(node);
    const styles = (0, $6a96e64db7f6a5d6$export$7c8099bbfe87b94d).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $e7b0f9c7c7a848ff$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $e7b0f9c7c7a848ff$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $e7b0f9c7c7a848ff$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $e7b0f9c7c7a848ff$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $e7b0f9c7c7a848ff$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $6a96e64db7f6a5d6$export$4f7f03641f7bfc8c) && !$e7b0f9c7c7a848ff$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
        if ('blotName' in match && 'formats' in match && typeof match.formats === 'function') return $e7b0f9c7c7a848ff$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $e7b0f9c7c7a848ff$var$matchBreak(node, delta) {
    if (!$e7b0f9c7c7a848ff$var$deltaEndsWith(delta, '\n')) delta.insert('\n');
    return delta;
}
function $e7b0f9c7c7a848ff$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query('code-block');
    const language = match && 'formats' in match && typeof match.formats === 'function' ? match.formats(node, scroll) : true;
    return $e7b0f9c7c7a848ff$var$applyFormat(delta, 'code-block', language, scroll);
}
function $e7b0f9c7c7a848ff$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))();
}
function $e7b0f9c7c7a848ff$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== 'list' || !$e7b0f9c7c7a848ff$var$deltaEndsWith(delta, '\n')) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            'OL',
            'UL'
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === 'number') return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))());
}
function $e7b0f9c7c7a848ff$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === 'OL' ? 'ordered' : 'bullet';
    const checkedAttr = element.getAttribute('data-checked');
    if (checkedAttr) list = checkedAttr === 'true' ? 'checked' : 'unchecked';
    return $e7b0f9c7c7a848ff$var$applyFormat(delta, 'list', list, scroll);
}
function $e7b0f9c7c7a848ff$export$c695b9637111f586(node, delta, scroll) {
    if (!$e7b0f9c7c7a848ff$var$deltaEndsWith(delta, '\n')) {
        if ($e7b0f9c7c7a848ff$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert('\n');
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($e7b0f9c7c7a848ff$var$isLine(nextSibling, scroll)) return delta.insert('\n');
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $7936fb1ed367d695$export$48b9f0688962d028)) return delta.insert('\n');
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $e7b0f9c7c7a848ff$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === 'italic') formats.italic = true;
    if (style.textDecoration === 'underline') formats.underline = true;
    if (style.textDecoration === 'line-through') formats.strike = true;
    if (style.fontWeight?.startsWith('bold') || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $e7b0f9c7c7a848ff$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().insert('\t').concat(delta);
    return delta;
}
function $e7b0f9c7c7a848ff$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === 'TABLE' ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll('tr'));
        const row = rows.indexOf(node) + 1;
        return $e7b0f9c7c7a848ff$var$applyFormat(delta, 'table', row, scroll);
    }
    return delta;
}
function $e7b0f9c7c7a848ff$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === 'O:P') return delta.insert(text.trim());
    if (!$e7b0f9c7c7a848ff$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes('\n') && !$e7b0f9c7c7a848ff$var$isBetweenInlineElements(node, scroll)) return delta;
        // convert all non-nbsp whitespace into regular space
        text = text.replace(/[^\S\u00a0]/g, ' ');
        // collapse consecutive spaces into one
        text = text.replace(/ {2,}/g, ' ');
        if (node.previousSibling == null && node.parentElement != null && $e7b0f9c7c7a848ff$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $e7b0f9c7c7a848ff$var$isLine(node.previousSibling, scroll)) // block structure means we don't need leading space
        text = text.replace(/^ /, '');
        if (node.nextSibling == null && node.parentElement != null && $e7b0f9c7c7a848ff$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $e7b0f9c7c7a848ff$var$isLine(node.nextSibling, scroll)) // block structure means we don't need trailing space
        text = text.replace(/ $/, '');
        // done removing whitespace and can normalize all to regular space
        text = text.replaceAll('\u00a0', ' ');
    }
    return delta.insert(text);
}





class $807f09aeb25243a3$export$2e2bcd8739ae039 extends (0, $62fec3ecd9958ea0$export$2e2bcd8739ae039) {
    static DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
    };
    lastRecorded = 0;
    ignoreChange = false;
    stack = {
        undo: [],
        redo: []
    };
    currentRange = null;
    constructor(quill, options){
        super(quill, options);
        this.quill.on((0, $6c63a051452c3514$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $6c63a051452c3514$export$2e2bcd8739ae039).events.SELECTION_CHANGE) {
                if (value && source !== (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $6c63a051452c3514$export$2e2bcd8739ae039).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $807f09aeb25243a3$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: 'z',
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                'z',
                'Z'
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: 'y',
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener('beforeinput', (event)=>{
            if (event.inputType === 'historyUndo') {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === 'historyRedo') {
                this.redo();
                event.preventDefault();
            }
        });
    }
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $807f09aeb25243a3$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change('redo', 'undo');
    }
    transform(delta) {
        $807f09aeb25243a3$var$transformStack(this.stack.undo, delta);
        $807f09aeb25243a3$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change('undo', 'redo');
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        else {
            const index = $807f09aeb25243a3$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        }
    }
}
function $807f09aeb25243a3$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $807f09aeb25243a3$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $807f09aeb25243a3$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK) != null;
    });
    return false;
}
function $807f09aeb25243a3$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($807f09aeb25243a3$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $807f09aeb25243a3$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}






class $36267fae9da1fc28$var$Uploader extends (0, $62fec3ecd9958ea0$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('drop', (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
}
$36267fae9da1fc28$var$Uploader.DEFAULTS = {
    mimetypes: [
        'image/png',
        'image/jpeg'
    ],
    handler (range, files) {
        if (!this.quill.scroll.query('image')) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.SILENT);
        });
    }
};
var $36267fae9da1fc28$export$2e2bcd8739ae039 = $36267fae9da1fc28$var$Uploader;







const $0c9be4b4ab4ff1e0$var$INSERT_TYPES = [
    'insertText',
    'insertReplacementText'
];
class $0c9be4b4ab4ff1e0$var$Input extends (0, $62fec3ecd9958ea0$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener('beforeinput', (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $6c63a051452c3514$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
    deleteRange(range) {
        (0, $333c6520bc9e571e$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index).insert(text, formats), (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$0c9be4b4ab4ff1e0$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $0c9be4b4ab4ff1e0$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
}
function $0c9be4b4ab4ff1e0$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === 'string') return event.data;
    if (event.dataTransfer?.types.includes('text/plain')) return event.dataTransfer.getData('text/plain');
    return null;
}
var $0c9be4b4ab4ff1e0$export$2e2bcd8739ae039 = $0c9be4b4ab4ff1e0$var$Input;





const $6142e7505d44d38a$var$isMac = /Mac/i.test(navigator.platform);
const $6142e7505d44d38a$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $6142e7505d44d38a$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || // RTL scripts or moving from the end of the previous line
    event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') return true;
    if ($6142e7505d44d38a$var$isMac && event.key === 'a' && event.ctrlKey === true) return true;
    return false;
};
class $6142e7505d44d38a$var$UINode extends (0, $62fec3ecd9958ea0$export$2e2bcd8739ae039) {
    isListening = false;
    selectionChangeDeadline = 0;
    constructor(quill, options){
        super(quill, options);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                'ArrowLeft',
                'ArrowRight'
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $6a96e64db7f6a5d6$export$e43113f0aad76fe)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';
                if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener('keydown', (event)=>{
            if (!event.defaultPrevented && $6142e7505d44d38a$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $6142e7505d44d38a$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener('selectionchange', listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $6a96e64db7f6a5d6$export$e43113f0aad76fe)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
}
var $6142e7505d44d38a$export$2e2bcd8739ae039 = $6142e7505d44d38a$var$UINode;



(0, $6c63a051452c3514$export$2e2bcd8739ae039).register({
    'blots/block': (0, $7936fb1ed367d695$export$2e2bcd8739ae039),
    'blots/block/embed': (0, $7936fb1ed367d695$export$48b9f0688962d028),
    'blots/break': (0, $01df5b50ebe61a4f$export$2e2bcd8739ae039),
    'blots/container': (0, $9f0c19bdc7022f30$export$2e2bcd8739ae039),
    'blots/cursor': (0, $838ba222167c4d97$export$2e2bcd8739ae039),
    'blots/embed': (0, $d9edc4b08d80ecb5$export$2e2bcd8739ae039),
    'blots/inline': (0, $ef46692c8d3ac68f$export$2e2bcd8739ae039),
    'blots/scroll': (0, $5582395c1372c6cd$export$2e2bcd8739ae039),
    'blots/text': (0, $0223954ca10581a2$export$2e2bcd8739ae039),
    'modules/clipboard': (0, $e7b0f9c7c7a848ff$export$2e2bcd8739ae039),
    'modules/history': (0, $807f09aeb25243a3$export$2e2bcd8739ae039),
    'modules/keyboard': (0, $333c6520bc9e571e$export$2e2bcd8739ae039),
    'modules/uploader': (0, $36267fae9da1fc28$export$2e2bcd8739ae039),
    'modules/input': (0, $0c9be4b4ab4ff1e0$export$2e2bcd8739ae039),
    'modules/uiNode': (0, $6142e7505d44d38a$export$2e2bcd8739ae039)
});
var $b01b8198fe568ec6$export$2e2bcd8739ae039 = (0, $6c63a051452c3514$export$2e2bcd8739ae039);





class $88bd0ed8af36f292$var$IndentAttributor extends (0, $6a96e64db7f6a5d6$export$651d45509677cf07) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === '+1' || value === '-1') {
            const indent = this.value(node) || 0;
            normalizedValue = value === '+1' ? indent + 1 : indent - 1;
        } else if (typeof value === 'number') normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $88bd0ed8af36f292$var$IndentClass = new $88bd0ed8af36f292$var$IndentAttributor('indent', 'ql-indent', {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $88bd0ed8af36f292$export$2e2bcd8739ae039 = $88bd0ed8af36f292$var$IndentClass;



class $5a80bdb49dfb1206$var$Blockquote extends (0, $7936fb1ed367d695$export$2e2bcd8739ae039) {
    static blotName = 'blockquote';
    static tagName = 'blockquote';
}
var $5a80bdb49dfb1206$export$2e2bcd8739ae039 = $5a80bdb49dfb1206$var$Blockquote;



class $54bee53c2b362e1b$var$Header extends (0, $7936fb1ed367d695$export$2e2bcd8739ae039) {
    static blotName = 'header';
    static tagName = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
var $54bee53c2b362e1b$export$2e2bcd8739ae039 = $54bee53c2b362e1b$var$Header;





class $468fc7ddf1cc3dfe$export$122a2a667e12876b extends (0, $9f0c19bdc7022f30$export$2e2bcd8739ae039) {
}
$468fc7ddf1cc3dfe$export$122a2a667e12876b.blotName = 'list-container';
$468fc7ddf1cc3dfe$export$122a2a667e12876b.tagName = 'OL';
class $468fc7ddf1cc3dfe$export$2e2bcd8739ae039 extends (0, $7936fb1ed367d695$export$2e2bcd8739ae039) {
    static create(value) {
        const node = super.create();
        node.setAttribute('data-list', value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('data-list') || undefined;
    }
    static register() {
        (0, $6c63a051452c3514$export$2e2bcd8739ae039).register($468fc7ddf1cc3dfe$export$122a2a667e12876b);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement('span');
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === 'checked') {
                this.format('list', 'unchecked');
                e.preventDefault();
            } else if (format === 'unchecked') {
                this.format('list', 'checked');
                e.preventDefault();
            }
        };
        ui.addEventListener('mousedown', listEventHandler);
        ui.addEventListener('touchstart', listEventHandler);
        this.attachUI(ui);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute('data-list', value);
        else super.format(name, value);
    }
}
$468fc7ddf1cc3dfe$export$2e2bcd8739ae039.blotName = 'list';
$468fc7ddf1cc3dfe$export$2e2bcd8739ae039.tagName = 'LI';
$468fc7ddf1cc3dfe$export$122a2a667e12876b.allowedChildren = [
    $468fc7ddf1cc3dfe$export$2e2bcd8739ae039
];
$468fc7ddf1cc3dfe$export$2e2bcd8739ae039.requiredContainer = $468fc7ddf1cc3dfe$export$122a2a667e12876b;







class $0bd9492cc8e3e4a0$var$Bold extends (0, $ef46692c8d3ac68f$export$2e2bcd8739ae039) {
    static blotName = 'bold';
    static tagName = [
        'STRONG',
        'B'
    ];
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
var $0bd9492cc8e3e4a0$export$2e2bcd8739ae039 = $0bd9492cc8e3e4a0$var$Bold;



class $69ec79a04f2db2d5$var$Italic extends (0, $0bd9492cc8e3e4a0$export$2e2bcd8739ae039) {
    static blotName = 'italic';
    static tagName = [
        'EM',
        'I'
    ];
}
var $69ec79a04f2db2d5$export$2e2bcd8739ae039 = $69ec79a04f2db2d5$var$Italic;



class $6d16e1aed52b8757$export$2e2bcd8739ae039 extends (0, $ef46692c8d3ac68f$export$2e2bcd8739ae039) {
    static blotName = 'link';
    static tagName = 'A';
    static SANITIZED_URL = 'about:blank';
    static PROTOCOL_WHITELIST = [
        'http',
        'https',
        'mailto',
        'tel',
        'sms'
    ];
    static create(value) {
        const node = super.create(value);
        node.setAttribute('href', this.sanitize(value));
        node.setAttribute('rel', 'noopener noreferrer');
        node.setAttribute('target', '_blank');
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute('href');
    }
    static sanitize(url) {
        return $6d16e1aed52b8757$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute('href', this.constructor.sanitize(value));
    }
}
function $6d16e1aed52b8757$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement('a');
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return protocols.indexOf(protocol) > -1;
}



class $d1902717535ea3e6$var$Script extends (0, $ef46692c8d3ac68f$export$2e2bcd8739ae039) {
    static blotName = 'script';
    static tagName = [
        'SUB',
        'SUP'
    ];
    static create(value) {
        if (value === 'super') return document.createElement('sup');
        if (value === 'sub') return document.createElement('sub');
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === 'SUB') return 'sub';
        if (domNode.tagName === 'SUP') return 'super';
        return undefined;
    }
}
var $d1902717535ea3e6$export$2e2bcd8739ae039 = $d1902717535ea3e6$var$Script;



class $daf8c18c3bbe0720$var$Strike extends (0, $0bd9492cc8e3e4a0$export$2e2bcd8739ae039) {
    static blotName = 'strike';
    static tagName = [
        'S',
        'STRIKE'
    ];
}
var $daf8c18c3bbe0720$export$2e2bcd8739ae039 = $daf8c18c3bbe0720$var$Strike;



class $101eb7f77601f65f$var$Underline extends (0, $ef46692c8d3ac68f$export$2e2bcd8739ae039) {
    static blotName = 'underline';
    static tagName = 'U';
}
var $101eb7f77601f65f$export$2e2bcd8739ae039 = $101eb7f77601f65f$var$Underline;



class $6813bed97afb2ca6$var$Formula extends (0, $d9edc4b08d80ecb5$export$2e2bcd8739ae039) {
    static blotName = 'formula';
    static className = 'ql-formula';
    static tagName = 'SPAN';
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error('Formula module requires KaTeX.');
        const node = super.create(value);
        if (typeof value === 'string') {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
            });
            node.setAttribute('data-value', value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute('data-value');
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
var $6813bed97afb2ca6$export$2e2bcd8739ae039 = $6813bed97afb2ca6$var$Formula;




const $0aaf6ace05e344d3$var$ATTRIBUTES = [
    'alt',
    'height',
    'width'
];
class $0aaf6ace05e344d3$var$Image extends (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f) {
    static blotName = 'image';
    static tagName = 'IMG';
    static create(value) {
        const node = super.create(value);
        if (typeof value === 'string') node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $0aaf6ace05e344d3$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $6d16e1aed52b8757$export$83d2e9e3e4ee39ed)(url, [
            'http',
            'https',
            'data'
        ]) ? url : '//:0';
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($0aaf6ace05e344d3$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
var $0aaf6ace05e344d3$export$2e2bcd8739ae039 = $0aaf6ace05e344d3$var$Image;




const $1c8ba880f81d9d8c$var$ATTRIBUTES = [
    'height',
    'width'
];
class $1c8ba880f81d9d8c$var$Video extends (0, $7936fb1ed367d695$export$48b9f0688962d028) {
    static blotName = 'video';
    static className = 'ql-video';
    static tagName = 'IFRAME';
    static create(value) {
        const node = super.create(value);
        node.setAttribute('frameborder', '0');
        node.setAttribute('allowfullscreen', 'true');
        node.setAttribute('src', this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $1c8ba880f81d9d8c$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $6d16e1aed52b8757$export$2e2bcd8739ae039).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute('src');
    }
    format(name, value) {
        if ($1c8ba880f81d9d8c$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
var $1c8ba880f81d9d8c$export$2e2bcd8739ae039 = $1c8ba880f81d9d8c$var$Video;














const $08af0e7195cb4f6d$var$TokenAttributor = new (0, $6a96e64db7f6a5d6$export$651d45509677cf07)('code-token', 'hljs', {
    scope: (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE
});
class $08af0e7195cb4f6d$export$9460eee64f276be7 extends (0, $ef46692c8d3ac68f$export$2e2bcd8739ae039) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $5c0b3cffc90a1532$export$2e2bcd8739ae039).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $08af0e7195cb4f6d$var$TokenAttributor.add(this.domNode, value);
    }
    format(format, value) {
        if (format !== $08af0e7195cb4f6d$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $08af0e7195cb4f6d$var$TokenAttributor.add(this.domNode, value);
        else {
            $08af0e7195cb4f6d$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$08af0e7195cb4f6d$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
}
$08af0e7195cb4f6d$export$9460eee64f276be7.blotName = 'code-token';
$08af0e7195cb4f6d$export$9460eee64f276be7.className = 'ql-token';
class $08af0e7195cb4f6d$export$6c415d1fdae3dfdb extends (0, $5c0b3cffc90a1532$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === 'string') domNode.setAttribute('data-language', value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute('data-language') || 'plain';
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute('data-language', value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $08af0e7195cb4f6d$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $08af0e7195cb4f6d$var$SyntaxCodeBlockContainer extends (0, $5c0b3cffc90a1532$export$3b131632d3d15165) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $08af0e7195cb4f6d$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $08af0e7195cb4f6d$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join('\n')}\n`;
        const language = $08af0e7195cb4f6d$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $7936fb1ed367d695$export$992ff47219af5a2b)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $08af0e7195cb4f6d$export$6c415d1fdae3dfdb.blotName,
                            $08af0e7195cb4f6d$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $08af0e7195cb4f6d$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : 'plain';
        return `<pre data-language="${language}">\n${(0, $0223954ca10581a2$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $08af0e7195cb4f6d$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$08af0e7195cb4f6d$var$SyntaxCodeBlockContainer.allowedChildren = [
    $08af0e7195cb4f6d$export$6c415d1fdae3dfdb
];
$08af0e7195cb4f6d$export$6c415d1fdae3dfdb.requiredContainer = $08af0e7195cb4f6d$var$SyntaxCodeBlockContainer;
$08af0e7195cb4f6d$export$6c415d1fdae3dfdb.allowedChildren = [
    $08af0e7195cb4f6d$export$9460eee64f276be7,
    (0, $838ba222167c4d97$export$2e2bcd8739ae039),
    (0, $0223954ca10581a2$export$2e2bcd8739ae039),
    (0, $01df5b50ebe61a4f$export$2e2bcd8739ae039)
];
const $08af0e7195cb4f6d$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === 'string') {
        const majorVersion = lib.versionString.split('.')[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $08af0e7195cb4f6d$export$2e2bcd8739ae039 extends (0, $62fec3ecd9958ea0$export$2e2bcd8739ae039) {
    static register() {
        (0, $6c63a051452c3514$export$2e2bcd8739ae039).register($08af0e7195cb4f6d$export$9460eee64f276be7, true);
        (0, $6c63a051452c3514$export$2e2bcd8739ae039).register($08af0e7195cb4f6d$export$6c415d1fdae3dfdb, true);
        (0, $6c63a051452c3514$export$2e2bcd8739ae039).register($08af0e7195cb4f6d$var$SyntaxCodeBlockContainer, true);
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
    initListener() {
        this.quill.on((0, $6c63a051452c3514$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $08af0e7195cb4f6d$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement('select');
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement('option');
                option.textContent = label;
                option.setAttribute('value', key);
                select.appendChild(option);
            });
            select.addEventListener('change', ()=>{
                blot.format($08af0e7195cb4f6d$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $08af0e7195cb4f6d$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $6c63a051452c3514$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($08af0e7195cb4f6d$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'plain';
        language = this.languages[language] ? language : 'plain';
        if (language === 'plain') return (0, $0223954ca10581a2$export$96e6fc3a139b2555)(text).split('\n').reduce((delta, line, i)=>{
            if (i !== 0) delta.insert('\n', {
                [(0, $5c0b3cffc90a1532$export$2e2bcd8739ae039).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))());
        const container = this.quill.root.ownerDocument.createElement('div');
        container.classList.add((0, $5c0b3cffc90a1532$export$2e2bcd8739ae039).className);
        container.innerHTML = $08af0e7195cb4f6d$var$highlight(this.options.hljs, language, text);
        return (0, $e7b0f9c7c7a848ff$export$df3f009e3d155b20)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $08af0e7195cb4f6d$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(delta.length(), {
                    [$08af0e7195cb4f6d$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split('\n').reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert('\n', {
                        [(0, $5c0b3cffc90a1532$export$2e2bcd8739ae039).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
}
$08af0e7195cb4f6d$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: 'plain',
            label: 'Plain'
        },
        {
            key: 'bash',
            label: 'Bash'
        },
        {
            key: 'cpp',
            label: 'C++'
        },
        {
            key: 'cs',
            label: 'C#'
        },
        {
            key: 'css',
            label: 'CSS'
        },
        {
            key: 'diff',
            label: 'Diff'
        },
        {
            key: 'xml',
            label: 'HTML/XML'
        },
        {
            key: 'java',
            label: 'Java'
        },
        {
            key: 'javascript',
            label: 'JavaScript'
        },
        {
            key: 'markdown',
            label: 'Markdown'
        },
        {
            key: 'php',
            label: 'PHP'
        },
        {
            key: 'python',
            label: 'Python'
        },
        {
            key: 'ruby',
            label: 'Ruby'
        },
        {
            key: 'sql',
            label: 'SQL'
        }
    ]
};







class $b58c27ff0f0dbf58$export$1e4baea7053fc0e3 extends (0, $7936fb1ed367d695$export$2e2bcd8739ae039) {
    static blotName = 'table';
    static tagName = 'TD';
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute('data-row', value);
        else node.setAttribute('data-row', $b58c27ff0f0dbf58$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute('data-row')) return domNode.getAttribute('data-row');
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $b58c27ff0f0dbf58$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute('data-row', value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
class $b58c27ff0f0dbf58$export$b05581f4e764e162 extends (0, $9f0c19bdc7022f30$export$2e2bcd8739ae039) {
    static blotName = 'table-row';
    static tagName = 'TR';
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
class $b58c27ff0f0dbf58$export$76ccd210b9029917 extends (0, $9f0c19bdc7022f30$export$2e2bcd8739ae039) {
    static blotName = 'table-body';
    static tagName = 'TBODY';
}
class $b58c27ff0f0dbf58$export$f2c3aea42b2a048f extends (0, $9f0c19bdc7022f30$export$2e2bcd8739ae039) {
    static blotName = 'table-container';
    static tagName = 'TABLE';
    balanceCells() {
        const rows = this.descendants($b58c27ff0f0dbf58$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $b58c27ff0f0dbf58$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($b58c27ff0f0dbf58$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($b58c27ff0f0dbf58$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($b58c27ff0f0dbf58$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $b58c27ff0f0dbf58$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($b58c27ff0f0dbf58$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($b58c27ff0f0dbf58$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $b58c27ff0f0dbf58$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($b58c27ff0f0dbf58$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($b58c27ff0f0dbf58$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
$b58c27ff0f0dbf58$export$f2c3aea42b2a048f.allowedChildren = [
    $b58c27ff0f0dbf58$export$76ccd210b9029917
];
$b58c27ff0f0dbf58$export$76ccd210b9029917.requiredContainer = $b58c27ff0f0dbf58$export$f2c3aea42b2a048f;
$b58c27ff0f0dbf58$export$76ccd210b9029917.allowedChildren = [
    $b58c27ff0f0dbf58$export$b05581f4e764e162
];
$b58c27ff0f0dbf58$export$b05581f4e764e162.requiredContainer = $b58c27ff0f0dbf58$export$76ccd210b9029917;
$b58c27ff0f0dbf58$export$b05581f4e764e162.allowedChildren = [
    $b58c27ff0f0dbf58$export$1e4baea7053fc0e3
];
$b58c27ff0f0dbf58$export$1e4baea7053fc0e3.requiredContainer = $b58c27ff0f0dbf58$export$b05581f4e764e162;
function $b58c27ff0f0dbf58$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}


class $b7ccffa93951e25f$var$Table extends (0, $62fec3ecd9958ea0$export$2e2bcd8739ae039) {
    static register() {
        (0, $6c63a051452c3514$export$2e2bcd8739ae039).register((0, $b58c27ff0f0dbf58$export$1e4baea7053fc0e3));
        (0, $6c63a051452c3514$export$2e2bcd8739ae039).register((0, $b58c27ff0f0dbf58$export$b05581f4e764e162));
        (0, $6c63a051452c3514$export$2e2bcd8739ae039).register((0, $b58c27ff0f0dbf58$export$76ccd210b9029917));
        (0, $6c63a051452c3514$export$2e2bcd8739ae039).register((0, $b58c27ff0f0dbf58$export$f2c3aea42b2a048f));
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $b58c27ff0f0dbf58$export$f2c3aea42b2a048f)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(offset, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $b58c27ff0f0dbf58$export$1e4baea7053fc0e3).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill('\n').join('');
            return memo.insert(text, {
                table: (0, $b58c27ff0f0dbf58$export$9bd6f73cbe857f1b)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))().retain(range.index));
        this.quill.updateContents(delta, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $6c63a051452c3514$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    'TD',
                    'TR',
                    'TBODY',
                    'TABLE'
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $6c63a051452c3514$export$2e2bcd8739ae039).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
}
var $b7ccffa93951e25f$export$2e2bcd8739ae039 = $b7ccffa93951e25f$var$Table;







const $91dc39b97ea1d950$var$debug = (0, $2b9568fe518fbc26$export$2e2bcd8739ae039)('quill:toolbar');
class $91dc39b97ea1d950$export$2e2bcd8739ae039 extends (0, $62fec3ecd9958ea0$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement('div');
            container.setAttribute('role', 'toolbar');
            $91dc39b97ea1d950$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === 'string') this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $91dc39b97ea1d950$var$debug.error('Container required for toolbar', this.options);
            return;
        }
        this.container.classList.add('ql-toolbar');
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll('button, select')).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $6c63a051452c3514$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf('ql-') === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === 'BUTTON') input.setAttribute('type', 'button');
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $91dc39b97ea1d950$var$debug.warn('ignoring attaching to nonexistent format', format, input);
            return;
        }
        const eventName = input.tagName === 'SELECT' ? 'change' : 'click';
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === 'SELECT') {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains('ql-active')) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute('value');
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $6a96e64db7f6a5d6$export$297a1fa96f55f00f)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($a839195070a4070f$exports)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format(format, value, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === 'SELECT') {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector('option[selected]');
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === 'string') value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ''; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove('ql-active');
                input.setAttribute('aria-pressed', 'false');
            } else if (input.hasAttribute('value')) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute('value') || value != null && value.toString() === input.getAttribute('value') || value == null && !input.getAttribute('value');
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle('ql-active', isActive);
                input.setAttribute('aria-pressed', isActive.toString());
            }
        });
    }
}
$91dc39b97ea1d950$export$2e2bcd8739ae039.DEFAULTS = {};
function $91dc39b97ea1d950$var$addButton(container, format, value) {
    const input = document.createElement('button');
    input.setAttribute('type', 'button');
    input.classList.add(`ql-${format}`);
    input.setAttribute('aria-pressed', 'false');
    if (value != null) {
        input.value = value;
        input.setAttribute('aria-label', `${format}: ${value}`);
    } else input.setAttribute('aria-label', format);
    container.appendChild(input);
}
function $91dc39b97ea1d950$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement('span');
        group.classList.add('ql-formats');
        controls.forEach((control)=>{
            if (typeof control === 'string') $91dc39b97ea1d950$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $91dc39b97ea1d950$var$addSelect(group, format, value);
                else $91dc39b97ea1d950$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $91dc39b97ea1d950$var$addSelect(container, format, values) {
    const input = document.createElement('select');
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value !== false) option.setAttribute('value', String(value));
        else option.setAttribute('selected', 'selected');
        input.appendChild(option);
    });
    container.appendChild(input);
}
$91dc39b97ea1d950$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $6a96e64db7f6a5d6$export$775b6bb06e53a214).INLINE) != null) this.quill.format(name, false, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === 'rtl' && align == null) this.quill.format('align', 'right', (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            else if (!value && align === 'right') this.quill.format('align', false, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            this.quill.format('direction', value, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === '+1' || value === '-1') {
                let modifier = value === '+1' ? 1 : -1;
                if (formats.direction === 'rtl') modifier *= -1;
                this.quill.format('indent', indent + modifier, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt('Enter link URL:'); // eslint-disable-line no-alert
            this.quill.format('link', value, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === 'check') {
                if (formats.list === 'checked' || formats.list === 'unchecked') this.quill.format('list', false, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                else this.quill.format('list', 'unchecked', (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format('list', value, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
        }
    }
};


const $469d8b6ca234aa38$var$alignLeftIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $469d8b6ca234aa38$var$alignCenterIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"/></svg>";
const $469d8b6ca234aa38$var$alignRightIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"/></svg>";
const $469d8b6ca234aa38$var$alignJustifyIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"4\" y2=\"4\"/></svg>";
const $469d8b6ca234aa38$var$backgroundIcon = "<svg viewbox=\"0 0 18 18\"><g class=\"ql-fill ql-color-label\"><polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"4\"/><polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"4\" y=\"7\"/><polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"12\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"9\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"15\"/><polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"8\"/><path d=\"M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z\"/><path d=\"M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z\"/><path d=\"M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"3\"/><path d=\"M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z\"/><rect height=\"1\" width=\"1\" x=\"2\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"6\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"3\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"3\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"14\"/><polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"7\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"6\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"8\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"9\"/><path d=\"M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"3\"/><polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"2\"/><rect height=\"1\" width=\"1\" x=\"12\" y=\"5\"/><rect height=\"1\" width=\"1\" x=\"13\" y=\"4\"/><polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"/><rect height=\"1\" width=\"1\" x=\"9\" y=\"14\"/><rect height=\"1\" width=\"1\" x=\"8\" y=\"15\"/><path d=\"M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z\"/><rect height=\"1\" width=\"1\" x=\"5\" y=\"15\"/><path d=\"M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z\"/><rect height=\"1\" width=\"1\" x=\"11\" y=\"15\"/><path d=\"M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z\"/><rect height=\"1\" width=\"1\" x=\"14\" y=\"15\"/><rect height=\"1\" width=\"1\" x=\"15\" y=\"11\"/></g><polyline class=\"ql-stroke\" points=\"5.5 13 9 5 12.5 13\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"11\" y2=\"11\"/></svg>";
const $469d8b6ca234aa38$var$blockquoteIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"4\" y=\"5\"/><rect class=\"ql-fill ql-stroke\" height=\"3\" width=\"3\" x=\"11\" y=\"5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M7,8c0,4.031-3,5-3,5\"/><path class=\"ql-even ql-fill ql-stroke\" d=\"M14,8c0,4.031-3,5-3,5\"/></svg>";
const $469d8b6ca234aa38$var$boldIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z\"/><path class=\"ql-stroke\" d=\"M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z\"/></svg>";
const $469d8b6ca234aa38$var$cleanIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"5\" x2=\"13\" y1=\"3\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"9.35\" y1=\"12\" y2=\"3\"/><line class=\"ql-stroke\" x1=\"11\" x2=\"15\" y1=\"11\" y2=\"15\"/><line class=\"ql-stroke\" x1=\"15\" x2=\"11\" y1=\"11\" y2=\"15\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"7\" x=\"2\" y=\"14\"/></svg>";
const $469d8b6ca234aa38$var$codeIcon = "<svg viewbox=\"0 0 18 18\"><polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"/><polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"/><line class=\"ql-stroke\" x1=\"10\" x2=\"8\" y1=\"5\" y2=\"13\"/></svg>";
const $469d8b6ca234aa38$var$colorIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-color-label ql-stroke ql-transparent\" x1=\"3\" x2=\"15\" y1=\"15\" y2=\"15\"/><polyline class=\"ql-stroke\" points=\"5.5 11 9 3 12.5 11\"/><line class=\"ql-stroke\" x1=\"11.63\" x2=\"6.38\" y1=\"9\" y2=\"9\"/></svg>";
const $469d8b6ca234aa38$var$directionLeftToRightIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"/><line class=\"ql-stroke ql-fill\" x1=\"15\" x2=\"11\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M11,3a3,3,0,0,0,0,6h1V3H11Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"11\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"13\" y=\"4\"/></svg>";
const $469d8b6ca234aa38$var$directionRightToLeftIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"/><line class=\"ql-stroke ql-fill\" x1=\"9\" x2=\"5\" y1=\"4\" y2=\"4\"/><path class=\"ql-fill\" d=\"M5,3A3,3,0,0,0,5,9H6V3H5Z\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"5\" y=\"4\"/><rect class=\"ql-fill\" height=\"11\" width=\"1\" x=\"7\" y=\"4\"/></svg>";
const $469d8b6ca234aa38$var$formulaIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z\"/><rect class=\"ql-fill\" height=\"1.6\" rx=\"0.8\" ry=\"0.8\" width=\"5\" x=\"5.15\" y=\"6.2\"/><path class=\"ql-fill\" d=\"M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z\"/></svg>";
const $469d8b6ca234aa38$var$headerIcon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z\"/></svg>";
const $469d8b6ca234aa38$var$header2Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $469d8b6ca234aa38$var$header3Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $469d8b6ca234aa38$var$header4Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z\"/></svg>";
const $469d8b6ca234aa38$var$header5Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z\"/></svg>";
const $469d8b6ca234aa38$var$header6Icon = "<svg viewBox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z\"/></svg>";
const $469d8b6ca234aa38$var$italicIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"13\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"5\" x2=\"11\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"8\" x2=\"10\" y1=\"14\" y2=\"4\"/></svg>";
const $469d8b6ca234aa38$var$imageIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"10\" width=\"12\" x=\"3\" y=\"4\"/><circle class=\"ql-fill\" cx=\"6\" cy=\"7\" r=\"1\"/><polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"/></svg>";
const $469d8b6ca234aa38$var$indentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"/></svg>";
const $469d8b6ca234aa38$var$outdentIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"5 7 5 11 3 9 5 7\"/></svg>";
const $469d8b6ca234aa38$var$linkIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"11\" y1=\"7\" y2=\"11\"/><path class=\"ql-even ql-stroke\" d=\"M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z\"/><path class=\"ql-even ql-stroke\" d=\"M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z\"/></svg>";
const $469d8b6ca234aa38$var$listBulletIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"6\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"3\" x2=\"3\" y1=\"14\" y2=\"14\"/></svg>";
const $469d8b6ca234aa38$var$listCheckIcon = "<svg class=\"\" viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"4\" y2=\"4\"/><polyline class=\"ql-stroke\" points=\"3 4 4 5 6 3\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"14\" y2=\"14\"/><polyline class=\"ql-stroke\" points=\"3 14 4 15 6 13\"/><line class=\"ql-stroke\" x1=\"9\" x2=\"15\" y1=\"9\" y2=\"9\"/><polyline class=\"ql-stroke\" points=\"3 9 4 10 6 8\"/></svg>";
const $469d8b6ca234aa38$var$listOrderedIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"4\" y2=\"4\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"9\" y2=\"9\"/><line class=\"ql-stroke\" x1=\"7\" x2=\"15\" y1=\"14\" y2=\"14\"/><line class=\"ql-stroke ql-thin\" x1=\"2.5\" x2=\"4.5\" y1=\"5.5\" y2=\"5.5\"/><path class=\"ql-fill\" d=\"M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z\"/><path class=\"ql-stroke ql-thin\" d=\"M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156\"/><path class=\"ql-stroke ql-thin\" d=\"M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109\"/></svg>";
const $469d8b6ca234aa38$var$subscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z\"/><path class=\"ql-fill\" d=\"M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z\"/></svg>";
const $469d8b6ca234aa38$var$superscriptIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-fill\" d=\"M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z\"/><path class=\"ql-fill\" d=\"M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z\"/></svg>";
const $469d8b6ca234aa38$var$strikeIcon = "<svg viewbox=\"0 0 18 18\"><line class=\"ql-stroke ql-thin\" x1=\"15.5\" x2=\"2.5\" y1=\"8.5\" y2=\"9.5\"/><path class=\"ql-fill\" d=\"M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z\"/><path class=\"ql-fill\" d=\"M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z\"/></svg>";
const $469d8b6ca234aa38$var$tableIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"3\" x=\"5\" y=\"5\"/><rect class=\"ql-fill\" height=\"2\" width=\"4\" x=\"9\" y=\"5\"/><g class=\"ql-fill ql-transparent\"><rect height=\"2\" width=\"3\" x=\"5\" y=\"8\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"8\"/><rect height=\"2\" width=\"3\" x=\"5\" y=\"11\"/><rect height=\"2\" width=\"4\" x=\"9\" y=\"11\"/></g></svg>";
const $469d8b6ca234aa38$var$underlineIcon = "<svg viewbox=\"0 0 18 18\"><path class=\"ql-stroke\" d=\"M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3\"/><rect class=\"ql-fill\" height=\"1\" rx=\"0.5\" ry=\"0.5\" width=\"12\" x=\"3\" y=\"15\"/></svg>";
const $469d8b6ca234aa38$var$videoIcon = "<svg viewbox=\"0 0 18 18\"><rect class=\"ql-stroke\" height=\"12\" width=\"12\" x=\"3\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"5\" y=\"3\"/><rect class=\"ql-fill\" height=\"12\" width=\"1\" x=\"12\" y=\"3\"/><rect class=\"ql-fill\" height=\"2\" width=\"8\" x=\"5\" y=\"8\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"3\" y=\"12\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"5\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"7\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"10\"/><rect class=\"ql-fill\" height=\"1\" width=\"3\" x=\"12\" y=\"12\"/></svg>";
var $469d8b6ca234aa38$export$2e2bcd8739ae039 = {
    align: {
        '': $469d8b6ca234aa38$var$alignLeftIcon,
        center: $469d8b6ca234aa38$var$alignCenterIcon,
        right: $469d8b6ca234aa38$var$alignRightIcon,
        justify: $469d8b6ca234aa38$var$alignJustifyIcon
    },
    background: $469d8b6ca234aa38$var$backgroundIcon,
    blockquote: $469d8b6ca234aa38$var$blockquoteIcon,
    bold: $469d8b6ca234aa38$var$boldIcon,
    clean: $469d8b6ca234aa38$var$cleanIcon,
    code: $469d8b6ca234aa38$var$codeIcon,
    'code-block': $469d8b6ca234aa38$var$codeIcon,
    color: $469d8b6ca234aa38$var$colorIcon,
    direction: {
        '': $469d8b6ca234aa38$var$directionLeftToRightIcon,
        rtl: $469d8b6ca234aa38$var$directionRightToLeftIcon
    },
    formula: $469d8b6ca234aa38$var$formulaIcon,
    header: {
        '1': $469d8b6ca234aa38$var$headerIcon,
        '2': $469d8b6ca234aa38$var$header2Icon,
        '3': $469d8b6ca234aa38$var$header3Icon,
        '4': $469d8b6ca234aa38$var$header4Icon,
        '5': $469d8b6ca234aa38$var$header5Icon,
        '6': $469d8b6ca234aa38$var$header6Icon
    },
    italic: $469d8b6ca234aa38$var$italicIcon,
    image: $469d8b6ca234aa38$var$imageIcon,
    indent: {
        '+1': $469d8b6ca234aa38$var$indentIcon,
        '-1': $469d8b6ca234aa38$var$outdentIcon
    },
    link: $469d8b6ca234aa38$var$linkIcon,
    list: {
        bullet: $469d8b6ca234aa38$var$listBulletIcon,
        check: $469d8b6ca234aa38$var$listCheckIcon,
        ordered: $469d8b6ca234aa38$var$listOrderedIcon
    },
    script: {
        sub: $469d8b6ca234aa38$var$subscriptIcon,
        super: $469d8b6ca234aa38$var$superscriptIcon
    },
    strike: $469d8b6ca234aa38$var$strikeIcon,
    table: $469d8b6ca234aa38$var$tableIcon,
    underline: $469d8b6ca234aa38$var$underlineIcon,
    video: $469d8b6ca234aa38$var$videoIcon
};


const $09b36a484e30e87f$var$DropdownIcon = "<svg viewbox=\"0 0 18 18\"><polygon class=\"ql-stroke\" points=\"7 11 9 13 11 11 7 11\"/><polygon class=\"ql-stroke\" points=\"7 7 9 5 11 7 7 7\"/></svg>";
let $09b36a484e30e87f$var$optionsCounter = 0;
function $09b36a484e30e87f$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === 'true')}`);
}
class $09b36a484e30e87f$var$Picker {
    constructor(select){
        this.select = select;
        this.container = document.createElement('span');
        this.buildPicker();
        this.select.style.display = 'none';
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener('mousedown', ()=>{
            this.togglePicker();
        });
        this.label.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.togglePicker();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener('change', this.update.bind(this));
    }
    togglePicker() {
        this.container.classList.toggle('ql-expanded');
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $09b36a484e30e87f$var$toggleAriaAttribute(this.label, 'aria-expanded');
        // @ts-expect-error
        $09b36a484e30e87f$var$toggleAriaAttribute(this.options, 'aria-hidden');
    }
    buildItem(option) {
        const item = document.createElement('span');
        // @ts-expect-error
        item.tabIndex = '0';
        item.setAttribute('role', 'button');
        item.classList.add('ql-picker-item');
        const value = option.getAttribute('value');
        if (value) item.setAttribute('data-value', value);
        if (option.textContent) item.setAttribute('data-label', option.textContent);
        item.addEventListener('click', ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener('keydown', (event)=>{
            switch(event.key){
                case 'Enter':
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case 'Escape':
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement('span');
        label.classList.add('ql-picker-label');
        label.innerHTML = $09b36a484e30e87f$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = '0';
        label.setAttribute('role', 'button');
        label.setAttribute('aria-expanded', 'false');
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement('span');
        options.classList.add('ql-picker-options');
        // Don't want screen readers to read this until options are visible
        options.setAttribute('aria-hidden', 'true');
        // @ts-expect-error
        options.tabIndex = '-1';
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$09b36a484e30e87f$var$optionsCounter}`;
        $09b36a484e30e87f$var$optionsCounter += 1;
        this.label.setAttribute('aria-controls', options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add('ql-picker');
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove('ql-expanded');
        this.label.setAttribute('aria-expanded', 'false');
        // @ts-expect-error
        this.options.setAttribute('aria-hidden', 'true');
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector('.ql-selected');
        if (item === selected) return;
        if (selected != null) selected.classList.remove('ql-selected');
        if (item == null) return;
        item.classList.add('ql-selected');
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute('data-value')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
        else this.label.removeAttribute('data-value');
        if (item.hasAttribute('data-label')) // @ts-expect-error Fix me later
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
        else this.label.removeAttribute('data-label');
        if (trigger) {
            this.select.dispatchEvent(new Event('change'));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector('option[selected]');
        this.label.classList.toggle('ql-active', isActive);
    }
}
var $09b36a484e30e87f$export$2e2bcd8739ae039 = $09b36a484e30e87f$var$Picker;



class $923af48808382d41$var$ColorPicker extends (0, $09b36a484e30e87f$export$2e2bcd8739ae039) {
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add('ql-color-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).slice(0, 7).forEach((item)=>{
            item.classList.add('ql-primary');
        });
    }
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute('value') || '';
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector('.ql-color-label');
        const value = item ? item.getAttribute('data-value') || '' : '';
        if (colorLabel) {
            if (colorLabel.tagName === 'line') colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
}
var $923af48808382d41$export$2e2bcd8739ae039 = $923af48808382d41$var$ColorPicker;



class $5f1205e2080da574$var$IconPicker extends (0, $09b36a484e30e87f$export$2e2bcd8739ae039) {
    constructor(select, icons){
        super(select);
        this.container.classList.add('ql-icon-picker');
        Array.from(this.container.querySelectorAll('.ql-picker-item')).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
        });
        this.defaultItem = this.container.querySelector('.ql-selected');
        this.selectItem(this.defaultItem);
    }
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
}
var $5f1205e2080da574$export$2e2bcd8739ae039 = $5f1205e2080da574$var$IconPicker;


const $dac21464d824ad21$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== 'visible' && overflowY !== 'clip';
};
class $dac21464d824ad21$var$Tooltip {
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer('ql-tooltip');
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($dac21464d824ad21$var$isScrollable(this.quill.root)) this.quill.root.addEventListener('scroll', ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
    hide() {
        this.root.classList.add('ql-hidden');
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove('ql-flip');
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add('ql-flip');
        }
        return shift;
    }
    show() {
        this.root.classList.remove('ql-editing');
        this.root.classList.remove('ql-hidden');
    }
}
var $dac21464d824ad21$export$2e2bcd8739ae039 = $dac21464d824ad21$var$Tooltip;











const $23ba1a686a50085b$var$ALIGNS = [
    false,
    'center',
    'right',
    'justify'
];
const $23ba1a686a50085b$var$COLORS = [
    '#000000',
    '#e60000',
    '#ff9900',
    '#ffff00',
    '#008a00',
    '#0066cc',
    '#9933ff',
    '#ffffff',
    '#facccc',
    '#ffebcc',
    '#ffffcc',
    '#cce8cc',
    '#cce0f5',
    '#ebd6ff',
    '#bbbbbb',
    '#f06666',
    '#ffc266',
    '#ffff66',
    '#66b966',
    '#66a3e0',
    '#c285ff',
    '#888888',
    '#a10000',
    '#b26b00',
    '#b2b200',
    '#006100',
    '#0047b2',
    '#6b24b2',
    '#444444',
    '#5c0000',
    '#663d00',
    '#666600',
    '#003700',
    '#002966',
    '#3d1466'
];
const $23ba1a686a50085b$var$FONTS = [
    false,
    'serif',
    'monospace'
];
const $23ba1a686a50085b$var$HEADERS = [
    '1',
    '2',
    '3',
    false
];
const $23ba1a686a50085b$var$SIZES = [
    'small',
    false,
    'large',
    'huge'
];
class $23ba1a686a50085b$export$2e2bcd8739ae039 extends (0, $e05344d517000266$export$2e2bcd8739ae039) {
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener('click', listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM('click', document.body, listener);
    }
    addModule(name) {
        const module = super.addModule(name);
        if (name === 'toolbar') // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute('class') || '';
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith('ql-')) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === 'direction') // @ts-expect-error
                button.innerHTML = icons[name][''] + icons[name].rtl;
                else if (typeof icons[name] === 'string') // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || '';
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) $23ba1a686a50085b$var$fillSelect(select, $23ba1a686a50085b$var$ALIGNS);
                if (typeof icons.align === 'object') return new (0, $5f1205e2080da574$export$2e2bcd8739ae039)(select, icons.align);
            }
            if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                const format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) $23ba1a686a50085b$var$fillSelect(select, $23ba1a686a50085b$var$COLORS, format === 'background' ? '#ffffff' : '#000000');
                return new (0, $923af48808382d41$export$2e2bcd8739ae039)(select, icons[format]);
            }
            if (select.querySelector('option') == null) {
                if (select.classList.contains('ql-font')) $23ba1a686a50085b$var$fillSelect(select, $23ba1a686a50085b$var$FONTS);
                else if (select.classList.contains('ql-header')) $23ba1a686a50085b$var$fillSelect(select, $23ba1a686a50085b$var$HEADERS);
                else if (select.classList.contains('ql-size')) $23ba1a686a50085b$var$fillSelect(select, $23ba1a686a50085b$var$SIZES);
            }
            return new (0, $09b36a484e30e87f$export$2e2bcd8739ae039)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.EDITOR_CHANGE, update);
    }
}
$23ba1a686a50085b$export$2e2bcd8739ae039.DEFAULTS = (0, $0d18bb024fdf2a99$export$2e2bcd8739ae039)({}, (0, $e05344d517000266$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit('formula');
                },
                image () {
                    let fileInput = this.container.querySelector('input.ql-image[type=file]');
                    if (fileInput == null) {
                        fileInput = document.createElement('input');
                        fileInput.setAttribute('type', 'file');
                        fileInput.setAttribute('accept', this.quill.uploader.options.mimetypes.join(', '));
                        fileInput.classList.add('ql-image');
                        fileInput.addEventListener('change', ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = '';
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit('video');
                }
            }
        }
    }
});
class $23ba1a686a50085b$export$ba0102162f9e195c extends (0, $dac21464d824ad21$export$2e2bcd8739ae039) {
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter') {
                this.save();
                event.preventDefault();
            } else if (event.key === 'Escape') {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove('ql-hidden');
        this.root.classList.add('ql-editing');
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute('data-mode')) this.textbox.value = '';
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute('placeholder', this.textbox.getAttribute(`data-${mode}`) || '');
        this.root.setAttribute('data-mode', mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute('data-mode')){
            case 'link':
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, 'link', value, (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format('link', value, (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case 'video':
                value = $23ba1a686a50085b$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case 'formula':
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute('data-mode'), value, (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER);
                        if (this.root.getAttribute('data-mode') === 'formula') this.quill.insertText(index + 1, ' ', (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index + 2, (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = '';
        this.hide();
    }
}
function $23ba1a686a50085b$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || 'https'}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $23ba1a686a50085b$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement('option');
        if (value === defaultValue) option.setAttribute('selected', 'selected');
        else option.setAttribute('value', String(value));
        select.appendChild(option);
    });
}





const $2eff835e68476ac5$var$TOOLBAR_CONFIG = [
    [
        'bold',
        'italic',
        'link'
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        'blockquote'
    ]
];
class $2eff835e68476ac5$export$572b56f7a5e9813a extends (0, $23ba1a686a50085b$export$ba0102162f9e195c) {
    static TEMPLATE = [
        '<span class="ql-tooltip-arrow"></span>',
        '<div class="ql-tooltip-editor">',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-close"></a>',
        '</div>'
    ].join('');
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = '0px';
                this.root.style.width = '';
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $a5020f719d503ef6$export$9a58ef0d7ad3278c)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('.ql-close').addEventListener('click', ()=>{
            this.root.classList.remove('ql-editing');
        });
        this.quill.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains('ql-hidden')) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector('.ql-tooltip-arrow');
        // @ts-expect-error
        arrow.style.marginLeft = '';
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
}
class $2eff835e68476ac5$export$2e2bcd8739ae039 extends (0, $23ba1a686a50085b$export$2e2bcd8739ae039) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $2eff835e68476ac5$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-bubble');
    }
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $2eff835e68476ac5$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $469d8b6ca234aa38$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $469d8b6ca234aa38$export$2e2bcd8739ae039));
        }
    }
}
$2eff835e68476ac5$export$2e2bcd8739ae039.DEFAULTS = (0, $0d18bb024fdf2a99$export$2e2bcd8739ae039)({}, (0, $23ba1a686a50085b$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format('link', false, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});









const $c31ac7177c72c5d3$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                '1',
                '2',
                '3',
                false
            ]
        }
    ],
    [
        'bold',
        'italic',
        'underline',
        'link'
    ],
    [
        {
            list: 'ordered'
        },
        {
            list: 'bullet'
        }
    ],
    [
        'clean'
    ]
];
class $c31ac7177c72c5d3$var$SnowTooltip extends (0, $23ba1a686a50085b$export$ba0102162f9e195c) {
    static TEMPLATE = [
        '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
        '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
        '<a class="ql-action"></a>',
        '<a class="ql-remove"></a>'
    ].join('');
    preview = this.root.querySelector('a.ql-preview');
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-action').addEventListener('click', (event)=>{
            if (this.root.classList.contains('ql-editing')) this.save();
            else // @ts-expect-error Fix me later
            this.edit('link', this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector('a.ql-remove').addEventListener('click', (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, 'link', false, (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $1afdc0502a30db43$export$2e2bcd8739ae039).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $1afdc0502a30db43$export$2e2bcd8739ae039).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $6d16e1aed52b8757$export$2e2bcd8739ae039), range.index);
                if (link != null) {
                    this.linkRange = new (0, $a5020f719d503ef6$export$9a58ef0d7ad3278c)(range.index - offset, link.length());
                    const preview = (0, $6d16e1aed52b8757$export$2e2bcd8739ae039).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute('href', preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute('data-mode');
    }
}
class $c31ac7177c72c5d3$var$SnowTheme extends (0, $23ba1a686a50085b$export$2e2bcd8739ae039) {
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $c31ac7177c72c5d3$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add('ql-snow');
    }
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons(toolbar.container.querySelectorAll('button'), (0, $469d8b6ca234aa38$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll('select'), (0, $469d8b6ca234aa38$export$2e2bcd8739ae039));
            // @ts-expect-error
            this.tooltip = new $c31ac7177c72c5d3$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) this.quill.keyboard.addBinding({
                key: 'k',
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
}
$c31ac7177c72c5d3$var$SnowTheme.DEFAULTS = (0, $0d18bb024fdf2a99$export$2e2bcd8739ae039)({}, (0, $23ba1a686a50085b$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit('link', preview);
                    } else this.quill.format('link', false, (0, $6c63a051452c3514$export$2e2bcd8739ae039).sources.USER);
                }
            }
        }
    }
});
var $c31ac7177c72c5d3$export$2e2bcd8739ae039 = $c31ac7177c72c5d3$var$SnowTheme;


(0, $b01b8198fe568ec6$export$2e2bcd8739ae039).register({
    'attributors/attribute/direction': (0, $d9816cce0476f347$export$4158215dafad9efa),
    'attributors/class/align': (0, $b88e03f2e2231de6$export$7f3685f5846c07da),
    'attributors/class/background': (0, $d96f3d57b3588768$export$8aa96c8963152b12),
    'attributors/class/color': (0, $db342fd56e369e0d$export$42795dcf0ec6f3c8),
    'attributors/class/direction': (0, $d9816cce0476f347$export$630028b3af294dec),
    'attributors/class/font': (0, $5a73a06410542650$export$78a99ee601572ab),
    'attributors/class/size': (0, $8047ded6c01b115d$export$c84684d52bca9684),
    'attributors/style/align': (0, $b88e03f2e2231de6$export$d2060f5d114c9fe8),
    'attributors/style/background': (0, $d96f3d57b3588768$export$dc1cbcab4c682ef),
    'attributors/style/color': (0, $db342fd56e369e0d$export$1415f56796d9a5a9),
    'attributors/style/direction': (0, $d9816cce0476f347$export$175979e518d1dfd1),
    'attributors/style/font': (0, $5a73a06410542650$export$23b468d4ca3f8c96),
    'attributors/style/size': (0, $8047ded6c01b115d$export$5443b95a30e89ac5)
}, true);
(0, $b01b8198fe568ec6$export$2e2bcd8739ae039).register({
    'formats/align': (0, $b88e03f2e2231de6$export$7f3685f5846c07da),
    'formats/direction': (0, $d9816cce0476f347$export$630028b3af294dec),
    'formats/indent': (0, $88bd0ed8af36f292$export$2e2bcd8739ae039),
    'formats/background': (0, $d96f3d57b3588768$export$dc1cbcab4c682ef),
    'formats/color': (0, $db342fd56e369e0d$export$1415f56796d9a5a9),
    'formats/font': (0, $5a73a06410542650$export$78a99ee601572ab),
    'formats/size': (0, $8047ded6c01b115d$export$c84684d52bca9684),
    'formats/blockquote': (0, $5a80bdb49dfb1206$export$2e2bcd8739ae039),
    'formats/code-block': (0, $5c0b3cffc90a1532$export$2e2bcd8739ae039),
    'formats/header': (0, $54bee53c2b362e1b$export$2e2bcd8739ae039),
    'formats/list': (0, $468fc7ddf1cc3dfe$export$2e2bcd8739ae039),
    'formats/bold': (0, $0bd9492cc8e3e4a0$export$2e2bcd8739ae039),
    'formats/code': (0, $5c0b3cffc90a1532$export$52f0f02147b12c03),
    'formats/italic': (0, $69ec79a04f2db2d5$export$2e2bcd8739ae039),
    'formats/link': (0, $6d16e1aed52b8757$export$2e2bcd8739ae039),
    'formats/script': (0, $d1902717535ea3e6$export$2e2bcd8739ae039),
    'formats/strike': (0, $daf8c18c3bbe0720$export$2e2bcd8739ae039),
    'formats/underline': (0, $101eb7f77601f65f$export$2e2bcd8739ae039),
    'formats/formula': (0, $6813bed97afb2ca6$export$2e2bcd8739ae039),
    'formats/image': (0, $0aaf6ace05e344d3$export$2e2bcd8739ae039),
    'formats/video': (0, $1c8ba880f81d9d8c$export$2e2bcd8739ae039),
    'modules/syntax': (0, $08af0e7195cb4f6d$export$2e2bcd8739ae039),
    'modules/table': (0, $b7ccffa93951e25f$export$2e2bcd8739ae039),
    'modules/toolbar': (0, $91dc39b97ea1d950$export$2e2bcd8739ae039),
    'themes/bubble': (0, $2eff835e68476ac5$export$2e2bcd8739ae039),
    'themes/snow': (0, $c31ac7177c72c5d3$export$2e2bcd8739ae039),
    'ui/icons': (0, $469d8b6ca234aa38$export$2e2bcd8739ae039),
    'ui/picker': (0, $09b36a484e30e87f$export$2e2bcd8739ae039),
    'ui/icon-picker': (0, $5f1205e2080da574$export$2e2bcd8739ae039),
    'ui/color-picker': (0, $923af48808382d41$export$2e2bcd8739ae039),
    'ui/tooltip': (0, $dac21464d824ad21$export$2e2bcd8739ae039)
}, true);
var $849888171009792d$export$2e2bcd8739ae039 = (0, $b01b8198fe568ec6$export$2e2bcd8739ae039);



function $e68aa2c391c1fe4a$export$2e2bcd8739ae039(props) {
    const containerRef = (0, $bJrD0.useRef)(null);
    (0, $bJrD0.useEffect)(()=>{
        const container = containerRef.current;
        const editorContainer = container.appendChild(container.ownerDocument.createElement("div"));
        const quill = new (0, $849888171009792d$export$2e2bcd8739ae039)(editorContainer, {
            theme: "snow",
            placeholder: props.placeholder
        });
        if (props.editorRef) props.editorRef(quill);
        if (props.defaultValue) try {
            quill.setContents(JSON.parse(props.defaultValue).delta);
        } catch  {
            quill.setText(props.defaultValue);
        }
        // I cannot work out how to prevent the image being added into the editor
        // on paste, so this will delete any images if found since the image
        // should be attached to the message not be part of the text content
        quill.on("text-change", (delta, oldDelta, source)=>{
            const contents = quill.getContents();
            let index = 0;
            contents.ops.forEach((op)=>{
                if (op.insert && op.insert.image) quill.deleteText(index, 1, "silent");
                else if (typeof op.insert === "string") index += op.insert.length;
                else index += 1;
            });
            props.genPreview(quill.getText(), quill.getContents());
        });
        return ()=>{
            props.editorRef.current = null;
            container.innerHTML = "";
        };
    }, []);
    return (0, $9SeGy.h)("div", {
        class: "quill-container",
        ref: containerRef
    });
}




var $bJrD0 = parcelRequire("bJrD0");
function $bd90da8fd697beab$var$_extends() {
    return $bd90da8fd697beab$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bd90da8fd697beab$var$_extends.apply(null, arguments);
}
function $bd90da8fd697beab$export$2e2bcd8739ae039(props) {
    const [preview, setPreview] = (0, $bJrD0.useState)(null);
    const [link, setLink] = (0, $bJrD0.useState)("");
    const [text, setText] = (0, $bJrD0.useState)(props.text || "");
    const [title, setTitle] = (0, $bJrD0.useState)(props.title || "");
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const writerForm = (0, $bJrD0.useRef)(null);
    const cleanForm = ()=>{
        setPreview(null);
        setLink(null);
        setText("");
        setTitle("");
    };
    const sendMessage = (writerForm)=>{
        props.sendMessage(writerForm, {
            title: writerForm?.current?.querySelector(".title-input")?.value,
            text: JSON.stringify({
                delta: props.editorRef.current.getContents(),
                textOnly: props.editorRef.current.getText()
            })
        });
        cleanForm();
    };
    const genPreview = (text, delta)=>{
        if (!text || text.trim() === "") {
            setPreview(null);
            setLink(null);
            return;
        }
        // Text can contain links, so we need the delta content to find all links
        let deltaString = JSON.stringify(delta);
        // waiting for the dom to be updated
        setTimeout(()=>{
            let links = deltaString.match(/(https?:\/\/[^\s\\"]+)/gi);
            if (links && links[0] != link) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/links/by_url?url=${encodeURIComponent(links[0])}`).then((r)=>{
                if (r && deltaString.indexOf(links[0]) >= 0) {
                    setLink(links[0]);
                    setPreview(r);
                }
            });
        }, 0);
    };
    const onKeyDown = (event)=>{
        if (event.ctrlKey && (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).is_it_enter(event)) {
            sendMessage(writerForm);
            return;
        }
    };
    const onPaste = (event)=>{
        props.addFiles("image/jpeg", event.clipboardData.files);
    };
    if (props.sending) return (0, $9SeGy.h)("div", {
        class: "message-placeholder"
    }, (0, $9SeGy.h)("div", {
        class: "spinner orange-spinner"
    }, (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null), (0, $9SeGy.h)("div", null)));
    return (0, $9SeGy.h)("div", {
        id: props.id,
        class: "writer",
        ref: writerForm
    }, !props.isChild && (0, $9SeGy.h)("input", {
        type: "text",
        class: "title-input",
        onKeyPress: (e)=>onKeyDown(e),
        placeholder: t("title_placeholder"),
        value: title,
        onChange: (e)=>setTitle(e.target.value)
    }), (0, $9SeGy.h)("div", {
        onPasteCapture: onPaste,
        onKeyDown: onKeyDown
    }, (0, $9SeGy.h)((0, $e68aa2c391c1fe4a$export$2e2bcd8739ae039), {
        editorRef: (quill)=>{
            props.editorRef.current = quill;
        },
        defaultValue: text,
        placeholder: t("text_placeholder"),
        genPreview: genPreview
    })), !!preview && (0, $9SeGy.h)((0, $c72cf4b6b78e8f8e$export$330d558700ffa676), $bd90da8fd697beab$var$_extends({
        inWriter: true
    }, preview)), !!props.files.length && (0, $9SeGy.h)((0, $c72cf4b6b78e8f8e$export$ca445ff2f74d7dc4), {
        files: props.files,
        toggleFile: props.toggleFile,
        invertFiles: props.invertFiles,
        inWriter: true
    }), (0, $9SeGy.h)("div", {
        class: "options"
    }, (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6)?.info?.upload?.image && (0, $9SeGy.h)("button", {
        class: "option",
        onClick: ()=>props.inputFile("image/*", true),
        title: t("upload_image")
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "regular",
        icon: "images"
    })), (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6)?.info?.upload?.video && (0, $9SeGy.h)("button", {
        class: "option",
        onClick: ()=>props.inputFile("video/*"),
        title: t("upload_video")
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "film"
    })), (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6)?.info?.upload?.pdf && (0, $9SeGy.h)("button", {
        class: "option",
        onClick: ()=>props.inputFile("application/pdf"),
        title: t("upload_pdf")
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "regular",
        icon: "file-pdf"
    })), (0, $9SeGy.h)("div", {
        class: "actions"
    }, !!props.cancel && (0, $9SeGy.h)("button", {
        class: "cancel",
        onClick: (e)=>props.cancel(e)
    }, t("cancel")), (0, $9SeGy.h)("button", {
        disabled: !props.group || props.uploading,
        type: "submit",
        class: "submit",
        onClick: ()=>sendMessage(writerForm)
    }, t("submit")))));
}


const $b0c42e92c84db02f$export$29913b8f065577b2 = (0, $37e28339f35f2974$export$2e2bcd8739ae039);
const $b0c42e92c84db02f$export$d7a960146e1a269e = (0, $fe5a7484fb575b8e$export$2e2bcd8739ae039);
const $b0c42e92c84db02f$export$29beae8571dce55f = (0, $bd90da8fd697beab$export$2e2bcd8739ae039);








var $bJrD0 = parcelRequire("bJrD0");
function $2f916fd353a9e499$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const me = (0, $7ba8b1ffcfbcdb40$export$6ccbb43953eebf8)((0, $5332018adf75499b$export$a94cb3a0c5b0c060));
    const location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    const searchParams = new URLSearchParams(location.search);
    const [loaded, setLoaded] = (0, $bJrD0.useState)(false);
    const [title, setTitle] = (0, $bJrD0.useState)(searchParams.get("title") || "");
    const [text, setText] = (0, $bJrD0.useState)(searchParams.get("text") || "");
    const [url, setUrl] = (0, $bJrD0.useState)(searchParams.get("url") || "");
    const parent = searchParams.get("parent") || "";
    const [files, setFiles] = (0, $bJrD0.useState)([]);
    const [group, setGroup] = (0, $bJrD0.useState)("");
    (0, $bJrD0.useEffect)(()=>{
        setTimeout(()=>{
            (0, $cd2f6546c5cf5c32$export$3e32638432616b6).fetch().then((user)=>{
                if (!user || user?._networkError) {
                    setLoaded(true);
                    return;
                }
                if (user.data["default_group"]) setGroup(user.data["default_group"]);
                else if (user.groups.length == 1) setGroup(user.groups[0]["id"]);
                if (searchParams.get("message")) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${searchParams.get("message")}`).then((m)=>{
                    if (!m) {
                        setLoaded(true);
                        return;
                    }
                    if (m?.files?.length) Promise.all(m.files.map((f)=>(0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/files/${f.id}`).catch(()=>null).then((f)=>f))).then((files)=>{
                        setFiles(files.filter((f)=>f != null));
                        setTitle(m?.data?.title || "");
                        setText(m?.data?.text || "");
                        setUrl("");
                        setLoaded(true);
                    });
                    else {
                        setTitle(m?.data?.title || "");
                        setText(m?.data?.text || "");
                        setUrl("");
                        setLoaded(true);
                    }
                }).catch(()=>{
                    setLoaded(true);
                });
                else setLoaded(true);
            });
        }, 100);
    }, []);
    if (!loaded) return;
    return (0, $9SeGy.h)("main", null, (0, $9SeGy.h)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $9SeGy.h)("div", {
        class: "content"
    }, (0, $9SeGy.h)("article", {
        class: "mt-2"
    }, (0, $9SeGy.h)("div", {
        class: "container"
    }, !parent && me?.groups?.length > 1 && (0, $9SeGy.h)("div", {
        class: "mb-1"
    }, (0, $9SeGy.h)("label", {
        class: "px-1",
        for: "group_share_choice"
    }, t("group_share_choice")), (0, $9SeGy.h)("select", {
        value: group,
        class: "form-select",
        name: "group_share_choice",
        onChange: (e)=>setGroup(e.target.value),
        required: true
    }, me?.groups.map((e)=>(0, $9SeGy.h)("option", {
            key: e["id"],
            value: e["id"]
        }, e.name)))), !!parent && (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        for: "apiKey"
    }, t("parent_message"), ":", " "), (0, $9SeGy.h)("input", {
        type: "text",
        name: "parent_message",
        value: parent,
        class: "form-control font-size-80",
        readonly: "readonly"
    })), (0, $9SeGy.h)((0, $b0c42e92c84db02f$export$d7a960146e1a269e), {
        focus: true,
        group: group,
        title: title,
        parent: parent,
        text: text || url ? `${text}\n${url}` : "",
        files: files
    })))));
}


const $be03c4de42ac64ff$export$9c257beea3dbd13a = (0, $6f8b52f4496f3b9a$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$1a13290ec7702c7 = (0, $dd2a1b0379ca9bf9$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$959a4441e74dcd2b = (0, $4016a5cf4497ca7a$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$8ff3eb003b44d68f = (0, $0b07cfe23f8797f2$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$35f3ae0a16fef81 = (0, $aed7e74f78402a69$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$14834abbfce3b8cd = (0, $73f3a1fb1b71c71a$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$4b31f5af7c5f8dee = (0, $2ed7e499aaac665f$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$4b85d3515bd863a5 = (0, $a06567713ad1b415$export$2e2bcd8739ae039);
const $be03c4de42ac64ff$export$c9915453de10000b = (0, $2f916fd353a9e499$export$2e2bcd8739ae039);





var $9SeGy = parcelRequire("9SeGy");

var $bJrD0 = parcelRequire("bJrD0");


var $9SeGy = parcelRequire("9SeGy");

var $bJrD0 = parcelRequire("bJrD0");



var $iisr1 = parcelRequire("iisr1");

const $0580fe301059d98e$var$EmojiPicker = (0, $iisr1.lazy)(()=>(parcelRequire("3C1av")));

function $0580fe301059d98e$export$2e2bcd8739ae039(props) {
    const [showPicker, setShowPicker] = (0, $bJrD0.useState)(false);
    const pickerRef = (0, $bJrD0.useRef)(null);
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const handleEmojiClick = async (emoji)=>{
        setShowPicker(false);
        const response = await (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post(`/api/messages/${props.messageId}/reactions`, {
            reaction: emoji.emoji
        }).catch(()=>null);
        if (response) props.updateReactions(response);
    };
    const handleClickOutside = (event)=>{
        if (pickerRef.current && !pickerRef.current.contains(event.target)) setShowPicker(false);
    };
    (0, $bJrD0.useEffect)(()=>{
        (parcelRequire("3C1av"));
        if (showPicker) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showPicker
    ]);
    return (0, $9SeGy.h)("div", {
        ref: pickerRef
    }, (0, $9SeGy.h)("div", {
        class: "d-flex",
        style: {
            cursor: "pointer"
        },
        onClick: ()=>{
            if ($0580fe301059d98e$var$EmojiPicker) setShowPicker(!showPicker);
        }
    }, t("react")), showPicker && (0, $9SeGy.h)("div", {
        style: {
            position: "absolute",
            zIndex: 1000
        }
    }, (0, $9SeGy.h)((0, $iisr1.Suspense), {
        fallback: null
    }, (0, $9SeGy.h)($0580fe301059d98e$var$EmojiPicker, {
        onEmojiClick: handleEmojiClick,
        emojiStyle: "native",
        reactionsDefaultOpen: true,
        previewConfig: {
            defaultEmoji: "26aa",
            defaultCaption: "",
            showPreview: true
        },
        reactions: [
            "1f44d",
            "2764-fe0f",
            "1f923",
            "1f622",
            "1f44e",
            "1f621"
        ]
    }))));
}



function $9dbe6f8e1c81690f$export$2e2bcd8739ae039(props) {
    const [reactions, setReactions] = (0, $bJrD0.useState)([]);
    const [hoveredReaction, setHoveredReaction] = (0, $bJrD0.useState)(null);
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const MAX_VISIBLE_USERS = 10;
    const loadReactions = async (reactionData)=>{
        const formattedReactions = Object.values(reactionData).map((reaction)=>({
                emoji: reaction.emoji,
                count: reaction.count,
                users: reaction.users,
                currentUserReactionId: reaction.currentUserReactionId
            }));
        setReactions(formattedReactions);
    };
    (0, $bJrD0.useEffect)(()=>{
        if (!props.messageId) return;
        const fetchReactions = async ()=>{
            const reactionData = await (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${props.messageId}/reactions`).catch(()=>null);
            if (reactionData) await loadReactions(reactionData);
        };
        fetchReactions();
    }, [
        props.messageId
    ]);
    const handleReactionClick = async (currentUserReactionId)=>{
        // If current user set this emoji type, click to remove it
        if (currentUserReactionId) {
            await (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).delete(`/api/messages/${props.messageId}/reactions/${currentUserReactionId}`).catch((err)=>console.warn(err));
            const reactionData = await (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${props.messageId}/reactions`).catch(()=>null);
            if (reactionData) await loadReactions(reactionData);
        }
    };
    return (0, $9SeGy.h)("a", {
        className: "d-flex action seamless-link font-size-90 capitalize"
    }, reactions.map(({ emoji: emoji, count: count, users: users, currentUserReactionId: currentUserReactionId })=>(0, $9SeGy.h)("div", {
            key: emoji,
            className: "reaction-emoji",
            style: {
                cursor: currentUserReactionId ? "pointer" : "default"
            },
            title: users.slice(0, MAX_VISIBLE_USERS).join("\n") + (users.length > MAX_VISIBLE_USERS ? `\n${t("and_x_more", {
                count: `${users.length - MAX_VISIBLE_USERS}`
            })}...` : ""),
            onMouseEnter: ()=>setHoveredReaction(emoji),
            onMouseLeave: ()=>setHoveredReaction(null)
        }, (0, $9SeGy.h)("span", {
            style: {
                opacity: hoveredReaction === emoji && currentUserReactionId ? 0.6 : 1,
                transition: "opacity 0.2s ease-in-out"
            },
            onClick: ()=>currentUserReactionId && handleReactionClick(currentUserReactionId)
        }, emoji), (0, $9SeGy.h)("span", {
            className: "reaction-count"
        }, count))), reactions.length > 0 && (0, $9SeGy.h)("div", {
        class: "dot"
    }, "\u2022"), (0, $9SeGy.h)((0, $9SeGy.Fragment), null, (0, $9SeGy.h)("div", {
        class: "font-size-90",
        className: "reaction-button"
    }, (0, $9SeGy.h)((0, $0580fe301059d98e$export$2e2bcd8739ae039), {
        messageId: props?.messageId,
        updateReactions: loadReactions
    }))));
}


function $d0274a88e468a969$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const bookmarks = (0, $7ba8b1ffcfbcdb40$export$6ccbb43953eebf8)((0, $1648cda18d60f785$export$b294d243702b04e2));
    const isPinned = props?.message?.sortOrder !== undefined;
    return (0, $9SeGy.h)("div", {
        class: "message-footer"
    }, (0, $9SeGy.h)("div", {
        class: "infos"
    }, props.message && !props.isPublic && (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6)?.info?.allow_message_reactions && (0, $9SeGy.h)((0, $9SeGy.Fragment), null, (0, $9SeGy.h)((0, $9dbe6f8e1c81690f$export$2e2bcd8739ae039), {
        messageId: props.message.id
    }), (0, $9SeGy.h)("div", {
        class: "dot"
    }, "\u2022")), !props?.isPublic && props?.author && props?.author?.id === (0, $cd2f6546c5cf5c32$export$3e32638432616b6).id && (0, $9SeGy.h)((0, $9SeGy.Fragment), null, (0, $9SeGy.h)("a", {
        class: "action seamless-link font-size-90 capitalize d-none d-sm-block",
        onClick: (e)=>props.editMessage(e)
    }, t("edit")), (0, $9SeGy.h)("div", {
        class: "dot d-none d-sm-block"
    }, "\u2022")), !props?.isPublic && props?.isChild && props?.message && (0, $9SeGy.h)((0, $9SeGy.Fragment), null, (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "action seamless-link font-size-90 capitalize",
        to: `/messages/${props?.message.id}${props?.message?.children.length ? "" : "?focus=reply"}`
    }, props?.message?.children.length ? props.message.children.some((e)=>(0, $cd2f6546c5cf5c32$export$6008d97729a90c74).isNew(e.id)) ? (0, $9SeGy.h)("b", null, t("replies", {
        count: props.message.children.length
    })) : t("replies", {
        count: props.message.children.length
    }) : t("reply")), (0, $9SeGy.h)("div", {
        class: "dot"
    }, "\u2022")), (0, $9SeGy.h)("div", {
        class: "date font-size-90",
        title: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanFullDate(props?.message.createdAt)
    }, (0, $9SeGy.h)((0, $be03c4de42ac64ff$export$35f3ae0a16fef81), {
        timestamp: props?.message.createdAt
    })), (0, $9SeGy.h)((0, $9SeGy.Fragment), null, (0, $9SeGy.h)("div", {
        class: "dot"
    }, "\u2022"), (0, $9SeGy.h)("div", {
        class: "font-size-90"
    }, props?.author && props?.author?.name ? props.author.name : "--"))), (0, $9SeGy.h)("div", null, !props?.isPublic && (0, $9SeGy.h)("div", {
        class: "options dropdown",
        onClick: (e)=>e?.target?.closest(".dropdown")?.classList.toggle("active")
    }, (0, $9SeGy.h)("div", {
        class: "none-if-follows-empty"
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "solid",
        icon: "ellipsis-h"
    })), (0, $9SeGy.h)("div", {
        class: "dropdown-menu dropdown-options"
    }, props?.author && props?.author?.id === (0, $cd2f6546c5cf5c32$export$3e32638432616b6).id && (0, $9SeGy.h)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.deleteMessage(e)
    }, t("delete")), (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6)?.info?.allow_public_links && (0, $9SeGy.h)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.openPublicLink(e)
    }, t("public_link")), (0, $cd2f6546c5cf5c32$export$3e32638432616b6).groups?.length > 1 && (0, $9SeGy.h)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.shareMessage(e)
    }, t("share_message")), !props?.message?.isInFront && props?.author && props?.author.id == (0, $cd2f6546c5cf5c32$export$3e32638432616b6).id && (0, $9SeGy.h)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.publishInGroup(e)
    }, t("publish_in_group")), props?.message?.isInFront && (0, $9SeGy.h)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>isPinned ? props.unpinInGroup(e) : props.pinInGroup(e)
    }, isPinned ? t("unpin_in_group") : t("pin_in_group")), !bookmarks.some((b)=>b.message.id === props?.message.id) && (0, $9SeGy.h)("a", {
        class: "seamless-link capitalize",
        onClick: ()=>{
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("bookmark_added"));
            (0, $1648cda18d60f785$export$72009cc673d27d80)(props.message.id);
        }
    }, t("add_bookmark")), bookmarks.some((b)=>b.message.id === props?.message.id) && (0, $9SeGy.h)("a", {
        class: "seamless-link capitalize",
        onClick: ()=>{
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("bookmark_removed"));
            (0, $1648cda18d60f785$export$2db69b245b3902c8)(bookmarks.find((b)=>b.message.id === props.message.id));
        }
    }, t("remove_bookmark")), props?.author?.id == (0, $cd2f6546c5cf5c32$export$3e32638432616b6).id && (0, $9SeGy.h)("a", {
        class: "seamless-link capitalize",
        onClick: (e)=>props.editMessage(e)
    }, t("edit"))))));
}



var $9SeGy = parcelRequire("9SeGy");



var $bJrD0 = parcelRequire("bJrD0");

var $9SeGy = parcelRequire("9SeGy");

var $bJrD0 = parcelRequire("bJrD0");


function $b7448f13a7a35d50$export$2e2bcd8739ae039({ editorRef: editorRef, contents: contents }) {
    const containerRef = (0, $bJrD0.useRef)(null);
    (0, $bJrD0.useEffect)(()=>{
        const container = containerRef.current;
        const editorContainer = container.appendChild(container.ownerDocument.createElement("div"));
        const quill = new (0, $849888171009792d$export$2e2bcd8739ae039)(editorContainer, {
            theme: "snow",
            readOnly: true,
            modules: {
                toolbar: null
            }
        });
        if (editorRef) editorRef(quill);
        quill.setContents(contents);
        return ()=>{
            editorRef.current = null;
        };
    }, []);
    return (0, $9SeGy.h)("div", {
        ref: containerRef
    });
}


function $5d78aeb8bd3c3482$var$parseJson(jsonString) {
    try {
        let o = JSON.parse(jsonString);
        return o && typeof o === "object" ? o : false;
    } catch (e) {
        return false;
    }
}
function $5d78aeb8bd3c3482$export$f2f615077a189f21(message) {
    let type, delta, textOnly;
    let parsed = $5d78aeb8bd3c3482$var$parseJson(message.data.text);
    if (parsed) {
        delta = parsed?.delta ?? null;
        textOnly = parsed?.textOnly ?? "";
        type = message?.type ?? "standard";
    } else {
        delta = null;
        textOnly = message.data.text ?? "";
        type = "standard";
    }
    return {
        "type": type,
        "text": textOnly,
        "delta": delta
    };
}


function $5345fa5f2538b9ef$export$2e2bcd8739ae039(props) {
    const [preview, setPreview] = (0, $bJrD0.useState)(null);
    const readOnlyRefs = (0, $bJrD0.useRef)({});
    const displayStandardMessageText = (text)=>{
        if (!text) return "";
        // escape html a little (just enough to avoid xss I hope)
        let txt = text.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
        // replace url by real links
        let shift = 0;
        let match = null;
        while(match = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getUrl(txt.slice(shift))){
            let url = match[0];
            if (url.length >= 50) url = `${url.slice(0, 25)}...${url.slice(-24)}`;
            let link = `<a href="${match[0]}" target="_blank">${url}</a>`;
            txt = txt.slice(0, match["index"] + shift) + link + txt.slice(match["index"] + shift + match[0].length);
            shift += match["index"] + link.length;
        }
        // replace line returns
        txt = txt.replace(/\n/g, "<br/>");
        return {
            __html: txt
        };
    };
    const quillData = (0, $5d78aeb8bd3c3482$export$f2f615077a189f21)(props.message);
    (0, $bJrD0.useEffect)(()=>{
        if (!preview && props.message) {
            if (props.message.data) {
                let previewUrl = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getUrl(quillData.text);
                if (previewUrl) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/links/by_url?url=${encodeURIComponent(previewUrl[0])}`).then((r)=>setPreview(r));
            }
        }
    }, [
        preview,
        props.message
    ]);
    return (0, $9SeGy.h)("div", {
        class: "message-body"
    }, props.message.data && props.message.data.title && (0, $9SeGy.h)("div", {
        class: "title"
    }, (0, $9SeGy.h)("span", null, props.message.data.title)), props.message.data && props.message.data.text && props.message.data.text.trim() && (0, $9SeGy.h)("div", {
        class: "card-text"
    }, quillData.type === "rich_text" ? (0, $9SeGy.h)((0, $b7448f13a7a35d50$export$2e2bcd8739ae039), {
        editorRef: (quill)=>{
            readOnlyRefs.current[props.message.id] = quill;
        },
        contents: quillData.delta
    }) : (0, $9SeGy.h)("p", {
        dangerouslySetInnerHTML: displayStandardMessageText(quillData.text)
    })), preview && (!props.message.data || !props.message.data["no_embed"]) && (0, $9SeGy.h)((0, $c72cf4b6b78e8f8e$export$330d558700ffa676), {
        key: preview.url,
        url: preview.url,
        preview: preview.preview,
        data: preview.data
    }), props.files && (0, $9SeGy.h)((0, $c72cf4b6b78e8f8e$export$ca445ff2f74d7dc4), {
        files: props.files
    }));
}



var $9SeGy = parcelRequire("9SeGy");



var $bJrD0 = parcelRequire("bJrD0");

function $7cd04194507a3338$export$2e2bcd8739ae039(props) {
    const stack = [
        props.message.id,
        ...props.message.lineage
    ].reverse();
    const [breadcrumbs, setBreadcrumbs] = (0, $bJrD0.useState)([]);
    const [group, setGroup] = (0, $bJrD0.useState)(null);
    const getTitle = (message, previewLink)=>{
        if (message) {
            if (message["data"] && message["data"]["title"]) return message["data"]["title"];
            if (previewLink && previewLink["data"]) return previewLink["data"]["title"];
            if (message["data"] && message["data"]["text"]) {
                const quillData = (0, $5d78aeb8bd3c3482$export$f2f615077a189f21)(props.message);
                let url = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getUrl(quillData.text);
                if (url && url.length > 0) url = url[0];
                if (url) return url;
                return quillData.text;
            }
        }
        // When all else fails, just say who and when
        return `${message?.author?.name}, ${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanTime(message.createdAt)}`;
    };
    const loadBreadcrumbs = (ids)=>{
        let breadcrumbs = [];
        Promise.all(ids.map((id)=>(0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${id}`).catch(()=>null))).then((messages)=>{
            Promise.all(messages.map((message)=>{
                let previewUrl = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getUrl(message?.data?.text);
                if (previewUrl) return (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/links/by_url?url=${encodeURIComponent(previewUrl[0])}`).catch(()=>null);
                return Promise.resolve(null);
            })).then((links)=>{
                for(let i = 0; i < ids.length; i++)breadcrumbs[i] = getTitle(messages[i], links[i]);
                setBreadcrumbs(breadcrumbs);
            });
        });
    };
    (0, $bJrD0.useEffect)(()=>{
        loadBreadcrumbs(stack);
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/groups/${props.message.group.id}`).then((group)=>{
            if (group) setGroup(group);
        }).catch(()=>null);
    }, []);
    if (stack.length > 0) {
        const stack_truncated = [
            stack[0],
            ...stack.slice(Math.min(3, stack.length) * -1).slice(1)
        ];
        const breadcrumbs_truncated = [
            breadcrumbs[0],
            ...breadcrumbs.slice(Math.min(3, breadcrumbs.length) * -1).slice(1)
        ];
        return (0, $9SeGy.h)("div", {
            class: "message-breadcrumbs"
        }, (0, $9SeGy.h)("nav", {
            style: "--bs-breadcrumb-divider: '>';"
        }, (0, $9SeGy.h)("ol", {
            class: "breadcrumb"
        }, group && (0, $9SeGy.h)("li", {
            class: "breadcrumb-item"
        }, (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
            key: group.id,
            to: `/groups/${group.id}`,
            class: "no-decoration"
        }, (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).limitLength(group.name || group.id.slice(0, 8), 30))), stack_truncated.filter((e)=>e != null).map((e, i)=>(0, $9SeGy.h)((0, $9SeGy.Fragment), {
                key: e
            }, (0, $9SeGy.h)((0, $9SeGy.Fragment), null, i == 1 && stack.length > 3 && (0, $9SeGy.h)("li", {
                class: "breadcrumb-item"
            }, "...")), (0, $9SeGy.h)("li", {
                class: "breadcrumb-item"
            }, (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
                key: e,
                to: `/messages/${e}`,
                class: "no-decoration"
            }, (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).limitLength(breadcrumbs_truncated[i] || e.slice(0, 8), 30))))))));
    }
}




var $bJrD0 = parcelRequire("bJrD0");





var $9SeGy = parcelRequire("9SeGy");

function $60554f5dad9b853e$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const getError = (error)=>{
        switch(error?.type){
            case "invalid_token":
                return t("invalid_token_error");
            default:
                return t("error");
        }
    };
    return (0, $9SeGy.h)("div", {
        class: "message"
    }, (0, $9SeGy.h)("div", {
        class: "message-body"
    }, (0, $9SeGy.h)("p", {
        class: "card-text"
    }, getError(props.error))));
}


function $48e0eac2816dd5e6$export$2e2bcd8739ae039(props) {
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const me = (0, $7ba8b1ffcfbcdb40$export$6ccbb43953eebf8)((0, $5332018adf75499b$export$a94cb3a0c5b0c060));
    const [author, setAuthor] = (0, $bJrD0.useState)(null);
    const [parent, setParent] = (0, $bJrD0.useState)(null);
    const [files, setFiles] = (0, $bJrD0.useState)(null);
    const [isRemoved, setIsRemoved] = (0, $bJrD0.useState)(false);
    const [edit, setEdit] = (0, $bJrD0.useState)(false);
    const [message, setMessage] = (0, $bJrD0.useState)(null);
    const [errorMessage, setErrorMessage] = (0, $bJrD0.useState)(null);
    const messageRef = (0, $bJrD0.useRef)(message);
    const setMessageRef = (message)=>{
        messageRef.current = message;
        setMessage(message);
    };
    const [, forceUpdate] = (0, $bJrD0.useReducer)((x)=>x + 1, 0);
    (0, $bJrD0.useEffect)(()=>{
        window.addEventListener("newChild", onNewChild);
        window.addEventListener("editMessage", onEditMessage);
        loadMessage();
        (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).markAsRead(props.id);
        if (!props.isChild) setTimeout(()=>window.scrollTo(0, 0));
        setTimeout(()=>{
            if (props.id == (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).action) {
                const msgElement = document.getElementById(props.id);
                if (msgElement) {
                    msgElement.scrollIntoView({
                        block: "start",
                        behavior: "smooth"
                    });
                    setTimeout(()=>msgElement.classList.remove("highlight"), 1000);
                }
            }
        }, 1000);
    }, []);
    const hydrateMessage = (m)=>{
        setMessageRef(m);
        if (m?.author?.id) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/users/${m.author.id}`).then((u)=>{
            if (u) setAuthor(u);
        }).catch(()=>null);
        if (m?.parent?.id) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${m.parent.id}`).then((p)=>{
            if (p) setParent(p);
        }).catch(()=>null);
        // delay loading of files a little bit
        setTimeout(()=>{
            if (m?.files?.length) Promise.all(m.files.map((f)=>(0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/files/${f.id}`).catch(()=>null).then((f)=>f))).then((files)=>setFiles(files.filter((f)=>f != null)));
        }, 100);
    };
    const loadMessage = ()=>{
        if (props?.message) {
            if (props?.files?.length) setFiles(props?.message?.files.map((f)=>({
                    id: f.id,
                    status: "loading"
                })));
            hydrateMessage(props.message);
        } else if (props?.token) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/public/${props.token}`).then((m)=>{
            if (!m) throw new Error("invalid_token");
            if (m?.files?.length) setFiles(m?.files.map((f)=>({
                    id: f.id,
                    status: "loading"
                })));
            hydrateMessage(m);
        }).catch((err)=>{
            let error = {
                "type": err?.message || "unknown"
            };
            setErrorMessage(error);
        });
        else (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${props.id}`).then((m)=>{
            if (!m) return;
            if (m?.files?.length) setFiles(m?.files.map((f)=>({
                    id: f.id,
                    status: "loading"
                })));
            hydrateMessage(m);
        }).catch(()=>null);
    };
    const onNewChild = (event)=>{
        if (!messageRef.current?.id) return;
        const newMsg = event.detail;
        if (newMsg?.parent && (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getId(newMsg?.parent) == props.id) {
            newMsg.author = me;
            let newChildren = messageRef?.current?.children ? [
                ...messageRef.current.children,
                newMsg
            ] : [
                newMsg
            ];
            let newRef = Object.assign(messageRef.current, {
                children: newChildren
            });
            setMessageRef(newRef);
            forceUpdate();
        }
    };
    const openPublicLink = async (event)=>{
        event.preventDefault();
        let newTab = window.open("about:blank", "_blank");
        const res = await (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${props.id}/get-public-link`).catch(()=>null);
        if (res) newTab.location = `${document.baseURI}public/${res.token}`;
    };
    const onEditMessage = (event)=>{
        if (event.detail.id == props.id) {
            setEdit(false);
            hydrateMessage(event.detail);
            props.key = +Date.now();
        }
    };
    const getComponentClass = ()=>{
        let cn = "message";
        if (props.isChild) cn += " child";
        if (props.id == (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).action) cn += " highlight";
        return cn;
    };
    const deleteMessage = (event)=>{
        event.preventDefault();
        if (confirm(t("ask_delete_message"))) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).delete(`/api/messages/${props.id}`).then(()=>{
            if (props.isChild) setIsRemoved(true);
            else navigate(`/groups/${message.group.id}`);
        }).catch((err)=>console.warn(err));
    };
    const shareMessage = (event)=>{
        event.preventDefault();
        navigate(`/share?message=${props.id}`);
    };
    const editMessage = (event)=>{
        event.preventDefault();
        setEdit(true);
    };
    const publishInGroup = ()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/messages/${props.id}`, {
            lastActivityDate: Math.floor(Date.now() / 1000),
            isInFront: true
        }).then((res)=>{
            if (!res) {
                alert.add(t("error"), "alert-danger");
                return;
            }
            navigate(`/groups/${message.group.id}`);
        }).catch(()=>null);
    };
    const pinInGroup = ()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/messages/${props.id}`, {
            pinnedInGroup: true
        }).then((res)=>{
            if (!res) {
                alert.add(t("error"), "alert-danger");
                return;
            }
            navigate(`/groups/${message.group.id}`);
        }).catch(()=>null);
    };
    const unpinInGroup = ()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/messages/${props.id}`, {
            pinnedInGroup: false
        }).then((m)=>{
            if (!m) {
                alert.add(t("error"), "alert-danger");
                return;
            }
            hydrateMessage(m);
        }).catch(()=>null);
    };
    const cancelEdit = (event)=>{
        event.preventDefault();
        setEdit(false);
    };
    const displayWriter = (isChild, focus)=>{
        return (0, $9SeGy.h)((0, $b0c42e92c84db02f$export$d7a960146e1a269e), {
            cancel: edit ? cancelEdit : null,
            files: edit ? files : [],
            focus: focus || !!edit,
            group: message.group,
            messageId: edit ? props.id : null,
            parent: edit ? parent?.id : props.id,
            text: edit ? message.data["text"] : "",
            title: edit ? message.data["title"] : "",
            isChild: isChild
        });
    };
    if (errorMessage?.type) return (0, $9SeGy.h)((0, $9SeGy.Fragment), null, (0, $9SeGy.h)((0, $60554f5dad9b853e$export$2e2bcd8739ae039), {
        error: errorMessage
    }));
    if (isRemoved || !message) // placeholder (to be able to target it)
    return (0, $9SeGy.h)("div", {
        id: props.id,
        className: "message"
    });
    return (0, $9SeGy.h)((0, $9SeGy.Fragment), null, !props?.isChild && !props?.isPublic && (0, $9SeGy.h)((0, $7cd04194507a3338$export$2e2bcd8739ae039), {
        key: message?.id,
        message: message
    }), (0, $9SeGy.h)("div", {
        id: props.id,
        className: getComponentClass()
    }, edit && displayWriter(props?.isChild), !edit && (0, $9SeGy.h)((0, $9SeGy.Fragment), null, props.isChild && !props.isPublic && edit && (0, $9SeGy.h)("div", {
        class: "message-head d-none d-md-block"
    }, (0, $9SeGy.h)("img", {
        class: "rounded-circle w-3 material-shadow avatar",
        style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(me.id),
        src: me.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(me.avatar?.id, 100, 100) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar
    })), (0, $9SeGy.h)((0, $d385cb0a744355a5$export$2e2bcd8739ae039), {
        author: author,
        message: message,
        isPublic: props?.isPublic,
        isChild: props?.isChild
    }), (0, $9SeGy.h)("div", {
        class: "main"
    }, (0, $9SeGy.h)((0, $5345fa5f2538b9ef$export$2e2bcd8739ae039), {
        message: message,
        files: files || [],
        isPublic: props?.isPublic,
        isChild: props?.isChild
    }), (0, $9SeGy.h)((0, $d0274a88e468a969$export$2e2bcd8739ae039), {
        author: author,
        message: message,
        editMessage: editMessage,
        deleteMessage: deleteMessage,
        shareMessage: shareMessage,
        publishInGroup: publishInGroup,
        pinInGroup: pinInGroup,
        unpinInGroup: unpinInGroup,
        openPublicLink: openPublicLink,
        isPublic: props?.isPublic,
        isChild: props?.isChild
    })))), props?.postMessageComponent, !props?.isChild && !props?.isPublic && (0, $9SeGy.h)((0, $02bd391920972de4$export$2e2bcd8739ae039), {
        childMessages: message?.children,
        key: props.id,
        id: props.id
    }), !edit && !props?.isPublic && !props?.isChild && (0, $9SeGy.h)("div", {
        class: "message child mt-2"
    }, me?.id && (0, $9SeGy.h)("div", {
        class: "message-head d-none d-md-block"
    }, (0, $9SeGy.h)("img", {
        class: "rounded-circle w-3 material-shadow avatar",
        style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(me.id),
        src: me?.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(me.avatar["id"], 100, 100) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar
    })), displayWriter(true, props.focus)));
}









var $9SeGy = parcelRequire("9SeGy");


class $2b42a26c55ba553a$export$2e2bcd8739ae039 extends (0, $9SeGy.Component) {
    constructor(props){
        super(props);
        let loaded = 1 + Math.floor(window.screen.width * window.screen.height / 68800);
        this.state = {
            loaded: loaded,
            messages: [],
            scrollTop: 0,
            totalMessages: 0,
            pageYOffset: 0,
            page: 0
        };
        this.scroll_cooldown = Date.now();
        this.onScroll = this.onScroll.bind(this);
        this.loadMessages = this.loadMessages.bind(this);
        this.onNewParent = this.onNewParent.bind(this);
        window.addEventListener("newParent", this.onNewParent);
    }
    onNewParent() {
        this.loadMessages(0);
    }
    componentDidMount() {
        this.loadMessages(0);
        window.addEventListener("scroll", this.onScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    }
    loadMessages(page) {
        if (this.props.isFeed) {
            (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get("/api/feed/page/" + page * 30).then((res)=>{
                this.updateMessageList(res, page);
            });
            return;
        }
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/groups/${this.props.id}`).then((res)=>{
            this.setState({
                group: res
            });
        });
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/groups/${this.props.id}/page/${page}`).then((res)=>{
            this.updateMessageList(res, page);
        });
    }
    updateMessageList(res, page) {
        if (res && Array.isArray(res["messages"])) {
            let new_loaded = Math.max(this.state.loaded, page * 30);
            let msgList = this.state.messages;
            // don't add already added messages
            res["messages"].map((mid)=>!msgList.find((msg)=>msg.id == mid) && msgList.push({
                    id: mid
                }));
            this.setState({
                messages: msgList,
                totalMessages: res["totalItems"],
                page: page,
                loaded: new_loaded
            }, ()=>{});
            if ((page + 1) * 30 < new_loaded) setTimeout(()=>this.loadMessages(page + 1));
        }
    }
    onScroll() {
        // prevent loading messages if we are in a post
        if (window.getComputedStyle(document.getElementById("group").parentNode).display == "none") return;
        // don't load if on cooldown
        if (this.scroll_cooldown + 100 < Date.now()) {
            this.scroll_cooldown = Date.now();
            this.setState({
                pageYOffset: window.pageYOffset
            });
            // don't load if unecessary
            if (Array.isArray(this.state.messages) && document.body.scrollHeight - window.screen.height - 500 < window.pageYOffset && this.state.loaded < this.state.totalMessages) {
                this.setState((prevState)=>({
                        loaded: prevState.loaded + 10
                    }));
                if (this.state.loaded + 30 > this.state.messages.length) {
                    this.loadMessages(this.state.page + 1);
                    // update page count right away
                    this.setState((prevState)=>({
                            page: prevState.page + 1
                        }));
                }
            }
        }
    }
    render() {
        if (!this.props.id && !this.props.isFeed) return;
        return (0, $9SeGy.h)((0, $9SeGy.Fragment), null, Array.isArray(this.state.messages) && this.state.messages.slice(0, this.state.loaded).map((msg, i)=>{
            return (0, $9SeGy.h)((0, $6a345a2434031edc$export$84c965ec8b6b0f92), {
                tabindex: i + 1,
                key: msg.id,
                id: msg.id,
                isFeed: this.props.isFeed
            });
        }));
    }
}



var $9SeGy = parcelRequire("9SeGy");




function $0336d0c72cfa625f$export$2e2bcd8739ae039(props) {
    let params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    return (0, $9SeGy.h)("main", null, (0, $9SeGy.h)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $9SeGy.h)("div", {
        class: "content"
    }, (0, $9SeGy.h)("article", {
        class: "mb-3 justify-content-center d-flex"
    }, (0, $9SeGy.h)("div", {
        class: "container pb-3"
    }, (0, $9SeGy.h)((0, $48e0eac2816dd5e6$export$2e2bcd8739ae039), {
        focus: !!(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("focus", (0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).search),
        isPublic: false,
        isChild: false,
        message: props?.message,
        id: params.id,
        key: params.id
    })))));
}



var $9SeGy = parcelRequire("9SeGy");





var $bJrD0 = parcelRequire("bJrD0");

function $2ff1bd810ea4c925$export$2e2bcd8739ae039(props) {
    const [author, setAuthor] = (0, $bJrD0.useState)(null);
    const [preview, setPreview] = (0, $bJrD0.useState)(null);
    const [id, setId] = (0, $bJrD0.useState)(null);
    const [data, setData] = (0, $bJrD0.useState)(null);
    const [lastActivityDate, setLastActivityDate] = (0, $bJrD0.useState)(null);
    const [children, setChildren] = (0, $bJrD0.useState)(0);
    const [loaded, setLoaded] = (0, $bJrD0.useState)(false);
    const [textPreview, setTextPreview] = (0, $bJrD0.useState)("");
    const [isPinned, setIsPinned] = (0, $bJrD0.useState)(false);
    const getAvatar = (user)=>{
        return (0, $9SeGy.h)("img", {
            title: user ? user.name : "--",
            className: `avatar material-shadow${user ? "" : " removed-user"}`,
            style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(user ? user.id : ""),
            src: user?.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(user.avatar["id"], 100, 100) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
            onError: (e)=>e.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar
        });
    };
    const setDefaultMiniature = (e)=>{
        e.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar;
        e.currentTarget.style.height = "180px";
        e.currentTarget.style.width = "auto";
        e.currentTarget.style.position = "absolute";
        e.currentTarget.style.left = "50%";
        e.currentTarget.style.transform = "translate(-50%, 0%)";
    };
    (0, $bJrD0.useEffect)(()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/messages/${props.id}/preview`).then((p)=>{
            if (!p) return;
            if (p?.author?.id) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/users/${p.author.id}`).then((u)=>{
                if (u) setAuthor(u);
            }).catch(()=>null);
            setPreview(p?.preview);
            setId(props.id);
            setChildren(p?.children);
            setLoaded(true);
            setLastActivityDate(p?.lastActivityDate);
            setData(p?.data);
            setTextPreview((0, $5d78aeb8bd3c3482$export$f2f615077a189f21)(p).text);
            setIsPinned(p?.sortOrder !== undefined);
        }).catch(()=>null);
    }, []);
    if (!props?.id) return null;
    if (!data) return (0, $9SeGy.h)("div", {
        class: "d-inline-block message-preview unselectable"
    }, (0, $9SeGy.h)("div", {
        class: "card message-preview-loading material-shadow-with-hover"
    }));
    return (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        to: `/messages/${id}`,
        class: "d-inline-block seamless-link message-preview unselectable",
        title: data?.title
    }, (0, $9SeGy.h)("div", {
        tabindex: props?.tabindex,
        class: "card material-shadow-with-hover"
    }, getAvatar(author), (0, $9SeGy.h)("div", {
        class: "card-miniature-loading"
    }, loaded && (0, $9SeGy.h)((0, $9SeGy.Fragment), null, preview ? (0, $9SeGy.h)("div", {
        class: "card-miniature"
    }, (0, $9SeGy.h)("img", {
        width: "320",
        height: "180",
        src: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getId(preview), 320, 180),
        onError: (e)=>setDefaultMiniature(e)
    })) : (0, $9SeGy.h)("div", {
        class: "text-preview"
    }, textPreview))), (0, $9SeGy.h)("div", {
        class: "card-body border-top d-flex justify-content-between"
    }, (0, $9SeGy.h)("span", {
        class: "left-buffer"
    }), (0, $9SeGy.h)("span", {
        class: "title",
        title: data?.title || (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanFullDate(lastActivityDate)
    }, data?.title || (0, $9SeGy.h)((0, $be03c4de42ac64ff$export$35f3ae0a16fef81), {
        timestamp: lastActivityDate
    })), isPinned && !props.isFeed && (0, $9SeGy.h)("div", {
        class: "pinned-icon"
    }, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: "regular",
        icon: "thumbtack"
    })), (0, $9SeGy.h)("span", {
        class: "children"
    }, children > 0 && (0, $9SeGy.h)("span", null, `${children} `, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).isNew(id) ? "solid" : "regular",
        icon: "comment"
    }))))));
}



var $9SeGy = parcelRequire("9SeGy");



var $bJrD0 = parcelRequire("bJrD0");


function $a241afa5477ddabe$export$2e2bcd8739ae039(props) {
    const [author, setAuthor] = (0, $bJrD0.useState)(props?.message?.author || null);
    (0, $bJrD0.useEffect)(()=>{
        if (props?.message?.author) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/users/${props.message.author}`).then((author)=>author && setAuthor(author)).catch(()=>null);
    }, []);
    const displayAuthorName = ()=>{
        if (!author?.name) return {
            __html: "--"
        };
        let authorName = author.name;
        // make the search terms stand out
        let words = authorName.split(" ");
        for(let j = 0; j < words.length; j++)if (!words[j].match((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).urlRegExp)) {
            let searchTerms = props.search.split(" ");
            for(let k = 0; k < searchTerms.length; k++)words[j] = words[j].replace(new RegExp((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).escapeRegex(searchTerms[k]), "gi"), "<b>$&</b>");
        }
        authorName = words.join(" ");
        return {
            __html: authorName
        };
    };
    const displayMessageTitle = ()=>{
        if (!props?.message?.data?.title) return {
            __html: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanTime(props?.message?.lastActivityDate)
        };
        // escape html a little (just enough to avoid xss I hope)
        let title = props?.message?.data?.title.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
        // make the search terms stand out
        let words = title.split(" ");
        let searchTerms = props?.search.split(" ") || [];
        for(let j = 0; j < words.length; j++){
            if (!words[j].match((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).urlRegExp)) for(let k = 0; k < searchTerms.length; k++)words[j] = words[j].replace(new RegExp((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).escapeRegex(searchTerms[k]), "gi"), "<b>$&</b>");
        }
        title = words.join(" ");
        return {
            __html: title
        };
    };
    const displayMessageText = ()=>{
        if (!props?.message?.data?.text) return "";
        // escape html a little (just enough to avoid xss I hope)
        let txt = (0, $5d78aeb8bd3c3482$export$f2f615077a189f21)(props?.message)?.text?.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
        // make the search terms stand out for not url words
        let lines = txt.split("\n");
        for(let i = 0; i < lines.length; i++){
            let words = lines[i].split(" ");
            for(let j = 0; j < words.length; j++)if (!words[j].match((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).urlRegExp)) {
                let searchTerms = props.search.split(" ");
                for(let k = 0; k < searchTerms.length; k++){
                    if (!searchTerms[k]) continue;
                    words[j] = words[j].replace(new RegExp((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).escapeRegex(searchTerms[k]), "gi"), "<b>$&</b>");
                }
                let hashtags = props?.hashtags.split(" ") || [];
                for(let k = 0; k < hashtags.length; k++){
                    if (!hashtags[k]) continue;
                    words[j] = words[j].replace(new RegExp(`#${hashtags[k]}`, "gi"), "<b>$&</b>");
                }
            }
            lines[i] = words.join(" ");
        }
        txt = lines.join("\n");
        // replace url by real links
        let shift = 0;
        let match = null;
        while(match = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).getUrl(txt.slice(shift))){
            let url = match[0];
            if (url.length >= 50) url = `${url.slice(0, 25)}...${url.slice(-24)}`;
            let searchTerms = props?.search.split(" ") || [];
            for(let i = 0; i < searchTerms.length; i++)url = url.replace(new RegExp((0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).escapeRegex(searchTerms[i]), "gi"), "<b>$&</b>");
            let link = `<a href="${match[0]}" target="_blank">${url}</a>`;
            txt = txt.slice(0, match["index"] + shift) + link + txt.slice(match["index"] + shift + match[0].length);
            shift += match["index"] + link.length;
        }
        // replace line returns
        txt = txt.replace(/\n/g, "<br/>");
        return {
            __html: txt
        };
    };
    const getMiniature = ()=>{
        if (props?.preview) return (0, $9SeGy.h)("div", {
            class: "card-miniature",
            style: `background-image: url('${(0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(props?.preview, 100, 100)}')`
        });
        let avatar = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar;
        if (author?.avatar?.id) avatar = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(author.avatar["id"], 100, 100);
        return (0, $9SeGy.h)("div", {
            class: "card-miniature",
            style: `background-image: url('${avatar}')`
        });
    };
    const getLink = ()=>{
        if (props.message.parent && props.message.children == 0) return `/messages/${props.message.parent}/${props.message.id}`;
        return `/messages/${props.message.id}`;
    };
    return (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: "d-inline-block seamless-link message-preview unselectable",
        to: getLink(),
        title: props?.title
    }, (0, $9SeGy.h)("div", {
        tabindex: props.tabindex,
        class: "card material-shadow-with-hover"
    }, (0, $9SeGy.h)("div", {
        class: "card-body border-top"
    }, getMiniature(), (0, $9SeGy.h)("div", {
        class: "infos"
    }, (0, $9SeGy.h)("div", {
        class: "title",
        dangerouslySetInnerHTML: displayAuthorName()
    }), (0, $9SeGy.h)("div", {
        class: "dot"
    }, "\u2022"), (0, $9SeGy.h)("div", {
        class: "title",
        title: props?.title || (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).humanFullDate(props.message.lastActivityDate),
        dangerouslySetInnerHTML: displayMessageTitle()
    })), (0, $9SeGy.h)("div", {
        class: "text"
    }, props?.message?.data?.text?.trim() && (0, $9SeGy.h)("p", {
        class: "card-text",
        dangerouslySetInnerHTML: displayMessageText()
    })), (0, $9SeGy.h)("div", {
        class: "children"
    }, !!props.message.children && (0, $9SeGy.h)("span", null, `${props.message.children} `, (0, $9SeGy.h)((0, $607f51540ffcd426$export$8b29a4b6778bf7f), {
        family: (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).isNew(props.message.id) ? "solid" : "regular",
        icon: "comment"
    }))))));
}


const $6a345a2434031edc$export$f69c19e57285b83a = (0, $48e0eac2816dd5e6$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$36e783c4ff07cd7c = (0, $5345fa5f2538b9ef$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$ff4023171d74287f = (0, $7cd04194507a3338$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$34692698b50bc55e = (0, $6e64521ddde455b6$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$e4f91797a78e658f = (0, $02bd391920972de4$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$448e87951e58f7a8 = (0, $d0274a88e468a969$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$14933f4fded8a04f = (0, $d385cb0a744355a5$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$89085c7857c3f940 = (0, $2b42a26c55ba553a$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$4025c8e17986f775 = (0, $0336d0c72cfa625f$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$84c965ec8b6b0f92 = (0, $2ff1bd810ea4c925$export$2e2bcd8739ae039);
const $6a345a2434031edc$export$423dfe6469a8e0dd = (0, $a241afa5477ddabe$export$2e2bcd8739ae039);



function $ac6c208c16ca16e8$export$2e2bcd8739ae039() {
    let params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    return (0, $9SeGy.h)("article", {
        class: "justify-content-center d-flex mt-2"
    }, (0, $9SeGy.h)("div", {
        class: "container"
    }, (0, $9SeGy.h)("main", null, (0, $9SeGy.h)("div", {
        class: "content"
    }, (0, $9SeGy.h)("article", {
        class: "mb-3 justify-content-center d-flex"
    }, (0, $9SeGy.h)("div", {
        class: "container pb-3"
    }, (0, $9SeGy.h)((0, $6a345a2434031edc$export$f69c19e57285b83a), {
        focus: false,
        isPublic: true,
        isChild: false,
        token: params.token
    })))))));
}


const $f367d32ad26358d9$export$21a94553ffa41578 = (0, $53140ff71bd6800b$export$2e2bcd8739ae039);
const $f367d32ad26358d9$export$b44239f84c8f0268 = (0, $245fbd49526c814f$export$2e2bcd8739ae039);
const $f367d32ad26358d9$export$89200835fb4edfb9 = (0, $7cecaa63b21a4acb$export$2e2bcd8739ae039);
const $f367d32ad26358d9$export$e9e03eeea26d4dee = (0, $10fcb144e46b2198$export$2e2bcd8739ae039);
const $f367d32ad26358d9$export$68b4491d6924a6d1 = (0, $ac6c208c16ca16e8$export$2e2bcd8739ae039);






var $9SeGy = parcelRequire("9SeGy");




var $bJrD0 = parcelRequire("bJrD0");


function $69115444f08d0dc6$export$2e2bcd8739ae039() {
    const params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const me = (0, $7ba8b1ffcfbcdb40$export$6ccbb43953eebf8)((0, $5332018adf75499b$export$a94cb3a0c5b0c060));
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const [secretKey, setSecretKey] = (0, $bJrD0.useState)("");
    const [inviteKey, setInviteKey] = (0, $bJrD0.useState)("");
    const [users, setUsers] = (0, $bJrD0.useState)([]);
    const [group, setGroup] = (0, $bJrD0.useState)({});
    const [alertMessage, setAlertMessage] = (0, $bJrD0.useState)("");
    (0, $bJrD0.useEffect)(()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/groups/${params.id}`).then((group)=>{
            if (!group) return;
            setGroup(group);
            setSecretKey(group.secretKey);
            setInviteKey(group.inviteKey);
            Promise.all(group.users.map((u)=>(0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).get(`/api/users/${u.id}`).catch(()=>null).then((u)=>u))).then((users)=>setUsers(users.filter((u)=>u != null)));
        }).catch(()=>null);
        setAlertMessage(t((0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("alert")));
    }, []);
    const resetInviteKey = (event)=>{
        event.preventDefault();
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post(`/api/groups/${group.id}/reset-invite-key`, {}).then((res)=>{
            if (!res) return;
            (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("group_updated"));
            setInviteKey(res["inviteKey"]);
        }).catch(()=>null);
    };
    const updateSettings = (event)=>{
        event.preventDefault();
        const name = document.querySelector("#settings_form input[name='name']").value;
        if (name) group.name = name;
        setGroup(Object.assign({}, group));
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/groups/${group.id}`, group).then((res)=>{
            if (!res) return;
            setGroup(res);
            setAlertMessage(t("group_updated"));
            navigate(`${location.pathname}?alert=group_updated`);
        }).catch(()=>null);
    };
    const leaveGroup = (event)=>{
        event.preventDefault();
        if (me.data?.default_group == group.id) {
            let user = {};
            user.data = {
                default_group: me.groups[0].id
            };
            (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/users/${me.id}`, user).then(()=>{
                (0, $cd2f6546c5cf5c32$export$3e32638432616b6).fetch();
                leave();
            }).catch((err)=>console.warn(err));
        } else leave();
    };
    const leave = ()=>{
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post(`/api/groups/${group.id}/leave`, {}).then((res)=>{
            if (!res || !res["entityType"]) (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("error"), "alert-danger");
            else {
                (0, $cd2f6546c5cf5c32$export$3e32638432616b6).fetch();
                (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(t("group_left"));
                navigate("/");
            }
        }).catch(()=>null);
    };
    return (0, $9SeGy.h)("div", null, (0, $9SeGy.h)("div", {
        class: "group-settings mb-3"
    }, (0, $9SeGy.h)("div", {
        class: "card"
    }, (0, $9SeGy.h)("div", {
        class: "card-body"
    }, (0, $9SeGy.h)("div", {
        class: "container-fluid p-1"
    }, (0, $9SeGy.h)("div", {
        class: "row"
    }, (0, $9SeGy.h)("div", {
        class: "col-12 col-md-10"
    }, (0, $9SeGy.h)("form", {
        id: "settings_form",
        class: "mb-1 border-bottom pb-1"
    }, (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        for: "name"
    }, t("name"), ": "), (0, $9SeGy.h)("input", {
        type: "text",
        name: "name",
        minlength: "1",
        maxlength: "128",
        placeholder: t("name_input"),
        value: group.name,
        class: "form-control",
        required: true
    })), (0, $9SeGy.h)("button", {
        onClick: updateSettings,
        class: "btn btn-outline-secondary"
    }, t("save_changes"))), (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6)?.info?.show?.group_invitation_links && (0, $9SeGy.h)("form", {
        class: "mb-1 border-bottom pb-1"
    }, (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        for: "inviteKey"
    }, t("invitation_link"), ":", " "), (0, $9SeGy.h)("input", {
        type: "text",
        name: "inviteKey",
        value: `${window.location.protocol}//${window.location.host}/invitation/${inviteKey}`,
        class: "form-control font-size-80",
        readonly: "readonly"
    })), (0, $9SeGy.h)("button", {
        class: "btn btn-outline-secondary",
        onClick: resetInviteKey
    }, t("reset_invitation_link"))), (0, $9SeGy.h)("form", null, (0, $9SeGy.h)("button", {
        onClick: (e)=>leaveGroup(e),
        class: "btn btn-outline-danger"
    }, t("quit_group"))))))))), (0, $9SeGy.h)("div", {
        class: "user-list mb-3"
    }, (0, $9SeGy.h)("h3", null, t("users")), users.map((user)=>user && (0, $9SeGy.h)("div", {
            class: "user-card",
            key: user.id
        }, (0, $9SeGy.h)("img", {
            class: "avatar material-shadow-with-hover",
            style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(user.id),
            src: user.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(user.avatar["id"], 200, 200) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
            onError: (e)=>e.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar
        }), (0, $9SeGy.h)("span", null, user["name"])))), alertMessage && (0, $9SeGy.h)("div", {
        class: "global-alert alert alert-success"
    }, alertMessage));
}



var $9SeGy = parcelRequire("9SeGy");

var $9SeGy = parcelRequire("9SeGy");




var $bJrD0 = parcelRequire("bJrD0");


function $eee779cb2410b301$export$2e2bcd8739ae039() {
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const me = (0, $7ba8b1ffcfbcdb40$export$6ccbb43953eebf8)((0, $5332018adf75499b$export$a94cb3a0c5b0c060));
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    const [apiKey, setApiKey] = (0, $bJrD0.useState)(null);
    const [alertMessage, setAlertMessage] = (0, $bJrD0.useState)("");
    (0, $bJrD0.useEffect)(()=>{
        (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).get("apiKey").then((apiKey)=>setApiKey(apiKey));
        setAlertMessage(t((0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).getParam("alert")));
    }, []);
    const resetApiKey = (event)=>{
        event.preventDefault();
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post(`/api/users/${me.id}/reset-api-key`, {}).then(()=>(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).logout()).catch((err)=>console.warn(err));
    };
    const inputAvatar = ()=>{
        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.addEventListener("change", (event)=>{
            const formData = new FormData();
            formData.append("file", event.target.files[0]);
            (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).sendFile(formData, (file)=>{
                (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/users/${me.id}`, {
                    avatar: file["id"]
                }).then(()=>{
                    setAlertMessage(t("settings_updated"));
                    navigate(`${location.pathname}?alert=settings_updated`);
                }).catch((err)=>console.warn(err));
            });
        });
        input.click();
    };
    const destroyAccount = (event)=>{
        event.preventDefault();
        let confirmDeletion = confirm(t("are_you_sure"));
        if (confirmDeletion) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).delete(`/api/users/${me.id}`).then(()=>{
            navigate("/logout");
        }).catch((err)=>console.warn(err));
    };
    const updateSettings = (event)=>{
        event.preventDefault();
        const name = document.querySelector("#settings_form input[name='name']").value;
        const login = document.querySelector("#settings_form input[name='email']").value;
        const password = document.querySelector("#settings_form input[name='password']").value;
        const notification_emails = document.querySelector("#settings_form select[name='notification_emails']").value;
        const default_group = document.querySelector("#settings_form select[name='default_group']").value;
        const default_page = document.querySelector("#settings_form select[name='default_page']").value;
        const lang = document.querySelector("#settings_form select[name='lang']").value;
        let user = {};
        if (name) user.name = name;
        if (login) user.login = login;
        if (password) user.password = password;
        user["data"] = {
            notification_emails: notification_emails,
            default_group: default_group,
            default_page: default_page,
            lang: lang
        };
        (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).put(`/api/users/${me.id}`, user).then((res)=>{
            if (!res) return;
            if (res["error"]) (0, $cd2f6546c5cf5c32$export$5ea928c9faf85bd3).add(res["error"], "alert-danger");
            else {
                setAlertMessage(t("settings_updated"));
                navigate(`${location.pathname}?alert=settings_updated`);
            }
        }).catch(()=>null);
    };
    if (me && me?.data) return (0, $9SeGy.h)("div", {
        class: "user-settings"
    }, (0, $9SeGy.h)("div", {
        class: "card"
    }, (0, $9SeGy.h)("div", {
        class: "identite card-body"
    }, (0, $9SeGy.h)("div", {
        class: "container-fluid p-1"
    }, (0, $9SeGy.h)("div", {
        class: "row"
    }, (0, $9SeGy.h)("div", {
        class: "col-12 col-md-2"
    }, (0, $9SeGy.h)("img", {
        class: "img-fluid rounded-circle material-shadow avatar",
        src: me.avatar ? (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).crop(me.avatar["id"], 100, 100) : (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
        style: (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).backgroundHash(me.id || ""),
        onError: (e)=>e.currentTarget.src = (0, $cd2f6546c5cf5c32$export$7debb50ef11d5e0b).defaultAvatar,
        onClick: (e)=>inputAvatar(e)
    })), (0, $9SeGy.h)("div", {
        class: "col-12 col-md-10"
    }, (0, $9SeGy.h)("form", {
        id: "settings_form",
        class: "mb-3"
    }, (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        for: "name"
    }, t("name"), ": "), (0, $9SeGy.h)("input", {
        type: "text",
        name: "name",
        minlength: "1",
        maxlength: "128",
        placeholder: t("name_input"),
        value: me.name,
        class: "form-control"
    })), (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        for: "email"
    }, t("email"), ": "), (0, $9SeGy.h)("input", {
        type: "email",
        name: "email",
        placeholder: t("email_input"),
        value: me.login,
        class: "form-control"
    })), (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        for: "password"
    }, t("password"), ": "), (0, $9SeGy.h)("input", {
        type: "password",
        name: "password",
        autocomplete: "off",
        minlength: "8",
        maxlength: "128",
        placeholder: t("password_input"),
        class: "form-control"
    })), (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        for: "notification_emails"
    }, t("notification_emails"), ":"), (0, $9SeGy.h)("select", {
        name: "notification_emails",
        class: "form-control",
        value: me?.data["notification_emails"] || "immediately"
    }, (0, $9SeGy.h)("option", {
        value: "none"
    }, t("none")), (0, $9SeGy.h)("option", {
        value: "immediately"
    }, t("immediately")), (0, $9SeGy.h)("option", {
        value: "hourly"
    }, t("hourly")), (0, $9SeGy.h)("option", {
        value: "daily"
    }, t("daily")), (0, $9SeGy.h)("option", {
        value: "weekly"
    }, t("weekly")), (0, $9SeGy.h)("option", {
        value: "monthly"
    }, t("monthly")))), (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        for: "default_group"
    }, t("default_group"), ":"), (0, $9SeGy.h)("select", {
        name: "default_group",
        class: "form-control",
        value: me?.data["default_group"]
    }, me.groups?.map((e)=>(0, $9SeGy.h)("option", {
            key: e.id,
            value: e.id
        }, e.name)))), (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        for: "default_page"
    }, t("default_page"), ":"), (0, $9SeGy.h)("select", {
        name: "default_page",
        class: "form-control",
        value: me?.data["default_page"] || "default_group"
    }, (0, $9SeGy.h)("option", {
        value: "feed"
    }, t("feed")), (0, $9SeGy.h)("option", {
        value: "default_group"
    }, t("default_group")))), (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        class: "capitalize",
        for: "lang"
    }, t("lang"), ":"), (0, $9SeGy.h)("select", {
        name: "lang",
        class: "form-control",
        value: (0, $cd2f6546c5cf5c32$export$9a771d6906431624).getCurrentLang()
    }, Object.keys((0, $cd2f6546c5cf5c32$export$9a771d6906431624).possibleLang).map((k)=>(0, $9SeGy.h)("option", {
            key: k,
            value: k
        }, (0, $cd2f6546c5cf5c32$export$9a771d6906431624).possibleLang[k])))), (0, $9SeGy.h)("button", {
        onClick: (e)=>updateSettings(e),
        class: "btn btn-primary"
    }, t("save_changes"))), (0, $9SeGy.h)("form", {
        id: "api_key_form"
    }, (0, $9SeGy.h)("div", {
        class: "form-group"
    }, (0, $9SeGy.h)("label", {
        for: "apiKey"
    }, t("api_key"), ":", " "), (0, $9SeGy.h)("input", {
        type: "text",
        name: "apiKey",
        value: apiKey,
        class: "form-control font-size-80",
        readonly: "readonly"
    })), (0, $9SeGy.h)("button", {
        class: "btn btn-outline-secondary",
        onClick: resetApiKey
    }, t("reset_api_key"))), (0, $9SeGy.h)("form", {
        id: "destroy_form"
    }, (0, $9SeGy.h)("label", {
        class: "d-block",
        for: "destroy_account"
    }, t("destroy_account_explain")), (0, $9SeGy.h)("button", {
        onClick: (e)=>destroyAccount(e),
        name: "destroy_account",
        class: "btn btn-danger"
    }, t("destroy_account")))))))), alertMessage && (0, $9SeGy.h)("div", {
        class: "global-alert alert alert-success"
    }, alertMessage));
}








function $2e4039a8780c9af0$export$2e2bcd8739ae039() {
    const params = (0, $2e634cb2b6e12a73$export$99eaa27ddbbb95ef)();
    const { t: t } = (0, $23287d5819478a30$export$9fc83ad70ead8663)();
    const me = (0, $7ba8b1ffcfbcdb40$export$6ccbb43953eebf8)((0, $5332018adf75499b$export$a94cb3a0c5b0c060));
    return (0, $9SeGy.h)("main", null, (0, $9SeGy.h)((0, $520fa8871428281e$export$42cfbb80f7861e77), null), (0, $9SeGy.h)("div", {
        class: "content"
    }, (0, $9SeGy.h)("article", {
        class: "mt-2 justify-content-center d-flex"
    }, (0, $9SeGy.h)("div", {
        class: "container pb-3"
    }, (0, $9SeGy.h)("div", {
        class: "settings"
    }, (0, $9SeGy.h)("ul", {
        class: "nav nav-tabs"
    }, (0, $9SeGy.h)("li", {
        class: "nav-item"
    }, (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
        class: `nav-link${params.type == "users" ? " active" : ""}`,
        to: `/users/${me.id}/settings`
    }, t("account"))), me.groups?.length > 0 && (0, $9SeGy.h)("li", {
        class: "nav-item dropdown group-list",
        tabindex: "-1",
        onClick: (e)=>e.currentTarget.classList.toggle("active")
    }, (0, $9SeGy.h)("div", {
        class: `nav-link${params.type == "groups" ? " active" : ""}`
    }, t("groups")), (0, $9SeGy.h)("div", {
        class: "dropdown-menu"
    }, me.groups?.map((e)=>(0, $9SeGy.h)((0, $34f84368c0c9d98a$export$a6c7ac8248d6e38a), {
            key: `/groups/${e.id}/settings`,
            class: "seamless-link",
            to: `/groups/${e.id}/settings`
        }, e.name))))), params.type === "users" && (0, $9SeGy.h)((0, $eee779cb2410b301$export$2e2bcd8739ae039), {
        id: params.id,
        key: params.id
    }), params.type === "groups" && (0, $9SeGy.h)((0, $69115444f08d0dc6$export$2e2bcd8739ae039), {
        id: params.id,
        key: params.id
    }))))));
}



const $1180cc40af8fd7c1$export$7756bc8dbeb9ec70 = (0, $69115444f08d0dc6$export$2e2bcd8739ae039);
const $1180cc40af8fd7c1$export$c72f6eaae7b9adff = (0, $2e4039a8780c9af0$export$2e2bcd8739ae039);
const $1180cc40af8fd7c1$export$6587c76ebf15601c = (0, $eee779cb2410b301$export$2e2bcd8739ae039);





var $bJrD0 = parcelRequire("bJrD0");
function $63a436771d8fc45d$var$App() {
    const navigate = (0, $2e634cb2b6e12a73$export$9770f232ac06a008)();
    const location = (0, $2e634cb2b6e12a73$export$45d76561a5302f2b)();
    const toggleDropdowns = (e)=>{
        if (!e.target.closest(".dropdown")) // close dropdowns if we are clicking on something else
        document.querySelectorAll(".dropdown").forEach((n)=>n.classList.remove("active"));
        else // close dropdowns that are not clicked on
        document.querySelectorAll(".dropdown").forEach((n)=>{
            if (n != e.target.closest(".dropdown")) n.classList.remove("active");
        });
    };
    function Logout() {
        (0, $bJrD0.useEffect)(()=>{
            (0, $cd2f6546c5cf5c32$export$ddcffe0146c8f882).reset();
        }, []);
        return (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$444b3ab0cb9aec40), {
            replace: true,
            to: "/login"
        });
    }
    // initial load
    (0, $bJrD0.useEffect)(()=>{
        // this test is here to ensure that 'api' gets loaded before
        // this may come from a transpilation issue with parceljs
        if ((0, $cd2f6546c5cf5c32$export$644d8ea042df96a6) && typeof (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6).update === "function") (0, $cd2f6546c5cf5c32$export$644d8ea042df96a6).update();
        else console.error("Could not use api.update()");
        (0, $cd2f6546c5cf5c32$export$6008d97729a90c74).update();
        (0, $cd2f6546c5cf5c32$export$a4ea57bd994c1f0d).update();
        // manage dropdowns
        window.addEventListener("click", (e)=>toggleDropdowns(e));
        return ()=>{
            window.removeEventListener("click", (e)=>toggleDropdowns(e));
        };
    });
    (0, $cd2f6546c5cf5c32$export$3e32638432616b6).fetch().then((user)=>{
        if (user?._networkError) // Network is down — don't redirect, stay on current page
        return;
        if (location.pathname === "/") {
            let redirect = "/login";
            if (user) {
                redirect = "/create-group";
                if (user?.groups[0]) {
                    const defaultPage = user?.data?.default_page || "default_group";
                    if (defaultPage === "default_group" && user?.data?.default_group) redirect = `/groups/${user.data.default_group}`;
                    else redirect = "/feed";
                }
            }
            navigate(redirect);
        }
        if (location.pathname.match(/^\/invitation/)) {
            if (user) (0, $cd2f6546c5cf5c32$export$7d6f1c8842f9f527).post(`/api/groups/invitation/${(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).id}`, {}).catch(()=>null).then((res)=>{
                if (res) navigate(res.group ? "/groups/" + res.group : "/");
            });
            else navigate(`/signup?inviteKey=${(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).id}`);
        }
        if (!(0, $cd2f6546c5cf5c32$export$5375cda95f0b0eb4).isOutside() && !user) navigate("/login");
    });
    return (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$3565eb3d00ca5a74), null, (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/password-reset",
        element: (0, $9SeGy.h)((0, $f367d32ad26358d9$export$b44239f84c8f0268), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/public/:token",
        element: (0, $9SeGy.h)((0, $f367d32ad26358d9$export$68b4491d6924a6d1), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/share",
        element: (0, $9SeGy.h)((0, $be03c4de42ac64ff$export$c9915453de10000b), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/signup",
        element: (0, $9SeGy.h)((0, $f367d32ad26358d9$export$89200835fb4edfb9), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/stop-notification-emails/:userId/:token",
        element: (0, $9SeGy.h)((0, $f367d32ad26358d9$export$e9e03eeea26d4dee), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/login",
        element: (0, $9SeGy.h)((0, $f367d32ad26358d9$export$21a94553ffa41578), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/logout",
        element: (0, $9SeGy.h)(Logout, null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/:type/:id/settings",
        element: (0, $9SeGy.h)((0, $1180cc40af8fd7c1$export$c72f6eaae7b9adff), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/bookmarks",
        element: (0, $9SeGy.h)((0, $be03c4de42ac64ff$export$9c257beea3dbd13a), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/create-group",
        element: (0, $9SeGy.h)((0, $be03c4de42ac64ff$export$1a13290ec7702c7), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/groups/:id",
        element: (0, $9SeGy.h)((0, $be03c4de42ac64ff$export$959a4441e74dcd2b), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/groups/:id/random",
        element: (0, $9SeGy.h)((0, $be03c4de42ac64ff$export$4b31f5af7c5f8dee), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/groups/:id/search",
        element: (0, $9SeGy.h)((0, $520fa8871428281e$export$5cc34a6155e65c0e), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/groups/:id/write",
        element: (0, $9SeGy.h)((0, $b0c42e92c84db02f$export$29913b8f065577b2), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/feed",
        element: (0, $9SeGy.h)((0, $be03c4de42ac64ff$export$8ff3eb003b44d68f), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/messages/:id",
        element: (0, $9SeGy.h)((0, $6a345a2434031edc$export$4025c8e17986f775), null)
    }), (0, $9SeGy.h)((0, $2e634cb2b6e12a73$export$e7b0ac011bb776c6), {
        path: "/messages/:id/:child_id",
        element: (0, $9SeGy.h)((0, $6a345a2434031edc$export$4025c8e17986f775), null)
    }));
}
var $63a436771d8fc45d$export$2e2bcd8739ae039 = $63a436771d8fc45d$var$App;



const $2b67dd6f65354df9$var$router = (0, $34f84368c0c9d98a$export$1f3f55432a00e06d)([
    {
        path: "*",
        Component: (0, $63a436771d8fc45d$export$2e2bcd8739ae039)
    }
], {
    basename: `/${document.baseURI.split("/")[3]}`
});
function $2b67dd6f65354df9$var$Index() {
    return (0, $9SeGy.h)((0, $34f84368c0c9d98a$export$323e4fc2fa4753fb), {
        router: $2b67dd6f65354df9$var$router
    });
}
(0, $9SeGy.render)((0, $9SeGy.h)($2b67dd6f65354df9$var$Index, null), document.body);


//# sourceMappingURL=app.49d01c16.js.map
